webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);



var HTTP = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/gateway';

// (url, data, method, options)
/* harmony default export */ __webpack_exports__["a"] = ({
  //上传
  upload: function upload(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])('http://wimg2.ciwong.net/avatar/upload', data, 'post', true, true);
  },
  getAreas: function getAreas(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/areas/{code}', data, 'get');
  },
  login: function login(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/oauth/v2/login', data, 'post');
  },
  logout: function logout(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/oauth/v2/logout', data, 'get');
  },
  service: function service(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_epage_Service', data, 'get');
  },
  // serviceProducts  : (data) => $http(HTTP+'/v5/service/v2/get_service_products_by_id', data, 'get'),
  serviceProducts: function serviceProducts(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/service/v2/get_service_products_by_id_classids', data, 'get');
  },
  catalogues: function catalogues(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v2/package/catalogues_package', data, 'get');
  },
  resources: function resources(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/package/book_resources_v2', data, 'get');
  },
  grads: function grads(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/get_my_classes', data, 'get');
  },
  publish: function publish(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperteacher/publishWork', data, 'post');
  },
  // homework  : (data) => $http(HTTP+'/v5/epaperwork/v2/getPublishWorkRecordsForWeiXin', data, 'get'),
  homework: function homework(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperteacher/getPublishWorkRecords', data, 'get');
  },

  updaterecord: function updaterecord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/usedpackage/updaterecord', data, 'post');
  },
  // finishier: (data) => $http(HTTP + '/v6/epaperwork/v2/getWorkContenSubmitRecords', data, 'get'),
  triggler: function triggler(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/epaperwork/workEventTriggler', data, 'post');
  },

  //获取排行榜
  rankContent: function rankContent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getEworkContentScoreStatistics', data, 'get');
  },
  rankWork: function rankWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getEworkStatistics', data, 'get');
  },
  //获取作业统计
  rankStatistics: function rankStatistics(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/workAnswerStatistics', data, 'get');
  },
  //获取单个题目的信息
  getSingleWork: function getSingleWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + "/v1/question/GetQuestionByVersions", data, 'get');
  },
  // 获取听说模考试卷
  getExamination: function getExamination(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/listen_speak_examination', data, 'get');
  },
  // 获取在线作答试卷
  getOnlineExamination: function getOnlineExamination(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v1/package/examinationdata', data, 'get');
  },
  //获取最近书本
  getLast: function getLast(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_userbook_top', data, 'get');
  },
  //撤回指定作业
  delWork: function delWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperteacher/deleteWork', data, 'post');
  },
  // 获取答案	@param : doWorkId
  getWorkAnswers: function getWorkAnswers(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getWorkAnswers', data, 'get');
  },
  //获取作业内容详情
  getDoWork: function getDoWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getDoWorkInfo', data, 'get');
  },
  //获取用户信息
  getInfo: function getInfo(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/get_info', data, 'get');
  },
  //获取课文跟读段落
  getClassText: function getClassText(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/followread_text_paragraph', data, 'get');
  },
  //获取单词
  getWords: function getWords(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/followread_words', data, 'get');
  },
  //获取用户详细信息
  getUserInformation: function getUserInformation(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/get_info_base', data, 'get');
  },
  //获取老师布置作业题号
  getTeacherQuerstion: function getTeacherQuerstion(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getDoWorkInfo', data, 'get');
  },
  //获取系统消息接口
  getSystemMessages: function getSystemMessages(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getMsgsByType', data, 'get');
  },
  //获取教育顾问信息接口
  getConsultant: function getConsultant(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/service/v2/get_epage_advisor', data, 'get');
  },
  //获取老师班级详情接口
  getClass: function getClass(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/get_my_classes', data, 'get');
  },
  //获取老师详细信息学校ID接口:
  getDetailedInf: function getDetailedInf(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/getUserInfo', data, 'get');
  },

  //修改老师头像
  getAvatar: function getAvatar(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/update_avatar', data, 'post');
  },
  //修改密码
  getPassWord: function getPassWord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/new/updatePwd', data, 'get');
  },
  //发送手机验证码:
  getsendVerifyCode: function getsendVerifyCode(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/sendVerifyCode', data, 'get');
  },
  //验证手机验证码:
  getcheckVerifyCode: function getcheckVerifyCode(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/checkVerifyCode', data, 'get');
  },
  //修改/绑定手机号
  getMobile: function getMobile(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/bindMobile', data, 'get');
  },
  //获取班级成员列表
  getClassStudent: function getClassStudent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/relation/getclassmembers', data, 'get');
  },
  //删除本班学生
  deleteStudent: function deleteStudent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/kick_out_class', data, 'get');
  },
  //获取班级所有服务开通情况
  getAllservice: function getAllservice(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_service_state2', data, 'get');
  },
  //查询学校列表
  getSchool: function getSchool(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/school/search', data, 'get');
  },
  //修改班级信息
  modifyClassInformation: function modifyClassInformation(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/class/update_classInfo_byId', data, 'get');
  },
  //创建班级接口
  createClass: function createClass(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/create', data, 'post', false, true);
  },
  //统计作业次数
  getHomeworkStatistics: function getHomeworkStatistics(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getEworkRecordsStatistics', data, 'get');
  },
  //设置已读消息
  setRead: function setRead(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/setRead', data, 'get');
  },
  //修改性别
  modifySex: function modifySex(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/update', data, 'post');
  },
  //未读消息数量
  unreadMessage: function unreadMessage(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getNoReadMsgCountByType', data, 'get');
  },
  //校讯通
  getSchoolMsg: function getSchoolMsg(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v5/message/agentEventTriggler', data, 'post');
  },

  modifyPwd: function modifyPwd(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/setPassword', data, 'get');
  },
  //置顶
  setBookTop: function setBookTop(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/set_userbook_top', data, 'get');
  },
  //分享
  toShare: function toShare(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/comm/url/longToShort', data, 'post');
  },
  searchStudent: function searchStudent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/getUserByMobile', data, 'get');
  },
  //添加单个学生进入班级
  addOneStudent: function addOneStudent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/apply', data, 'get');
  },
  //批量创建学生账号
  createStudent: function createStudent(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/relation/createAndAddStudentMembers', data, 'post');
  },
  //一键催交
  urgeWorks: function urgeWorks(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epapernotice/workReminder', data, 'post');
  },
  //在线批改作业
  correctWork: function correctWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/saveCorrectAnswer', data, 'post');
  },
  //听说批改作业
  correctListenWork: function correctListenWork(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperwork/examination/correct_listenspeak', data, 'post');
  },
  //获取试卷http://192.168.2.164:8069/BooksAuthor/GetList?userID=155014&keyWord=&periodId=0&SubjectID=0&pageIndex=1&pageSize=20
  getPaper: function getPaper(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/GetList', data, 'get');
  },
  //ExaminationID
  delPaper: function delPaper(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/DeleteExamination', data, 'post');
  },
  //http://100.114.31.171:8895/message/agentEventTriggler
  setClassMsg: function setClassMsg(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/agentEventTriggler', data, 'post');
  },
  //http://192.168.1.48:8895/message/getSendMessages
  getClassMsg: function getClassMsg(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getSendMessages', data, 'get');
  },
  //注册
  signup: function signup(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v5/user/signin', data, 'get');
  },
  // getAllCount: (data) => $http(HTTP+ '/v2/package/resource_statistics_web', data, 'get'),
  getAllCount: function getAllCount(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/package/resource_statistics_web', data, 'get');
  },
  //预览筛选
  filterListen: function filterListen(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/resource_data_web', data, 'get');
  },
  // 获取班级交集服务
  getClassService: function getClassService(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_epage_Service_classids', data, 'get');
  },
  //最近布置过
  getRecentPublishBokk: function getRecentPublishBokk(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperteacher/getPublishbook', data, 'get');
  },

  // 新接口

  // 获取成绩总汇
  getEworkStatistics: function getEworkStatistics(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v2/epaperstatistics/getEworkScoreStatistics', data, 'get');
  },
  // 获取内容详情
  finishier: function finishier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperteacher/getWorkContenSubmitRecords', data, 'get');
  },
  // 获取班级
  getMemberlist: function getMemberlist(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/relation/getClassMembersByIds2', data, 'get');
  },
  // 按内容导出成绩
  exportContentReport: function exportContentReport(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/exportContentReport', data, 'get');
  },
  // 导出成绩汇总
  exportWorkReport: function exportWorkReport(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/exportWorkReport', data, 'get');
  },
  // 创建班级分组
  addTeam: function addTeam(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/relation/add_team', data, 'post');
  },
  // 修改班级分组
  ediTeam: function ediTeam(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/relation/edit_team', data, 'post');
  },
  // 删除班级分组
  delTeam: function delTeam(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/relation/del_team', data, 'get');
  },

  downLoad: function downLoad(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])('https://epbank.oss-cn-shenzhen.aliyuncs.com/PublishTools/update/update.xml', data, 'get');
  },
  //获取班级统计报告
  getClassWorkStatistics: function getClassWorkStatistics(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getClassWorkStatistics', data, 'get');
  },
  //导出成绩报告
  exportClassWorkStatistics: function exportClassWorkStatistics(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/exportClassWorkStatistics', data, 'get');
  },
  // 班级成绩曲线
  getclasssoreline: function getclasssoreline(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v2/gather/class/getclasssoreline', data, 'get');
  },
  //获取班级作业报告基本情况
  getClassBaseInfo: function getClassBaseInfo(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + "/v2/gather/class/getclassbaseinfo", data, 'get');
  },
  //班级报告成绩详情
  getClassWorkReport: function getClassWorkReport(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + "/v1/epaperstatistics/getClassWorkReportList", data, 'get');
  },
  //导出班级报告详情
  exportClassWorkReport: function exportClassWorkReport(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + "/v1/epaperstatistics/exportClassWorkReport", data, 'get');
  },
  //作业报告详情
  getStudentWorkReport: function getStudentWorkReport(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getStudentWorkReportList', data, 'get');
  },

  //学生报告-成绩信息
  getStudentWorkReportInfo: function getStudentWorkReportInfo(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getStudentWorkReport', data, 'get');
  },

  //学生报告-成绩曲线
  getScoreRecord: function getScoreRecord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getScoreRecord', data, 'get');
  },

  //学生报告-作业详情列表
  getStudentReportDetail: function getStudentReportDetail(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperstatistics/getStudentReportDetailList', data, 'get');
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brandId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return http; });
/* unused harmony export schoolId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return httpApp; });
var user = JSON.parse(window.localStorage.getItem('user'));
/*
* 不许改动这个文件
*/
var host = window.location.host;
var clientId = 100131;
var brandId = 570678343;
var http = 'https://eapi.my.ciwong.com';
var httpApp = 'https://m.teacher.jiaofuyun.com';

// if (host == 'xi.my.prev.ciwong.com') {
//     http = 'https://eapi.my.prev.ciwong.com';
//     httpApp = 'https://prevm.teacher.jiaofuyun.com'
// } else if (host == 'xi.my.ciwong.com') {
//     http = 'https://eapi.my.ciwong.com';
//     httpApp = 'https://m.teacher.jiaofuyun.com'
// } else {
//     brandId = 524726977
// }

// http = 'http://eapi.my.prev.ciwong.com';
// brandId = 570678343;


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["nowDate"] = nowDate;
/* harmony export (immutable) */ __webpack_exports__["timeStamp"] = timeStamp;
/* harmony export (immutable) */ __webpack_exports__["aroundDate"] = aroundDate;
/* harmony export (immutable) */ __webpack_exports__["formatDate"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["formatDataToMinutes"] = formatDataToMinutes;
/* harmony export (immutable) */ __webpack_exports__["formatDataToMinute"] = formatDataToMinute;
/* harmony export (immutable) */ __webpack_exports__["timeAxis"] = timeAxis;
/* harmony export (immutable) */ __webpack_exports__["timestampToTime"] = timestampToTime;
/* harmony export (immutable) */ __webpack_exports__["closeDateState"] = closeDateState;
/* harmony export (immutable) */ __webpack_exports__["closeDate"] = closeDate;
/* harmony export (immutable) */ __webpack_exports__["speekingType"] = speekingType;
/* harmony export (immutable) */ __webpack_exports__["numFilter"] = numFilter;
/* harmony export (immutable) */ __webpack_exports__["countDownDate"] = countDownDate;
/* harmony export (immutable) */ __webpack_exports__["countLast"] = countLast;
/* harmony export (immutable) */ __webpack_exports__["stringParam"] = stringParam;
/* harmony export (immutable) */ __webpack_exports__["compareDate"] = compareDate;
/* harmony export (immutable) */ __webpack_exports__["parseParam"] = parseParam;
/* harmony export (immutable) */ __webpack_exports__["gradText"] = gradText;
/* harmony export (immutable) */ __webpack_exports__["formatHtml"] = formatHtml;
/* harmony export (immutable) */ __webpack_exports__["fromCharCode"] = fromCharCode;
/* harmony export (immutable) */ __webpack_exports__["setAssess"] = setAssess;
/* harmony export (immutable) */ __webpack_exports__["toMath"] = toMath;
/* harmony export (immutable) */ __webpack_exports__["toPercent"] = toPercent;
/* harmony export (immutable) */ __webpack_exports__["secTotime"] = secTotime;
/* harmony export (immutable) */ __webpack_exports__["secTotime1"] = secTotime1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

function nowDate(date) {
  return date ? new Date(date) : new Date();
}
/*
    转化成时间戳
    返回（s）秒
*/
function timeStamp(date) {
  date = Date.parse(nowDate(date));
  return date / 1000;
}
/*
    日期加减
*/
function aroundDate(date, num) {
  date = nowDate(date);
  date.setDate(date.getDate() + num);
  return date;
}

function formatDate(date, format) {
  if (!date) {
    return false;
  }
  date = nowDate(date * 1000);

  var obj = {
    'y+': date.getFullYear(),
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'W+': date.getDay()
  };
  var weeks = ['日', '一', '二', '三', '四', '五', '六'];
  obj['W+'] = '周' + weeks[obj['W+']];
  if (new RegExp("(y+)").test(format)) {
    format = format.replace(RegExp.$1, obj['y+']);
  }
  for (var j in obj) {
    if (new RegExp("(" + j + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? obj[j] : ("00" + obj[j]).substr(("" + obj[j]).length));
    }
  }
  return format;
}

function formatDataToMinutes(data) {
  return Math.ceil(data / 60);
}
function formatDataToMinute(data) {
  return Math.ceil(data / 60);
}

function timeAxis(date, currentTime) {
  // debugger
  var timestampDiff = (currentTime - date) / 60 / 60 / 24;
  var res = '';
  var currentDate = nowDate(currentTime * 1000);
  var times = formatDate(date, 'hh:mm');
  if (timestampDiff > 0) {
    if (timestampDiff < 1 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate()) {
      res = '今天 ' + times;
    } else if (timestampDiff < 2 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() + 1) {
      res = '昨天 ' + times;
    } else if (timestampDiff < 3 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() + 2) {
      res = '前天 ' + times;
    } else {
      res = formatDate(date, 'MM-dd') + ' ' + times;
    }
  } else if (timestampDiff < 0) {
    if (timestampDiff > -1 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate()) {
      res = '今天 ' + times;
    } else if (timestampDiff > -2 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() - 1) {
      res = '明天 ' + times;
    } else if (timestampDiff > -3 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() - 2) {
      res = '后天 ' + times;
    } else {
      res = formatDate(date, 'MM-dd') + ' ' + times;
    }
  }

  return res;
}
function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() + ' ';
  return Y + M + D;
}

function closeDateState(currentTime, publishDate, effectiveDate) {
  // let currentDate = timeStamp();
  // let timestampDiff = (currentDate - date) / 24 / 60 / 60;
  var res = '';
  if (currentTime < publishDate) {
    res = 1;
  } else if (currentTime > effectiveDate) {
    res = -1;
  } else {
    res = 0;
  }
  return res;
}

function closeDate(currentTime, publishDate, effectiveDate) {
  var state = closeDateState(currentTime, publishDate, effectiveDate);

  var res = '';

  switch (state) {
    case 1:
      res = countDownDate(currentTime, publishDate) + '后' + ' ' + '发布';
      break;
    case 0:
      res = countDownDate(currentTime, effectiveDate) + '后' + ' ' + '截止';
      break;
    default:
      res = '';
  }
  return res;
}

function speekingType(index, resourceType) {
  var data = ['跟读', '朗读', '背诵'];
  if (resourceType === 'a7527f97-14e6-44ef-bf73-3039033f128e') {
    data = ['跟读', '朗读'];
  }
  return data[index - 1];
}

// 保留小数点后两位的过滤器，尾数四舍五入
function numFilter(value) {
  var realVal = Number(value).toFixed(2);
  return Number(realVal);
}

function countDownDate(currentTime, date) {
  var timestampDiff = currentTime - date;
  var res = '';

  timestampDiff = timestampDiff < 0 ? timestampDiff * -1 : timestampDiff;

  if (timestampDiff < 3600) {
    res = Math.floor(timestampDiff / 60) + '分';
  } else if (timestampDiff < 3600 * 24) {
    res = Math.floor(timestampDiff / 3600) + '小时' + Math.floor(timestampDiff / 60 % 60) + '分';
  } else if (timestampDiff > 3600 * 24) {
    res = Math.floor(timestampDiff / 3600 / 24) + '天' + Math.floor(timestampDiff / 3600 % 24) + '小时' + Math.floor(timestampDiff / 60 % 60) + '分';
  }
  return res;
}

function countLast(date) {
  var currentDate = timeStamp();
  var timestampDiff = currentDate - date;
  var res = '';

  timestampDiff = timestampDiff < 0 ? timestampDiff * -1 : timestampDiff;
  if (timestampDiff < 86400 && nowDate().getMonth() == nowDate(date * 1000).getMonth() && nowDate().getDate() == nowDate(date * 1000).getDate()) {
    res = '今天';
  } else if (timestampDiff < 86400 * 2 && nowDate().getMonth() == nowDate(date * 1000).getMonth() && nowDate().getDate() == nowDate(date * 1000).getDate() + 1) {
    res = '昨天';
  } else {
    var lastDays = Math.ceil(timestampDiff / 86400);
    res = lastDays + '天前';
  }
  return res;
}

function stringParam(obj) {
  var res = "";
  for (var k in obj) {
    res += '&' + k + '=' + obj[k];
  }
  return res.slice(1);
}

function compareDate(date) {
  var res = date - timeStamp();
  return res >= 0 ? true : false;
}

function parseParam(url) {
  var arr = '';
  var obj = {};
  url = url || window.location.href;
  if (url.split("?").length > 1) {
    arr = url.split('?')[1].split('&');
    arr.map(function (item) {
      item = item.split('=');
      var k = item[0],
          v = item[1];
      obj[k] = v;
    });
    return obj;
  }
}

function gradText(num) {
  var data = __webpack_require__(266);
  var res = '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id == num) {
        res = item.name;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return res;
}
// 格式化题干html
function formatHtml(val, type) {
  if (type == 3) {
    return val.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
  } else {
    return val.replace(/&nbsp;/g, ' ');
  }
}
// 数字转成字母
function fromCharCode(val) {
  return String.fromCharCode(65 + val);
}
// 设置得分(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
function setAssess(userAnswer) {
  var html = '';
  if (userAnswer && userAnswer.score !== undefined) {
    if (userAnswer.assess === 0) {
      html = '评分中';
    } else if (userAnswer.assess === 5) {
      html = '批改失败';
    } else {
      html = parseFloat(userAnswer.score) + '分';
    }
  } else {
    html = 0 + '分';
  }
  return html;
}

function toMath(num, count, defaultValue) {

  if (num == 0) {
    return 0;
  } else if (num == "-" || !num) {
    return num = "-";
  }
  return num = parseFloat(parseFloat(num).toFixed(count));
}
function toPercent(num, count, defaultValue) {

  if (num == 0) {
    return 0;
  } else if (num == "-" || !num) {
    return num = "-";
  }

  return num = Math.floor(Number(num * 100).toFixed(count)) + "%";
}

function secTotime(s) {
  var t = '';
  if (s > -1) {
    var hour = Math.floor(s / 3600);
    var min = Math.floor(s / 60) % 60;
    var sec = s % 60;
    if (hour > 0) {
      t = hour + '小时';
    }

    if (min > 0) {
      t += min + '分钟';
    }
    if (sec > 0) {
      t += sec + '秒';
    }
  }
  return t !== '' ? t : '-';
}

function secTotime1(s) {
  s = s ? s.toFixed(0) : '';
  var t = '';
  if (s > -1) {
    var hour = Math.floor(s / 3600);
    var min = Math.floor(s / 60) % 60;
    var sec = s % 60;
    if (hour > 0) {
      t = hour + 'h';
    }

    if (min > 0) {
      t += min + 'min';
    }
    if (sec > 0) {
      t += sec + 's';
    }
  }
  return t !== '' ? t : '-';
}

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/null.99ffc9a.png";

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1184),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STORAGE_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return WRITE_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return READ_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLEAN_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return WORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WRITE_WORKS; });
/* unused harmony export READ_WORKS */
/* unused harmony export MODIDY_WORKS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLEAN_WORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USER; });
/* unused harmony export READ_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return WRITE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLEAN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SUBJECT; });
/* unused harmony export READ_SUBJECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WRITE_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLEAN_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WRITE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WRITE_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAN_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WRITE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAN_STATE; });
var STORAGE_KEY = 'xxwl';
var CRUMB = 'crumb';
var WRITE_CRUMB = 'write_crumb';
var READ_CRUMB = 'read_crumb';
var CLEAN_CRUMB = 'clean_crumb';
var WORKS = 'works';
var WRITE_WORKS = 'write_works';
var READ_WORKS = 'read_works';
var MODIDY_WORKS = 'modify_works';
var CLEAN_WORKS = 'clean_works';
var USER = 'user';
var READ_USER = 'read_user';
var WRITE_USER = 'write_user';
var CLEAN_USER = 'clean_user';
var SUBJECT = 'subject';
var READ_SUBJECT = 'read_subject';
var WRITE_SUBJECT = 'write_subject';
var CLEAN_SUBJECT = 'clean_subject';
var TOAST = 'toast';
var WRITE_TOAST = 'write_toast';
var CLEAN_TOAST = 'clean_toast';
var CATALOG = 'catalog';
var WRITE_CATALOG = 'write_catalog';
var CLEAN_CATALOG = 'clean_catalog';
var STATE = 'navstate';
var WRITE_STATE = 'write_navstate';
var CLEAN_STATE = 'clean_navstate';

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1188),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1155),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(940)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1249),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1193),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1220),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1187),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1203),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1161),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAALCAYAAABYpyyrAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAABgSURBVAiZZY2xDcMgAMCciCfgDQ4AfmZHcAxn4E6JqtajPfhSXWtxzqHWCqqtNUspqjLnFBBwjCGttVeUUrxU+eLmhz8Reu/svQGIMXLnnN+acybEGEkpoZJSIjzlmX0AiJY1QJWAsygAAAAASUVORK5CYII="

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA1klEQVQokZXSP0oDQRiG8d8OaWxiEz1ACrWz0VssNkEPkF4QK+2FtBLS6gXiNoKnsLCxsPIAwSpBBS1isTOyBBk3TzV/3udjmO8rPi4ONOjhHCV24tkL7jHGWwoWDXGAG2z6mzmGqCA0pGlGgm7MDJK4hVsUGen3hTG7HXAaq7Wli7OAozWkRNnBXtptjB6z6c/Lw7TcDblghq+Ouk/7KxX/4zWom7suDwETdXPbMsd1wEw9EcsW0jJmZ+lzKpxgkZEWOLYycnCHPkZ4xjfe8YSreFel8A9rrSp2moTTlQAAAABJRU5ErkJggg=="

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1232),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var grads = [{ id: 1101, periodid: '1001', name: '一年级' }, { id: 1102, periodid: '1001', name: '二年级' }, { id: 1103, periodid: '1001', name: '三年级' }, { id: 1104, periodid: '1001', name: '四年级' }, { id: 1105, periodid: '1001', name: '五年级' }, { id: 1106, periodid: '1001', name: '六年级' }, { id: 1107, periodid: '1003', name: '七年级' }, { id: 1108, periodid: '1003', name: '八年级' }, { id: 1109, periodid: '1003', name: '九年级' }, { id: 1111, periodid: '1005', name: '高一' }, { id: 1112, periodid: '1005', name: '高二' }, { id: 1113, periodid: '1005', name: '高三' }];

/* harmony default export */ __webpack_exports__["default"] = (grads);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elementaryPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return juniorPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return periods; });
var elementaryPeriods = [{ text: '一年级', grade: 1101, period: 1001 }, { text: '二年级', grade: 1102, period: 1001 }, { text: '三年级', grade: 1103, period: 1001 }, { text: '四年级', grade: 1104, period: 1001 }, { text: '五年级', grade: 1105, period: 1001 }, { text: '六年级', grade: 1106, period: 1001 }];
var juniorPeriods = [{ text: '初一', grade: 1107, period: 1003 }, { text: '初二', grade: 1108, period: 1003 }, { text: '初三', grade: 1109, period: 1003 }, { text: '高一', grade: 1111, period: 1005 }, { text: '高二', grade: 1112, period: 1005 }, { text: '高三', grade: 1113, period: 1005 }];
var periods = [{ text: '一年级', grade: 1101, period: 1001 }, { text: '二年级', grade: 1102, period: 1001 }, { text: '三年级', grade: 1103, period: 1001 }, { text: '四年级', grade: 1104, period: 1001 }, { text: '五年级', grade: 1105, period: 1001 }, { text: '六年级', grade: 1106, period: 1001 }, { text: '初一', grade: 1107, period: 1003 }, { text: '初二', grade: 1108, period: 1003 }, { text: '初三', grade: 1109, period: 1003 }, { text: '高一', grade: 1111, period: 1005 }, { text: '高二', grade: 1112, period: 1005 }, { text: '高三', grade: 1113, period: 1005 }];

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


// const { accessToken } = JSON.parse(window.localStorage.getItem('user'))
var Vue = __webpack_require__(22);
var qs = __webpack_require__(1042);

/* harmony default export */ __webpack_exports__["a"] = (function (url, data, method, customerQuery, isFormData) {
  // Vue.http.options.emulateJSON = true;

  var _this = this;
  var user = JSON.parse(window.localStorage.getItem('user'));
  var query = {
    clientId: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */],
    brandId: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */],
    accessToken: user ? user.accessToken : ''
  };
  var Authorization = window.localStorage.user ? JSON.parse(window.localStorage.user).userId : data.userId;
  if (!data) {
    data = {};
  }
  if ('post' == method) {
    data.clientId = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */];
    data.brandId = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */];
  }
  // if (data.userId && data.clientId) {
  //   query = {}
  // }

  // if(!customerQuery) {
  // 	Axios.defaults.headers.common['Authorization'] = 'Basic '+window.btoa( Authorization +':');
  // 	Axios.defaults.withCredentials = true;
  // }

  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

  // Axios.defaults.headers.common['Authorization'] = 'Basic '+window.btoa( Authorization +':');
  // Axios.defaults.withCredentials = true;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](url + '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filter__["stringParam"])(query), method == 'get' ? {
    params: data
  } : isFormData ? qs.stringify(data) : data).then(function (res) {
    var data = res.data;
    if (data.errcode == 10008 || data.errcode == 10009 || data.errcode == 17 || data.errcode == 18 || data.errcode == 27) {
      Vue.prototype.$toast('账号异常');
      window.localStorage.removeItem("user");
      window.location.assign('/');
      return false;
    } else if (data.errcode == 15 || data.errcode == 26 || data.errcode == 401) {
      Vue.prototype.$toast(data.msg, 'error');
      return false;
    }
    return data;
  }).catch(function (err) {
    return err;
  });
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DrawCanvas = function () {
  function DrawCanvas(obj, percent) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DrawCanvas);

    this.settings = {
      obj: obj,
      percent: percent
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DrawCanvas, [{
    key: "runCircle",
    value: function runCircle() {
      var defaultSetting = {
        url: "./static/green_point.png", //飞机小图地址
        obj: "", //场景添加的canvas id 名
        percent: 0, //圆环转动的百分比  0-1
        circleBottomColor: "#e3f1ee", //圆环底色
        outerColorStart: "#fff", //外部圆环 渐变色
        outerColorMid: "#fff",
        outerColorEnd: "#fff",
        innerColorStart: "#88dbc8", //内部圆环 渐变色
        innerColorEnd: "#88dbc8"
      };

      Object.extend = function (destination, source) {
        for (var property in source) {
          destination[property] = source[property];
        }
        return destination;
      };
      this.option = Object.extend(defaultSetting, this.settings);

      var obj = this.option.obj;

      var percent = this.option.percent;
      this.outerColorStart = this.option.outerColorStart;
      this.outerColorMid = this.option.outerColorMid;
      this.outerColorEnd = this.option.outerColorEnd;
      this.innerColorStart = this.option.innerColorStart;
      this.innerColorEnd = this.option.innerColorEnd;
      this.circleBottomColor = this.option.circleBottomColor;

      var preA = Math.PI / 180;

      this.canvasC = document.getElementById(obj); //this.$refs.canvasDom    this.option.obj


      console.log("this.canvasC", this.canvasC);
      /*控制运动*/
      this.context = this.canvasC.getContext("2d");

      var windowW = parseInt(this.canvasC.parentNode.offsetWidth); //parentNode

      this.lineW1 = 13;
      this.lineW0 = 10;

      if (windowW > 500) {
        this.lineW1 = 36;
        this.lineW0 = 10;
      }
      var canvasW = windowW * 0.6;
      var R = parseInt(canvasW / 2 - 2 * this.lineW1 - 2 * this.lineW0 - 10);
      this.R0 = parseInt(canvasW / 2 - this.lineW0 - 4);
      this.R1 = parseInt(canvasW / 2 - this.lineW1 - this.lineW0 - 10);
      this.ra = parseInt(canvasW / 2 - this.lineW0 / 2 - 25); //改这里
      var canvasH = canvasW;
      var rotateAngle = percent * 360;
      var anotherA = 0;
      if (percent > 0.5) {
        anotherA = (percent - 0.5) * 360 * preA;
      }
      this.rotataRadians = preA * rotateAngle;
      this.canvasC.width = canvasW;
      this.canvasC.height = canvasH;

      this.x = this.canvasC.width / 2;
      this.y = this.canvasC.height / 2;
      this.startAa = -Math.PI / 2;
      this.startA = 0;

      var preSceond = 100 / (Math.PI * 2);
      this.CanvasApp();
      this.context.fillStyle = '#ff0';
      this.context.fillText(percent, 20, 20);
    }
  }, {
    key: "CanvasApp",
    value: function CanvasApp() {

      var loading = 0;
      var _this = this;
      var imageUrl = this.option.url;
      this.canvasC.setAttribute("data-run", "1");

      this.imageAir = new Image();
      this.imageAir.onload = function () {
        _this.imgWidth = _this.option.imgWidth || _this.imageAir.width;
        var imgHeight = _this.option.imgHeight || _this.imageAir.height;
        _this.imgX = -_this.imgWidth / 2 - 3;
        _this.imgY = -_this.imgHeight / 2 - 8;
        _this.drawScreen();
      };
      this.imageAir.src = imageUrl;
    }
  }, {
    key: "drawScreen",
    value: function drawScreen() {
      // debugger
      var _this = this;

      if (this.startA < this.rotataRadians) {
        this.startA += 0.1;
      }

      console.log("context", this.context);
      this.context.fillStyle = "#fff";
      this.context.fillRect(0, 0, this.canvasC.width, this.canvasC.height);

      this.context.save();
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.fillRect(0, 0, this.canvasC.width, this.canvasC.height);
      this.context.translate(this.x, this.y);
      this.context.rotate(-Math.PI / 2);

      // //中环
      this.context.beginPath();
      this.context.strokeStyle = this.circleBottomColor;
      this.context.lineWidth = this.lineW1;
      this.context.arc(0, 0, this.R1, 0, Math.PI * 2, false);
      this.context.stroke();
      this.context.closePath();
      //
      // // Linear gradients
      this.context.beginPath();
      var gradient2 = this.context.createLinearGradient(this.R1, 0, -this.R1, 0);
      gradient2.addColorStop(0, this.innerColorStart);
      gradient2.addColorStop(1, this.innerColorEnd);
      this.context.lineCap = "round";
      // this.context.strokeStyle = "#88dbc8";
      this.context.strokeStyle = gradient2;

      this.context.lineWidth = this.lineW1;
      this.context.arc(0, 0, this.R1, 0, this.startA, false);
      this.context.stroke();
      this.context.closePath();
      //
      // //画图
      if (this.startAa < this.rotataRadians - Math.PI / 2) {
        this.startAa += 0.1;
        this.canvasC.setAttribute("data-run", "1");
      } else {
        clearInterval(this.Timer);
        this.canvasC.setAttribute("data-run", "0");
      }
      this.context.save();
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      var ax = this.ra * Math.cos(this.startAa);
      var ay = this.ra * Math.sin(this.startAa);
      this.context.translate(this.x + ax, this.y + ay);
      this.context.rotate(this.startAa);
      this.context.drawImage(_this.imageAir, _this.imgX, _this.imgY, 12, 12);
      this.context.restore();

      this.Timer = setInterval(this.drawScreen, 20);
    }
  }]);

  return DrawCanvas;
}();

/* harmony default export */ __webpack_exports__["a"] = (DrawCanvas);

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAlFJREFUOI2llD9oFEEUxn9vdj0IB4JamFMLG1EISJqAXSCtCcQodlaSm12DYFIJKq6IglHSRO72llxhGyMkIIh/IlgIMUWEFNrYCqdBUkt251l4d8TlLib6VbPzvfnNx7zHCk3FcTwC3BGRfkDYJhEZKZfLz9mFfIBarTYBPO5So6ra0/qYn58vbG5uTgFr1tpX+WJJkmTAObciIgZYVNUb1trPIqKd6EmSnFfVheZF9xqNxu0oilzLN6p6TUSMqr601p4LguBTNxhAlmUHW2FE5GapVHo7NzfX2sNX1SERwfO86W6QarV60RgzDPSpal/OHkzTdL1arY6FYbjqi8hhAOfclzxoZmamp1gsPgXOtt9IJF+GiBwF3idJcskn19GWoijyi8XiC2CwW/Ic1HfO3TLdCkql0sPdwgBUNVXV+34ns16vH0nT9OoeYF9VdSwMw9WOCdM0HQa8bQdWgCHP844DV3Ll73zfPx2G4So0B7uD+psgJyKT1trZ1ijFcbzRbMwfc1ir1U4ZY352BKrqISAFLlhrl6y1ba/RaCz29vZeB9aCIHgNUKlUDgDrzrlvHYEi8gN4ZK1dyntRFKXAg+17hUJhf5Zl+4Bj3YDLqvqmy3PsqDbQ87z2PJbL5Wd7gWxtbYkxv/trVPU7gHPuxL8kAhCR1tkNAywDqOrUfwAnm8tlSZJkQFU/AKKqC8aYaHx8fMc/TjOAxHHcZ4y5C4yqqjPGnBGAOI4vA7Mi0rMT5C8XTARBUDEAQRDUsyw7CTwBsr1x9KOqjgZBUAH4BRnvAvpVgYm9AAAAAElFTkSuQmCC"

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.4b6fc83.gif";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/noMessage.7c611a5.png";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAABDxJREFUWIW1mb+PG0UUxz/Pa6/Xt/H5nODYJ0VRAkWCRJEKkQaRmiYV/AH8SPIf0AFCQkoDioR0QYgaCVHQQUGBEGkikCIakgYiaCwlufjsO/vstfdLYfvw+db2zubylVaWd96b99mZ55m3YyOjJNWAK8CrwEvAOeD8pPnvyfUXcBf4ycy2s8ZygdqU9KmkP+Su3yV9ImnzeYF9LqmbAWxeXUmfHQvoMYMtAn0hK1xB0tZzAJvXlqSCK9xJSXdcosRxrH6/r8FgoDiOXSHvSDqZxGIJcHngF+Bymofpdrt0Oh0Gg8Gh+6VSiXK5TLFYTDsuvwJXzGy4CvA2cG1Vb6PRiCdPntDv95fahWFItVrF7EioJH1pZtcXAkq6Dmyt6kUSzWaT4XC4yhSAIAio1WqpbIEbZnb7CKCkOvAQCFb18PTpU3Z3d9MGBKBarXLixIk0pj3gRTNrAuRmGj5OAxfHsTMcQLvdTmtaAj6YfskBSDoPvJvGu9frubIB45yd/yEt0fuSGgeAwIeAl8YziiJ3OnffEvAR/A/4WlrPOI7dqLL7vgGQk3QRuJA5qoNSLjVTXZB0MQdcdfHK5/NOULPyvFRZNKurOeCSi4fv+65BDuSwq0x1KQc0XDyCICCXy602nJPv+1n8GjnGlbCTUi64h7S+vu7swwTQaQSnwVxyMQgCSqWSaxiYAO67epkZtVot1ZQVCgVOnTqVBQ4Yr4PNLI75fJ5Go0GhsLjWDIKAer2eKWcnauYngJnWQc/zaDQadDodOp0Oo9EIz/PwfZ8wDLNOayJgag0GA/b39+n3+4RhyNraGuVymXK5nGjf7XbpdrsUi0WCIFg64osA7wFvJ7VKYm9vj8FgQBRFRFGEpIP2KWilUjkyjcPhkFardVBcTD/NDN/3KRQKFItF1tbWlgHes8lW92dS6+PHj1NXL9OAuVyOKIpS+1UqlWVL0Mt5M7sv6QEJeeiS3NMRdtWS/fmBmd2fEvyYZLEor45LZkYYhouav4dJyS/pHONpPlJRb29vs7e391wANzY2Fg3CPnDWzB7lAMzsIXArybJarWapQlaqWCwum6FbZvYIDr80rQP/AJV569FoRLPZfKZidVaFQoF6vb4o/9rAGTPrwMxLk5m1gRtJHp7nUavVXAvORKXo670p3CHACeQ3wM0kL9/3OX369LNsW5RKJTY3N5elzE0z+/YQ07yFJAN+Bl5P6kESOzs7dDqdpOZEmRmVSmXVqvAD8KaZafZm4jhrfHr6G3B2UW9xHB/swbO7y6w8z2N9fZ0wDFelx7/AK5M0Syc5HL9FUaRer6d2u61Wq6WdnR31+/20J1tfyfX4bQ70mqRh2mgOGkp6JzPYHOSFyZOmHpYlGkj6WtLxv+pKOiPpC0m9DGC7Gh/5nnGJmXlhk3QZeIvx3xDVybUxaW5Nrm3gDvCdmd3NEuc/Tiho1O0TV0MAAAAASUVORK5CYII="

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAEQElEQVRogcWZa4gWVRjHfzu1u+22ZJobZGZWtGR5qTAq7WIXulIU0gXKFCViKfNDEVFBYB+6gpAgfWhBISgtIqMUQikhyFWyMlo3NS206MJeNFbLzf59OO/EdPbMvOfMHLc/PLyc8z6X38ycmTnnTIMkImgOcAUwFTgXaAfagAQYAvqAvUAP8BmwAThUpWBDBfArgQeA64HJgbF9GPg3gbWlqksKteskva142iRpbihHiPN0SVsjAtvaIelmXx7fofIIsNzDbx/wNbAbGKj1tQAdwJTab0OdHMuBR+tW8ji6FQVnqU/SGklLJE2R1FAn1yRJiyStkrSrIO/7ktqLchUVaZS0uSD5i5LG+F7aHFsi6Y+c/D9LOqsM+Oc5CTdLurwicNbOkLlqLvWHgr+ek+iliMC2PZZTc60v+OKcBA8eQ+jUrsqp3VUPfFJO4KJRgE5tdg7DjUXgOx0Br4widGoLHRxDkppd4Fc7nHv+B+jU3nHw/Dtcs44bHY4dAYVelfRyRPAmScMWzz4b/BIHdMgQacrEfSQzTmPA3+fguj8Lvtr6czCwwAkyL4ysno4E32fl3Z6CN8oM/KzWBCZvlvSL4+yslDS2Irjr5XRmAtwKtFpTmA0eEyofzQf2AE9WyLHC0XcvkpY5jmhCpDOeVZcyj7NA67dyfZAAF1hHsxv4qcIZytNCoBeYXSK222qflmDWiFltLUPlqcnAp5jL3xgQt81qn5QA463OveW5vNUJ7ABmevr/aLVbE0auSA5XpfLUOZiru9jD91er3ZIAR63O5hhUAVrg4XPAajcmwBGrsyUKjp/eA2Z5+LVZ7eEE6Lc6T4+CVKxDwFLgTuBPD/+JdvzxmJuxI9N5YRy2XG3BAIc8cm2mAwmw0+o8DxhXAaxIq4BLCX9PXGa1DybAJofj7WWoCjQAzMPvRrR1NnC+1bclAdYBf1l/zClRIE8bMW/nN0rGP+zoW53OBdZbc4EfIs1Vni05N8nat1bOAWXm4zc4inYGJLfn47skzYsAPcPB9VwWHEnfOJxaPQtkV0ArJR0XARqNXLwflXSiDX63A/zdgCKvyaw7YwAj6XEHz7L0/6xjIuk3h/NDEWF87VoHhySNc4Ej6ZqcgGmjCN0m6XcHw3/WsK7ALkfQ0CjBnyyzwW/rS9s3L8EnjuBhSfOPIfQdkvY76vbWDsgLfIykw44kkrkJmyJDP5NTS5ImumKKks3QyD2NVN9LuiUC8CxJ3QXQd+XF1kt8iqSPCxL3ylyBmQGw02R2yb4qyPudpKlFeXw/Xr0F3FPHpwfYDnyBWSP2A38DY4EJwPSaXVQnTzdwEzBY6BVwpjrlfkzF0rCkpb48oWPyVElPyH33l9VBSc/LfFTwZil7UzVLekruZ66v9kh6QdL4MgxVvuWnuhi4DbND1V4b061AE2br4whmjTmI+YbfDXyI2RgqrX8AkHeTkZDlD7MAAAAASUVORK5CYII="

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAMCAYAAAA9HRKyAAAABHNCSVQICAgIfAhkiAAAAwdJREFUaIHtmU9oHFUcxz+/N8vGkCWx5BBMs4SEJmQ3lyqIrevBiIkkp0JLQZEUUepJKRbEoydvlaKCoMUUKRWjUOihkD+meOo/eijYYRExhwQxh0BCh6QmO/P1sBkV2aQr211hM5/LvHnvy4/f+7zLG8aIufZJC6nwLeA9w/oBhH4FPqbkXWDi3T9IeHwkvhtOsVh8XdIxSS+YWQm4ZWZXhoaGLsUZA2D2024I5wzylQoJfPBGGXvnt8a03uQkvhtKsVjslnQJGNklcj2KoteGh4d/d+hDB6Xp3Q4HoLxWmi5nE2oi8d1wJE0DI57n0dPTw8DAAIODg/T29tLW1gYw4pz7GsAx1zFpWOFRRQ0rMNcxWefem5/5A6eq9j1/4FQjWmpmfN9/Eyh4nkdfXx+ZTAbP83DO0draSjabJZPJAIz6vj/pwN7eq6Ckr+T0fPlt72xCFUin917+h28p8V07xwG6urpIpVIVA52dnQCY2YkUIo+B0Ddg4wZPxkFJn5NOv8/29sLOTM5mz6veO2hmJD3ArDrfIre0tJT4roEgCNaB+GpUkXQ6HQ+fcRjle6rxPc4VBKsAgo8IvQ/Y3l4weJbyZHKnrZX/4tsS37UiaXPnWU3cpYCfgCOIb5FOgh0VTFCyKVLRjwaH/4qb3dfYmaN16Xy/MHv+JvBcVb7hfjabPfJ/tdoM+L5/DRjf2Nigvb29YmZrayse3nWICwCGpZC+w8Kndzkc4mxCLah63zvZhJr4EmBlZYVSqVQxsLq6Gg8/c6x3X5R0G8AMj8hdxovu/ftwJN1mbG2qjo3vD9YOTgnuwCN8wx3WDia+aySfz1+R9EMYhiwuLhIEAWEYEkURm5ubLC8vEwQBwNVcLjdT/jE3cy6LuXnDBisVFfoZRS/zytmlBu6leZk5lwW3YGaHKi1L+gWilxLfjwff958ys8vAi7tErre0tLza39+/Yn9PTT3B1vppYBSj/J0gbgBzpDu+YOSNh/VufF+R+G44vu9PAsfMrACEkm6a2dVcLncxzvwJtCda59qTj0MAAAAASUVORK5CYII="

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAMCAYAAAA9HRKyAAAABHNCSVQICAgIfAhkiAAAAplJREFUaIHtlkFIFGEUx3/v23WzQ63RodBLdOwgBUXqgiDkSl61uRRKJHqIQjpExz11q6SIKJc2L4XWOVhXkg6laZciOoh0jC6Vqxdzd+Z1cDc03N2JXUca53ec7/893vvNGxihyPuHdfxYvYRqF0KrwCFFvwC3yYeSdF/9RUDteHl3D2F7ALgmyFGAwPc2Usq3yi0O7h3l5FAOQACYvn+YtVxahOatail8hlAn8Stfverf10zeawQ7I3Bsq+PAd42p5Fv5SKSui47L3wyaMKzlxkt9DADrhfITaMJsX9e7BE0YyE+UejkQ+K4pbnwLzazlxtGEMWSi50Vor1RXkBiZaF9tu92FTB3oFyRWKSZIjKkD/V605Gsy0T5XvoV2phouGGCoXFBVH6vRtsK1stkAF6gOlj/e4Fs18F015Xd2k2+HISF9Z1lE9in6DOSsQMOG8AMikevkcq8ETimaFSS6zRP4GlVdce1bWRZh/072+79TdOjOt64YEAVAeIExMYXvAAo3sUM3iuH1CgT/tNUiBYdufEvgu2r+xTeiQnrkjQhtiubBWMAnoJu8pAg7rwWOF2srzBIfbvV8KD8xOTIrcNql73fEh1t2rlkfMDkyI9Diyrfy1mAkCSBIGNXniH1iq/D6DZKeDuNL1L3vQjagCgo768q36KjhzM8xhVkAEUI45ikh58PfYVWdI76U8mwQv7LUlFKYhwq+YZ6lpsB3tWQbn6jqHFTc7xk6h8cMknCoM+cUXSheEuHIpjC6AE4vknC8m8SnWJaN2j2qugglfKsuonYPlmXvTJM+wrJscHor7nckZCGi8ufpdKqefHYAhy6E1kJyBsgQiT6i4+Kqh2P4n+lUPWvZQaAz8O0BpXwb0oSjyaLv39wxagimSSYLAAAAAElFTkSuQmCC"

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1239),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1210),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1160),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1151),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1172),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var routerObj = [{
  path: 'selectText',
  name: '',
  title: '选择课文',
  component: __webpack_require__(1144)
}, {
  path: 'home',
  name: 'home',
  title: '首页',
  component: __webpack_require__(1128)
}, {
  path: 'ranks',
  name: '',
  title: '单个作业排名',
  component: __webpack_require__(1136)
}, {
  path: 'selectListenSpeak',
  name: '',
  title: '选择听说模考大题',
  component: __webpack_require__(1141)
}, {
  path: 'checkTSMK',
  name: '',
  title: '听说模考详情',
  component: __webpack_require__(1125)
}, {
  path: 'selectOnlinePaper',
  name: '',
  title: '在线作答预览',
  component: __webpack_require__(1143)
}, {
  path: 'checkOnlinePaper',
  name: '',
  title: '在线作答详情',
  component: __webpack_require__(1124)
}, {
  path: 'watchSinglePaper',
  name: '',
  title: '错题统计',
  component: __webpack_require__(1147)
}, { /*:workId/:content/:effectiveDate/:sendDate/:reviceObject/:workName'*/
  path: 'rankWork',
  name: 'rankWork',
  title: '总排名',
  component: __webpack_require__(1137)
}, {
  path: 'watchStukw',
  name: '',
  title: '查看作业',
  component: __webpack_require__(1149)
}, {
  path: 'watchStudc',
  name: '',
  title: '查看作业',
  component: __webpack_require__(1148)
}, {
  path: 'setHomework',
  name: 'setHomework',
  title: '选择习题册',
  component: __webpack_require__(1145)
}, {
  path: 'publishHomeWork',
  name: 'publishHomeWork',
  title: '书本目录',
  component: __webpack_require__(1102)
}, {
  path: 'readWords',
  name: '',
  title: '单词跟读',
  component: __webpack_require__(1138)
}, {
  path: 'ForgotPwd',
  name: '',
  title: '忘记密码',
  component: __webpack_require__(1123)
}, {

  path: 'personMsg/:userId',
  name: 'personMsg',
  title: '个人中心',
  component: __webpack_require__(1135)
}, {
  path: 'class',
  name: '',
  title: '班级',
  component: __webpack_require__(1126)
}, {
  path: 'schoolMsg',
  name: '',
  title: '校讯通',
  component: __webpack_require__(1117)
}, {
  path: 'register',
  name: '',
  title: '注册',
  component: __webpack_require__(1139)
}, {
  path: 'publishBooks',
  name: 'publishBooks',
  title: '作业',
  component: __webpack_require__(1100)
}, {
  path: 'managePaper',
  name: '',
  title: '管理试卷',
  component: __webpack_require__(1130)
}, {
  path: 'setPaper',
  name: '',
  title: '试卷列表',
  component: __webpack_require__(1122)
}, {
  path: 'selectObject',
  name: '',
  title: '选择布置对象',
  component: __webpack_require__(1142)
}, {
  path: 'selectGrade',
  name: 'selectGrade',
  title: '选择布置班级',
  component: __webpack_require__(1140)
}, {
  path: 'publishFinish',
  name: 'publishFinish',
  title: '布置作业',
  component: __webpack_require__(1101)
}, {
  path: 'classManage',
  name: 'classManage',
  title: '班级管理',
  component: __webpack_require__(1079)
}, {
  path: 'classReport',
  name: 'classReport',
  title: '班级报告',
  component: __webpack_require__(1127)
}, {
  path: 'studentReport',
  name: 'studentReport',
  title: '学生报告',
  component: __webpack_require__(1146)
}, {
  path: 'oneStudentReport',
  name: 'oneStudentReport',
  title: '一份作业的详情',
  component: __webpack_require__(1132)
}];

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/web',
  name: '',
  component: __webpack_require__(1134),
  children: routerObj
}, {
  path: '/api',
  name: '',
  component: __webpack_require__(1133),
  children: routerObj
}, {
  path: '/login',
  name: 'login',
  component: __webpack_require__(1129)
}, {
  path: '/',
  name: 'login',
  redirect: '/login'
}, {
  path: '*',
  component: __webpack_require__(1131)
}]);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _setHomework$login$pu;

/* harmony default export */ __webpack_exports__["a"] = (_setHomework$login$pu = {
	setHomework: '书籍列表',
	login: '登录',
	publishHomeWork: '书籍目录',
	home: '作业',
	personMsg: '个人中心',
	systemMessages: '系统消息',
	readWords: '选择单词',
	selectListenSpeak: '选择听说模考大题',
	selectText: '选择段落',
	class: '班级管理',
	checkOnlinePaper: '在线作答详情',
	selectOnlinePaper: '在线作答预览',
	checkTSMK: '听说模考详情',
	ranks: '单个作业排名',
	rankWork: '总排名',
	register: '注册',
	ForgotPwd: '忘记密码',
	schoolMsg: '校讯通',
	managePaper: '管理试卷',
	publishBooks: '布置作业',
	selectObject: '布置对象',
	watchSinglePaper: '错题统计',
	watchStudc: '查看单词详情',
	watchStukw: '查看课文详情',
	selectGrade: '选择布置对象'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'setHomework', '选择书籍'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'rankWork', '查看成绩'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'classManage', '班级管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'home', '检查作业'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'publishBooks', '确认发布'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'publishFinish', '发布成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'workStatistics', "作业报告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'classReport', '班级报告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'studentReport', '学生报告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_setHomework$login$pu, 'oneStudentReport', '学生报告'), _setHomework$login$pu);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_crumb__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_works__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_user__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_subject__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_toast__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_catalog__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_nav_state__ = __webpack_require__(579);
/*
 * @Author: 大明冯
 * @Date: 2018-08-07 10:50:17
 * @Last Modified by: 大明冯
 * @Last Modified time: 2018-08-07 11:40:39
 */














__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  modules: {
    crumb: __WEBPACK_IMPORTED_MODULE_5__modules_crumb__["a" /* default */],
    works: __WEBPACK_IMPORTED_MODULE_6__modules_works__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_7__modules_user__["a" /* default */],
    subject: __WEBPACK_IMPORTED_MODULE_8__modules_subject__["a" /* default */],
    toast: __WEBPACK_IMPORTED_MODULE_9__modules_toast__["a" /* default */],
    catalog: __WEBPACK_IMPORTED_MODULE_10__modules_catalog__["a" /* default */],
    navstate: __WEBPACK_IMPORTED_MODULE_11__modules_nav_state__["a" /* default */]
  },
  plugins: __WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* default */]
}));

/***/ }),
/* 427 */
/***/ (function(module, exports) {

var Toast = {};
Toast.install = function (Vue, options) {
    var opt = {
        defaultType: 'right', // 默认显示颜色
        duration: '2000' // 持续时间
    };
    for (var property in options) {
        opt[property] = options[property]; // 使用 options 的配置
    }
    Vue.prototype.$toast = function (tips, type) {
        if (type) {
            opt.defaultType = type; // 如果有传type，位置则设为该type
        }
        if (document.getElementsByClassName('vue-toast').length) {
            // 如果toast还在，则不再执行
            return;
        }
        var template = '<div class="vue-toast toast-' + opt.defaultType + '">';
        var imgUrl = void 0;
        if (opt.defaultType == 'right') {
            imgUrl = './static/img/toast-right.png';
        } else {
            imgUrl = './static/img/toast-error.png';
        }
        template += "<img src=" + imgUrl + " /><p>" + tips + '</p></div>';

        var toastTpl = Vue.extend({
            // template: '<div class="vue-toast toast-'+opt.defaultType+'"><p>' + tips + '</p></div>'
            template: template

        });
        var tpl = new toastTpl().$mount().$el;
        document.body.appendChild(tpl);
        setTimeout(function () {
            document.body.removeChild(tpl);
        }, opt.duration);
    };
};
module.exports = Toast;

/***/ }),
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1170),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */,
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(1254)
var prodEnv = __webpack_require__(257)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// // see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(1040)

module.exports = {
  build: {
    env: __webpack_require__(257),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: './',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: true,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(434),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

// see http://vuejs-templates.github.io/webpack for documentation.

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      newNum: "",
      securityNum: "",
      flag: "",
      wait: 60,
      waitCode: false,
      fail: false,
      title: "更换手机号",
      infoShow: true,
      sendCode: false
    };
  },

  // created() {
  //   console.log(this.oldMobile);
  //   // if (this.oldMobile == "") {
  //   //   this.title = "绑定手机号";
  //   //   this.infoShow = false;
  //   // }
  // },
  props: ["layerMB", "oldMobile"],

  watch: {
    layerMB: function layerMB(val) {
      this.$refs.unfold.style.display = "block";
      console.log(this.oldMobile);
      if (this.oldMobile == "未绑定") {
        this.title = "绑定手机号";
        this.infoShow = false;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["removeCrumb", "setCrumb", "setUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    close: function close() {
      this.$refs.unfold.style.display = "none";
      this.newNum = "";
      this.securityNum = "";
      this.waitCode = false;
      this.wait = 60;
    },
    send: function send() {
      var _this = this;

      this.sendCode = true;
      var reg = /^1[34578]\d{9}$/; //验证规则
      if (this.newNum == "") {
        this.$toast("手机号不能为空", "error");
        return false;
      } else if (!reg.test(this.newNum)) {
        this.$toast("号码格式不对，或该号码不支持", "error");
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getsendVerifyCode({
          mobile: this.newNum,
          template_id: 1,
          business_id: __WEBPACK_IMPORTED_MODULE_3__config__["c" /* brandId */]
        }).then(function (res) {
          if (!res.data) {
            _this.$toast(res.msg);
            return false;
          }
          _this.wait = 60;
          _this.waitCode = true;
          _this.$toast("已发送验证码成功", "right");
          _this.countTime();
        });
      }
    },
    countTime: function countTime() {
      var _this2 = this;

      var timer = setInterval(function () {
        if (_this2.wait == 0) {
          _this2.waitCode = false;
          clearInterval(timer);
        } else {
          _this2.wait--;
        }
      }, 1000);
    },
    sure: function sure() {
      var _this3 = this;

      if (!this.securityNum || !this.newNum) {
        // this.$toast("短信验证码不能为空")
        return false;
      }
      if (!this.sendCode) {
        this.$toast("请输入正确的短信验证码");
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getcheckVerifyCode({
        verify_code: this.securityNum,
        business_id: __WEBPACK_IMPORTED_MODULE_3__config__["c" /* brandId */],
        mobile: this.newNum
      }).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.modifyMB();
      });
    },
    modifyMB: function modifyMB() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getMobile({
        verify_code: this.securityNum,
        business_id: __WEBPACK_IMPORTED_MODULE_3__config__["c" /* brandId */],
        mobile: this.newNum
      }).then(function (res) {
        if (!res.data) {
          _this4.$toast(res.msg);
          return false;
        }
        var userInfo = _this4.getUser();
        userInfo.mobile = _this4.newNum;
        _this4.setUser(userInfo);

        _this4.$toast("手机号修改成功", "right");
        _this4.$emit("sureMobile", _this4.newNum);
        _this4.$refs.unfold.style.display = "none";
        _this4.newNum = "";
        _this4.securityNum = "";
      });
    }
  })
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            oldPW: '',
            newPW: '',
            surePW: ''
        };
    },

    props: ['layerPW', 'password'],
    watch: {
        layerPW: function layerPW(val) {
            this.$refs.unfold.style.display = 'block';
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['removeUser']), {
        close: function close() {
            this.$refs.unfold.style.display = 'none';
        },
        sure: function sure() {
            var _this = this;

            if (!this.newPW || !this.oldPW || !this.surePW) {
                return false;
            }
            if (this.oldPW != this.password) {
                this.$toast("旧密码输入错误", 'error');
                return false;
            }
            if (this.oldPW == this.newPW) {
                this.$toast("新密码与旧密码重复", 'error');
                return false;
            }
            if (this.newPW != this.surePW) {
                this.$toast("与新密码输入不符合", 'error');
                return false;
            }

            __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getPassWord({ newPwd: this.surePW, oldPwd: this.password }).then(function (res) {
                if (!res) {
                    return false;
                }
                _this.$toast("修改密码成功", 'right');
                _this.removeUser();
                // this.$router.push({path:'login'});
                window.localStorage.removeItem("user");
                window.localStorage.removeItem("basicData");
                var url = window.location.href;
                if (/\.my\./.test(url)) {
                    window.location.assign(window.location.origin);
                } else {
                    window.location.assign("#/web/login");
                }
            });
            this.oldPW = '';
            this.newPW = '';
            this.surePW = '';
            this.$refs.unfold.style.display = 'none';
        }
    })
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__notice_notice_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userInformation: this.getUser(),
      isNotice: false,
      params: {},
      initLogo: "static/img/photo.png"
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.userInf();
    });
  },

  components: {
    notice: __WEBPACK_IMPORTED_MODULE_4__notice_notice_vue___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["getUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(["setUser", "removeUser"]), {
    goPersonal: function goPersonal() {
      var userId = JSON.parse(window.localStorage.user).userId.toString();
      this.$router.push({ path: "/web/personMsg/" + userId });
    },


    // 退出登录
    logout: function logout() {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 1,
        noticeText: "确认退出账号登录!",
        noticeTitle: "确认退出"
      };
    },
    isConfirm: function isConfirm(val) {
      if (val) {
        window.localStorage.setItem("Checked", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ isChecked: false }));
        this.userInformation = {};
        this.removeUser();
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("basicData");
        window.sessionStorage.removeItem("studentsTemp");
        window.sessionStorage.removeItem("studentsListData");
        var url = window.location.href;
        if (/\.my\./.test(url)) {
          window.location.assign(window.location.origin);
        } else {
          window.location.assign("#/login");
        }
      }
    },
    userInf: function userInf() {
      this.userInformation = this.getUser();
      this.userInformation.avatar = this.userInformation.avatar || this.initLogo;
    },


    // 获取系统消息
    getData: function getData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getSystemMessages(this.param).then(function (res) {
        if (!res) {
          return;
        }
        _this2.arr = res.data.pageList;
      });
    }
  })
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  // props: ['cover','bookName','serviceId','serviceName','packageId', 'subject'],
  props: ["booksData", "type"],
  data: function data() {
    return {
      paper: this.booksData,
      defaultBook: "../../assets/img/default.png"
    };
  },
  created: function created() {
    this.getRecengBook();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["getUser"]), {
    setTop: function setTop() {
      this.$emit("setTop", {
        top: 1,
        productId: this.booksData.productId,
        serviceId: this.booksData.serviceId
      });
    },
    view: function view() {
      // if(window.localStorage.user && window.localStorage.user != "underfined"){
      // 	const userInfo = JSON.parse(window.localStorage.getItem("user"));
      // }

      var userInfo = this.getUser();
      var query = {
        versionId: this.booksData.examinationID,
        brandId: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */],
        clientId: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */],
        userId: userInfo.userId
      };
      this.$router.push({ path: "selectOnlinePaper", query: query });
    },
    getRecengBook: function getRecengBook() {
      // let params = {
      //     bookId: this.booksData.packageId,
      //     userId: this.getUser().userId
      // }
      // fetch.getRecentPublishBokk(params).then(res=>{
      //     if (!res) {
      //         return false
      //     }
      // })
    }
  })
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      checkedStudents: this.selectObj.checkedStudents,
      students: this.selectObj.studentArr,
      classId: this.selectObj.classId,
      className: this.selectObj.className,
      isIndeterminate: false,
      checkAll: false
    };
  },

  props: ['selectObj', 'index'],
  methods: {
    // 点击单个班级事件
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.students.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.students.length;
      this.$emit('selectedClass', this.checkedStudents, this.students, this.classId);
    },

    // 点击年级全选按钮事件
    handleCheckAllChange: function handleCheckAllChange(event) {
      var arr = [];
      this.selectObj.studentArr.forEach(function (item) {
        arr.push(item.userId);
      });
      this.checkedStudents = event.target.checked ? arr : [];
      this.isIndeterminate = false;
      this.$emit('selectedClass', this.checkedStudents, this.students, this.classId);
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selecter_selecter_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selecter_selecter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__selecter_selecter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch_http__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			province: '',
			city: '',
			district: '',
			provinces: [],
			cities: [],
			districts: [],
			province_text: "请选择省",
			city_text: "请选择市",
			district_text: "请选择区"
		};
	},

	components: {
		selecter: __WEBPACK_IMPORTED_MODULE_0__selecter_selecter_vue___default.a
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			_this.initSeletList();
		});
	},

	methods: {
		initSeletList: function initSeletList() {
			var _this2 = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fetch_http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* http */] + '/gateway/v5/areas/', {}, 'get').then(function (res) {
				if (res) {
					var data = res.data;
					for (var i = 0; i < data.length; i++) {
						var pl = {
							id: data[i].areaCode,
							name: data[i].areaName
						};
						_this2.provinces.push(pl);
					}
				}
			});
		},
		selecter: function selecter(obj) {
			var _this3 = this;

			if (obj.key == 'province') {
				this.cities = [];
				this.province_text = obj.text;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fetch_http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* http */] + '/gateway/v5/areas/' + obj.value + '', { code: obj.value }, 'get').then(function (res) {
					if (res) {
						var data = res.data;
						for (var i = 0; i < data.length; i++) {
							var pl = {
								id: data[i].areaCode,
								name: data[i].areaName
							};
							_this3.cities.push(pl);
						}
						_this3.city_text = '请选择市';
						_this3.district_text = '请选择区';
					}
				});
				this.$emit('selectAreas', { 'id': obj.value, 'type': obj.key });
			} else if (obj.key == 'city') {
				this.districts = [];
				this.city_text = obj.text;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fetch_http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* http */] + '/gateway/v5/areas/' + obj.value + '', { code: obj.value }, 'get').then(function (res) {
					if (res) {
						var data = res.data;
						for (var i = 0; i < data.length; i++) {
							var pl = {
								id: data[i].areaCode,
								name: data[i].areaName
							};
							_this3.districts.push(pl);
						}
					}
				});
				this.district_text = '请选择区';
				this.$emit('selectAreas', { 'id': obj.value, 'type': obj.key });
			} else {
				this.district_text = obj.text;
				this.$emit('selectAreas', { 'id': obj.value, 'type': obj.key });
			}
		}
	}
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['id', 'title', 'setQuestionId'],
    data: function data() {
        return {
            questionId: []
        };
    },

    watch: {
        setQuestionId: function setQuestionId(val) {
            this.$emit('selectedClass', { id: this.id, 'checked': val ? 1 : 0 });
        }
    }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selecter_selecter_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selecter_selecter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__selecter_selecter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_originSelect_originSelect__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_originSelect_originSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_originSelect_originSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["moduleId", "item", "serviceId", "packageId", "cId", "index", "readTime"],

  data: function data() {
    return {
      ResType_DanCiGenDu: "a7527f97-14e6-44ef-bf73-3039033f128e",
      ResType_Xuanzeduanluo: "992a5055-e9d0-453f-ab40-666b4d7030bb",
      ResType_Zaixianzuoda: "c458a8d4-e3ca-403c-b6b2-ae166e955590",
      chooseTotal: "",
      speektypes: [],
      readTimes: [{ id: 1, name: "1次" }, { id: 2, name: "2次" }, { id: 3, name: "3次" }],
      textNum: "",
      speek_text: "",
      time_text: "1次",
      timesId: 0,
      typesId: 0
    };
  },

  components: {
    selecter: __WEBPACK_IMPORTED_MODULE_2__selecter_selecter_vue___default.a,
    OriginSelect: __WEBPACK_IMPORTED_MODULE_4__components_originSelect_originSelect___default.a
  },
  created: function created() {
    var _this = this;

    this.chooseSpeek();
    this.$nextTick(function () {
      var resourceType = _this.item.resourceType;
      if (resourceType == _this.ResType_DanCiGenDu || resourceType == _this.ResType_Xuanzeduanluo) {
        _this.keep();
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getWorks"]), {
    chooseSpeek: function chooseSpeek() {
      if (this.item.resourceType == this.ResType_DanCiGenDu || this.moduleId == 30) {
        this.speek_text = "跟读";
        this.item.chooseText = "选择单词";
        this.speektypes = [{ id: 1, name: "跟读" }, { id: 2, name: "朗读" }];
        this.textNum = this.item.itemCount ? "已选 &nbsp;" + '<i style="color:#01B98F">' + this.item.itemCount + "&nbsp;</i>" + "个单词" : "全选";
      } else if (this.item.resourceType == this.ResType_Xuanzeduanluo) {
        this.speek_text = "跟读";
        this.item.chooseText = "选择段落";
        this.speektypes = [{ id: 1, name: "跟读" }, { id: 2, name: "朗读" }, { id: 3, name: "背诵" }];
        this.textNum = this.item.itemCount ? "已选 &nbsp;" + '<i style="color:#01B98F">' + this.item.itemCount + "&nbsp;</i>" + "</i>个段落" : "全选";
      } else if (this.moduleId == 15) {
        this.item.chooseText = "选择大题";
        this.textNum = this.item.itemCount ? "已选 &nbsp;" + '<i style="color:#01B98F">' + this.item.itemCount + "&nbsp;</i>" + "个大题" : "全选";
      } else if (this.item.resourceType == this.ResType_Zaixianzuoda) {
        this.textNum = "";
        this.item.chooseText = "选择大题";
      } else if (this.moduleId == 66) {
        this.item.chooseText = "预览";
      }
    },
    keep: function keep() {
      var works = this.getWorks();
      if (!works.contents || !works.contents.length) {
        return;
      }
      var contents = works.contents;
      for (var i = 0, len = contents.length; i < len; i++) {
        var item = contents[i];
        if (item.parentVersionId == this.item.parentVersionId && item.versionId == this.item.versionId && item.moduleId == this.moduleId) {
          this.timesId = item.readtimes;
          this.typesId = item.speekingtype;
          break;
        }
      }

      // this.speek_text = this.speektypes[this.typesId-1].name
      // this.time_text = this.readTimes[this.timesId-1].name
      //   this.speek_text = this.speektypes[this.typesId].name;
      //   this.time_text = this.readTimes[this.timesId].name;
    },
    selecter: function selecter(obj) {
      // if(obj.key == 'types') {
      // 	this.typesId = obj.value;
      // 	this.speek_text = obj.text;
      // } else if(obj.key == 'times') {
      // 	this.timesId = obj.value;
      // 	this.time_text = obj.text;
      // }
      if (obj.key == "types") {
        this.typesId = obj.index + 1;
        this.speek_text = obj.value;
      } else if (obj.key == "times") {
        this.timesId = obj.index + 1;
        this.time_text = obj.value;
      }

      var item = this.item;
      item.requirementContent = {
        readtimes: this.timesId,
        speekingtype: this.typesId
      };
      item.readtimes = this.timesId;
      item.speekingtype = this.typesId;
      var params = {
        versionId: item.versionId,
        parentVersionId: item.parentVersionId,
        resourceType: item.resourceType,
        requirementContent: {
          readtimes: this.timesId,
          speekingtype: this.typesId
        },
        index: this.index,
        item: item
      };
      this.$emit("changeParams", params);
    }
  })
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__group__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__group__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectTitle: [{ title: "学生列表" }, { title: "小组管理" }],
      changeStyle: 0,
      newStuList: [],
      classIndex: "",
      classId: '',
      studentsList: ''
    };
  },

  components: {
    groups: __WEBPACK_IMPORTED_MODULE_2__group___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.getClass();
    });
  },

  watch: {
    $route: "getClass"
  },
  methods: {
    toggle: function toggle(index) {
      this.changeStyle = index;
      this.getClass();
    },


    // clildData(val) {
    //   console.log(val);
    //   if (val) {
    //     let param = {
    //       classIds: this.classId,
    //       userRole: 1
    //     };
    //     this.getStuList(param);
    //   }
    // },

    getClass: function getClass() {
      this.classIndex = this.$route.query.index;
      this.studentsList = JSON.parse(window.sessionStorage.getItem("studentsListData"))[this.classIndex];
      this.newStuList = this.studentsList.data;
      this.classId = this.studentsList.classId;
      console.log(this.studentsList);
    },


    // 获取班级数据
    getStuList: function getStuList(param) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getMemberlist(param).then(function (res) {
        if (!res) {
          return false;
        }
        var newData = res.data[0];
        var students = _this2.getGroups(newData.data);
        var studentsListData = JSON.parse(window.sessionStorage.getItem("studentsListData"));
        window.sessionStorage.setItem("studentsListData", "");

        var _loop = function _loop(i, len) {
          var item = studentsListData[i];
          var arr = [];
          if (newData.classId == item.classId) {
            item.students = students;
            item.data = newData.data;
            students.newStu.map(function (sItem) {
              arr.push(sItem);
            });
            item.students = arr;
            return "break";
          }
        };

        for (var i = 0, len = studentsListData.length; i < len; i++) {
          var _ret = _loop(i, len);

          if (_ret === "break") break;
        }
        window.sessionStorage.setItem("studentsListData", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(studentsListData));
        _this2.getClass();
        console.log(studentsListData, "new");
      });
    },


    // 获取班级的分组，对分组进行处理
    getGroups: function getGroups(students) {
      var group = {};
      var newStu = [];
      var groupTitles = [];
      var student_count = 0;
      students.sort(function (a, b) {
        return a.userName.localeCompare(b.userName);
      });
      for (var index = 0, len = students.length; index < len; index++) {
        var _item = students[index];
        if (_item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        _item.teamName = _item.teamName || "未分组";
        var same_index = groupTitles.indexOf(_item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: _item.teamName,
            data: [_item],
            count: 1,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          var _group = newStu[same_index];
          _group.data.push(_item);
          _group.count += 1;

          newStu[same_index] = _group;
        }
        student_count++;
      }
      return { newStu: newStu, student_count: student_count };
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notice_notice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notice_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__notice_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      groups: [],
      isNotice: false,
      groupsLength: "",
      params: {},
      classid: ""
    };
  },

  components: {
    notice: __WEBPACK_IMPORTED_MODULE_2__notice_notice___default.a
  },
  props: ["index"],
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.getStudentsList();
    });
  },

  watch: {
    $route: "getStudentsList"
  },
  methods: {
    addGroup: function addGroup() {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 9,
        noticeTitle: "新建小组",
        identify: "addGroup",
        addGroups: this.groups,
        classid: this.classid
      };
    },
    edit: function edit(index) {
      this.isNotice = !this.isNotice;
      var allGroups = [];
      var editGroups = this.groups[index];
      this.groups.map(function (item) {
        if (item.title == editGroups.title) {
          return false;
        } else {
          allGroups.push(item);
        }
      });
      allGroups.map(function (item) {
        item.data.map(function (child) {
          child.checked = false;
        });
      });
      editGroups.data.map(function (sItem) {
        sItem.checked = true;
      });

      this.params = {
        type: 9,
        noticeTitle: "编辑小组",
        identify: "edit",
        editGroups: editGroups,
        allGroups: allGroups,
        classid: this.classid
      };
    },
    delTeam: function delTeam(index) {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 10,
        noticeTitle: "删除确认",
        identify: "delete",
        groups: this.groups[index]
      };
    },
    isConfirm: function isConfirm(val) {
      if (val) {
        var param = {
          classIds: this.classid,
          userRole: 1
        };
        this.getStuList(param);
      }
    },
    getStudentsList: function getStudentsList() {
      var groupsList = JSON.parse(window.sessionStorage.getItem("studentsListData"))[this.index];
      this.classid = groupsList.classId;
      this.groups = groupsList.students;
      this.groupsLength = groupsList.students.length;
      for (var i = 0; i < this.groups.length; i++) {
        var item = this.groups[i];
        if (item.title == "未分组") {
          this.groupsLength = this.groups.length - 1;
        }
      }
    },


    // 获取班级数据
    getStuList: function getStuList(param) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getMemberlist(param).then(function (res) {
        if (!res) {
          return false;
        }
        var newData = res.data[0];
        var students = _this2.getGroups(newData.data);
        var studentsListData = JSON.parse(window.sessionStorage.getItem("studentsListData"));
        window.sessionStorage.setItem("studentsListData", "");

        var _loop = function _loop(i, len) {
          var item = studentsListData[i];
          var arr = [];
          if (newData.classId == item.classId) {
            item.students = students;
            item.data = newData.data;
            students.newStu.map(function (sItem) {
              arr.push(sItem);
            });
            item.students = arr;
            return "break";
          }
        };

        for (var i = 0, len = studentsListData.length; i < len; i++) {
          var _ret = _loop(i, len);

          if (_ret === "break") break;
        }
        window.sessionStorage.setItem("studentsListData", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(studentsListData));_this2.getStudentsList();
        // console.log(studentsListData, "new");
      });
    },


    // 获取班级的分组，对分组进行处理
    getGroups: function getGroups(students) {
      var group = {};
      var newStu = [];
      var groupTitles = [];
      var student_count = 0;
      students.sort(function (a, b) {
        return a.userName.localeCompare(b.userName);
      });
      for (var index = 0, len = students.length; index < len; index++) {
        var _item = students[index];
        if (_item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        _item.teamName = _item.teamName || "未分组";
        var same_index = groupTitles.indexOf(_item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: _item.teamName,
            data: [_item],
            count: 1,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          var _group = newStu[same_index];
          _group.data.push(_item);
          _group.count += 1;

          newStu[same_index] = _group;
        }
        student_count++;
      }
      return { newStu: newStu, student_count: student_count };
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["defalutTitle"],
  data: function data() {
    return {
      title: "",
      change: false
    };
  },

  methods: {
    modify: function modify() {
      this.title = this.defalutTitle;
      this.change = !this.change;
    },
    handler: function handler() {
      this.change = false;
      this.$emit("changeTitle", this.title);
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selecter_selecter_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selecter_selecter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_selecter_selecter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progressBar_progressBar_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progressBar_progressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_progressBar_progressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showName: false,
      TimeStatus: 2,
      timeStamp: "",
      timeStampText: "",
      Timetext: ["已截止", "进行中", "待发布"],
      d: "",
      h: "",
      m: "",
      isNotice1: false,
      params1: {},
      isNotice2: false,
      params2: {},
      operationText: "操作",
      operations: [{ name: "一键催交" }, { name: "撤回作业" }],
      index: "", //用户点击操作的对应的下标
      option_text: ["一键催交", "成绩汇总", "撤回作业"],
      remindType: 0
    };
  },

  components: {
    notice: __WEBPACK_IMPORTED_MODULE_1__components_notice_notice_vue___default.a,
    selecter: __WEBPACK_IMPORTED_MODULE_2__components_selecter_selecter_vue___default.a,
    progressBar: __WEBPACK_IMPORTED_MODULE_3__components_progressBar_progressBar_vue___default.a
  },
  props: ["content", "delIndex", "PageIndex"],
  created: function created() {
    this.$nextTick(function () {});
  },


  methods: {
    enter: function enter() {
      this.showName = true;
    },
    leave: function leave() {
      this.showName = false;
    },
    isConfirm1: function isConfirm1(val) {
      var _this = this;

      if (val) {
        var userId = JSON.parse(window.localStorage.user).userId.toString();
        var contents = this.content.workList[this.index];
        __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].urgeWorks({
          workId: contents.workId,
          userId: userId
        }).then(function (res) {
          if (!res) {
            return false;
          }
          _this.$toast("催交作业成功", "right");
        });
      }
    },
    isConfirm2: function isConfirm2(val) {
      var _this2 = this;

      if (val) {
        var contents = this.content.workList[this.index];
        __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].delWork({ workId: contents.workId }).then(function (res) {
          if (!res) {
            return false;
          }
          _this2.$emit("removeWork", _this2.index, _this2.delIndex);
          _this2.$toast("撤回作业成功", "right");
        });
      }
    },
    toRank: function toRank(item, index) {
      if (item.resourceType && (item.resourceType == "803ef46d-e0cc-4f97-b1eb-b3ef411d058e" || item.resourceType == "eb5d05a2-d604-4879-8f9a-be5a45ae414e")) {
        return false;
      }
      console.log(item, "777");

      var params = {
        workId: item.workId,
        effectiveDate: this.content.effectiveDate, // 截止时间
        sendDate: this.content.sendDate, // 布置时间(定时发布)
        publishDate: this.content.publishDate, // 布置时间(立即发布)
        index: index, // 索引
        state: this.content.state, // 1为定时发布 0为立即发布
        bookName: this.content.bookName, // 书名
        workMessage: item.workMessage, // 备注信息
        reviceObject: item.reviceObject // 班级
      };
      this.$router.push({
        path: "rankWork",
        query: params
      });
    },

    // 催交作业
    rush: function rush(item, index) {
      this.index = index;
      this.isNotice1 = !this.isNotice1;

      this.params1 = {
        type: 1,
        noticeText: "确定给未交作业的学生发提醒消息？",
        noticeTitle: "催交作业"
      };
    },

    // 撤回作业
    recall: function recall(item, index) {
      this.index = index;

      this.isNotice2 = !this.isNotice2;

      this.params2 = {
        type: 1,
        noticeText: "确定要撤回本次作业？",
        noticeTitle: "撤回作业"
      };
    },
    isClickBtn: function isClickBtn(item, index) {
      item.isShow_recall = !item.isShow_recall;
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chooseText_chooseText_vue__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chooseText_chooseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chooseText_chooseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["resourceName", "sIndex", "resourceList", "serviceId", "packageId", "cId", "moduleInfo", "publishedBooks", "checkedResource"],
  components: {
    chooseText: __WEBPACK_IMPORTED_MODULE_2__chooseText_chooseText_vue___default.a
  },
  data: function data() {
    return {
      ResType_DanCiGenDu: "a7527f97-14e6-44ef-bf73-3039033f128e",
      ResType_Xuanzeduanluo: "992a5055-e9d0-453f-ab40-666b4d7030bb",
      ResType_BaoTingXie: "3ac07125-31ac-11e5-a511-782bcb066f05",
      parentVersion_Id: "",
      version_Id: "",
      selectModules: [],
      selectedTextNumArr: [],
      isChecked: false,
      userTimes: 0
    };
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.addKey();
    });
  },

  watch: {
    resourceList: function resourceList(val) {
      this.addKey();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    addKey: function addKey() {
      var _this3 = this;

      var _this = this;
      this.selectedTextNumArr = this.resourceList;

      this.selectedTextNumArr.forEach(function (item, i) {
        _this3.selectedTextNumArr[i].isShow = false;
        if (_this3.moduleInfo.moduleId == 10 || _this3.moduleInfo.moduleId == 127 || _this3.moduleInfo.moduleId == 30) {
          //同步跟读
          if (item.resourceType == _this3.ResType_DanCiGenDu || item.resourceType == _this3.ResType_BaoTingXie) {
            _this3.selectedTextNumArr[i].chooseText = "选择单词";
          } else if (item.resourceType == _this3.ResType_Xuanzeduanluo) {
            _this3.selectedTextNumArr[i].chooseText = "选择段落";
          }
        } else if (_this3.moduleInfo.moduleId == 15 || _this3.moduleInfo.moduleId == 124) {
          _this3.selectedTextNumArr[i].chooseText = "选择大题";
        } else {
          _this3.selectedTextNumArr[i].chooseText = '预览';
        }
      });

      this.getPublished();
    },
    getPublished: function getPublished() {
      var _this4 = this;

      // console.log(this.publishedBooks, '++++++', this.resourceList, this.cId * 1)
      this.resourceList.map(function (stitem) {
        stitem.isPublished = false;
        _this4.publishedBooks.map(function (item) {
          if (item.cId == _this4.cId * 1) {
            item.subjectList.map(function (sItem) {
              if (sItem.resourceType == stitem.resourceType && sItem.resourceName == stitem.resourceName && sItem.versionId == stitem.versionId) {
                stitem.isPublished = true;
              } else if (sItem.resourceName == stitem.resourceName) {
                stitem.isPublished = true;
              }
            });
          }
        });
        return stitem;
      });
      this.selectedTextNumArr = this.resourceList;
    },
    increment: function increment(e, item, resourceType) {
      item.isChecked = !item.isChecked;
      var params = {
        isChecked: item.isChecked,
        versionId: item.versionId,
        parentVersionId: item.parentVersionId,
        change: true,
        moduleId: this.moduleInfo.moduleId,
        resourceType: resourceType,
        requirementContent: {
          readtimes: 1,
          speekingtype: 1
        },
        time: 0,
        refLong: item.refLong,
        resourceName: item.resourceName
      };
      this.getUseTimes(params);
    },
    changeParams: function changeParams(res) {
      // let params = {
      //   isChecked: true,
      //   versionId: res.versionId,
      //   change: false,
      //   moduleId: this.moduleInfo.moduleId,
      //   resourceType: res.resourceType,
      //   parentVersionId: res.parentVersionId,
      //   requirementContent: res.requirementContent
      // };
      var changeData = {
        itemCount: res.item.itemCount,
        defAnswerTime: res.item.defAnswerTime,
        bigItemCount: res.item.bigItemCount,
        sentenceCount: res.item.sentenceCount
      };
      this.reBackData(res.item, changeData);
      // this.getUseTimes(params);
    },
    getUseTimes: function getUseTimes(res) {
      var _this5 = this;

      var params = {
        moduleId: res.moduleId,
        versionId: res.versionId,
        parentVersionId: res.parentVersionId,
        resourceType: res.resourceType
      };
      __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].getAllCount(params).then(function (result) {
        if (!result) {
          return false;
        }
        var data = result.data;
        _this5.reBackData(res, data);
      });
    },
    reBackData: function reBackData(res, data) {
      if (res.resourceType === "992a5055-e9d0-453f-ab40-666b4d7030bb") {
        res.refLong = data.refAnswerTime || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDataToMinutes"])(data.sentenceCount * data.defAnswerTime * res.requirementContent.readtimes);
      } else if (res.resourceType === "a7527f97-14e6-44ef-bf73-3039033f128e" || res.resourceType === "3ac07125-31ac-11e5-a511-782bcb066f05") {
        res.refLong = data.refAnswerTime || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDataToMinutes"])(data.itemCount * data.defAnswerTime * res.requirementContent.readtimes);
      } else {
        res.refLong = data.refAnswerTime || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDataToMinutes"])(data.defAnswerTime * data.itemCount);
      }
      res.itemCount = data.itemCount; // 题目数量
      res.bigItemCount = data.bigItemCount || 0; // 题目数量
      res.sentenceCount = data.sentenceCount || 0;
      res.defAnswerTime = data.defAnswerTime;
      res.refScore = data.refScore || 100;
      if (res.time) {
        res.refLong = 0;
      }
      this.$emit("increment", res);
    },

    // 跳转
    goDetail: function goDetail(item, index) {
      if (!item.isChecked) {
        this.$toast("请选择布置内容！", "error");
        return false;
      }
      var moduleId = this.moduleInfo.moduleId;
      var url = window.location.href;
      url = url.split('&isFirst=1')[0] + '&isFirst=1';
      var http = "/exam/#/";
      var userdata = this.getUser();
      var params = "?parentVersionId=" + this.resourceList[index].parentVersionId + "&versionId=" + this.resourceList[index].versionId + "&resourceType=" + this.resourceList[index].resourceType + "&moduleId=" + this.moduleInfo.moduleId + "&checkedResource=" + item.checkedResource + "&accessToken=" + userdata.accessToken + "&clientId=" + userdata.clientId + "&redirectUrl=" + url;
      if (moduleId == 10 || moduleId == 30) {
        //单词跟读
        if (this.resourceList[index].resourceType == this.ResType_DanCiGenDu || this.resourceList[index].resourceType == this.ResType_BaoTingXie) {
          window.location.href = http + "selectDanci" + params;
          //选择段落
        } else if (this.resourceList[index].resourceType == this.ResType_Xuanzeduanluo) {
          window.location.href = http + "selectJuzi" + params;
        }
      } else if (moduleId == 124 || moduleId == 15) {
        // 听说模考
        window.location.href = http + "selectExam" + params;
      } else if (moduleId == 66) {
        // 互动教程
        window.location.href = http + "selectInteract" + params;
      }
    }
  })
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      navData: [],
      current: [0, 0],
      isShow: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.navData = [{
        title: "作业",
        child: [{
          title: "布置作业",
          path: "/web/selectGrade"
        }, {
          title: "检查作业",
          path: "/web/home"
        }]
      }];
      _this.current = _this.getNavSate();
      _this.getClass();
    });
  },

  watch: {
    nvaState: function nvaState(newVal) {
      this.current = newVal;
    }
  },
  computed: {
    nvaState: function nvaState() {
      return this.getNavSate();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setState"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getNavSate"]), {
    toggle: function toggle(sindex, index, item) {
      this.current = [sindex, index];
      this.setState(this.current);
      var params = { path: item.path };
      if (sindex) {
        params.query = { index: index };
      }
      this.$router.push(params);
    },
    getClass: function getClass() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].grads({ userRole: 2, exists: 1 }).then(function (grads) {
        if (!grads) return false;
        var arr = [];
        for (var i = 0; i < grads.data.length; i++) {
          var item = grads.data[i];
          arr.push({
            title: item.className,
            path: "/web/classManage"
          });
        }
        _this2.navData.push({
          child: arr,
          title: "班级"
        });
      });
    }
  })
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_periods__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkArea_checkArea_vue__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkArea_checkArea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__checkArea_checkArea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfirm: false,
      gradsArr: __WEBPACK_IMPORTED_MODULE_0__data_periods__["a" /* elementaryPeriods */],
      addClassList: [{
        isShowUl: false,
        currentText: "",
        currentGrad: "",
        currentPeriod: "",
        className: ""
      }],
      step: 1,
      areaCode: "",
      keyWords: "",
      schoolList: [],
      title: this.params.noticeTitle,
      param: "",
      schoolId: this.params.currentClass.schoolId || "",
      schoolName: this.params.currentClass.schoolName || "",
      abolishText: "取消",
      ensureText: "确定",
      PageIndex: 0,
      PageCount: 1,
      clickFlag: true
    };
  },

  props: ["params"],
  components: {
    checkArea: __WEBPACK_IMPORTED_MODULE_1__checkArea_checkArea_vue___default.a,
    paging: __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue___default.a
  },
  watch: {
    step: function step(val) {
      if (val == 2) {
        // this.getData();
      }
    }
  },
  created: function created() {
    if (this.params.currentClass.schoolName.indexOf("小学") > -1) {
      this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["a" /* elementaryPeriods */];
    } else if (this.params.currentClass.schoolName.indexOf("中学") > -1) {
      this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["b" /* juniorPeriods */];
    } else if (this.params.currentClass.schoolName.indexOf("初中") > -1) {
      this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["b" /* juniorPeriods */];
    } else {
      this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["c" /* periods */];
    }
  },

  methods: {
    abolish: function abolish() {
      if (this.step == 3) {
        this.addClassList = [{
          isShowUl: false,
          currentText: "",
          currentGrad: "",
          currentPeriod: "",
          className: ""
        }];
        this.abolishText = "取消";
        this.ensureText = "确定";
        this.schoolName = "";
        this.title = "创建班级";
        this.step = 1;
      } else {
        this.$emit("isConfirm", this.isConfirm);
      }
    },
    ensure: function ensure() {
      var _this = this;

      if (!this.clickFlag) {
        return false;
      }
      if (this.step == 1) {
        this.clickFlag = false;
        if (this.addClassList[0].currentText == "") {
          this.$toast("请选择年级", "error");
          return;
        } else if (this.addClassList[0].className == "") {
          this.$toast("请输入班级名字", "error");
          return;
        }
        for (var i = 0, len = this.addClassList.length; i < len; i++) {
          var item = this.addClassList[i];
          var addClassObj = {
            uId: __WEBPACK_IMPORTED_MODULE_4__config__["c" /* brandId */],
            className: item.className,
            period: item.currentPeriod,
            grade: item.currentGrad,
            schoolId: this.schoolId
          };
          __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].createClass(addClassObj).then(function (res) {
            if (!res) {
              return false;
            }
            if (res) {
              _this.step = 3;
              _this.abolishText = "继续添加";
              _this.ensureText = "查看我的班级";
              _this.clickFlag = true;
              console.log(res);
            }
          });
        }
      } else if (this.step == 3) {
        this.isConfirm = true;
        this.$emit("isConfirm", this.isConfirm);
      }
    },
    closeNotice: function closeNotice() {
      // this.isConfirm = false;
      this.$emit("isConfirm", this.isConfirm);
    },
    oneMoreClass: function oneMoreClass() {
      this.addClassList.push({
        isShowUl: false,
        currentText: "",
        currentGrad: "",
        currentPeriod: ""
      });
    },
    showUl: function showUl(index) {
      this.addClassList[index].isShowUl = !this.addClassList[index].isShowUl;
    },
    closeUl: function closeUl() {
      for (var i = 0, len = this.addClassList.length; i < len; i++) {
        this.addClassList[i].isShowUl = false;
      }
    },
    checkGrad: function checkGrad(item, index) {
      this.addClassList[index].isShowUl = false;
      this.addClassList[index].currentText = item.text;
      this.addClassList[index].currentGrad = item.grade;
      this.addClassList[index].currentPeriod = item.period;
    },
    modify: function modify() {
      if (schoolId > 0) {
        return false;
      }
      this.step = 2;
      this.title = "选择学校";
    },

    //选择学校系列方法
    setParams: function setParams() {
      this.param = {
        page: this.PageIndex,
        pagesize: 10
      };
      if (this.keyWords || this.areaCode) {
        this.param.areaCode = this.areaCode;
        this.param.wd = this.keyWords;
      }
    },
    selectAreas: function selectAreas(obj) {
      if (obj.type != "province") {
        this.PageIndex = 1;

        var id = obj.id;
        this.areaCode = id;
        this.getData();
      }
    },
    getData: function getData() {
      var _this2 = this;

      this.setParams();
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getSchool(this.param).then(function (res) {
        if (!res) {
          return false;
        }
        _this2.schoolList = res.data;
        _this2.PageCount = Math.ceil(res.total / _this2.param.pagesize);
      });
    },
    search: function search() {
      this.PageIndex = 1;
      if (!this.keyWords.trim()) {
        this.getData();
      }
      this.getData();
    },
    checkSchool: function checkSchool(item) {
      switch (item.period) {
        case 2:
          this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["a" /* elementaryPeriods */];
          break;
        case 4:
          this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["c" /* periods */];
          break;
        case 12:
          this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["b" /* juniorPeriods */];
          break;
        default:
          this.gradsArr = __WEBPACK_IMPORTED_MODULE_0__data_periods__["c" /* periods */];
      }
      this.schoolName = item.schoolName;
      this.title = "创建班级";
      this.schoolId = item.schoolId;
      this.step = 1;
    },
    deleteAdd: function deleteAdd(index) {
      this.addClassList.splice(index, 1);
    },
    pageNum: function pageNum(num) {
      this.PageIndex = num;
      this.getData();
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfirm: false,
      title: "",
      changeStyle: "",
      keywords: "",
      isSearch: false,
      selectStu: [],
      selCount: 0,
      teamName: "",
      classid: "",
      stustr: "",
      identify: "",
      checked: false,
      editGroups: [],
      selectStudents: [], // 学生列表
      noStudent: false,
      editStu: [],
      isSuccess: false,
      editStuStr: [],
      btnShow: true
      // students: [],  // 原数据
      // students1: [],  // 显示学生列表
      // students2: [],   
      // EditGroup: []
    };
  },

  props: ["params"],
  created: function created() {
    this.title = this.params.noticeTitle;
    this.classid = this.params.classid;

    this.identify = this.params.identify;
    // 新建小组的时候
    if (this.identify == "addGroup") {
      this.addTeam = this.params.addGroups;
      console.log(this.addTeam);
      this.addTeam.map(function (item) {
        item.data.map(function (sItem) {
          sItem.checked = false;
        });
      });
      this.selectStudents = this.params.addGroups;
    }
    // 编辑的时候
    if (this.identify == "edit") {
      this.selectStudents = this.params.allGroups; // 编辑时候左边显示除了本身之外的所有小组

      this.editGroups = this.params.editGroups; // 右边显示本身小组
      var arr = this.editGroups.data; //定义新变量接收本身小组数据
      this.editStu.push(arr);
      var newArr = [];
      newArr.push(arr);
      this.editStu = [].concat.apply([], newArr);
      console.log(this.editStu, "2");
      this.teamName = this.editGroups.title;
      this.teamId = this.editGroups.data[0].teamId;
      // 当用户不选择学生时候直接修改分组，此时传入的学生di即为该分组本身的学生id
      this.getStuStr();
    }
  },


  methods: {
    closeNotice: function closeNotice() {
      this.$emit("isConfirm", this.isConfirm);
    },
    stuToggle: function stuToggle(sitem) {
      sitem.checked = !sitem.checked;
      this.checked = sitem.checked;
      if (this.identify == "edit") {
        this.editStu.push(sitem);
        var editArr = this.editStu;
        this.editStu = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(editArr));
        var newEdit = this.editStu;
        for (var index = 0; index < newEdit.length; index++) {
          var element = newEdit[index];
          if (!element.checked) {
            newEdit.splice(index, 1);
          }
        }

        // 当用户编辑时候选择学生时候，调用函数
        this.getStuStr();
      }

      // 新建学生的时候
      this.selectStu.push(sitem);
      var newArr = this.selectStu;
      this.selectStu = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(newArr)); // 去除重复选择
      for (var j = 0; j < this.selectStu.length; j++) {
        var item = this.selectStu[j];
        if (!item.checked) {
          this.selectStu.splice(j, 1);
        }
      }
      this.selCount = this.selectStu.length;
      //   获取选择的学生id
      var newStu = this.selectStu;
      var stuArr = [];
      for (var i = 0; i < newStu.length; i++) {
        var _item = newStu[i];
        stuArr.push(_item.userId);
      }
      this.stustr = stuArr.join(",");
    },


    // 获取学生的id，进行拼接
    getStuStr: function getStuStr() {
      var editStudents = this.editStu;
      var editStudentsArr = [];
      for (var i = 0; i < editStudents.length; i++) {
        var item = editStudents[i];
        editStudentsArr.push(item.userId);
      }
      this.editStuStr = editStudentsArr.join(",");
      console.log(this.editStuStr, "edit");
    },


    // 搜索学生
    search: function search() {
      if (!this.keywords) {
        this.noStudent = false;
        this.selectStudents = this.params.allGroups;
        return false;
      }
      var newList = [];
      this.btnShow = false;
      for (var i = 0; i < this.selectStudents.length; i++) {
        var stuData = this.selectStudents[i];
        var item = this.selectStudents[i].data;
        var arr = [];
        for (var j = 0; j < item.length; j++) {
          if (item[j].userName.indexOf(this.keywords) > -1) {
            arr.push(item[j]);
            newList.push({
              checked: stuData.checked,
              count: stuData.count,
              data: arr,
              selNum: stuData.selNum,
              teamShow: stuData.teamShow,
              title: stuData.title
            });
          }
        }
      }
      this.selectStudents = newList;
      if (this.selectStudents.length == 0) {
        this.noStudent = true;
      }
      console.log(this.selectStudents);
    },


    // 清空搜索，显示学生列表
    clearInput: function clearInput() {
      this.keywords = "";
      this.noStudent = false;
      this.btnShow = true;
      this.selectStudents = this.params.addGroups;
      if (this.identify == "edit") {
        this.selectStudents = this.params.allGroups;
      }
    },


    // 删除已选学生
    deleteStu: function deleteStu(sitem, sIndex) {
      this.editStu.splice(sIndex, 1);
      sitem.checked = false;
      this.getStuStr();
    },
    deleteAddStu: function deleteAddStu(item, index) {
      this.selectStu.splice(index, 1);
      item.checked = false;
      this.selCount = this.selectStu.length;
      console.log();
    },


    // 取消选择
    abolish: function abolish() {
      this.$emit("isConfirm");
    },


    // 确定
    ensure: function ensure() {
      var _this = this;

      var identify = this.identify;
      if (this.teamName == "") {
        this.$toast("请输入分组名称", "error");
        return false;
      }

      switch (identify) {
        case "addGroup":
          if (this.teamName == "未分组") {
            this.$toast("不能新建未分组");
            return false;
          }
          if (!this.checked) {
            this.$toast("请至少选择一个学生", "error");
            return false;
          }
          for (var i = 0; i < this.addTeam.length; i++) {
            var item = this.addTeam[i];
            if (this.teamName == item.title) {
              this.$toast("该小组名称已存在，请重新输入小组名称");
              return false;
            }
          }
          var params = {
            teamname: this.teamName,
            classid: this.classid,
            stustr: this.stustr
          };
          __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].addTeam(params).then(function (res) {
            if (!res.data) {
              return false;
            }
            _this.isSuccess = true;
            _this.$emit("isConfirm", _this.isSuccess);
          });
          break;
        case "edit":
          var params1 = {
            teamid: this.teamId,
            teamname: this.teamName,
            classid: this.classid,
            stustr: this.editStuStr
          };
          __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].ediTeam(params1).then(function (res) {
            if (!res) {
              return false;
            }
            _this.isSuccess = true;
            _this.$emit("isConfirm", _this.isSuccess);
          });
          break;
      }
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfirm: false,
      isNewStudent: false,
      isChecked: false,
      userId: "",
      newStudentInf: "",
      studentNames: "",
      studentsArr: [],
      isRandomPwd: 0,
      initialPwd: 123456,
      isSearch: false
    };
  },

  props: ["params"],
  created: function created() {
    console.log(this.params);
  },

  methods: {
    abolish: function abolish() {
      this.$emit("isConfirm", this.isConfirm);
    },
    ensure: function ensure() {
      var _this = this;

      var that = this;
      if (this.studentNames == "") {
        this.$toast("请输入学生的姓名~", "error");
        return false;
      }
      var userArr = this.studentNames.split(/\s/);
      for (var i = userArr.length - 1, len = 0; i > len; i--) {
        debugger;
        var item = userArr[i];
        if (item == "") {
          userArr.splice(i, 1);
        }
      }
      var initialLength = userArr.length;
      var classStudent = this.params.classStudent;
      var repetitiveName = [];
      if (classStudent.length > 0) {
        classStudent.forEach(function (item1) {
          userArr.forEach(function (item2, index) {
            if (item1.userName == item2) {
              repetitiveName.push(item1.userName);
              userArr.splice(index, 1);
            }
          });
        });
      }
      userArr.forEach(function (item) {
        that.studentsArr.push({ name: item });
      });
      var repetitiveStr = repetitiveName[0];
      if (that.studentsArr.length == 0) {
        if (initialLength == 0) {
          this.$toast("请输入学生的姓名~", "error");
          return false;
        } else {
          this.$toast("班级已有" + repetitiveStr + "等人,请勿重复添加!", "error");
          return false;
        }
      }
      var param = {
        brandId: this.params.currentClass.brandId,
        schoolId: this.params.currentClass.schoolId,
        classId: this.params.currentClass.classId,
        isRandomPwd: this.isRandomPwd,
        userList: this.studentsArr,
        initialPwd: this.initialPwd
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].createStudent(param).then(function (res) {
        if (!res) {
          return false;
        }
        if (res) {
          var toastStr = "";
          if (res.data.length == initialLength) {
            toastStr = "已成功添加" + res.data.length + "个学生";
          } else {
            toastStr = "已成功添加" + res.data.length + "个学生,班级已有" + repetitiveStr + "等人,请勿重复添加";
          }
          _this.$toast(toastStr, "right");
          _this.isConfirm = true;
          _this.$emit("isConfirm", _this.isConfirm);
        }
      });
    },
    closeNotice: function closeNotice() {
      // this.isConfirm = false;
      this.$emit("isConfirm", this.isConfirm);
    },
    oldStuClick: function oldStuClick() {
      this.isNewStudent = false;
    },
    newStuClick: function newStuClick() {
      this.isNewStudent = true;
    },
    setRandomPwd: function setRandomPwd() {
      this.isChecked = true;
      this.isRandomPwd = 1;
      this.initialPwd = 0;
    },
    setinitialPwd: function setinitialPwd() {
      this.isChecked = false;
      this.isRandomPwd = 0;
      this.initialPwd = 123456;
    },
    addStudent: function addStudent(uin, name) {
      var _this2 = this;

      var flag = true;
      if (uin == this.params.teacherId) {
        this.$toast("您不可以添加自己进入班级哦~", "error");
        return false;
      }
      var classStudent = this.params.classStudent;
      if (classStudent.length > 0) {
        classStudent.forEach(function (item1) {
          if (uin == item1) {
            flag = false;
          }
        });
      }
      if (!flag) {
        this.$toast("班级已有" + name + ",请勿重复添加!", "error");
      }
      var classId = this.params.currentClass.classId;
      var param = {
        userId: uin,
        role: 1,
        classId: classId
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].addOneStudent(param).then(function (res) {
        if (!res) {
          _this2.$toast("班级已存在该学生~", "error");
          return false;
        }
        if (res) {
          _this2.isConfirm = true;
          _this2.$toast("添加学生成功", "right");
          _this2.$emit("isConfirm", _this2.isConfirm);
        }
      });
    },
    search: function search(e) {
      var _this3 = this;

      if (this.userId.length == 0) {
        this.isSearch = false;
      }
      if (this.userId.length != 5 && this.userId.length != 8 && this.userId.length != 9 && this.userId.length != 11) {
        this.newStudentInf = undefined;
        return false;
      }
      var params = {};
      if (this.userId.length == 5) {
        params.uin = this.userId;
      } else if (this.userId.length == 9 || this.userId.length == 8) {
        params.uin = this.userId;
      } else if (this.userId.length == 11) {
        params.mobile = this.userId;
      }
      this.isSearch = true;
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].searchStudent(params).then(function (res) {
        if (!res) {
          return false;
        }
        if (res.data.length > 0) {
          _this3.newStudentInf = res.data[0];
          if (_this3.newStudentInf.sex == 0) {
            _this3.newStudentInf.src = "./img/girl.png";
          } else if (_this3.newStudentInf.sex == 1) {
            _this3.newStudentInf.src = "./img/boy.png";
          } else {
            _this3.newStudentInf.src = false;
          }
        }
      });
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfirm: false,
      title: "",
      studentsList: [],
      teamid: "",
      classId: "",
      isSuccess: false
    };
  },

  props: ["params"],
  created: function created() {

    this.studentsList = this.params.groups;
    this.title = this.studentsList.title;
    this.teamid = this.studentsList.data[0].teamId;
    this.classId = this.studentsList.data[0].classId;
    console.log(this.studentsList);
  },

  methods: {
    closeNotice: function closeNotice() {
      this.$emit("isConfirm", this.isConfirm);
    },


    // 取消选择
    abolish: function abolish() {
      this.$emit("isConfirm", this.isConfirm);
    },


    // 确定
    ensure: function ensure() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].delTeam({ teamid: this.teamid }).then(function (res) {
        if (!res) {
          return false;
        }
        _this.isSuccess = true;
        console.log(JSON.parse(window.sessionStorage.getItem('studentsListData')));
        _this.$toast("删除成功", "right");
        _this.$emit("isConfirm", _this.isSuccess);
      });
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            noticeType: 1,
            textArr: [],
            randomArr: [],
            isInputArr: [true, false, false, false],
            isClose: false
        };
    },

    props: ['params'],
    watch: {
        noticeType: function noticeType(val) {
            var _this = this;

            this.$nextTick(function () {
                if (val == 2) {
                    _this.setRandomArr();
                    document.forms[0].elements[0].focus();
                }
            });
        }
    },
    methods: {
        abolish: function abolish() {
            this.noticeType = 1;
            this.textArr = [];
            this.$emit('isConfirm', this.isConfirm);
        },
        setRandomArr: function setRandomArr() {
            this.randomArr = [];
            for (var i = 0, len = this.isInputArr.length; i < len; i++) {
                this.randomArr.push(Math.floor(Math.random() * 10));
            }
        },
        ensure: function ensure() {
            switch (this.noticeType) {
                case 1:
                    this.noticeType = 2;
                    break;
                case 2:
                    var flag = true;
                    for (var i = 0, len = this.randomArr.length; i < len; i++) {
                        if (this.textArr[i] != this.randomArr[i]) {
                            flag = false;
                        }
                    }
                    if (this.isClose && flag) {
                        this.isConfirm = true;
                        this.$emit('isConfirm', this.isConfirm);
                        this.textArr = [];
                        this.isConfirm = false;
                        this.isClose = false;
                        this.noticeType = 1;
                    }
                    break;

            }
        },

        //输入完胜验证通过跳到下一个输入框
        moveNext: function moveNext(index) {

            if (this.textArr[index] != this.randomArr[index]) {
                this.$toast("验证码输入错误，请重新输入", 'delete');
                return false;
            }
            if (event.keyCode == 8) {

                /*if(this.textArr[index]==''){
                    switch(index){
                        case 0:
                            break;
                        case 1:
                            if(this.textArr[index-1] != this.randomArr[index-1]){
                                alert(1)
                                this.$toast("验证码输入错误，请重新输入");
                                document.forms[0].elements[index-1].focus();
                            }
                            break;
                        case 2:
                            if(this.textArr[index-1] != this.randomArr[index-1] || this.textArr[index-2] != this.randomArr[index-2]){
                                alert(1)
                                document.forms[0].elements[index-1].focus();
                            }
                            break;
                        case 3:
                            if(this.textArr[index-1] != this.randomArr[index-1] || this.textArr[index-2] != this.randomArr[index-2] || this.textArr[index-3] != this.randomArr[index-3]){
                                alert(1)
                                document.forms[0].elements[index-1].focus();
                            }
                            break;
                    }
                }*/
            } else {
                if (index < 3 && event.keyCode != 8) {
                    document.forms[0].elements[index + 1].focus();
                } else if (index == 3) {
                    /*let flag = true;
                    for(var i = 0,len = this.randomArr.length;i<len;i++){
                        if(this.textArr[i] != this.randomArr[i]){
                            flag = false;
                        }
                    }
                    if(flag==true){
                        this.isClose =  true;
                    }else{
                        this.isClose =  false;
                    }*/
                    this.isClose = true;
                }
            }
        },
        closeNotice: function closeNotice() {
            this.noticeType = 1;
            this.textArr = [];
            this.$emit('isConfirm', this.isConfirm);
        }
    }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isConfirm: false
        };
    },

    props: ['params'],
    methods: {
        closeNotice: function closeNotice() {
            this.$emit('isConfirm', this.isConfirm);
        }
    }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notice1_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notice1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__notice1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notice2_vue__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notice2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__notice2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delete_vue__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__delete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message_vue__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__service_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__particulars_vue__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__particulars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__particulars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addClass_vue__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addClass_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__addClass_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addStudent_vue__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addStudent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__addStudent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addGroups_vue__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addGroups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__addGroups_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delTeam_vue__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delTeam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__delTeam_vue__);
//
//
//
//
//
//
//

 //通用弹框组件一 确定取消按钮
 //通用弹框组件二 确定按钮
 //删除学生弹框组件
 //系统消息弹框组件
 //查看服务详情弹框组件
 //编辑班级信息弹框组件
 //添加或创建班级弹框组件
 //添加或创建班级弹框组件
 //新建或编辑组弹框组件
 //删除分组弹框组件

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentView: "notice1",
      isShow: false
    };
  },

  props: ["params", "isNotice"],
  components: {
    notice1: __WEBPACK_IMPORTED_MODULE_0__notice1_vue___default.a,
    notice2: __WEBPACK_IMPORTED_MODULE_1__notice2_vue___default.a,
    deleteNotice: __WEBPACK_IMPORTED_MODULE_2__delete_vue___default.a,
    message: __WEBPACK_IMPORTED_MODULE_3__message_vue___default.a,
    service: __WEBPACK_IMPORTED_MODULE_4__service_vue___default.a,
    particulars: __WEBPACK_IMPORTED_MODULE_5__particulars_vue___default.a,
    addClass: __WEBPACK_IMPORTED_MODULE_6__addClass_vue___default.a,
    addStudent: __WEBPACK_IMPORTED_MODULE_7__addStudent_vue___default.a,
    addGroups: __WEBPACK_IMPORTED_MODULE_8__addGroups_vue___default.a,
    delTeam: __WEBPACK_IMPORTED_MODULE_9__delTeam_vue___default.a
  },
  watch: {
    isNotice: function isNotice(val) {
      this.isShow = true;
      switch (this.params.type) {
        case 1:
          this.currentView = "notice1";
          break;
        case 2:
          this.currentView = "notice2";
          break;
        case 3:
          this.currentView = "deleteNotice";
          break;
        case 4:
          this.currentView = "message";
          break;
        case 5:
          this.currentView = "service";
          break;
        case 6:
          this.currentView = "particulars";
          break;
        case 7:
          this.currentView = "addClass";
          break;
        case 8:
          this.currentView = "addStudent";
          break;
        case 9:
          this.currentView = "addGroups";
          break;
        case 10:
          this.currentView = "delTeam";
          break;
        default:
          this.currentView = "notice1";
      }
    }
  },
  methods: {
    isConfirm: function isConfirm(val, classObj) {
      this.isShow = val;
      if (val) {
        this.isShow = !val;
        this.$emit("isConfirm", val, this.params.identify, this.params.userId, classObj || {});
      }
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isConfirm: false
        };
    },

    props: ['params'],
    methods: {
        abolish: function abolish() {
            this.$emit('isConfirm', this.isConfirm);
        },
        ensure: function ensure() {
            this.isConfirm = true;
            this.$emit('isConfirm', this.isConfirm);
        },
        closeNotice: function closeNotice() {
            this.$emit('isConfirm', this.isConfirm);
        }
    }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isConfirm: false
        };
    },

    props: ['params'],
    methods: {
        ensure: function ensure() {
            this.isConfirm = true;
            this.$emit('isConfirm', this.isConfirm);
            this.isConfirm = false;
        }
    }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_periods__ = __webpack_require__(267);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isConfirm: false,
            gradsArr: __WEBPACK_IMPORTED_MODULE_0__data_periods__["c" /* periods */],
            isShowUl: false,
            schoolName: this.params.currentClass.schoolName,
            className: this.params.currentClass.className,
            currentGrad: this.params.currentClass.gradeId,
            currentText: '',
            currentPeriod: this.params.currentClass.periodId
        };
    },

    props: ['params'],
    created: function created() {
        for (var i = 0, len = this.gradsArr.length; i < len; i++) {
            if (this.gradsArr[i].grade == this.params.currentClass.gradeId) {
                this.currentText = this.gradsArr[i].text;
            }
        }
    },

    methods: {
        abolish: function abolish() {
            this.$emit('isConfirm', this.isConfirm);
        },
        ensure: function ensure() {
            if (!this.className.length) {
                this.$toast('请输入班级名字', 'error');
                return false;
            }
            if (this.params.currentClass.className == this.className && this.currentGrad == this.params.currentClass.gradeId && this.currentPeriod == this.params.currentClass.periodId) {
                this.$emit('isConfirm', this.isConfirm);
                return false;
            }
            this.isConfirm = true;
            this.$emit('isConfirm', this.isConfirm, { classAliasName: this.className, gradeId: this.currentGrad, periodId: this.currentPeriod, classId: this.params.currentClass.classId });
        },
        closeNotice: function closeNotice() {
            this.$emit('isConfirm', this.isConfirm);
        },
        showUl: function showUl() {
            this.isShowUl = !this.isShowUl;
        },
        checkGrad: function checkGrad(item) {
            this.isShowUl = false;
            this.currentText = item.text;
            this.currentGrad = item.grade;
            this.currentPeriod = item.period;
        },
        closeUl: function closeUl() {
            this.isShowUl = false;
        }
    }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isConfirm: false,
            serviceArr: [],
            url: ''
        };
    },

    props: ['params'],
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            if (_this.params && _this.params.serviceArr) {
                _this.serviceArr = _this.params.serviceArr;
                for (var i = 0, lenI = _this.serviceArr.length; i < lenI; i++) {
                    var itemArr = _this.serviceArr[i];
                    itemArr.serviceArr = itemArr.IsBuyArr;
                    itemArr.serviceArr = itemArr.serviceArr.concat(itemArr.IsTryArr);
                }
                // const tb = document.querySelector("#tb")
                // this.autoRowSpan(tb,0,0);
            }
        });
    },

    methods: {
        abolish: function abolish() {
            this.$emit('isConfirm', this.isConfirm);
            document.body.style.overflow = "auto";
        },
        ensure: function ensure() {
            this.isConfirm = true;
            this.$emit('isConfirm', this.isConfirm);
            this.isConfirm = false;
            document.body.style.overflow = "auto";
        },
        closeNotice: function closeNotice() {
            this.$emit('isConfirm', this.isConfirm);
        },

        //表格合并相同值方法
        autoRowSpan: function autoRowSpan(tb, row, col) {
            var lastValue = "";
            var value = "";
            var pos = 1;
            for (var i = row; i < tb.rows.length; i++) {
                value = tb.rows[i].cells[col].innerText;
                if (lastValue == value) {
                    tb.rows[i].deleteCell(col);
                    tb.rows[i - pos].cells[col].rowSpan = tb.rows[i - pos].cells[col].rowSpan + 1;
                    pos++;
                } else {
                    lastValue = value;
                    pos = 1;
                }
            }
        },
        serviceExcel: function serviceExcel() {
            var classId = this.params.classId;
            var urlStr = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* http */] + "/gateway/v1/student/exportClassServicesByExcel?classId=" + classId + "&brandId=" + __WEBPACK_IMPORTED_MODULE_0__config__["c" /* brandId */] + "&clientId=" + __WEBPACK_IMPORTED_MODULE_0__config__["b" /* clientId */];
            this.url = urlStr;
        }
    }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['echartData', 'userName'],
  data: function data() {
    return {
      subjectF: false,
      subjectName: '整体曲线',
      subjectList: ['整体曲线', '单词跟读', '课文跟读', '听说模考', '线上作答', '报听写']
    };
  },

  watch: {
    echartData: function echartData(curVal, oldVal) {
      // if (curVal !== oldVal) {
      // }
      this.setOption();
    },
    userName: function userName(val) {
      this.setOption();
    }
  },
  created: function created() {
    this.$nextTick(function () {
      // console.log(this.echartData, 'ghghg')
    });
  },

  methods: {
    setOption: function setOption() {
      var curData = this.echartData;
      if (!curData.length) {
        return false;
      }
      var sendDate = [];
      var sore = [];
      var avgSore = [];
      curData.map(function (item, i) {
        sendDate.push(item.sendDate);
        var s = Math.floor(item.userAvgScore);
        var avgS = Math.floor(item.classAvgScore);
        sore.push(s);
        avgSore.push(avgS);
      });
      this.drawLine(sendDate, sore, avgSore, this.userName);
    },
    drawLine: function drawLine(sendDate, sore, avgSore, userName) {
      var myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        tooltip: {
          show: true,
          textStyle: {
            fontStyle: 'oblique'
          }
        },
        grid: {
          x: 30,
          y: 70
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          padding: 10,
          itemGap: 50,
          top: 0,
          selectedMode: false,
          textStyle: {
            fontSize: 12,
            color: '#999'
          },
          data: [{
            name: userName
          }, {
            name: '班级平均'
          }]
        },
        xAxis: {
          type: 'category',
          axisLine: {
            /* 横轴的字体颜色 */
            show: true,
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            /* 横轴刻度状态 */
            interval: 0,
            rotate: 30
          },
          data: sendDate
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: userName,
          data: sore,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          type: 'line',
          itemStyle: {
            /* 设置线的颜色 */
            normal: {
              color: "#0CC584",
              lineStyle: {
                color: "#0CC584"
              }
            }
          }
        }, {
          name: '班级平均',
          data: avgSore,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          type: 'line',
          itemStyle: {
            /* 设置线的颜色 */
            normal: {
              color: "#FF6200",
              lineStyle: {
                color: "#FF6200"
              }
            }
          }
        }]
      });
    },
    changetype: function changetype(data, i) {
      this.subjectName = data;
      this.subjectF = false;
      this.$emit('setresourceType', i);
    },
    selectShow: function selectShow() {
      this.subjectF = true;
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['echartData'],
  data: function data() {
    return {};
  },

  watch: {
    echartData: function echartData(curVal, oldVal) {
      console.log(curVal, 'oooo');
      // if (curVal !== oldVal) {
      // }
      this.setOption(curVal);
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.setOption(_this.echartData);
    });
  },

  methods: {
    setOption: function setOption(curData) {
      var legendData = ['未提交', '不及格(0 -59)', '合格(60-69)', '中等(70-79) ', '良好(80-90)', '优秀(90-100)'];
      var seriesData = [];
      curData.map(function (item) {
        var objS = {
          value: item.rate,
          name: legendData[item.status]
        };
        seriesData.push(objS);
      });
      this.drawLine(seriesData, legendData);
    },
    drawLine: function drawLine(seriesData, legendData) {
      var myChart = this.$echarts.init(document.getElementById('myChartpie'));
      myChart.setOption({
        //  tooltip: {
        //    trigger: 'item',
        //    formatter: "{b} : {c} ({d}%)"
        //  },
        legend: {
          orient: 'horizontal',
          selectedMode: false,
          padding: [5, 30],
          top: 'top',
          data: legendData
        },
        color: ['#D33636', '#079FA9', '#FA8000', '#FFCF07', '#8CD019', '#59BE4B'],
        series: [{
          name: '访问来源',
          type: 'pie',
          radius: '70%',
          center: ['50%', '60%'],
          data: seriesData,
          clickable: false,
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{b} {c}%"
              },
              labelLine: { show: true }
            }
          }
        }]
      });
    },
    changetype: function changetype(data, i) {
      this.subjectName = data;
      this.subjectF = false;
      this.$emit('setresourceType', i);
    },
    selectShow: function selectShow() {
      this.subjectF = true;
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reportDetail', 'workReport', 'timeData'],
  data: function data() {
    return {
      currentPage: 1
    };
  },
  created: function created() {
    this.$nextTick(function () {
      // this.setSorcTable()
    });
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('setPage', val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('setPage', val);
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      valIndex: -1,
      dataType: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.dataType = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.data);
      if (_this.selectObj === 'service' || _this.selectObj === 'grads') {
        for (var i = 0; i < _this.data.length; i++) {
          var item = _this.data[i];
          if (item.id == _this.selectId) {
            _this.valIndex = i;
            break;
          }
        }
      }
    });
  },

  props: ['data', 'selectId', 'defValue', 'selectObj'],
  methods: {
    changeEvent: function changeEvent(e) {
      // debugger

      var index = parseInt(e.target.value);

      if (this.dataType === 'number') {
        this.$emit('selecter', { 'key': this.selectObj, 'value': index + 1 });
      } else {

        this.$emit('selecter', { 'key': this.selectObj, 'value': !isNaN(index) ? this.data[index].name : e.target.value, 'index': index });
      }
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['PagenumId', "PageCount"],
    data: function data() {
        return {
            mypagenum: this.PagenumId
        };
    },

    watch: {
        PagenumId: function PagenumId(val) {
            this.PagenumId = val;
            if (val == 1) {
                this.mypagenum = val;
            }
        },
        mypagenum: function mypagenum(val) {
            this.$emit("mypagenum", val);
        }
    },
    methods: {
        lastone: function lastone() {
            this.mypagenum > 1 ? this.mypagenum-- : this.mypagenum;
        },
        nextone: function nextone() {
            this.mypagenum < this.PageCount ? this.mypagenum++ : this.mypagenum;
        }
    }

});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alertMsg_alertPW_vue__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alertMsg_alertPW_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__alertMsg_alertPW_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      layerPW: false,
      check: "",
      school: [],
      grads: []
    };
  },

  props: ["userInformation", "birthday", "userId"],
  components: {
    alertPW: __WEBPACK_IMPORTED_MODULE_3__alertMsg_alertPW_vue___default.a
  },
  watch: {
    userInformation: function userInformation(val) {
      this.check = this.userInformation.sex;
      this.schoolList();
    }
  },
  created: function created() {
    this.$nextTick(function () {});
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    altPassWord: function altPassWord() {
      this.layerPW = !this.layerPW;
    },
    schoolList: function schoolList() {
      var classes = this.userInformation.classes;
      var schoolArr = [];
      var gradsArr = [];
      for (var i = 0; i < classes.length; i++) {
        schoolArr.push(classes[i].schoolName);
        gradsArr.push(classes[i].className);
      }
      for (var i = 0, j = schoolArr.length; i < j; i++) {
        if (this.school.indexOf(schoolArr[i]) == -1) {
          this.school.push(schoolArr[i]);
        }
      }
      this.school = this.school.toString();
      for (var i = 0, k = gradsArr.length; i < k; i++) {
        if (this.grads.indexOf(gradsArr[i]) == -1) {
          this.grads.push(gradsArr[i]);
        }
      }
      this.grads = this.grads.toString();
    }

    // altMobile() {
    //   this.layerMB = !this.layerMB;
    // },

    // modify() {
    //   this.check = !this.check;

    //   if (!this.check) {
    //     fetch.modifySex({ sex: 0 }).then(res => {
    //       if (!res) {
    //         return false;
    //       }
    //       this.$toast("修改成功", "right");
    //     });
    //   } else {
    //     fetch.modifySex({ sex: 1 }).then(res => {
    //       if (!res) {
    //         return false;
    //       }
    //       this.$toast("修改成功", "right");
    //     });
    //   }
    // }

  })
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            school: [],
            layerSch: false,
            ret: []
        };
    },

    props: ['userInformation'],
    watch: {
        userInformation: function userInformation(val) {
            this.schoolList();
        }
    },
    methods: {
        schoolList: function schoolList() {
            var classes = this.userInformation.classes;
            var arr = [];
            for (var i = 0; i < classes.length; i++) {
                arr.push(classes[i].schoolName);
            }
            for (var i = 0, j = arr.length; i < j; i++) {
                if (this.school.indexOf(arr[i]) == -1) {
                    this.school.push(arr[i]);
                }
            }
            this.school = this.school.toString();
        }
    }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//

// 音频组件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            toParentIsPlay: false,
            audio: null,
            index: 0,
            stopPlayAll: false
        };
    },

    props: ['playerObj', 'src', 'id', 'allUrl'],
    watch: {
        playerObj: function playerObj(newVal, oldVal) {
            if (newVal == oldVal || !this.audio) {
                return false;
            }

            if (!newVal.id && newVal.id == this.id) {
                if (this.playerObj.isPlay) {
                    this.myIsPlay = true;

                    this.index = 0;
                    this.allPlay();
                } else {
                    this.myIsPlay = false;
                    this.stopPlayAll = true;
                }
                return false;
            }

            if (newVal.id == this.id && this.playerObj.isPlay) {
                this.myIsPlay = true;

                this.stopPlayAll = true;
                this.allPause();
                this.audio.play();
                this.playEnd();
            } else {
                this.audio.pause();
                this.myIsPlay = false;
            }
        }
    },
    methods: {
        player: function player(event) {
            this.audio = event.target.querySelector('audio');
            this.$emit('playedObj', { id: this.id, isPlay: !this.myIsPlay });
        },
        playEnd: function playEnd(cb) {
            var _this = this;
            this.audio.addEventListener('ended', function () {
                _this.myIsPlay = false;
                if (cb) {
                    cb();
                }
            });
        },
        allPause: function allPause() {
            var audios = document.querySelectorAll('audio');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audios), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item.pause();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        allPlay: function allPlay() {
            var that = this;
            var urls = this.allUrl;
            // let len = urls.length;

            console.log(this.index);
            if (that.stopPlayAll) {
                console.log(0, 0);
                return false;
            }

            // this.audio.src = urls[this.index];
            // that.audio.load();
            // this.audio.addEventListener('loadedmetadata', function(){
            //     that.audio.play();
            //     that.playEnd(function(){
            //         that.index++;
            //         if(that.index >= len){
            //             return false;
            //         }
            //         that.allPlay()
            //     });
            //     console.log('current source num', this.index)

            // })

            /*****************************************/

            var audios = document.querySelectorAll('audio');
            var len = audios.length;

            this.loopPlay();
        },
        loopPlay: function loopPlay() {
            var that = this;
            var len = this.allUrl.length;
            var audio = document.getElementById(this.allUrl[this.index]).children[0];
            // if(this.stopPlayAll) {
            //     console.log(11111111111)
            //     return false;
            // }
            audio.play();
            audio.addEventListener('ended', function () {
                that.index++;
                if (that.index >= len || that.stopPlayAll) {
                    return false;
                }
                console.log('current source num', that.index);

                that.loopPlay();
            });
        },
        play: function play() {
            this.myIsPlay = true;
            this.audio.play();
            this.playEnd();
        }
    }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videoId: 'video_' + +new Date(),
      letvPlayer: null
    };
  },

  props: ['pic', 'videoVu'],
  created: function created() {
    this.$nextTick(function () {
      this.loadJsLeVideo();
    });
  },

  methods: {
    videoPlay: function videoPlay() {
      this.letvPlayer.sdk.replayVideo();
    },

    // 载入乐视视频
    loadJsLeVideo: function loadJsLeVideo() {
      if (typeof CloudVodPlayer == 'function') {
        var letvPlayer = new CloudVodPlayer();
        letvPlayer.init({ "loadingpic": "./../../assets/img/loadingOnline.gif", "vu": this.videoVu.substr(7), "bgcolor": this.pic, "pu": "B6999F08EC", "uu": "2bfc338ed7", "posterType": 2, "gpcflag": 1, "skinnable": 0, "width": "300", "height": "150", "lang": "zh_CN", "callbackJs": function callbackJs(e) {
            console.log(1111, e);
          } }, this.videoId);
        // setTimeout(function(){
        // 	// console.log(1)
        // 	// debugger
        // 	letvPlayer.sdk.pauseVideo()
        // },6000)
        this.letvPlayer = letvPlayer;
      } else {
        // 没有乐视类就加载乐视js
        this.loadLetvJS();
      }
    },
    // 载入乐视js
    loadLetvJS: function loadLetvJS(callback) {
      var _this = this;
      var script = document.createElement('script');
      script.src = location.protocol + '//yuntv.letv.com/player/vod/bcloud.js';
      script.onload = function () {
        _this.loadJsLeVideo();
        if (callback) callback();
      };
      document.body.appendChild(script);
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unit_progressBar_js__ = __webpack_require__(269);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      canvasC: "",
      option: "",
      imageAir: "",
      startA: "",
      rotataRadians: "",
      context: "",
      x: "",
      y: "",
      R1: "",
      outerColorStart: "",
      outerColorMid: "",
      outerColorEnd: "",
      innerColorStart: "",
      innerColorEnd: "",
      circleBottomColor: "",
      lineW0: "",
      R0: "",
      lineW1: "",
      startAa: "",
      ra: "",
      imgX: "",
      imgY: "",
      imgWidth: "",
      imgHeight: "",
      Timer: ""
    };
  },

  props: ["index_id", "decimalsRate", "completeRate", "PageIndex"],
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.initData();
    });
  },


  methods: {
    initData: function initData() {
      var objName = "canvasThree" + this.index_id;
      this.runCircle({ obj: objName, percent: this.decimalsRate });
    },
    runCircle: function runCircle(settings) {
      var defaultSetting = {
        url: "./static/green_point.png", //飞机小图地址
        obj: "", //场景添加的canvas id 名
        percent: 0, //圆环转动的百分比  0-1
        circleBottomColor: "#e3f1ee", //圆环底色
        outerColorStart: "#fff", //外部圆环 渐变色
        outerColorMid: "#fff",
        outerColorEnd: "#fff",
        innerColorStart: "#88dbc8", //内部圆环 渐变色
        innerColorEnd: "#88dbc8"
      };

      Object.extend = function (destination, source) {
        for (var property in source) {
          destination[property] = source[property];
        }
        return destination;
      };
      this.option = Object.extend(defaultSetting, settings);

      var obj = this.option.obj;

      var percent = this.option.percent;
      this.outerColorStart = this.option.outerColorStart;
      this.outerColorMid = this.option.outerColorMid;
      this.outerColorEnd = this.option.outerColorEnd;
      this.innerColorStart = this.option.innerColorStart;
      this.innerColorEnd = this.option.innerColorEnd;
      this.circleBottomColor = this.option.circleBottomColor;

      var preA = Math.PI / 180;

      this.canvasC = document.getElementById(obj); //this.$refs.canvasDom
      // this.canvasC = this.$refs.canvasDom;
      // console.log('ById',this.canvasC)
      // console.log('refs',this.$refs.canvasDom)


      // if(!this.canvasC) return

      /*控制运动*/
      this.context = this.canvasC.getContext("2d");

      var windowW = parseInt(this.canvasC.parentNode.offsetWidth); //parentNode

      this.lineW1 = 13;
      this.lineW0 = 10;

      if (windowW > 500) {
        this.lineW1 = 36;
        this.lineW0 = 10;
      }
      var canvasW = windowW * 0.6;
      var R = parseInt(canvasW / 2 - 2 * this.lineW1 - 2 * this.lineW0 - 10);
      this.R0 = parseInt(canvasW / 2 - this.lineW0 - 4);
      this.R1 = parseInt(canvasW / 2 - this.lineW1 - this.lineW0 - 10);
      this.ra = parseInt(canvasW / 2 - this.lineW0 / 2 - 25); //改这里
      var canvasH = canvasW;
      var rotateAngle = percent * 360;
      var anotherA = 0;
      if (percent > 0.5) {
        anotherA = (percent - 0.5) * 360 * preA;
      }
      this.rotataRadians = preA * rotateAngle;
      this.canvasC.width = canvasW;
      this.canvasC.height = canvasH;

      this.x = this.canvasC.width / 2;
      this.y = this.canvasC.height / 2;
      this.startAa = -Math.PI / 2;
      this.startA = 0;

      var preSceond = 100 / (Math.PI * 2);
      this.CanvasApp();
      this.context.fillStyle = '#ff0';
      this.context.fillText(percent, 20, 20);
    },
    CanvasApp: function CanvasApp() {
      var loading = 0;
      var _this = this;
      var imageUrl = this.option.url;
      this.canvasC.setAttribute("data-run", "1");

      this.imageAir = new Image();
      this.imageAir.onload = function () {
        _this.imgWidth = _this.option.imgWidth || _this.imageAir.width;
        var imgHeight = _this.option.imgHeight || _this.imageAir.height;
        _this.imgX = -_this.imgWidth / 2 - 3;
        _this.imgY = -_this.imgHeight / 2 - 8;
        _this.drawScreen();
      };
      this.imageAir.src = imageUrl;
    },
    drawScreen: function drawScreen() {
      var _this = this;

      if (this.startA < this.rotataRadians) {
        this.startA += 0.1;
      }

      this.context.fillStyle = "#fff";
      this.context.fillRect(0, 0, this.canvasC.width, this.canvasC.height);

      this.context.save();
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.fillRect(0, 0, this.canvasC.width, this.canvasC.height);
      this.context.translate(this.x, this.y);
      this.context.rotate(-Math.PI / 2);

      // //中环
      this.context.beginPath();
      this.context.strokeStyle = this.circleBottomColor;
      this.context.lineWidth = this.lineW1;
      this.context.arc(0, 0, this.R1, 0, Math.PI * 2, false);
      this.context.stroke();
      this.context.closePath();
      //
      // // Linear gradients
      this.context.beginPath();
      var gradient2 = this.context.createLinearGradient(this.R1, 0, -this.R1, 0);
      gradient2.addColorStop(0, this.innerColorStart);
      gradient2.addColorStop(1, this.innerColorEnd);
      this.context.lineCap = "round";
      // this.context.strokeStyle = "#88dbc8";
      this.context.strokeStyle = gradient2;

      this.context.lineWidth = this.lineW1;
      this.context.arc(0, 0, this.R1, 0, this.startA, false);
      this.context.stroke();
      this.context.closePath();
      //
      this.context.save();
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      var ax = this.ra * Math.cos(this.startAa);
      var ay = this.ra * Math.sin(this.startAa);
      this.context.translate(this.x + ax, this.y + ay);
      this.context.rotate(this.startAa);
      this.context.drawImage(_this.imageAir, _this.imgX, _this.imgY, 12, 12);
      this.context.restore();
      // //画图
      if (this.startAa < this.rotataRadians - Math.PI / 2) {
        this.startAa += 0.1;
        this.canvasC.setAttribute("data-run", "1");
        clearInterval(this.Timer);
      } else {
        clearInterval(this.Timer);
        this.canvasC.setAttribute("data-run", "0");
        return false;
      }

      this.Timer = setInterval(this.drawScreen, 20);
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkboxLabel_checkboxLabel_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkboxLabel_checkboxLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__checkboxLabel_checkboxLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editInput_editInput__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editInput_editInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_editInput_editInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_originSelect_originSelect__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_originSelect_originSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_originSelect_originSelect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      grads: [],
      selectedClass: [],
      workName: "",
      dateShow: "",
      sendDate: "",
      completeDate: [],
      endDate: "",
      workMessage: "",
      isNotice: false,
      noticParams: {},
      publishType: "",
      examinationID: "",
      examinationTitle: "",
      paperScore: "",
      clickIndex: 1,
      paperSubjectId: Number,
      allTimes: 0,
      articles: [],
      words_text: ["跟读", "朗读"],
      text_text: ["跟读", "朗读", "背诵"],
      allCheckClassArr: [],
      partCheckClassArr: [],
      checkClassArr: [],
      check: "",
      params_type: 0,
      defalutTitle: "选择",
      seltime: {},
      default_V: {},
      target: "",
      serviceId: ''
    };
  },

  components: {
    classcom: __WEBPACK_IMPORTED_MODULE_2__checkboxLabel_checkboxLabel_vue___default.a,
    notice: __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue___default.a,
    EditInput: __WEBPACK_IMPORTED_MODULE_4__components_editInput_editInput___default.a,
    OriginSelect: __WEBPACK_IMPORTED_MODULE_9__components_originSelect_originSelect___default.a
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.default_V.defHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(), "hh");
      console.log(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(), "hh"));
      _this2.default_V.defMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(), "mm");
      _this2.setCrumb("布置作业");
      _this2.initData();
      _this2.serviceId = _this2.$route.query.serviceId;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapActions */])(["setCrumb", "setWorks", "cleanCatalog", "removeWorks", "removeSubject"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(["getWorks"]), {
    changeTitle: function changeTitle(val) {
      this.workName = val.trim() ? val : this.workName;
    },
    selLi: function selLi(item) {
      item.setQuestionId = !item.setQuestionId;
    },
    initData: function initData() {
      var _this3 = this;

      if (!this.getWorks().contents) {
        this.$router.push({ path: "/" });
        return;
      }
      var params = this.$route.query;
      this.params_type = params.type;
      if (params.type == 2) {
        this.publishType = params.type;
        this.examinationID = params.paper.examinationID;
        this.paperSubjectId = params.paper.subjectID;
        this.paperScore = params.paper.refScore;
        this.examinationTitle = params.paper.examinationTitle;
        // this.workName = formatDate(timeStamp(), 'y年M月dd日')+this.examinationTitle;
        this.workName = this.examinationTitle;
      } else {
        var selectedWorkName = params.selectedWorkName.substr(0, params.selectedWorkName.length - 1);
        // this.workName = formatDate(timeStamp(), 'y-M-dd')+'作业';
        this.workName = selectedWorkName;
        this.articles = this.getWorks().contents;
        this.articles.map(function (item) {
          if (item.refLong) {
            _this3.allTimes += item.refLong;
          }
        });
      }

      var nextDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["aroundDate"])("", 1) / 1000;
      this.completeDate = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(nextDate, "yyyy-MM-dd"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(nextDate, "hh"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(nextDate, "mm")];
      this.endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(nextDate, "yyyy-MM-dd");
      this.target = this.getWorks().target;

      this.initPage();
    },
    initPage: function initPage() {
      document.getElementById("myID").flatpickr({
        dateFormat: "Y-m-d",
        minDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["aroundDate"])(null, 1) / 1000, "yyyy-MM-dd").toString(),
        time_24hr: false,
        shorthandCurrentMonth: true,
        enableTime: false
      });
      var _this = this;
      document.getElementById("myIDSecond").flatpickr({
        dateFormat: "Y-m-d",
        minDate: "today",
        time_24hr: false,
        shorthandCurrentMonth: true,
        enableTime: false,
        onChange: function onChange(selectedDates) {
          _this.endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["aroundDate"])(selectedDates, 1) / 1000, "yyyy-MM-dd");

          _this.completeDate[0] = _this.endDate;
          _this.sendDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(selectedDates), "yyyy-MM-dd");
        }
      });
    },
    modify: function modify(type) {
      this.check = !this.check;
      if (type == 2) {
        this.dateShow = true;
        this.sendDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(), "yyyy-MM-dd");
        this.default_V.Hour = new Date().getHours() + 1;
      } else {
        this.dateShow = false;
        this.sendDate = '';
      }
    },
    selClass: function selClass(obj) {
      if (obj.checked) {
        this.selectedClass.push(obj.id);
      } else {
        var index = this.selectedClass.indexOf(obj.id);
        this.selectedClass.splice(index, 1);
      }
    },

    // adClass() {
    //   this.isNotice = !this.isNotice;
    //   this.noticParams = {
    //     type: 1,
    //     noticeText: "调整班级后，已添加的作业内容将会被删除，确定调整班级？",
    //     noticeTitle: "系统提示"
    //   };
    // },
    // preview(item, index) {
    //   let query = {
    //     resourceName: item.resourceName,
    //     parentVersionId: item.parentVersionId,
    //     versionId: item.versionId,
    //     moduleId: item.moduleId,
    //     checkedResource: item.checkedResource,
    //     readTime: item.refLong,
    //     resourceType: item.resourceType,
    //     selectFlag: false
    //     // cId: item.cId
    //   };
    //   if (item.moduleId == 10 || item.moduleId == 127) {
    //     //同步跟读
    //     if (item.resourceType == "a7527f97-14e6-44ef-bf73-3039033f128e") {
    //       this.$router.push({ path: "readWords", query });
    //     } else if (
    //       item.resourceType == "992a5055-e9d0-453f-ab40-666b4d7030bb"
    //     ) {
    //       this.$router.push({ path: "selectText", query });
    //     }
    //   } else if (item.moduleId == 15) {
    //     //听说模考
    //     this.$router.push({ path: "selectListenSpeak", query });
    //   } else if (item.moduleId == 124) {
    //     //线上作答
    //     this.$router.push({ path: "selectOnlinePaper", query });
    //   }
    // },
    selecter: function selecter(obj) {
      if (obj.key === "hours") {
        this.completeDate[1] = obj.value;
        // this.seltime.hours = obj.value
      } else if (obj.key === "minutes") {
        this.completeDate[2] = obj.value;
        // this.seltime.minutes = obj.value
      } else if (obj.key === "time_hours") {
        this.seltime.time_hours = obj.value;
        var selectDate = new Date(this.sendDate.replace(/-/g, '/')).getTime() / 1000 + this.seltime.time_hours * 60 * 60 + this.default_V.defMinute * 60;
        var nowTime = Math.ceil(+new Date() / 1000);
        if (selectDate < nowTime) {
          this.$toast("定时发布时间至少比现在晚1个小时。");
        }
      } else if (obj.key === "time_minutes") {
        this.seltime.time_minutes = obj.value;
      }
    },
    goPrev: function goPrev() {
      this.$router.go(-1);
    },
    publish: function publish() {
      var _this4 = this;

      document.getElementById("btn").disabled = true;
      var time_hours = this.seltime.time_hours ? this.seltime.time_hours : this.default_V.Hour;
      var time_minutes = this.seltime.time_minutes ? this.seltime.time_minutes : this.default_V.defMinute;

      var selhours = this.seltime.hours ? this.seltime.hours : this.default_V.defHour;
      var selminutes = this.seltime.minutes ? this.seltime.minutes : this.default_V.defMinute;

      var sendDate = this.sendDate + " " + time_hours + ":" + time_minutes;

      var endDate = this.endDate + " " + selhours + ":" + selminutes;
      var publishUserName = JSON.parse(localStorage.getItem("user")).realName;
      var obj = {
        // workName: this.workName || formatDate(timeStamp(), 'y年M月dd日')+this.selectedWorkName,
        workName: this.workName,
        workMessage: this.workMessage || "同学们请按时完成作业",
        completeDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(endDate),
        publishUserName: publishUserName,
        sendDate: this.sendDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(sendDate) : 0
        // sendDate: this.sendDate ? timeStamp(sendDate) : Math.ceil(+new Date() / 1000)
        // classList: gradsList
      };

      if (obj.endDate < obj.sendDate) {
        this.$toast("作业发送时间不能大于作业截止时间！", "error");
        return false;
      }
      if (this.publishType == 2) {
        obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj, {
          workMessageType: 1,
          publishType: 1,
          // sourceType: clientId,
          workType: 0,
          userList: this.getWorks().userList,
          bookId: 0,
          bookName: "",
          subjectId: this.paperSubjectId
        });
        var contents = [{
          workTag: 2,
          moduleId: 124,
          versionId: this.examinationID,
          packageId: "0",
          cId: "0",
          parentVersionId: "0",
          resourceName: this.examinationTitle,
          resourceType: "1f693f76-02f5-4a40-861d-a8503df5183f",
          checkedResource: "",
          requirementContent: {
            readtimes: 1,
            speekingtype: 1
          },
          workScore: this.paperScore
        }];
        this.setWorks({ contents: [] });
        this.setWorks({ contents: contents });
      }
      this.setWorks(obj);
      var workData = this.getWorks();
      console.log(workData);
      __WEBPACK_IMPORTED_MODULE_6__fetch__["a" /* default */].publish(workData).then(function (res) {
        if (!res.data) {
          var _this = _this4;
          setTimeout(function () {
            _this.$router.push({ path: "/login" });
          }, 2000);
          return false;
        }
        // if(workData.classList.length == 1) {
        //     window.localStorage.setItem("serviceId",this.serviceId)
        // }
        _this4.cleanCatalog();
        _this4.removeWorks();
        _this4.removeSubject();
        window.sessionStorage.setItem("pageIndex", 1);
        window.sessionStorage.removeItem('studentsTemp');

        _this4.$router.push({ path: "publishFinish" });
      });
    },
    isConfirm: function isConfirm() {
      var query = {
        bookType: 1
      };
      this.$router.push({ path: "selectObject", query: query });
    }
  })
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setState"]), {
    goFun: function goFun(index) {
      this.setState([0, index]);
      this.$router.push({ path: index ? "home" : "selectGrade" });
    }
  })
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__homeWorkContent_homeWorkContent_vue__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__homeWorkContent_homeWorkContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__homeWorkContent_homeWorkContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    homeworkcontent: __WEBPACK_IMPORTED_MODULE_4__homeWorkContent_homeWorkContent_vue___default.a
  },
  data: function data() {
    return {
      catalog: [], // 章节信息!!!!
      package: {},
      module: [],
      resourceName: "",
      cId: "",
      contents: [],
      unitId: 0,
      pageId: 0,
      itemId: 0,
      works: {},
      packageId: 0,
      serviceId: 0,
      subjectId: 0,
      serviceName: "",
      bookName: "",
      selected: false,
      selectedWorkName: "", //存储选中单元
      bookId: "",
      allTimes: 0,
      publishedBooks: []
    };
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    this.$nextTick(function () {
      var params = _this2.$route.query;
      _this2.bookId = params.bookId;
      _this2.serviceId = params.serviceId;
      _this2.packageId = params.packageId;
      _this2.bookName = params.bookName;
      _this2.cId = params.cId;
      console.log(params, "2.2");

      _this2.getRecengBook();
      var catalog = _this2.getCatalog();
      console.log(catalog);

      var subject = _this2.getSubject(); // 题目信息!!!!

      if (subject.length) {
        _this2.contents = _this2.getWorks().contents;
        _this2.module = subject;
        _this2.initQuestion();
      }
      if (catalog.length) {
        _this2.catalog = catalog;
        _this2.getCatalogChecked(catalog);
      } else {
        _this2.getCatalogs();
      }

      if (params.checkedResource) {
        _this2.routerData(params);
      }

      // window.localStorage.setItem("serviceId", this.serviceId)
    });
  },

  watch: {
    $route: "getCatalog"
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapActions */])(["setWorks", "setCrumb", "removeWorks", "setSuject", "setCatalog"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(["getWorks", "getSubject", "getCatalog", "getUser"]), {
    initData: function initData() {
      var params = {
        workType: this.serviceId,
        packageId: this.packageId,
        workMessageType: 1,
        brandId: __WEBPACK_IMPORTED_MODULE_5__config__["c" /* brandId */],
        sourceType: __WEBPACK_IMPORTED_MODULE_5__config__["b" /* clientId */],
        publishType: 1,
        bookId: this.bookId,
        bookName: this.bookName
      };
      this.setWorks(params);
    },
    getCatalogs: function getCatalogs() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__fetch__["a" /* default */].catalogues({ packageId: this.packageId, serviceId: this.serviceId }).then(function (res) {
        if (!res) {
          return false;
        }
        var data = res.data;
        _this3.catalog = data.catalogues;
        // this.bookName = data.packages.book_name;
        _this3.bookId = data.packages.package_id;
        _this3.setWorks({ subjectId: data.packages.subject_id });
        _this3.catalog.map(function (item) {
          item.count = 0;
        });
        _this3.initData();

        _this3.setCatalog(data.catalogues);
        // let firstSelect = []
        // for(let i=0,len=this.catalog.length;i<len;i++){
        //   firstSelect.push(this.catalog[0].id)

        // }
        _this3.setCatalogChecked([0, 0, 0, 0], true);
        // this.firstInitPage(data.catalogues);
        // if (this.$route.query.isFirst) {
        //   this.firstInitPage(data.catalogues);
        // }
      });
    },
    firstInitPage: function firstInitPage(catalogues) {
      if (!catalogues || !catalogues.length) return false;
      var first = void 0;
      var cId = 0;
      var name = "";
      var contents = this.getWorks().contents;
      if (contents && contents.length > 0) {
        cId = this.getSubject()[0].moduleInfo.packageCatalogueId; //获取到最后一次显示章节内容的ID,下次显示对应章节
        var _this = this;
        // 默认打开选中的第一个,下面逻辑处理显示对应章节
        catalogues.map(function (catalog, index) {
          if (catalog.children.length == 0) {
            if (catalog.id == cId) {
              name = catalog.name;
              _this.unitId = catalog.id;
            }
          } else {
            catalog.children.map(function (catalog2, index2) {
              if (catalog2.children.length == 0) {
                if (catalog2.id == cId) {
                  name = catalog2.name;
                  _this.unitId = catalog.id;
                  _this.pageId = catalog2.id;
                }
              } else {
                catalog2.children.map(function (catalog3, index3) {
                  if (catalog3.children.length == 0) {
                    if (catalog3.id == cId) {
                      name = catalog3.name;
                      _this.unitId = catalog.id;
                      _this.pageId = catalog2.id;
                      _this.itemId = catalog3.id;
                    }
                  }
                });
              }
            });
          }
        });
        !name && (cId = 0);
      } else {
        first = catalogues[0];
        this.unitId = first.id;
        if (!first.children.length) {
          cId = first.id;
          name = first.name;
        } else {
          var second = first.children[0];
          this.pageId = second.id;
          if (!second.children.length) {
            cId = second.id;
            name = second.name;
          } else {
            var third = second.children[0];
            cId = third.id;
            name = third.name;
            this.itemId = cId;
          }
        }
      }
      this.selectedWorkName = name; //选中单元赋值
      this.cId = cId;
      this.getResources(cId);
    },
    getRecengBook: function getRecengBook() {
      var _this4 = this;

      var params = {
        bookId: this.packageId,
        userId: this.getUser().userId
      };
      __WEBPACK_IMPORTED_MODULE_6__fetch__["a" /* default */].getRecentPublishBokk(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this4.publishedBooks = res.data;
      });
    },
    getCatalogChecked: function getCatalogChecked(data) {
      for (var index = 0, len = data.length; index < len; index++) {
        var item = data[index];
        if (item.checked && !item.children.length) {
          this.cId = item.id;
        } else if (item.children.length) {
          this.getCatalogChecked(item.children);
        }
      }
    },
    setCatalogChecked: function setCatalogChecked(arr, isFirst) {
      var catalog = this.catalog;
      this.mapCatalog(catalog, arr, 0, isFirst);
      this.catalog = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(catalog));
    },
    mapCatalog: function mapCatalog(catalogItem, arr, i, isFirst) {
      for (var index = 0, len = catalogItem.length; index < len; index++) {
        var item = catalogItem[index];
        item.checked = false;
        if (item.id == arr[i] || index == arr[i]) {
          ++i;
          item.checked = true;
        }

        if (index == 0 && isFirst && !item.children.length) {
          this.cId = item.id;
          this.getResources(item.id);
        } else if (item.children && item.children.length > 0) {
          this.mapCatalog(item.children, arr, i, isFirst);
        }

        if (item.id == arr[i] || index == arr[i]) {
          --i;
          break;
        }
      }
    },
    toggle: function toggle(typeId, item, arr) {
      if (typeId == 1) {
        this.pageId = item.id;
        this.setCatalogChecked(arr);
      } else if (typeId == 0) {
        this.unitId = item.id;
        this.setCatalogChecked(arr);
      } else if (typeId == 2) {
        this.itemId = item.id;
        this.setCatalogChecked(arr);
      }
      this.setCatalogChecked(arr);
      if (item.children.length) {
        return false;
      }
      this.selectedWorkName = item.name; //选中单元赋值
      this.selected = true;
      this.resourceName = item.name;
      this.cId = item.id; //每次点完的cid要保存到一个地方
      this.module = [];
      this.getResources(item.id);
    },
    getResources: function getResources(cId) {
      var _this5 = this;

      var params = {
        packageId: this.packageId,
        cId: cId,
        moduleIds: "10,15,30,66,124,123,127"
      };
      __WEBPACK_IMPORTED_MODULE_6__fetch__["a" /* default */].resources(params).then(function (res) {
        if (!res) {
          return false;
        }
        if (res) {
          _this5.module = res.data;
          _this5.setSuject([]);
          // this.setWorks({ contents: [] });
          // this.contents = [];
          _this5.initQuestion();
        }
      });
    },
    initQuestion: function initQuestion() {
      var _this6 = this;

      var contents = this.contents;
      if (!contents) {
        return false;
      }
      this.allTimes = 0;
      contents.map(function (item) {
        if (item.refLong) {
          _this6.allTimes += item.refLong;
        }
        _this6.getNewData({
          moduleId: item.moduleId,
          versionId: item.versionId,
          parentVersionId: item.parentVersionId,
          requirementContent: item.requirementContent,
          itemCount: item.itemCount,
          defAnswerTime: item.defAnswerTime,
          refLong: item.refLong,
          bigItemCount: item.bigItemCount,
          sentenceCount: item.sentenceCount,
          resourceName: item.resourceName,
          resourceType: item.resourceType
        }, true);
      });
    },
    subQuestion: function subQuestion() {
      if (!this.contents.length) {
        this.$toast("请选择布置内容");
        return false;
      }
      var title = this.addCatalogCount(0);
      var params = {
        selectedWorkName: title,
        type: 1,
        serviceId: this.serviceId
      };
      this.setWorks({ allTimes: this.allTimes });
      this.$router.push({ path: "publishBooks", query: params });
    },
    increment: function increment(res) {
      var _this7 = this;

      var _this = this;
      var selectContents = this.contents;
      var contents = [];
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        packageId: this.packageId,
        cId: this.cId,
        checkedResource: "",
        requirementContent: "",
        workTag: 1,
        refLong: res.refLong,
        bigItemCount: res.bigItemCount,
        itemCount: res.itemCount,
        sentenceCount: res.sentenceCount,
        second: res.second
      }, "cId", this.cId);
      selectContents.map(function (item) {
        var _this = _this7;
        if (item.resourceType == res.resourceType && item.resourceName == res.resourceName && item.versionId == res.versionId) {
          if (res.isChecked) {
            _this7.allTimes -= item.refLong;
            if (res.resourceType === "992a5055-e9d0-453f-ab40-666b4d7030bb") {
              item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDataToMinutes"])(item.sentenceCount * res.second * res.requirementContent.readtimes);
            } else {
              item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["formatDataToMinutes"])(item.itemCount * res.second * res.requirementContent.readtimes);
            }

            // item.refLong = formatDataToMinutes(res.requirementContent.readtimes * res.second * item.count);
          }
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, item);
        } else {
          contents.push(item);
        }
      });

      // res.refLong = params.refLong;
      // res.count = params.count;
      // res.sentenceCount = params.sentenceCount;
      if (res.isChecked) {
        if (this.contents.length >= 20 && res.change) {
          this.$toast("您最多可以勾选20条内容！", "error");
          return false;
        }
        if (res.refLong) {
          this.allTimes += params.refLong;
        }
        this.getNewData(res, true, function (item, moduleId, index) {
          params.moduleId = moduleId;
          params.requirementContent = '{"readtimes":' + res.requirementContent.readtimes + ', "speekingtype":' + res.requirementContent.speekingtype + "}";
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, item);
          contents.push(params);

          if (res.change) {
            _this.addCatalogCount(_this.cId, 1);
          }
        });
      } else {
        this.getNewData(res, false);
        this.addCatalogCount(this.cId, -1);
        if (params.refLong) {
          this.allTimes -= params.refLong;
        }
      }
      this.setWorks({ contents: [] });
      this.setWorks({ contents: contents });
      this.contents = contents;
      this.catalogCount();
    },
    catalogCount: function catalogCount() {
      var catalog = this.catalog;
      if (this.contents.length == 0) {
        catalog.map(function (item) {
          item.count = 0;
          item.children.map(function (item2) {
            item2.count = 0;
            item2.children.map(function (item3) {
              item3.count = 0;
            });
          });
        });
      } else {
        this.contents.map(function (res, index) {
          var cid = res.cId;
          catalog.map(function (item) {
            if (index == 0) item.count = 0;
            if (!item.children.length) {
              if (item.id === cid) {
                item.count++;
              }
            } else {
              var children = item.children;
              children.map(function (citem) {
                if (index == 0) citem.count = 0;
                if (!citem.children.length) {
                  if (cid === citem.id) {
                    item.count++;
                    if (!citem.count) {
                      citem.count = 0;
                    }
                    citem.count++;
                  }
                } else {
                  var grandson = citem.children;
                  grandson.map(function (gitem) {
                    if (index == 0) gitem.count = 0;
                    if (!gitem.children.length) {
                      if (cid == gitem.id) {
                        !citem.count && (citem.count = 0);
                        citem.count++;
                        item.count++;
                        if (!gitem.count) {
                          gitem.count = 0;
                        }
                        gitem.count++;
                      }
                    }
                  });
                }
              });
            }
          });
        });
      }
      this.catalog = catalog;
      this.setCatalog(this.catalog);
    },
    addCatalogCount: function addCatalogCount(cid, num) {
      var title = "";
      this.catalog.map(function (item) {
        // item.count = 0;
        if (!item.children.length) {
          if (item.id === cid) {
            item.count += num;
          }
          if (item.count) {
            title += item.name + ",";
          }
        } else {
          var children = item.children;
          children.map(function (citem) {
            if (!citem.children.length) {
              if (cid === citem.id) {
                item.count += num;
                if (!citem.count) {
                  citem.count = 0;
                }
                citem.count += num;
              }
              if (citem.count) {
                title += citem.name + ",";
              }
            } else {
              var grandson = citem.children;
              grandson.map(function (gitem) {
                if (!gitem.children.length) {
                  if (cid == gitem.id) {
                    !citem.count && (citem.count = 0);
                    citem.count += num;
                    item.count += num;
                    if (!gitem.count) {
                      gitem.count = 0;
                    }
                    gitem.count += num;
                  }
                }
                if (gitem.count) {
                  title += gitem.name + ",";
                }
              });
            }
          });
        }
      });
      this.setCatalog(this.catalog);
      return title;
    },
    getNewData: function getNewData(res, isChecked, cb) {
      var newData = [];
      this.module.map(function (item, index) {
        var moduleInfo = item.moduleInfo;
        // if (moduleInfo.moduleId != 30) {
        var resourceList = item.resourceList;
        var obj = {};
        obj.moduleInfo = moduleInfo;
        obj.resourceList = [];
        resourceList.map(function (rItem, rIndex) {
          if (rItem.resourceType == res.resourceType && rItem.resourceName == res.resourceName && rItem.versionId == res.versionId && rItem.parentVersionId == res.parentVersionId) {
            rItem.isChecked = isChecked;
            rItem.readtimes = res.requirementContent.readtimes;
            rItem.speekingtype = res.requirementContent.speekingtype;
            rItem.itemCount = res.itemCount;
            rItem.refLong = res.refLong;
            rItem.bigItemCount = res.bigItemCount;
            rItem.sentenceCount = res.sentenceCount;
            rItem.checkedResource = res.checkedResource || "";
            rItem.defAnswerTime = res.defAnswerTime;
            rItem.workScore = res.refScore;
            if (cb) {
              cb(rItem, moduleInfo.moduleId, rIndex);
            }
          }
          obj.resourceList.push(rItem);
        });
        newData.push(obj);
        // }
      });
      this.setSuject([]);
      this.setSuject(newData);
      this.module = newData;
    },
    routerData: function routerData(params) {
      var contents = this.contents;
      console.log(params, "%^(&*())))__)");
      var checkedResource = params.checkedResource.split(",");
      for (var i = 0, len = contents.length; i < len; i++) {
        var item = contents[i];
        if (item.resourceType == params.resourceType && item.moduleId == params.moduleId && item.versionId == params.versionId && item.parentVersionId == params.parentVersionId) {
          item.itemCount = item.resourceType == "fcfd6131-cdb6-4eb8-9cb9-031f710a8f15" ? params.bigQuesCount : params.count;
          item.bigItemCount = params.bigQuesCount;
          item.sentenceCount = params.sentenceCount;
          item.checkedResource = checkedResource.join(",");
          item.workScore = params.refScore;
          if (item.resourceType == '992a5055-e9d0-453f-ab40-666b4d7030bb') {
            item.refLong = Math.ceil(item.sentenceCount * item.defAnswerTime * item.readtimes / 60);
          } else {
            item.refLong = Math.ceil(item.itemCount * item.defAnswerTime * item.readtimes / 60);
          }
        }
        this.getNewData(item, true);
      }
      this.setWorks({ contents: [] });
      this.setWorks({ contents: contents });
    },
    back: function back() {
      var classIds = JSON.parse(window.sessionStorage.getItem("classIds")).classId;
      this.$router.push({
        path: "setHomework",
        query: { bookType: 1, classIdstr: classIds }
      });
    }
  })
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
     props: ["imgSrc"],
     data: function data() {
          return {
               imgFlag: true
          };
     },

     methods: {
          imgFun: function imgFun() {
               this.imgFlag = false;
               this.$emit("imgBigShow", this.imgFlag);
          }
     }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imitation_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imitation_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 阅读理解,该题型包含小题，小题类型有：1单选图、6简答题、7模仿朗读
 // 附件
 // 听说的tab
 // 附件
 // 1单选题
 // 3填空题
 // 6简答题
 // 7模仿朗读or简答题

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['page', 'moduleId', 'question', 'isShowAnswer', 'playerObj', 'qtype'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_2__attachments_vue___default.a,
        singleChoice: __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue___default.a,
        filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
        shortanswer: __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue___default.a,
        imitation: __WEBPACK_IMPORTED_MODULE_6__imitation_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {
        // debugger;
    },
    methods: {
        // 格式化填空
        fillFormatHtml: function fillFormatHtml(val) {
            var data = val;
            if (this.qtype == 9) {
                data = data.replace(/\s+style="[^"]*"/g, '');
            }
            return data.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },
        correctScore: function correctScore(_correctScore) {
            this.$emit('correctScore', _correctScore);
        }
    }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_audio_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_audio_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 附件
 // 音频组件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            letvFile: 1
        };
    },

    props: ['attachments', 'playerObj', 'id'],
    components: {
        theAudio: __WEBPACK_IMPORTED_MODULE_0__player_audio_vue___default.a
    },
    watch: {},
    created: function created() {
        this.$nextTick(function () {
            // this.handleUrl();
        });
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        handleUrl: function handleUrl(data) {
            var flagLetv = data.indexOf('letv://');
            if (flagLetv) {
                this.letvFile = 0;
            } else {
                return data;
            }
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },

        videoSrc: function videoSrc(item) {
            var src = item.substr(7);
            return 'pu=B6999F08EC&uu=2bfc338ed7&vu=' + src + '&auto_play=1&width=656&height=504';
        }
    }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__allFilling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reading_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__reading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imitation_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__imitation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__judge_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__judge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__judge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 试卷
 // 1单选题
 // 2多选题
 // 3填空题
 // 4完形填空 9 短文改错 10 语篇填空题
 // 5阅读理解
 // 6简答题
 // 7模仿朗读or简答题
 // 8判断题



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    singleChoice: __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default.a,
    multipleChoice: __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default.a,
    filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
    judge: __WEBPACK_IMPORTED_MODULE_9__judge_vue___default.a,
    allFilling: __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default.a,
    reading: __WEBPACK_IMPORTED_MODULE_6__reading_vue___default.a,
    shortanswer: __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue___default.a,
    imitation: __WEBPACK_IMPORTED_MODULE_8__imitation_vue___default.a
  },
  data: function data() {
    return {
      exampaper: { parts: [] },
      barHide: false,
      myUserAnswers: [],
      playerObj: 0,
      checkedResource: "",
      webloading: true,
      selectedExampaperArr: [],
      videoPlay: true,
      paperBtnInfo: true,
      questionNum: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
      doworkTime: 0
    };
  },

  props: ["page", "selectFlag", "moduleId", // 资源模块, 15[听说模考] / 124[在线作答]
  "exampaperData", // 试卷
  "userAnswers", // 用户答案
  "showdata", // 作业详情【显示的选题】
  "isShowAnswer", "packageId", "cId", "serviceId", "versionId", "padShow", "thirdParty", "doworkTimes"],
  watch: {
    barHide: function barHide(val) {
      this.barHide = val;
    },
    exampaperData: function exampaperData(val) {
      this.exampaperData = val;
      if (this.thirdParty) {
        var contents = this.getWorks().contents;
        if (this.page == "selectListenSpeak" || this.page == "selectOnlinePaper") {
          for (var i = 0, len = contents.length; i < len; i++) {
            if (this.versionId == contents[i].versionId) {
              this.checkedResource = contents[i].checkedResource;
            }
          }
          // if(this.exampaperData.checkedResourceEmpty==0){
          //    this.checkedResource = [];
          // }
          //给每个数据加上一个选中字段
          if (this.selectFlag) {
            for (var i = 0, len = this.exampaperData.parts.length; i < len; i++) {
              var item = this.exampaperData.parts[i];
              item.isChecked = false;
              item.buttonText = "选择大题";
              if (this.checkedResource.length == 0 || this.checkedResource.indexOf(i) > -1) {
                this.selectedExampaperArr.push(i);
                item.isChecked = true;
                item.buttonText = "取消选择";
              }
            }
          }
          if (this.page == "selectListenSpeak") {
            this.doworkTime = this.selectedExampaperArr.length * 180 || this.exampaperData.parts.length * 180;
          } else if (this.page == "selectOnlinePaper") {
            this.doworkTime = this.doworkTimes * 60;
          }
        }
      }
      this.mergeAnswerToExampaper();
    },
    userAnswers: function userAnswers(val) {
      this.myUserAnswers = val;
      if (this.myUserAnswers && this.exampaperData) {
        this.mergeAnswerToExampaper();
      }
    },
    exampaper: function exampaper(val) {
      // 空数组为全选状态
      if (this.selectedExampaperArr && this.selectedExampaperArr.length == 0 && this.exampaper.parts) {
        for (var i = 0; i < this.exampaper.parts.length; i++) {
          this.selectedExampaperArr.push(i);
        }
      }
    }
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(["getWorks"]), {
    choiceBigQ: function choiceBigQ(item, index) {
      item.isChecked = !item.isChecked;
      this.exampaperData.parts[index] = item;
      this.selectedExampaperArr = [];
      for (var i = 0, len = this.exampaperData.parts.length; i < len; i++) {
        var item = this.exampaperData.parts[i];
        if (item.isChecked) {
          item.buttonText = "取消选择";
          this.selectedExampaperArr.push(i);
        } else if (!item.isChecked) {
          item.buttonText = "选择大题";
        }
      }

      this.doworkTime = this.selectedExampaperArr.length * 180 || this.exampaperData.parts.length * 180; // 等于0的时候就是全选
    },
    back: function back() {
      if (this.selectFlag) {
        this.$router.push({
          path: "publishHomeWork",
          query: {
            serviceId: this.serviceId,
            packageId: this.packageId,
            cId: this.cId,
            isFirst: 0
          }
        });
      } else {
        this.$router.back(-1);
      }
    },

    // 题目数组回传
    backQuestionArr: function backQuestionArr() {
      var _this2 = this;

      if (this.selectFlag) {
        (function () {
          var count = _this2.selectedExampaperArr.length;
          var score = 0;
          //累加选中的题目分值
          for (var i = 0, len = _this2.selectedExampaperArr.length; i < len; i++) {
            var item = _this2.exampaper.parts[_this2.selectedExampaperArr[i]].children;
            if (item.length > 1) {
              item.forEach(function (item1, index1) {
                score = score + item1.question_ref_sorce;
              });
            } else if (item.length === 1) {
              if (item[0].children.length > 0) {
                for (var j = 0, len1 = item[0].children.length; j < len1; j++) {
                  score = score + item[0].children[j].question_ref_sorce;
                }
              } else if (item[0].children.length === 0) {
                score = score + item[0].question_ref_sorce;
              }
            }
          }
          if (_this2.selectedExampaperArr.length === 0) {
            count = _this2.exampaper.parts.length;
          }
          if (_this2.exampaper.parts && _this2.selectedExampaperArr.length == _this2.exampaper.parts.length && _this2.selectedExampaperArr.length === 0) {
            // 全选状态为空数组
            _this2.selectedExampaperArr = [];
            score = _this2.exampaper.ref_score;
          }
          _this2.$emit("submitExampaper", _this2.selectedExampaperArr, count, score, _this2.exampaperData.parts.length);
        })();
      } else {
        this.$router.back(-1);
      }
    },

    // 合并答案到试卷
    mergeAnswerToExampaper: function mergeAnswerToExampaper() {
      var exampaperData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.exampaperData));
      var userAnswers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.myUserAnswers));
      exampaperData = this.showPartList(exampaperData, this.showdata);
      for (var index = 0; index < exampaperData.parts.length; index++) {
        exampaperData.parts[index] = this.setUserAnswer(exampaperData.parts[index], userAnswers);
        exampaperData.parts[index] = this.sortAttachments(exampaperData.parts[index]);
      }

      this.exampaper = exampaperData;
      this.webloading = false;
    },

    // --------------------------答案处理函数-----------------------------------------
    // 只显示老师布置的作业题
    showPartList: function showPartList(result, showdata) {
      if (showdata && showdata.length > 0) {
        var _showdata = showdata.split(",");
        var arrayObj = new Array(); //创建一个数组
        _showdata.forEach(function (d, i) {
          var l = result.parts.length - 1;
          if (d <= l) {
            var ret = result.parts[d];
            arrayObj.push(ret);
          }
        });
        var _result = {
          title: result.title,
          ref_score: result.ref_score,
          curriculum_id: result.curriculum_id,
          parts: arrayObj,
          id: result.id,
          version_id: result.version_id
        };
        result = _result;
      }
      return result;
    },
    // 设置参考答案
    // answerIdArr:正确答案选项组，options：题目选项
    setRefAnswer: function setRefAnswer(question) {
      // if(!question) return false;
      var answerIdArr = question.ref_info.answers;
      var options = question.options;
      var result = [],
          arr = [];
      // 选择题答案解析
      if (question.qtype == 1) {
        for (var i = 0; i < answerIdArr.length; i++) {
          for (var j = 0; j < options.length; j++) {
            options[j].is_answer = false;
            if (options[j].id == answerIdArr[i]) {
              options[j].index = j;
              options[j].is_answer = true;
              arr.push(options[j]);
              break;
            }
          }
        }
      }

      if (arr != "") {
        question.options = options;
        question.ref_info.answers = arr;
      }
      this.webloading = false;
      return question;
    },
    // 设置用户答案
    setUserAnswer: function setUserAnswer(questions, userAnswers) {
      var _this = this;
      if (questions && questions.children) {
        questions.children.forEach(function (question, index) {
          question = _this.setRefAnswer(question);
          question.userAnswer = _this.findUserAnswer(userAnswers, question.version_id);
          question.children && question.children.length > 0 && _this.setUserAnswer(question, userAnswers);
          questions.children[index] = question;
        });
      }
      return questions;
    },
    // 查找对应试卷id用户答案
    findUserAnswer: function findUserAnswer(userAnswers, versionId) {
      var result;
      userAnswers.forEach(function (m) {
        if (m.versionId && m.versionId == versionId || m.version_id && m.version_id == versionId) {
          result = m;
        }
      });
      if (result && !(result.answers instanceof Array)) {
        result.answers = JSON.parse(result.answers);
      }
      return result;
    },
    // 附件排序
    sortAttachments: function sortAttachments(questions) {
      if (questions && questions.children) {
        questions.children.forEach(function (question, index) {
          var atta = question.attachments,
              audioArr = [],
              imgArr = [],
              videoArr = [];
          for (var i = 0, len = atta.length; i < len; i++) {
            if (atta[i].file_type == 1) imgArr.push(atta[i]);
            if (atta[i].file_type == 2) audioArr.push(atta[i]);
            if (atta[i].file_type == 3) videoArr.push(atta[i]);
          }
          question.attachments = audioArr.concat(videoArr).concat(imgArr);
          questions.children[index] = question;
        });
      }
      return questions;
    },
    videoSrc: function videoSrc(item) {
      return "pu=B6999F08EC&uu=2bfc338ed7&vu=" + item + "&auto_play=1&width=656&height=504";
    },
    paperInfo: function paperInfo() {
      this.paperBtnInfo = !this.paperBtnInfo;
    },
    videoPlayer: function videoPlayer() {
      this.videoPlay = false;
    },
    playedObj: function playedObj(playerObj) {
      this.playerObj = playerObj;
    },
    correctScore: function correctScore(_correctScore) {
      this.$emit("correctScore", _correctScore);
    }
  })
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 填空题

 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            fillIndex: '',
            handle: -1,
            scoreVal: '0',
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: '',
            changeAnswer: ''
        };
    },

    props: ['page', 'question', 'parentqtype', 'isShowAnswer', 'moduleId', 'playerObj'],
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = -1;
        });
        // this.altData();
        this.$nextTick(function () {
            _this.altData();
        });
    },

    watch: {
        question: function question(old) {
            this.altData();
        }
    },
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    methods: {
        altData: function altData() {
            var options = this.question.options;
            for (var i = 0; i < options.length; i++) {
                var stem = options[i].stem;
                try {
                    stem = JSON.parse(stem);
                    if (stem instanceof Array) {
                        options[i].stem = stem.join('/');
                    }
                } catch (e) {}
            }
            this.question.options = [];
            this.question.options = options;
        },

        // 格式化{}填空
        fillFormatHtml: function fillFormatHtml(val) {
            return val.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
        },

        // 设置填空题得分(0:未批改 1:对 2:错 3:半对 4:未知)
        setAssessFilling: function setAssessFilling(question, index) {
            var html;
            var theAnswer;
            question.userAnswer && question.userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return theAnswer = answer;
            });

            if (theAnswer !== undefined) {
                if (theAnswer.assess === 0) {
                    // 未批改
                    html = '评分中';
                } else if (theAnswer.assess === 4) {
                    return '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = theAnswer.assess == 1 ? (question.question_ref_sorce / question.options.length).toFixed(1) || 0 : theAnswer.score || theAnswer.item_score || 0;
                    html = parseFloat(html) + '分';
                }
            } else {
                html = 0 + '分';
            }

            return html;
        },

        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(question, index) {
            var msg = '',
                answerIcon = '';
            var userAnswer;
            question.userAnswer && question.userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return userAnswer = answer;
            });

            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : userAnswer.assess == 4 ? 'f-bandui' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
                //                    msg = userAnswer.assess==4?'?':'';
            }
            //                if(msg) msg = '<span class="f-error_txt">'+msg+'</span>';
            return answerIcon || msg;
        },

        // 填空题用户答案
        setFillingAnswer: function setFillingAnswer(userAnswer, index) {
            var result = '';
            userAnswer && userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return result = answer.content;
            });
            return result;
        },
        setNewAns: function setNewAns(question, $index) {
            //过滤掉userAnswer 没有 或者分数为0的
            if (question.userAnswer.assess == 6 || question.userAnswer.answers[$index].assess == 6 || question.is_objective == 1) {
                return false;
            }
            var lenAns = question.userAnswer.answers.length - 1;
            var flag = $index > lenAns;
            if (flag) {
                return false;
            }
            this.halfRight = true;
            this.Cright = true;
            this.C_error = true;
            this.handle = $index;
            this.scoreVal = "";
        },
        handleHr: function handleHr(question, ind) {
            this.halfRight = false;
            this.Cright = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / question.options.length / 2).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCr: function handleCr(question, ind) {
            this.Cright = false;
            this.halfRight = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / question.options.length).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCe: function handleCe(question, ind) {
            this.C_error = false;
            this.halfRight = true;
            this.Cright = true;
            this.scoreVal = 0;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        checkPrice: function checkPrice(question, ind, val) {
            //输入值
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            } else if (val < 0) {
                this.$toast('最小分数为0', 'error');
                return false;
            }
            this.scoreVal = val * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },

        //确定
        sentNewSocre: function sentNewSocre(question, ind, val) {
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            var arrFlag = [0, 0, 0];
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            }
            question.userAnswer.answers[ind].score = this.scoreVal; //单个选项的分数改变
            if (this.scoreVal == 0) {
                question.userAnswer.answers[ind].assess = 2; //错
            } else if (this.scoreVal == maxScore) {
                question.userAnswer.answers[ind].assess = 1; //全对
            } else {
                question.userAnswer.answers[ind].assess = 3; //半对
            }
            this.handle = -1;
            this.correctContents.score = 0;
            for (var i = 0, len = this.correctContents.answers.length; i < len; i++) {
                var item = this.correctContents.answers[i];
                if (!item.score) {
                    item.assess == 1 ? item.score = maxScore : item.assess == 3 ? item.score = maxScore / 2 : item.score = 0;
                }
                this.correctContents.score += item.score * 1;
                if (item.assess == 1) {
                    //dui
                    arrFlag[0]++;
                } else if (item.assess == 2) {
                    //cuo
                    arrFlag[1]++;
                } else if (item.assess == 3) {
                    //bandui
                    arrFlag[2]++;
                }
            }
            if (arrFlag[0] == 3) {
                this.correctContents.score = question.question_ref_sorce * 1;
            }
            var flag = question.options.length; //参考答案的长度
            flag == arrFlag[0] ? this.correctContents.assess = 1 : arrFlag[2] > 0 || arrFlag[0] > 0 ? this.correctContents.assess = 3 : this.correctContents.assess = 2;
            this.$emit("correctScore", this.correctContents);
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_audio_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__player_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__);


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 模仿朗读或简答题


 // 音频组件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            handle: false,
            scoreVal: '0',
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: ''
        };
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj', 'id'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_3__player_audio_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue___default.a
    },
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = false;
        });
    },

    computed: {},
    methods: (_methods = {
        subPlayStatus: function subPlayStatus(val) {
            this.myIsPlay = val;
            console.log(val);
        },

        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'subPlayStatus', function subPlayStatus(val) {
        this.myIsPlay = val;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setNewAns', function setNewAns(question) {
        //过滤没有作答的 批改不显示
        if (question.userAnswer == undefined || question.userAnswer.assess == 6 || question.is_objective == 1) {
            return false;
        }
        this.handle = true;
        this.halfRight = true;
        this.Cright = true;
        this.C_error = true;
        this.scoreVal = "";
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleHr', function handleHr(question) {
        //半对
        this.halfRight = false;
        this.Cright = true;
        this.C_error = true;
        this.scoreVal = (question.question_ref_sorce / 2).toFixed(1) * 1;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleCr', function handleCr(question) {
        //对
        this.Cright = false;
        this.halfRight = true;
        this.C_error = true;
        this.scoreVal = question.question_ref_sorce;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleCe', function handleCe(question) {
        //错
        this.C_error = false;
        this.halfRight = true;
        this.Cright = true;
        this.scoreVal = 0;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'checkPrice', function checkPrice(question, val) {
        //输入值
        this.scoreVal = val * 1;
        var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
        if (val > maxScore) {
            this.$toast('最大分数不能超过该题分值', 'error');
            return false;
        } else if (val < 0) {
            this.$toast('最小分数为0', 'error');
            return false;
        }

        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'sentNewSocre', function sentNewSocre(question, maxScore, val) {
        if (val > maxScore) {
            this.$toast('最大分数不能超过该题分值', 'error');
            return false;
        }
        question.userAnswer.score = this.scoreVal; //一道题的分数改变
        question.userAnswer.answers.score = this.scoreVal; //单个选项的分数改变
        if (this.scoreVal == 0) {
            question.userAnswer.assess = 2; //改变批改状态
        } else if (this.scoreVal == maxScore) {
            question.userAnswer.assess = 1; //改变批改状态
        } else {
            question.userAnswer.assess = 3; //改变批改状态
        }
        this.handle = false;
        this.$emit("correctScore", this.correctContents);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'playedObj', function playedObj(playerObj) {
        this.$emit('playedObj', playerObj);
    }), _methods)
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 判断题

 // 附件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },

        //设置答案
        setAnswers: function setAnswers(answers) {
            return answers.indexOf('1') ? '错误' : '正确';
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			topicActive: '1'
		};
	},

	props: ['infoAnswer', 'listenTextModule', 'qtype'],
	methods: {
		tabListen: function tabListen(index) {
			this.topicActive = index;
		},
		setRefAnswer: function setRefAnswer(options, ref_info) {
			var _this = this;
			var result = '';
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (ref_info) {
					// 不是参考答案
					for (var j = 0; j < ref_info.answers.length; j++) {
						var answer = ref_info.answers[j];
						if (answer == option.id) {
							result += String.fromCharCode(65 + i) + ' ';
						}
					}
				}
			}
			return result;
		},

		// 格式化答案
		formatAnswers: function formatAnswers(text) {
			var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
			var jsgExp = /#JSGF/; //过滤简答题的答案
			if (regExp.test(text)) {
				text = text.replace(regExp, '');
			}
			if (jsgExp.test(text)) {
				text = '答案略';
			}
			return text.replace(/&nbsp;/g, ' ');
		}
	}
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 多选题
 // 附件
 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },
        setRefAnswer: function setRefAnswer(options, ref_info) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (ref_info) {
                    // 不是参考答案
                    for (var j = 0; j < ref_info.answers.length; j++) {
                        var answer = ref_info.answers[j];
                        if (answer == option.id) {
                            result += String.fromCharCode(65 + i) + ' ';
                        }
                    }
                }
            }

            return result;
        },

        // 用户答案选项
        setUserAnswer: function setUserAnswer(options, userAnswer) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (userAnswer) {
                    // 不是参考答案
                    var isCorrect = false;

                    for (var j = 0; j < userAnswer.answers.length; j++) {
                        var answer = userAnswer.answers[j];
                        if (_this.moduleId == 15) {
                            // 答案类型(1:音频文件 2:选项ID 3:填空题答案)
                            if (answer.answerType == 2 && answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        } else if (_this.moduleId == 124) {
                            // 答案类型(1:字符串 2:音频文件)
                            if (answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        }
                    }
                }
            }

            return result;
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__allFilling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imitation_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__imitation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__judge_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__judge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__judge_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 阅读理解,该题型包含小题，小题类型有：1单选图、6简答题、7模仿朗读
 // 附件
 // 附件
 // 1单选题
 // 2多选题
 // 3填空题
 // 4完形填空
 // 6简答题
 // 7模仿朗读or简答题
 // 8判断题

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['moduleId', 'question', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default.a,
        singleChoice: __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default.a,
        multipleChoice: __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default.a,
        filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
        allFilling: __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default.a,
        shortanswer: __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue___default.a,
        imitation: __WEBPACK_IMPORTED_MODULE_7__imitation_vue___default.a,
        judge: __WEBPACK_IMPORTED_MODULE_8__judge_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {
        // debugger;
    },
    methods: {
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },
        correctScore: function correctScore(_correctScore) {
            this.$emit('correctScore', _correctScore);
        }
    }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_audio_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__player_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 简答题


 // 音频组件
 // 在线的tab 
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            handle: false,
            scoreVal: 0,
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: '',
            bigImgShow: false,
            imgUrl: '',
            imgFlag: false
        };
    },

    props: ['page', 'question', 'parentqtype', 'isShowAnswer', 'moduleId', 'playerObj', 'id', 'padShow', 'underlineF'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_2__player_audio_vue___default.a,
        bigImgShow: __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default.a
    },
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = false;
        });
    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : userAnswer.assess == 4 ? 'f-bandui' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
            }
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },
        matchUrl: function matchUrl(val) {
            var reg = /\S.[jpg|png|jpeg]$/;
            if (reg.test(val)) {
                this.bigImgShow = true;
                this.imgUrl = val;
                return '<img src=' + val + ' class="width_20">';
            } else {
                return val;
            }
        },
        imgFun: function imgFun(val) {
            this.imgFlag = true;
        },
        imgBigShow: function imgBigShow(val) {
            this.imgFlag = val;
        },
        setNewAns: function setNewAns(question) {
            //过滤没有作答的 批改不显示
            if (question.userAnswer.assess == 6 || question.is_objective == 1) {
                return false;
            }
            this.handle = !this.handle;
            this.scoreVal = 0;
        },
        handleHr: function handleHr(question) {
            //半对
            this.halfRight = false;
            this.Cright = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / 2).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCr: function handleCr(question) {
            //对
            this.Cright = false;
            this.halfRight = true;
            this.C_error = true;
            this.scoreVal = question.question_ref_sorce;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCe: function handleCe(question) {
            //错
            this.C_error = false;
            this.halfRight = true;
            this.Cright = true;
            this.scoreVal = 0;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        checkPrice: function checkPrice(question, val) {
            //输入值
            this.scoreVal = val * 1;
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            } else if (val < 0) {
                this.$toast('最小分数为0', 'error');
                return false;
            }
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },

        //确定
        sentNewSocre: function sentNewSocre(question, maxScore, val) {

            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            }
            question.userAnswer.score = this.scoreVal; //一道题的分数改变
            question.userAnswer.answers.score = this.scoreVal; //单个选项的分数改变
            if (this.scoreVal == 0) {
                question.userAnswer.assess = 2; //改变批改状态
            } else if (this.scoreVal == maxScore) {
                question.userAnswer.assess = 1; //改变批改状态
            } else {
                question.userAnswer.assess = 3;
            }
            this.handle = false;
            this.$emit("correctScore", this.correctContents);
        },
        subPlayStatus: function subPlayStatus(val) {
            this.myIsPlay = val;
            console.log(val);
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 单选题
 // 附件
 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },

        // 用户答案选项
        setUserAnswer: function setUserAnswer(options, userAnswer) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (userAnswer) {
                    // 不是参考答案
                    var isCorrect = false;

                    for (var j = 0; j < userAnswer.answers.length; j++) {
                        var answer = userAnswer.answers[j];
                        if (_this.moduleId == 15) {
                            // 答案类型(1:音频文件 2:选项ID 3:填空题答案)
                            if (answer.answerType == 2 && answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        } else if (_this.moduleId == 124) {
                            // 答案类型(1:字符串 2:音频文件)
                            if (answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        }
                    }
                }
            }

            return result;
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_video_vue__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_video_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			topicActive: '1',
			videoP: true,
			myIsPlay: false,
			audio: null,
			explainsTags: [],
			emptyFlag: true
		};
	},

	props: ['infoAnswer', 'knowledgePoints', 'explains', 'tags', 'skillPoints', 'qtype'],
	components: {
		videoletv: __WEBPACK_IMPORTED_MODULE_0__player_video_vue___default.a
	},
	created: function created() {
		if (this.infoAnswer) {
			this.topicActive = 1;
		} else if (this.knowledgePoints.length > 0) {
			this.topicActive = 2;
		} else if (this.explains[0]) {
			this.topicActive = 3;
		} else if (this.tags) {
			this.topicActive = 4;
		} else if (this.skillPoints.length > 0) {
			this.topicActive = 5;
		} else {
			this.emptyFlag = false;
		}
		this.correctFlag = this.correctFill;
	},

	methods: {
		topicAct: function topicAct(index) {
			this.topicActive = index;
		},
		videoSrc: function videoSrc(item) {
			var src = item.substr(7);
			// return 'http://yuntv.letv.com/bcloud.html?uu=2bfc338ed7&vu='+ src +'&width=300&height=150&&pu=B6999F08EC'
			return 'pu=B6999F08EC&uu=2bfc338ed7&vu=' + src + '&auto_play=1&width=656&height=504';
		},
		setAnswers: function setAnswers(answers) {
			return answers.indexOf('1') ? '错误' : '正确';
		},
		setRefAnswer: function setRefAnswer(options, ref_info) {
			var _this = this;
			var result = '';
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (ref_info) {
					// 不是参考答案
					for (var j = 0; j < ref_info.answers.length; j++) {
						var answer = ref_info.answers[j];
						if (answer == option.id) {
							result += String.fromCharCode(65 + i) + ' ';
						}
					}
				}
			}
			return result;
		},
		setShortAnswer: function setShortAnswer(item) {
			if (typeof item == 'string') {
				try {
					var data = JSON.parse(item);
					if (data instanceof Array) {
						return data.join("/");
					} else {
						if (data.instead || data.add || data.isDelete) {
							var strHtml = '';
							if (data.instead) {
								strHtml += '改为' + data.instead + '/';
							}
							if (data.add) {
								strHtml += '单词前加' + data.add + '/';
							}
							if (data.isDelete) {
								strHtml += '删除' + '/';
							}
							return strHtml.replace(/\/$/g, '');
						}
					}
				} catch (error) {
					return item;
				}
			}
		},

		player: function player() {
			this.audio = document.querySelector('audio');
			this.audio.play();
			this.myIsPlay = true;
			var _this = this;
			this.audio.addEventListener('ended', function () {
				_this.myIsPlay = false;
			});
		},
		videoPlayer: function videoPlayer() {
			this.videoP = false;
		}
	}
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rankErrorOnline__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rankErrorOnline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rankErrorOnline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rankErrorRead__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rankErrorRead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rankErrorRead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rankErrorText__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rankErrorText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rankErrorText__);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      readShow: ""
    };
  },

  components: {
    rankErrorOnline: __WEBPACK_IMPORTED_MODULE_2__rankErrorOnline___default.a,
    rankErrorRead: __WEBPACK_IMPORTED_MODULE_3__rankErrorRead___default.a,
    rankErrorText: __WEBPACK_IMPORTED_MODULE_4__rankErrorText___default.a
  },
  props: ["exampaperData", "paperType", "useAnswer", "moduleId", "checkedResource"],
  watch: {
    //监听文件类型 
    paperType: function paperType(val) {
      this.isReadShow();
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.isReadShow();
    });
  },

  methods: {
    //格式化题干 qtype==3
    isReadShow: function isReadShow() {
      if (this.paperType == "a7527f97-14e6-44ef-bf73-3039033f128e") {
        this.readShow = "ReadShow";
      } else if (this.paperType == "992a5055-e9d0-453f-ab40-666b4d7030bb") {
        this.readShow = "TextShow";
      } else {
        this.readShow = "OnlineShow";
      }
    }
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bottomShow: true,
      progressW: 40,
      paperData: [],
      webloading: true,
      loadingImg: './img/loading.gif'
    };
  },

  props: ["workData", "answerData", "moduleId", "checkedResource"],
  watch: {
    workData: function workData(val) {
      this.mergeOnlineAnswer();
    }
  },
  created: function created() {
    this.$nextTick(function () {
      // this.setCrumb('作业统计');
    });
  },

  methods: {
    //格式化题干 完型填空 qtype==3
    fillFormatHtml: function fillFormatHtml(val) {
      return val.replace(/{#blank#}(\d*){#\/blank#}/g, '___$1___');
    },

    //过滤html标签
    delHtmlTag: function delHtmlTag(str) {
      str = this.fillFormatHtml(str);
      return str.replace(/<[^>]+>/g, "");
    },

    //处理试卷答案
    mergeOnlineAnswer: function mergeOnlineAnswer() {
      var checkStr = this.checkedResource;
      var workDataParts = new Array();
      if (checkStr == "") {
        workDataParts = this.workData.parts;
      } else {
        var strArr = new Array();
        strArr = checkStr.split(',');
        for (var l = 0, lenL = strArr.length; l < lenL; l++) {
          var itemL = strArr[l] * 1; //筛选作业内容
          workDataParts.push(this.workData.parts[itemL]);
        }
      }
      if (!workDataParts) {
        return false;
      }
      for (var i = 0, len = workDataParts.length; i < len; i++) {
        var item = workDataParts[i];
        var itemChildren = item.children;
        for (var k = 0, lenK = itemChildren.length; k < lenK; k++) {
          var itemCC = itemChildren[k];
          if (itemCC.children.length == "") {
            for (var j = 0, lenJ = this.answerData.statistics.length; j < lenJ; j++) {
              var itemAnswer = this.answerData.statistics[j];
              if (itemAnswer.versionId == itemCC.version_id) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(itemCC, itemAnswer);
              }
            }
          } else {
            var itemCCC = itemCC.children;
            for (var n = 0, lenN = itemCCC.length; n < lenN; n++) {
              var itemCCCS = itemCCC[n];
              for (var _j = 0, _lenJ = this.answerData.statistics.length; _j < _lenJ; _j++) {
                var _itemAnswer = this.answerData.statistics[_j];
                if (_itemAnswer.versionId == itemCCCS.version_id) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(itemCCCS, _itemAnswer);
                }
              }
            }
          }
        }
      }
      this.paperData = workDataParts;
      this.webloading = false;
    },
    watchTotal: function watchTotal(item) {
      var versionid = item.version_id;
      this.$router.push({ path: 'watchSinglePaper', query: { vid: versionid, moduleId: this.moduleId } });
    },
    watchSigle: function watchSigle(item) {
      var version_id = item.version_id;
      this.$router.push({ path: 'watchSinglePaper', query: { vid: version_id, moduleId: this.moduleId } });
    },

    //转换成两位小数
    toMathThree: function toMathThree(num) {
      var str = str = parseFloat(parseFloat(num).toFixed(2));
      return str;
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paperData: [],
      progressW: 30
    };
  },

  props: ["workData", "answerData", "checkedResource"],
  watch: {
    workData: function workData(val) {
      this.mergeAnswer();
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.mergeAnswer();
    });
  },

  methods: {
    mergeAnswer: function mergeAnswer() {
      var checkedWorkData = new Array();
      var checkStr = this.checkedResource;
      if (checkStr == "") {
        checkedWorkData = this.workData;
      } else {
        var strArr = new Array();
        strArr = checkStr.split(',');
        for (var j = 0, len = this.workData.length; j < len; j++) {
          var sigleData = this.workData[j];
          for (var k = 0, lenK = strArr.length; k < lenK; k++) {
            var checkWord = strArr[k];
            if (sigleData.versionId == checkWord * 1) {
              checkedWorkData.push(sigleData);
            }
          }
        }
      }
      var workData = [];
      for (var i = 0, _len = checkedWorkData.length; i < _len; i++) {
        var item = checkedWorkData[i];
        for (var _j = 0, lenJ = this.answerData.statistics.length; _j < lenJ; _j++) {
          var itemAnswer = this.answerData.statistics[_j];
          if (itemAnswer.versionId == item.versionId) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, itemAnswer);
          }
        }
        workData.push(item);
      }
      this.paperData = workData;
    },

    //转换成两位小数
    toMathThree: function toMathThree(num) {
      var str = str = parseFloat(parseFloat(num).toFixed(2));
      return str;
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paperData: [],
      progressW: 30
    };
  },

  props: ["workData", "answerData", "checkedResource"],
  watch: {
    workData: function workData(val) {
      this.mergeAnswer();
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.mergeAnswer();
    });
  },

  methods: {
    mergeAnswer: function mergeAnswer() {
      var checkedWorkData = new Array();
      var checkStr = this.checkedResource;
      if (checkStr == "") {
        checkedWorkData = this.workData;
      } else {
        var strArr = new Array();
        strArr = checkStr.split(',');
        for (var j = 0, len = this.workData.length; j < len; j++) {
          var sigleData = this.workData[j];
          for (var k = 0, lenK = strArr.length; k < lenK; k++) {
            var checkWord = strArr[k];
            if (sigleData.sentences[0].versionId == checkWord * 1) {
              checkedWorkData.push(sigleData);
            }
          }
        }
      }
      var workData = [];
      for (var i = 0, _len = checkedWorkData.length; i < _len; i++) {
        var item = checkedWorkData[i];
        for (var _k = 0, _lenK = item.sentences.length; _k < _lenK; _k++) {
          var itemC = item.sentences[_k];
          for (var _j = 0, lenJ = this.answerData.statistics.length; _j < lenJ; _j++) {
            var itemAnswer = this.answerData.statistics[_j];
            if (itemAnswer.versionId == itemC.versionId) {
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(itemC, itemAnswer);
            }
          }
        }
        workData.push(item);
      }
      this.paperData = workData;
    },

    //转换成两位小数
    toMathThree: function toMathThree(num) {
      var str = str = parseFloat(parseFloat(num).toFixed(2));
      return str;
    },
    matchCont: function matchCont(val) {
      return val.replace(/\{/g, '').replace(/\}/g, '');
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import watchStu from "../watchStukw/watchStukw.vue"
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sort: {
        key: 'index',
        val: 1
      }
    };
  },

  props: ['list', 'unlist', 'hList'],
  computed: {
    players: function players() {
      var arr = [];
      arr = this.list;
      this.sortTable(arr);
      return arr;
    }
  },
  methods: {
    sortTable: function sortTable(arr) {
      var _this = this;
      arr.sort(function (a, b) {
        if ('userName' == _this.sort.key) {
          if (a[_this.sort.key].localeCompare(b[_this.sort.key]) >= 0) {
            return _this.sort.val;
          } else {
            return -_this.sort.val;
          }
        } else {
          if (a[_this.sort.key] >= b[_this.sort.key] || !a[_this.sort.key]) {
            return _this.sort.val;
          } else {
            return -_this.sort.val;
          }
        }
      });
    },
    toMathTwo: function toMathTwo(num) {
      var str = str = parseFloat(parseFloat(num).toFixed(2));
      return str;
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["rankTableData", "singleData", "workId", "contentId", "activeIndex", "hasQuestion", "url"],
  data: function data() {
    return {
      ResType_DanCiGenDu: "a7527f97-14e6-44ef-bf73-3039033f128e",
      ResType_Xuanzeduanluo: "992a5055-e9d0-453f-ab40-666b4d7030bb",
      flag: true,
      current: 1,
      type: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      console.log(_this.url);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    checkMore: function checkMore(item, index) {
      if (!item.submitCount) {
        return false;
      }
      var moduleId = item.moduleId;
      var userdata = this.getUser();
      var url = window.location.href;
      var flag = void 0;
      var http = "/exam/#/";
      var params = "?resourceType=" + item.resourceType + "&parentVersionId=" + item.parentVersionId + "&versionId=" + item.versionId + "&moduleId=" + item.moduleId + "&doWorkId=" + item.doWorkId + "&workId=" + this.workId + "&contentId=" + this.contentId + "&activeIndex=" + this.activeIndex + "&rank=" + index + "&accessToken=" + userdata.accessToken + "&clientId=" + userdata.clientId + "&redirectUrl=" + url;
      if (moduleId == 124 || moduleId == 15) {
        // 跳转到查看检查作业
        window.location.href = http + "checkonlineExam" + params;
      } else if (moduleId == 66) {
        window.location.href = http + "selectInteract" + params;
      } else if (moduleId == 30) {
        window.location.href = http + "checkBaotingxie?" + "&rank=" + index + "&resourceType=" + item.resourceType + "&parentVersionId=" + item.parentVersionId + "&versionId=" + item.versionId + "&moduleId=" + item.moduleId + "&doWorkId=" + item.doWorkId + "&workId=" + this.workId + "&contentId=" + this.contentId + "&activeIndex=" + this.activeIndex + "&flag=" + (item.resourceType == this.ResType_DanCiGenDu ? 1 : 0) + "&accessToken=" + userdata.accessToken + "&clientId=" + userdata.clientId + "&redirectUrl=" + url;
      } else {
        window.location.href = http + "checkRead?" + "&rank=" + index + "&doWorkId=" + item.doWorkId + "&workId=" + this.workId + "&contentId=" + this.contentId + "&activeIndex=" + this.activeIndex + "&flag=" + (item.resourceType == this.ResType_DanCiGenDu ? 1 : 0) + "&accessToken=" + userdata.accessToken + "&clientId=" + userdata.clientId + "&redirectUrl=" + url;
      }
    },
    compare: function compare(data, flag) {
      return function (a, b) {
        var value1 = a[data];
        var value2 = b[data];
        if (!flag) {
          return value1 - value2;
        } else {
          return value2 - value1;
        }
      };
    }
  })
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rankTable_rankTable_vue__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rankTable_rankTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rankTable_rankTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rankWorkTable_rankWorkTable_vue__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rankWorkTable_rankWorkTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rankWorkTable_rankWorkTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rankError_rankError_vue__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rankError_rankError_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rankError_rankError_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      workList: "",
      workName: "",
      contentList: "",
      activeIndex: -1, //tab索引
      collectData: "",
      averageGrad: 0,
      isShow: false,
      collectHeader: [],
      workScore: "",
      rankTableData: "",
      singleData: "",
      reviceObject: "",
      hasQuestion: true,
      workId: '',
      contentId: '',
      url: ''
    };
  },

  components: {
    rankTable: __WEBPACK_IMPORTED_MODULE_2__rankTable_rankTable_vue___default.a,
    rankWorkTable: __WEBPACK_IMPORTED_MODULE_3__rankWorkTable_rankWorkTable_vue___default.a,
    rankError: __WEBPACK_IMPORTED_MODULE_4__rankError_rankError_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.workList = _this.$route.query;
      _this.activeIndex = _this.workList.index;
      _this.workId = _this.workList.workId;
      _this.toFetchStatistics(_this.workId);
      _this.reviceObject = _this.$route.query.reviceObject;
    });
  },


  methods: {
    goback: function goback() {
      this.$router.push({ path: "home" });
    },
    showInfo: function showInfo() {
      this.isShow = !this.isShow;
    },

    // 点击激活状态
    tabFun: function tabFun(index, contentId) {
      this.activeIndex = index;
      if (index > -1) {
        this.getFinishier(contentId);
      } else {
        this.toFetchStatistics(this.workId);
      }
    },

    //获取成绩汇总
    toFetchStatistics: function toFetchStatistics(workId) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getEworkStatistics({ workId: workId }).then(function (res) {
        if (!res) {
          return false;
        }
        that.filteData(res.data);
      });
    },
    filterStudents: function filterStudents(headerData, newTabDatas) {
      var array = [];
      var len = newTabDatas.length;
      headerData.map(function (hItem) {
        var i = 0;
        for (var index = 0; index < len; index++) {
          var element = newTabDatas[index];
          if (element.id == hItem.id) {
            var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, hItem, element);
            array.push(newData);
            break;
          }
          i++;
        }
        if (i === len) {
          array.push({
            score: "未提交"
          });
        }
      });
      return array;
    },
    filteData: function filteData(workData) {
      var _this2 = this;

      this.workName = workData.work.workName;
      this.contentList = workData.work.contentList;
      var headerData = workData.header[2];
      this.collectHeader = headerData;
      this.workScore = workData.header[3];
      var students = workData.receivers;
      var records = workData.records;
      var $this = this;
      this.setCorrectMark(records);
      this.collectData = students.map(function (sItem) {
        var unreceiver = 0;
        if (!sItem.tabDatas) {
          var tabDatas = [];
          _this2.contentList.map(function (c_item) {
            tabDatas.push({
              score: "未提交"
            });
          });
          sItem.tabDatas = tabDatas;
        }
        for (var j = 0, lens = records.length; j < lens; j++) {
          var item = records[j];
          var newTabDatas = item.tabDatas;
          var len = newTabDatas.length;

          if (sItem.userId === item.userId) {
            unreceiver = 0;
            if (headerData.length !== len) {
              item.tabDatas = $this.filterStudents(headerData, newTabDatas);
            }
            sItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, sItem, item);
            break;
          }
          unreceiver++;
        }
        if (unreceiver) {
          var _tabDatas = $this.filterStudents(headerData, []);
          sItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, sItem, { tabDatas: _tabDatas, totalScore: 0 });
        }
        return sItem;
      });

      // 成绩汇总时候，显示方式按照总分从高到低显示
      var newData = this.collectData;
      for (var index = 0; index < newData.length; index++) {
        for (var j = index + 1; j < newData.length; j++) {
          if (newData[index].totalScore < newData[j].totalScore) {
            var temp = newData[index];
            newData[index] = newData[j];
            newData[j] = temp;
          }
        }
      }
      this.collectData = newData;
      if (this.activeIndex > -1) {
        var contentId = this.contentList[this.activeIndex].contentId;
        this.getFinishier(contentId);
      }
    },
    setCorrectMark: function setCorrectMark(records) {
      var contentList = this.contentList;
      contentList.map(function (item) {
        item.correctMark = false;
        records.map(function (ritem) {
          for (var i = 0, len = ritem.tabDatas.length; i < len; i++) {
            var sitem = ritem.tabDatas[i];
            if (sitem.id == item.contentId && (sitem.workStatus == 15 || sitem.workStatus == 17)) {
              item.correctMark = true;
            }
          }
        });
      });
      this.contentList = contentList;
    },

    // 获取单个作业数据
    getFinishier: function getFinishier(contentId) {
      var _this3 = this;

      this.contentId = contentId;
      var user = JSON.parse(window.localStorage.getItem('user'));
      this.url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* http */] + "/gateway/v1/epaperstatistics/exportContentReport?" + 'clientId=' + __WEBPACK_IMPORTED_MODULE_5__config__["b" /* clientId */] + '&contentId=' + this.contentId + "&accessToken=" + user.accessToken;
      var params = {
        contentId: contentId,
        workId: this.workId
      };
      __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].finishier(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.hasQuestion = res.data[0].hasQuestion;
        _this3.rankTableData = res.data;
        _this3.average();
        _this3.singleData = {
          resourceName: _this3.contentList[_this3.activeIndex].resourceName,
          moduleId: _this3.contentList[_this3.activeIndex].moduleId,
          speekingtype: JSON.parse(_this3.contentList[_this3.activeIndex].requirementContent).speekingtype,
          readtimes: JSON.parse(_this3.contentList[_this3.activeIndex].requirementContent).readtimes,
          averageGrad: _this3.averageGrad,
          count: _this3.count,
          resourceType: _this3.contentList[_this3.activeIndex].resourceType,
          workScore: _this3.contentList[_this3.activeIndex].workScore
        };
      });
    },
    average: function average() {
      var count = 0;
      var score = 0;
      this.rankTableData.map(function (item) {
        if (item.submitDate) {
          score += item.actualScore;
          count++;
        }
      });
      this.averageGrad = score ? score / count : 0;
      this.count = count;
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["collectHeader", "collectData", "workScore", "url"],
  data: function data() {
    return {
      exportUrl: ""
    };
  },
  created: function created() {
    var workId = this.$route.query.workId;
    var user = JSON.parse(window.localStorage.getItem('user'));
    var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* http */] + "/gateway/v1/epaperstatistics/exportWorkReport?" + "clientId=" + __WEBPACK_IMPORTED_MODULE_0__config__["b" /* clientId */] + "&accessToken=" + user.accessToken + "&workId=" + workId;
    this.exportUrl = url;
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      parentVersionId: "",
      resourceName: "",
      isChecked: true,
      selectTextArr: [], //versionId集合
      followreadText: [],
      versionId: "",
      packageId: "",
      cId: "",
      serviceId: "",
      singleChoiceArr: [], // 0未选 1选择部分 2全部选择
      isAllChecked: true,
      checkedResource: "",
      doworkTime: 0,
      selectFlag: 1
    };
  },
  created: function created() {
    var _this = this;

    this.getText();
    this.$nextTick(function () {
      _this.setCrumb("选择单词");
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(["setCrumb"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["getWorks"]), {
    getText: function getText() {
      var _this2 = this;

      var that = this;
      var query = this.$route.query;
      this.parentVersionId = query.parentVersionId;
      this.versionId = query.versionId;
      this.resourceName = query.resourceName;
      this.packageId = query.packageId;
      this.serviceId = query.serviceId;
      this.cId = query.cId;
      this.checkedResource = query.checkedResource;

      //预览
      if (!query.selectFlag) {
        this.selectFlag = 0;
      }
      var wordData = {
        parentVersionId: query.parentVersionId,
        versionId: this.versionId,
        moduleId: 10,
        checkedResource: this.checkedResource,
        resourceType: query.resourceType
      };
      __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].filterListen(wordData).then(function (res) {
        if (!res) {
          return;
        }
        //获取到数据之后，根据用户已选择的数据初始化，并初始化选择框
        if (!res) {
          return;
        }
        _this2.followreadText = res.data;

        for (var i = 0, len = Math.ceil(_this2.followreadText.length / 4); i < len; i++) {
          _this2.singleChoiceArr.push(2);
          _this2.singleChoice(i, "2");
        }

        _this2.initData();
        var arr = _this2.singleChoiceArr;
        var fourFlag = 0;
        var fourArr = [];
        var endNum = _this2.followreadText.length % 4;
        console.log(_this2.followreadText);
        for (var j = 0, len = _this2.followreadText.length; j < len; j++) {
          var item = _this2.followreadText[j];
          fourFlag++;
          if (item.isChecked) {
            //为真的时候添加进去
            fourArr.push(item.isChecked);
          }
          if (fourFlag === 4 || j === len - 1 && fourFlag === endNum) {
            fourFlag = 0;
            if (fourArr.length === 0) {
              arr[Math.ceil((j + 1) / 4) - 1] = 0;
            } else if (fourArr.length === 4 || fourArr.length === endNum) {
              arr[Math.ceil((j + 1) / 4) - 1] = 2;
            } else {
              arr[Math.ceil((j + 1) / 4) - 1] = 1;
            }
            fourArr = [];
          }
        }
        _this2.singleChoiceArr = arr;
        _this2.singleChoiceArr.forEach(function (item, index) {
          if (item === 0 || item === 1) {
            that.isAllChecked = false;
          }
        });
      });
    },
    initData: function initData() {
      var contents = this.getWorks().contents;
      for (var i = 0, len = contents.length; i < len; i++) {
        if (contents[i].moduleId == this.$route.query.moduleId && this.parentVersionId == contents[i].parentVersionId && contents[i].versionId == this.versionId) {
          this.checkedResource = contents[i].checkedResource;
        }
      }
      this.selectTextArr = [];
      for (var i = 0, len = this.followreadText.length; i < len; i++) {
        var item = this.followreadText[i];
        var versionId = item.versionId;
        item.buttonText = "选择单词";
        item.isChecked = false;
        if (this.checkedResource.length == 0 || this.checkedResource.indexOf(versionId) > -1) {
          this.selectTextArr.push(versionId);
          item.isChecked = true;
          item.buttonText = "取消选择";
        }
      }
      this.doworkTime = this.selectTextArr.length * 10 || this.followreadText.length * 10; // 等于0的时候就是全选
    },

    //单选事件
    checkFun: function checkFun(item, index) {
      if (this.selectFlag === 0) return;
      var flag = true;
      var singleFlag = 0;
      var num = Math.ceil((index + 1) / 4) - 1;
      item.isChecked = !item.isChecked;
      var startNum = 4 * num;
      var maxLength = "";
      if (index + 3 > this.followreadText.length - 1) {
        maxLength = this.followreadText.length - 1;
      } else {
        maxLength = startNum + 3;
      }
      for (var i = startNum, len = maxLength; i <= len; i++) {
        var _item = this.followreadText[i];
        if (!_item.isChecked) {
          singleFlag++;
        }
      }
      if (singleFlag === maxLength - startNum + 1) {
        this.singleChoiceArr[num] = 0;
      } else if (singleFlag === 0) {
        this.singleChoiceArr[num] = 2;
      } else {
        this.singleChoiceArr[num] = 1;
      }
      this.singleChoiceArr.forEach(function (item1) {
        if (item1 === 0 || item1 === 1) {
          flag = false;
        }
      });
      this.isAllChecked = flag ? true : false;
      this.followreadText[index] = item;
      this.selectTextArr = [];
      for (var i = 0, len = this.followreadText.length; i < len; i++) {
        var item = this.followreadText[i];
        if (item.isChecked) {
          item.buttonText = "取消选择";
          this.selectTextArr.push(item.versionId);
        } else if (!item.isChecked) {
          item.buttonText = "选择单词";
        }
      }
      this.doworkTime = this.selectTextArr.length * 10 || this.followreadText.length * 10; // 等于0的时候就是全选
    },
    back: function back() {
      if (this.selectFlag) {
        this.$router.push({
          path: "publishHomeWork",
          query: {
            serviceId: this.serviceId,
            packageId: this.packageId,
            cId: this.cId,
            isFirst: 0
          }
        });
      } else {
        this.$router.back(-1);
      }
    },
    backSentenceArr: function backSentenceArr() {
      if (this.selectFlag) {
        this.selectTextArr = [];
        for (var i = 0, len = this.followreadText.length; i < len; i++) {
          var item = this.followreadText[i];
          if (item.isChecked) {
            this.selectTextArr.push(item.versionId);
          } else {
            this.isChecked = false;
          }
        }

        var count = this.selectTextArr.length;
        if (this.isChecked) {
          this.selectTextArr = [];
        }
        this.$emit("submitSentence", this.selectTextArr, count, this.followreadText.length);
      } else {
        this.$router.back(-1);
      }
    },

    //三选事件
    singleChoice: function singleChoice(index, type) {
      if (type == "1") {
        //对应的index,3的倍数传进来的
        index = index;
        var arr = this.singleChoiceArr;
        var flag = true;
        arr[index / 4] = arr[index / 4] === 2 ? 0 : 2;
        this.singleChoiceArr = arr;
        this.singleChoiceArr.forEach(function (item) {
          if (item === 0 || item === 1) {
            flag = false;
          }
        });
        this.isAllChecked = flag ? true : false;
      } else if (type == "2") {
        index = index * 4;
      }
      var maxLength = "";
      if (index + 3 > this.followreadText.length - 1) {
        maxLength = this.followreadText.length - 1;
      } else {
        maxLength = index + 3;
      }
      for (var j = index, len1 = maxLength; j <= len1; j++) {
        var obj = this.followreadText[j];
        obj.isChecked = this.singleChoiceArr[index / 4] === 2 ? true : false;
        obj.singleChecked = this.singleChoiceArr[index / 4] === 2 ? true : false;
        this.followreadText[j] = obj;
        this.selectTextArr = [];
        for (var i = 0, len = this.followreadText.length; i < len; i++) {
          var item = this.followreadText[i];
          if (item.isChecked) {
            item.buttonText = "取消选择";
            this.selectTextArr.push(item.versionId);
          } else if (!item.isChecked) {
            item.buttonText = "选择单词";
          }
        }
      }
      this.doworkTime = this.selectTextArr.length * 10 || this.followreadText.length * 10;
    },

    //全选事件
    allCheck: function allCheck() {
      var that = this;
      this.isAllChecked = !this.isAllChecked;
      this.singleChoiceArr.forEach(function (item, index) {
        that.singleChoiceArr[index] = that.isAllChecked ? 2 : 0;
        that.singleChoice(index, "2");
      });
    }
  })
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['echartData'],
  data: function data() {
    return {
      subjectF: false,
      subjectName: '整体曲线',
      subjectList: ['整体曲线', '单词跟读', '课文跟读', '听说模考', '线上作答', '报听写']
    };
  },

  components: {
    noFound: __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default.a
  },
  watch: {
    echartData: function echartData(curVal, oldVal) {
      this.setOption(curVal);
    }
  },
  created: function created() {
    this.$nextTick(function () {
      // this.drawLine([], [])
      // console.log(this.echartData, 'ghghg')
    });
  },

  methods: {
    setOption: function setOption(curData) {
      var recordDate = [];
      var sore = [];
      curData.map(function (item, i) {
        recordDate.push(item.recordDate);
        var s = Math.floor(item.Sore.toFixed(2));
        sore.push(s);
      });
      console.log(recordDate, sore);
      this.drawLine(recordDate, sore);
    },
    drawLine: function drawLine(recordDate, sore) {
      var myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        tooltip: {
          show: true,
          textStyle: {
            fontStyle: 'oblique'
          }
        },
        noDataLoadingOption: {
          text: '暂无数据',
          effect: 'bubble',
          effectOption: {
            effect: {
              n: 0
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            /* 横轴的字体颜色 */
            show: true,
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            /* 横轴刻度状态 */
            interval: 0,
            rotate: 30
          },
          data: recordDate
          // data: ['2018-08-01', '2018-08-12', '2018-08-13', '2018-08-14', '2018-08-15', '2018-08-16', '2018-08-17', '2018-08-18', '2018-08-19', '2018-08-20', '2018-08-21', '2018-08-22', '2018-08-23', '2018-08-24', '2018-08-25', '2018-08-26', '2018-08-27', '2018-08-28', '2018-08-29']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: sore,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          type: 'line',
          itemStyle: {
            /* 设置线的颜色 */
            normal: {
              color: "green",
              lineStyle: {
                color: "green"
              }
            }
          }
        }]
      });
    },
    changetype: function changetype(data, i) {
      this.subjectName = data;
      this.subjectF = false;
      this.$emit('setsoreType', i);
    },
    selectShow: function selectShow() {
      this.subjectF = true;
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcodejs2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['classList', 'className', 'wechatUrl', 'startDate', 'endDate', 'shareFlag'],
  data: function data() {
    return {
      selectFlag: false,
      timeFlag: true,
      startD: this.startDate,
      endD: this.endDate,
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          var date = new Date();
          var Y = date.getFullYear();
          var M = date.getMonth() + 1;
          var yesD = date.getDate();
          var minTime = Y - 1 + '-01-01 00:00:00';
          var maxTime = Y + '-' + M + '-' + (yesD - 1) + ' 00:00:00';
          return time.getTime() > new Date(maxTime) || time.getTime() < new Date(minTime);
        }
      },
      pickerOptions2: {
        disabledDate: function disabledDate(time) {
          var date = new Date();
          var Y = date.getFullYear();
          var M = date.getMonth() + 1;
          var yesD = date.getDate();
          var maxTime = Y + '-' + M + '-' + (yesD - 1) + ' 00:00:00';
          return time.getTime() > new Date(maxTime);
        }
      }
    };
  },

  components: {
    QRCode: __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default.a
  },
  watch: {
    wechatUrl: function wechatUrl(curVal, oldVal) {
      this.startD = this.startDate;
      this.endD = this.endDate;
      if (this.wechatUrl) {
        document.getElementById("qrcode").innerHTML = '';
      }
      this.qrcode();
    },
    startDate: function startDate() {
      this.startD = this.startDate;
      this.endD = this.endDate;
    },
    endDate: function endDate() {
      this.startD = this.startDate;
      this.endD = this.endD;
    }
  },
  methods: {
    qrcode: function qrcode() {
      var qrcode = new __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default.a("qrcode", {
        width: 170,
        height: 170
      });
      qrcode.makeCode(this.wechatUrl);
    },
    setOnemonth: function setOnemonth() {
      var nowdate = new Date();
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth();
      var d = nowdate.getDate();
      var formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      var maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59';
      this.timeFlag = true;
      var endDate = Date.parse(maxTime);
      var startDate = Date.parse(formatwdate);
      var data = {
        startDate: startDate,
        endDate: endDate
      };
      this.$emit('changedPicker', data);
    },
    selectShow: function selectShow() {
      this.selectFlag = true;
    },
    changedPicker: function changedPicker() {
      var data = {
        startDate: this.startD,
        endDate: this.endD
      };
      this.$emit('changedPicker', data);
    },
    changClassId: function changClassId(data) {
      this.selectFlag = false;
      this.$emit("changClassId", data);
    },
    setOneweek: function setOneweek() {
      var nowdate = new Date();
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth();
      var d = nowdate.getDate();
      var maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59';
      this.timeFlag = false;
      var endDate = Date.parse(maxTime);
      var startDate = Date.parse(maxTime) - 7 * 3600 * 24 * 1000;
      var data = {
        startDate: startDate,
        endDate: endDate
      };
      this.$emit('changedPicker', data);
    },
    getWorkStatistics: function getWorkStatistics() {
      // if (this.wechatUrl) {
      //   document.getElementById("qrcode").innerHTML = ''
      // }
      // this.qrcode()
      this.$emit('getWorkStatistics');
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userList', 'workList', 'url'],
  data: function data() {
    return {};
  },

  components: {
    noFound: __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default.a
  },
  created: function created() {
    this.$nextTick(function () {
      // this.getList()
    });
  },

  methods: {
    getList: function getList() {
      var list = this.userList;
      if (list.length > 10) {
        this.userList = list.slice(0, 10);
      }
    },
    setSorcTable: function setSorcTable() {
      var data = [{
        sentData: '2018-07-28',
        contentlist: [{
          workName: 'one',
          className: '一班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '75%',
          unPassAvg: '25%'
        }, {
          workName: 'one',
          className: '2班',
          submitAvg: '40%',
          excellentAvg: '15%',
          passAvg: '65%',
          unPassAvg: '35%'
        }, {
          workName: 'one',
          className: '3班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '60%',
          unPassAvg: '40%'
        }]
      }, {
        sentData: '2018-07-28',
        contentlist: [{
          workName: 'one',
          className: '一班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '75%',
          unPassAvg: '25%'
        }, {
          workName: 'one',
          className: '2班',
          submitAvg: '40%',
          excellentAvg: '15%',
          passAvg: '65%',
          unPassAvg: '35%'
        }, {
          workName: 'one',
          className: '3班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '60%',
          unPassAvg: '40%'
        }]
      }, {
        sentData: '2018-07-28',
        contentlist: [{
          workName: 'one',
          className: '一班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '75%',
          unPassAvg: '25%'
        }, {
          workName: 'one',
          className: '2班',
          submitAvg: '40%',
          excellentAvg: '15%',
          passAvg: '65%',
          unPassAvg: '35%'
        }, {
          workName: 'one',
          className: '3班',
          submitAvg: '50%',
          excellentAvg: '15%',
          passAvg: '60%',
          unPassAvg: '40%'
        }]
      }];
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['scoreData', 'url'],
  data: function data() {
    return {
      currentPage: 1
    };
  },

  components: {
    noFound: __WEBPACK_IMPORTED_MODULE_0__noData_nodata_vue___default.a
  },
  created: function created() {
    this.$nextTick(function () {});
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('setPage', val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('setPage', val);
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__notice_notice_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      PageIndex: 1,
      PageCount: 2,
      arr: [],
      isNotice: false,
      params: {},
      isDone: true,
      activeMsg: false
    };
  },

  props: ["loadData"],
  components: {
    paging: __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default.a,
    notice: __WEBPACK_IMPORTED_MODULE_5__notice_notice_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.loading = false;
    this.$nextTick(function () {
      _this.getMessages();
    });
  },

  watch: {
    loadData: function loadData(val) {
      // debugger
      if (val.loadMore && val.currentName.indexOf("schoolMsg") && this.PageIndex < this.PageCount) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    messages: function messages(item) {
      item.msgStatus = 1;
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].setRead({ msgIds: item.msgId }).then(function (res) {});
      //   this.isNotice = !this.isNotice;
      //   this.params = {
      //       type:4,
      //       noticeText:item.content.content,
      //       noticeTitle:"查看消息",
      //       noticeSrc:item.content.imgUrl,
      //       sender: item.senderName,
      //       time: formatDate(item.publishDate, 'yyyy-MM-dd hh:mm'),
      //       sendType: 2
      // }
    },
    isConfirm: function isConfirm(val) {},
    showMsg: function showMsg(index, item) {
      var reg = new RegExp("(^|\\s)" + "show_contents" + "(\\s|$)");

      var dom = this.$refs.msgshow[index];
      var newClass = dom.className.split(" ");

      if (reg.test(dom.className)) {
        dom.className = newClass.slice(0, newClass.length - 1).join(" ");
      } else {
        newClass.push("show_contents");
        dom.className = newClass.join(" ");
      }
      if (item.show_details == "true") {
        item.show_details = "false";
      } else {
        item.show_details = "true";
      }
    },
    setParams: function setParams() {
      this.param = {
        msgType: 30,
        page: this.PageIndex,
        pageSize: 6
      };
    },
    getMessages: function getMessages() {
      this.setParams();
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getSystemMessages(this.param).then(function (res) {
        if (!res) {
          _this2.isDone = false;
          return false;
        }
        res.data.pageList.map(function (item) {
          if (item.content.content.length > 60 || item.content.imgUrl) {
            item.show_details = "false";
          }
          _this2.messages(item);
        });
        // this.arr = res.data.pageList;

        _this2.PageCount = Math.ceil(res.data.totalCount / _this2.param.pageSize);
        _this2.arr = _this2.arr.concat(res.data.pageList);
        if (_this2.arr.length == 0) {
          _this2.isDone = false;
        }
      });
    },
    pageNum: function pageNum(val) {
      this.PageIndex = val;
      this.getMessages();
    },
    pull_work: function pull_work() {
      this.PageIndex++;
      this.getMessages();
    }
  })
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acceptMsg_vue__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acceptMsg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__acceptMsg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendMsg_vue__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendMsg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sendMsg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetch__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  inheritAttrs: false,
  data: function data() {
    return {
      index: 1,
      userInformation: this.getUser(),
      loadData: this.$attrs
    };
  },

  components: {
    acceptMsg: __WEBPACK_IMPORTED_MODULE_2__acceptMsg_vue___default.a,
    sendMsg: __WEBPACK_IMPORTED_MODULE_3__sendMsg_vue___default.a
  },
  watch: {
    '$attrs': function $attrs(val) {
      this.loadData = val;
    }
  },
  created: function created() {
    this.$nextTick(function () {});
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['setUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getUser']), {
    toggle: function toggle(param) {
      this.index = param;
      if (param == 2) {
        this.$set(this.userInformation, 'isUnread', false);
        this.setUser(this.userInformation);
      }
    }
  })
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkboxLabel_checkboxLabel_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkboxLabel_checkboxLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__checkboxLabel_checkboxLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_originSelect_originSelect__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_originSelect_originSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_originSelect_originSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      grads: [],
      selectedClass: [],
      msg: '',
      isNotice: false,
      classNames: '',
      showSelect: false,
      checkedClass: []
    };
  },

  components: {
    classcom: __WEBPACK_IMPORTED_MODULE_1__checkboxLabel_checkboxLabel_vue___default.a,
    notice: __WEBPACK_IMPORTED_MODULE_5__components_notice_notice_vue___default.a,
    OriginSelect: __WEBPACK_IMPORTED_MODULE_6__components_originSelect_originSelect___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.initData();
      _this.getClass();
      document.body.addEventListener("click", function () {
        _this.showSelect = false;
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    initData: function initData() {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getUser']), {
    selectClass: function selectClass() {
      this.showSelect = !this.showSelect;
    },
    checkedClassFun: function checkedClassFun(index) {
      this.grads[index].isChecked = !this.grads[index].isChecked;
    },
    selLi: function selLi(item) {

      var selRom = this.$refs.selRom;
      item.setQuestionId = !item.setQuestionId;
    },
    getClass: function getClass() {
      var _this2 = this;

      var params = {
        userRole: 2,
        exists: 1
      };
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].grads(params).then(function (res) {
        if (!res || !res.data) {
          return;
        }
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].setQuestionId = false;
          res.data[i].name = res.data[i].className;
          res.data[i].isChecked = false;
        }
        _this2.grads = res.data;
      });
    },
    sendMsg: function sendMsg() {
      var _this3 = this;

      var that = this;
      if (!this.checkedClass.length) {
        this.$toast("您还未选择班级对象哦！", 'error');
        return false;
      }
      if (!this.msg) {
        this.$toast("消息不能为空", 'error');
        return;
      }
      this.checkedClass.forEach(function (item, index) {
        that.selectedClass.push({
          classId: item.classId,
          className: item.className
        });
        _this3.classNames += item.className + ',';
      });
      var userInfo = this.getUser();
      var gradsList = [];
      var params = {
        eventName: "pushClassMessage",
        eventArgs: {
          brandId: __WEBPACK_IMPORTED_MODULE_3__config__["c" /* brandId */],
          senderId: userInfo.userId,
          brandName: userInfo.realName,
          attach: '',
          userType: 1,
          receiverIdList: this.selectedClass,
          classNames: this.classNames.substring(0, this.classNames.length - 1),
          messageContent: {
            content: this.msg,
            imgUrl: ''
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].setClassMsg(params).then(function (res) {
        if (!res) {
          return false;
        }
        if (res) {
          _this3.$toast('发送成功!', 'right');
          //          this.getClass();
          setTimeout(function () {
            that.msg = '';
            that.checkedClass = [];
            that.selectedClass = [];
            that.classNames = '';
            that.$emit("backMsg");
          }, 2500);
          _this3.grads.forEach(function (item, index) {
            item.isChecked = false;
          });
        }
      });
    },
    sortarr: function sortarr(arr) {
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = 0; j < arr.length - 1 - i; j++) {
          if (arr[j].gradeId > arr[j + 1].gradeId) {
            var temp = arr[j];
            arr[j] = arr[j + 1];
            arr[j + 1] = temp;
          }
        }
      }
      return arr;
    },
    isConfirm: function isConfirm() {
      this.getClass();
      this.$emit("backMsg");
    },
    back: function back() {
      this.getClass();
      this.$emit("backMsg");
    }
  })

});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__send_vue__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__send_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__send_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pageIndex: 1,
      pageCount: 2,
      greenBtn: true,
      params: {},
      pageList: [],
      isDone: true,
      isNotice: false,
      noticParams: {}
    };
  },

  props: ["loadData"],
  components: {
    paging: __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default.a,
    send: __WEBPACK_IMPORTED_MODULE_5__send_vue___default.a,
    notice: __WEBPACK_IMPORTED_MODULE_6__notice_notice_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.loading = false;
    this.$nextTick(function () {
      _this.initData();
    });
  },

  watch: {
    loadData: function loadData(val) {
      if (val.loadMore && val.currentName.indexOf("schoolMsg") && this.pageIndex < this.pageCount) {
        this.loading = true;
        this.pull_work();
      }
    },
    pageList: function pageList(val) {
      this.pageList = val;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), {
    setParams: function setParams() {
      var userInfo = this.getUser();
      this.params = {
        senderId: userInfo.userId,
        page: this.pageIndex,
        pageSize: 5,
        userType: 1
      };
    },
    initData: function initData() {
      var _this2 = this;

      this.setParams();
      __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].getClassMsg(this.params).then(function (res) {
        if (!res) {
          return false;
        }
        if (res) {
          res.data.pageList.map(function (item, index) {
            item.content = JSON.parse(item.content);
            // debugger
            if (item.content.content.length > 20) {
              item.show_details = "false";
            }
          });

          _this2.pageCount = Math.ceil(res.data.totalCount / _this2.params.pageSize);
          _this2.pageList = _this2.pageList.concat(res.data.pageList);
        }
      });
    },
    pageNum: function pageNum(val) {
      this.pageIndex = val;
      this.initData();
    },
    sendBtn: function sendBtn() {
      this.greenBtn = false;
    },
    backMsg: function backMsg() {
      this.greenBtn = true;
      this.initData();
    },
    showMsg: function showMsg(item, index) {
      // this.isNotice = !this.isNotice;
      // this.noticParams = {type:4,
      // 					noticeText:item.content.content,
      // 					noticeTitle:"查看消息",
      // 					sender: item.classNames,
      // 					time: formatDate(item.publishDate, 'yyyy-MM-dd hh:mm'),
      // 					sendType: 1
      // 				}
      var reg = new RegExp("(^|\\s)" + "show_contents" + "(\\s|$)");
      var dom = this.$refs.msgshow[index];
      var newClass = dom.className.split(" ");

      if (reg.test(dom.className)) {
        dom.className = newClass.slice(0, newClass.length - 1).join(" ");
      } else {
        newClass.push("show_contents");
        dom.className = newClass.join(" ");
      }
      if (item.show_details == "true") {
        item.show_details = "false";
      } else {
        item.show_details = "true";
      }
    },
    isConfirm: function isConfirm(val) {},
    pull_work: function pull_work() {
      this.pageIndex++;
      this.initData();
    }
  })
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["checked", "resourceName"],
  data: function data() {
    return {
      followreadText: [],
      isChecked: true,
      selectTextArr: [],
      versionid: "",
      packageId: "",
      cId: "",
      serviceId: "",
      checkedResource: "",
      doworkTime: 0,
      moduleId: 10,
      selectFlag: 1,
      indexArr: [],
      choose: true
    };
  },
  created: function created() {
    this.getText();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getWorks"]), {

    // 判断是否全选
    allChoose: function allChoose() {
      this.choose = !this.choose;
    },

    //获取课文跟读段落内容
    getText: function getText() {
      var _this = this;

      var router = this.$route.query;
      this.versionid = router.versionId;
      this.packageId = router.packageId;
      this.serviceId = router.serviceId;
      this.cId = router.cId;
      this.checkedResource = router.checkedResource;
      if (!router.selectFlag) {
        this.selectFlag = 0;
      }
      var textData = {
        parentVersionId: router.parentVersionId,
        versionId: this.versionid,
        moduleId: router.moduleId,
        checkedResource: this.checkedResource
      };

      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].filterListen(textData).then(function (res) {
        if (!res) {
          return;
        }
        _this.followreadText = res.data;
        _this.initData();
      });
    },

    //初始化页面数据，添加字段
    initData: function initData() {
      // debugger
      var contents = this.getWorks().contents;
      for (var i = 0, len = contents.length; i < len; i++) {
        if (contents[i].moduleId == this.$route.query.moduleId && this.versionid == contents[i].versionId) {
          this.checkedResource = contents[i].checkedResource;
          this.indexArr = contents[i].indexArr;
        }
      }
      var allCount = 0;
      var count = 0;
      for (var i = 0, len = this.followreadText.length; i < len; i++) {
        allCount += this.followreadText[i].sentences.length;
        var item = this.followreadText[i];
        var versionId = item.sentences[0].versionId;
        item.text = item.content;
        item.isChecked = false;
        item.buttonText = "选择段落";
        if (this.selectFlag) {
          if (this.checkedResource.length === 0 || this.indexArr.indexOf(i) > -1) {
            count += item.sentences.length;
            this.selectTextArr.push(versionId);
            item.isChecked = true;
            item.buttonText = "取消选择";
          }
        } else {
          this.selectTextArr.push(versionId);
        }
      }
      this.doworkTime = this.selectTextArr.length > 0 ? allCount * 15 : count * 15;
    },
    back: function back() {
      if (this.selectFlag) {
        this.$router.push({
          path: "publishHomeWork",
          query: {
            serviceId: this.serviceId,
            packageId: this.packageId,
            cId: this.cId,
            isFirst: 0
          }
        });
      } else {
        this.$router.back(-1);
      }
    },

    //选择按钮事件
    checkFun: function checkFun(item, index) {
      if (this.selectFlag === 0) return;
      item.isChecked = !item.isChecked;
      this.followreadText[index] = item;
      this.selectTextArr = [];
      var count = 0;
      var allCount = 0;
      for (var i = 0, len = this.followreadText.length; i < len; i++) {
        var item = this.followreadText[i];
        allCount += item.sentences.length;
        if (item.isChecked) {
          item.buttonText = "取消选择";
          count += item.sentences.length;
          this.selectTextArr.push(item.sentences[0].versionId);
        } else if (!item.isChecked) {
          item.buttonText = "选择段落";
        }
      }
      this.doworkTime = count * 15 || allCount * 15; // 等于0的时候就是全选
    },

    //点击回传选择段落数组
    backSentenceArr: function backSentenceArr() {
      if (this.selectFlag) {
        this.selectTextArr = [];
        this.indexArr = [];
        var count = 0;
        var allCount = 0;
        for (var i = 0, len = this.followreadText.length; i < len; i++) {
          var item = this.followreadText[i];
          if (item.isChecked) {
            //句子跟读中会有多个小句子
            count++;
            allCount += item.sentences.length;
            this.indexArr.push(i);
            for (var j = 0, len1 = item.sentences.length; j < len1; j++) {
              this.selectTextArr.push(item.sentences[j].versionId);
            }
          } else {
            this.isChecked = false;
          }
        }
        if (this.isChecked) {
          this.selectTextArr = [];
        }
        this.$emit("submitSentence", this.selectTextArr, count, allCount, this.followreadText.length, this.indexArr);
      } else {
        this.$router.back(-1);
      }
    }
  })
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectData", "autoIsShow", "selectObj", "selecterText", "checked", "index"],
  data: function data() {
    return {
      showSelecter: false
    };
  },

  watch: {},
  methods: {
    showPanel: function showPanel() {
      this.showSelecter = !this.showSelecter;
    },
    selected: function selected(index) {
      /*this.selecterText = value;*/
      this.showSelecter = false;
      var data = this.selectData[index] ? this.selectData[index] : { id: 0, name: "--全部--", periodid: 0 };
      console.log("data", data);
      this.$emit("selecter", {
        key: this.selectObj,
        value: data.id,
        text: data.name,
        periodid: data.periodid,
        index: this.index,
        dataIndex: index
      });
    },
    close: function close() {
      this.showSelecter = false;
    }
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__book_book_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__book_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__book_book_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_originSelect_originSelect__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_originSelect_originSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_originSelect_originSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selecter_selecter_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selecter_selecter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__selecter_selecter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_grads__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    book: __WEBPACK_IMPORTED_MODULE_3__book_book_vue___default.a,
    paging: __WEBPACK_IMPORTED_MODULE_4__paging_paging_vue___default.a,
    selecter: __WEBPACK_IMPORTED_MODULE_6__selecter_selecter_vue___default.a,
    OriginSelect: __WEBPACK_IMPORTED_MODULE_5__components_originSelect_originSelect___default.a
  },
  props: ["loadData"],
  data: function data() {
    return {
      showPage: false,
      catalog: [],
      service: [],
      grads: __WEBPACK_IMPORTED_MODULE_7__data_grads__["default"],
      keywords: "",
      serviceName: "",
      serviceId: 0,
      params: {},
      gradId: "",
      pageIndex: 1,
      pageCount: 2,
      catalogues: [],
      LastBookArr: [], //最近布置书
      gradText: "全部年级",
      serviceText: "全部服务",
      pull_data: true,
      isSearch: false,
      classIds: "",
      loading: false,
      loadMore: true
    };
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      var params = _this2.$route.query;
      // this.serviceId = window.localStorage.getItem('serviceId')

      if (params.classIdstr) {
        _this2.classIds = params.classIdstr;
        window.sessionStorage.setItem("classIds", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ classId: _this2.classIds }));
      } else {
        _this2.classIds = JSON.parse(window.sessionStorage.getItem("classIds")).classId;
      }

      // window.addEventListener('load', this.windowOnLoad);

      _this2.setWorks({ contents: [] });
      _this2.setSuject([]);
      _this2.setCatalog([]);

      _this2.getServices();
      _this2.getCatalog();
    });
  },

  watch: {
    $route: ["getServices", "getCatalog"],
    loadData: function loadData(val) {
      if (val.loadMore && val.currentName.indexOf("setHomework") && this.pageIndex < this.pageCount) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])(["setWorks", "removeWorks", "setSuject", "setCatalog"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['getWorks']), {
    windowOnLoad: function windowOnLoad() {
      this.pageIndex = 1;
      var path = this.$route.path;
      if (path.indexOf("/api") > -1) {
        this.pull_data = false;
      }
    },
    clearInput: function clearInput(e) {
      this.keywords = "";
    },
    search: function search(e) {
      this.isSearch = true;
      if (!this.keywords.trim()) {
        this.getCatalog();
      }
      this.pageIndex = 1;
      this.setParams();
      this.getCatalog();
    },
    selecter: function selecter(obj) {
      if (obj.key == "grads") {
        if (isNaN(obj.index)) {
          this.gradId = "";
        } else {
          this.gradId = this.grads[obj.index].id;
          this.gradText = obj.value;
        }
        window.localStorage.setItem("gradId", this.gradId);
      } else if (obj.key == "service") {
        if (isNaN(obj.index)) {
          this.serviceId = 0;
        } else {
          this.serviceId = this.service[obj.index].id;
          this.serviceText = obj.value;
        }
        window.localStorage.setItem("serviceId", this.serviceId);
      }

      this.pageIndex = 1;
      this.getCatalog();
    },
    setParams: function setParams() {
      var classList = this.getWorks().classList;
      this.params = {
        serviceId: this.serviceId,
        classIds: this.classIds,
        gradeId: this.gradId,
        keyWords: this.keywords.trim(),
        pageIndex: this.pageIndex,
        pageSize: 10
      };
    },
    getServices: function getServices() {
      if (window.sessionStorage.service && window.sessionStorage.service != "underfined") {
        this.service = JSON.parse(window.sessionStorage.getItem("service"));
        this.gradId = window.localStorage.getItem("gradId") * 1;
        var serviceId = window.localStorage.getItem('serviceId');
        var serviceArr = this.service.filter(function (item) {
          return item.id == serviceId;
        });
        if (serviceArr.length) {
          this.serviceId = serviceId;
        } else if (this.service.length == 1) {
          this.serviceText = this.service[0].name;
          this.serviceId = this.service[0].id;
        }
      }
    },
    getCatalog: function getCatalog() {
      this.setParams();
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_8__fetch__["a" /* default */].serviceProducts(this.params).then(function (res) {
        if (!res) {
          _this.catalog = [];
          return false;
        }
        if (!res.data.pageList) {
          return false;
        }
        if (_this.pageIndex == res.data.pageIndex) {
          var catalogData = res.data.pageList;
          _this.pageCount = Math.ceil(res.data.totalCount / _this.params.pageSize);
          if (_this.pageIndex !== 1) {
            _this.catalog = _this.catalog.concat(catalogData);
          } else {
            _this.catalog = [];
            _this.catalog = catalogData;
          }
        }
        _this.showPage = true;
        _this.loading = false;
        _this.getServiceText(_this.serviceId);
      });
    },
    setTop: function setTop(res) {
      var _this3 = this;

      var params = {
        productid: res.productId,
        serviceid: res.serviceId,
        istop: res.top
      };
      __WEBPACK_IMPORTED_MODULE_8__fetch__["a" /* default */].setBookTop(params).then(function (res) {
        if (res.ret || res.errcode) {
          return false;
        }
        // 置顶成功后刷新当前列表，置顶的显示在第一个
        _this3.catalog = [];
        _this3.$toast("置顶成功!");
        _this3.pageNum(1);
      });
    },
    getServiceText: function getServiceText(id) {
      var services = this.service;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.id == id) {
            this.serviceName = item.name;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    pageNum: function pageNum(pageIndex) {
      this.pageIndex = pageIndex;
      this.getCatalog();
    },
    pull_work: function pull_work() {
      this.pageIndex++;
      this.getCatalog();
    },
    back: function back() {
      this.$router.push({ path: "selectGrade", query: { bookType: 1 } });
    },


    // 滚动加载更多书籍
    handleScroll: function handleScroll() {
      var scrollTop = this.$refs.viewBooks.scrollTop; //scrollTop为滚动条在Y轴上的滚动距离
      var clientHeight = this.$refs.viewBooks.clientHeight; //clientHeight为内容可视区域的高度。
      var scrollHeight = this.$refs.viewBooks.scrollHeight; //scrollHeight为内容可视区域的高度加上溢出（滚动）的距离
      if (scrollTop + clientHeight === scrollHeight && scrollTop > 0) {
        this.loadMore = true;
        this.pull_work();
      } else {
        this.loadMore = false;
      }
    }
  })
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__book_book_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__book_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__book_book_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    book: __WEBPACK_IMPORTED_MODULE_1__book_book_vue___default.a,
    paging: __WEBPACK_IMPORTED_MODULE_2__paging_paging_vue___default.a
  },
  data: function data() {
    return {
      showPage: false,
      keyword: "",
      papers: [],
      params: {},
      pageIndex: 1,
      pageCount: 2,
      tagRes: false,
      isSearch: false
    };
  },
  created: function created() {
    var _this = this;

    this.loading = false;
    this.$nextTick(function () {
      _this.getPapers();
      _this.setCrumb("试卷");
    });
  },

  watch: {
    $route: ["getPapers"],
    $attrs: function $attrs(val) {
      if (val.loadMore && val.currentName) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(["setCrumb"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["getUser"]), {
    search: function search(e) {
      this.isSearch = true;
      if (!this.keyword.trim()) {
        this.getPapers();
      }
      this.pageIndex = 1;
      this.getPapers();
    },
    setParams: function setParams() {
      var userInfo = this.getUser();
      this.params = {
        userID: userInfo.userId,
        periodId: 0,
        SubjectID: 0,
        keyWord: this.keyword.trim(),
        pageIndex: this.pageIndex,
        pageSize: 12
      };
    },
    clearInput: function clearInput(e) {
      this.keyword = "";
    },
    getPapers: function getPapers() {
      var _this2 = this;

      this.setParams();
      __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].getPaper(this.params).then(function (res) {
        if (!res) {
          _this2.papers = [];
          return false;
        }
        if (!res.data.result) {
          return false;
        }
        if (_this2.pageIndex == res.data.page_index) {
          _this2.papers = _this2.papers.concat(res.data.result);
          _this2.pageCount = Math.ceil(res.data.total_count / _this2.params.pageSize);
        }
        _this2.showPage = true;
        _this2.loading = false;
      });
    },
    pageNum: function pageNum(pageIndex) {
      this.pageIndex = pageIndex;
      this.getPapers();
    },
    pull_work: function pull_work() {
      this.pageIndex++;
      this.getPapers();
    }
  })
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      src: ''
    };
  },

  props: ['useInfo', 'userScore', 'userRank'],
  created: function created() {},

  methods: {
    toSex: function toSex(sex) {
      return sex == 1 ? "../../../assets/img/boy.png" : "../../../assets/img/girl.png";
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      step: 1,
      mobile: '',
      av_step: '',
      code: '',
      password: '',
      confirmPassword: '',
      wait: 60,
      flag: false,
      timer: ''
    };
  },
  created: function created() {
    this.$nextTick(function () {});
  },

  methods: {
    del: function del(param) {
      if (param == 1) {
        this.mobile = '';
        this.code = '';
        this.password = '';
      } else {
        this.confirmPassword = '';
      }
      this.av_step = '';
    },
    resend: function resend() {
      if (this.wait != 0) {
        return false;
      }
      this.wait = 60;
      this.sendCode();
    },
    countTime: function countTime() {
      var _this = this;

      var timer = setInterval(function () {
        if (_this.wait == 0) {
          clearInterval(timer);
        } else {
          _this.wait--;
        }
      }, 1000);
    },
    avbtn: function avbtn(param) {
      if (param == 1) {
        if (this.mobile.length < 11) return false;

        var reg = /^1[3|4|5|7|8][0-9]{9}$/;
        var flag = reg.test(this.mobile);
        if (!flag) {
          this.$toast("请输入正确格式的手机号", "error");
          return false;
        }
        this.av_step = 1;
      } else if (param == 2) {
        this.av_step = 2;
      }
    },
    sendCode: function sendCode() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getsendVerifyCode({ mobile: this.mobile, template_id: 3, business_id: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */] }).then(function (res) {
        if (!res) {
          _this2.$toast(res.msg, "error");
          _this2.step = 1;
          return false;
        }
        _this2.step = 2;
        _this2.countTime();
      });
    },
    nextStep: function nextStep() {
      if (this.av_step == 1) {
        this.sendCode();
      } else if (this.av_step == 2) {
        this.verifyCode();
      }
    },
    verifyCode: function verifyCode() {
      var _this3 = this;

      if (this.code.length < 6) return false;
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getcheckVerifyCode({ verify_code: this.code, business_id: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */], mobile: this.mobile }).then(function (res) {
        if (!res) {
          _this3.$toast("验证码输入错误", 'right');
          return false;
        }
        _this3.step = 3;
      });
    },
    confirm: function confirm() {
      if (this.password.length < 6) {
        this.$toast("请输入6-20个字符的密码", "error");
        return false;
      }
    },
    confirmPwd: function confirmPwd() {
      if (this.password != this.confirmPassword) {
        this.$toast("密码前后输入不一致", "error");
        return false;
      }
      this.flag = true;
    },
    sendPwd: function sendPwd() {
      var _this4 = this;

      if (this.flag) {
        var param = {
          business_id: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */],
          mobile: this.mobile,
          verify_code: this.code,
          password: this.password,
          confirmPassword: this.confirmPassword
        };
        __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].modifyPwd(param).then(function (res) {
          if (!res) return false;
          _this4.$toast(res.msg, "right");
          window.location.assign(window.location.origin);
        });
      }
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__);

//
//
//
//
//
//
//

 // 接口
 // 所有题型组件



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		exampaper: __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default.a,
		watchStuHead: __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default.a
	},
	data: function data() {
		return {
			page: 'checkOnlinePaper', // 当前页面
			moduleId: 124, // 资源模块, 15[听说模考] / 124[在线作答]
			isShowAnswer: true,
			versionId: '', // 试卷ID 	4675443382047446397
			doWorkId: '', // 8176483212442072	
			exampaperData: null, // 试卷信息
			userAnswers: null, // 用户试卷答案
			showdata: null,
			useInfo: [],
			userScore: 0, // 显示的选题 Array(题目下标)
			userRank: 0,
			correctContents: [],
			actualScore: 0, //总分
			app_interaction: false

		};
	},
	created: function created() {
		var _this = this;

		var record = JSON.parse(this.$route.query.record);
		this.versionId = record.versionId;
		this.doWorkId = record.doWorkId;
		this.useInfo = record.userId;
		this.userRank = record.index;
		this.userScore = record.actualScore;
		this.$nextTick(function () {
			_this.setCrumb('查看详情');
			_this.app_interaction = window.localStorage.getItem('app_interaction');
			//获取用户信息  
		});
		__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getInfo({ userId: this.useInfo }).then(function (res) {
			if (!res) {
				return false;
			}
			_this.useInfo = res.data;
		});
		this.getOnlineAnswer(this.doWorkId);
		this.getOnlineExamination(this.versionId);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setCrumb']), {
		correctScore: function correctScore(_correctScore) {
			this.correctContents = [];
			this.actualScore = 0;
			for (var i = 0, lenA = this.userAnswers.length; i < lenA; i++) {
				var itemA = this.userAnswers[i];
				if (itemA.versionId == _correctScore.versionId) {
					itemA = _correctScore;
				}
				this.actualScore += itemA.score * 1;
				this.correctContents.push(itemA);
			}
			this.userAnswers = this.correctContents;
			this.userScore = this.actualScore;
			var data = {
				"doWorkId": this.doWorkId,
				"actualScore": this.actualScore,
				correctContents: this.correctContents
			};
			this.sentWorkSorce(data);
		},
		sentWorkSorce: function sentWorkSorce(data) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].correctWork(data).then(function (res) {
				if (!res) {
					return false;
				}
				_this2.$toast("批改成功", "right");
			}, function (err) {
				console.log(err);
			});
		},
		getOnlineAnswer: function getOnlineAnswer(doWorkId) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getWorkAnswers({ doWorkId: this.doWorkId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this3.userAnswers = res.data;
			}, function (err) {
				console.log(err);
			});
		},
		getOnlineExamination: function getOnlineExamination(versionId) {
			var _this4 = this;

			// 获取在线作答试卷
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getOnlineExamination({ versionId: versionId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this4.exampaperData = res.data;
			}, function (err) {
				console.log(err);
			});
		}
	})
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__);

//
//
//
//
//
//
//

 // 接口
 // 所有题型组件



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		exampaper: __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default.a,
		watchStuHead: __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default.a
	},
	data: function data() {
		return {
			page: 'checkTSMK', // 当前页面
			moduleId: 15, // 资源模块, 15[听说模考] / 124[在线作答]
			isShowAnswer: true,
			versionId: '', // 试卷ID 	4675443382047446397
			doWorkId: '', // 8176483212442072
			exampaperData: null, // 试卷信息
			userAnswers: null, // 用户试卷答案
			showdata: null, // 显示的选题 Array(题目下标)
			useInfo: [],
			userScore: 0, // 显示的选题 Array(题目下标)
			userRank: 0,
			actualScore: 0
		};
	},
	created: function created() {
		var _this = this;

		var record = JSON.parse(this.$route.query.record);
		this.versionId = record.versionId;
		this.doWorkId = record.doWorkId;
		this.useInfo = record.userId;
		this.userRank = record.index;
		this.userScore = record.actualScore;
		this.$nextTick(function () {
			_this.setCrumb('查看详情');
		});
		//获取用户信息
		__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getInfo({ userId: this.useInfo }).then(function (res) {
			if (!res) {
				return false;
			}
			_this.useInfo = res.data;
		});
		// 获取试卷
		this.getListenExamination(this.versionId);
		this.getListenAnswer(this.doWorkId);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setCrumb']), {
		correctScore: function correctScore(_correctScore) {
			this.correctContents = [];
			this.actualScore = 0;
			console.log(_correctScore);
			for (var i = 0, lenA = this.userAnswers.length; i < lenA; i++) {
				var itemA = this.userAnswers[i];
				if (itemA.versionId == _correctScore.versionId) {
					itemA = _correctScore;
				}
				this.actualScore += itemA.score * 1;
				this.correctContents.push(itemA);
			}
			this.actualScore = this.actualScore == NaN ? _correctScore.score : this.actualScore;
			this.userAnswers = this.correctContents;
			this.userScore = this.actualScore;
			var data = {
				doWorkId: this.doWorkId,
				submitUserId: this.useInfo.userId,
				actualScore: this.actualScore,
				codeId: 0,
				correctContents: this.correctContents
				// console.log("correctContents",data)
			};this.sentWorkSorce(data);
		},
		sentWorkSorce: function sentWorkSorce(data) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].correctListenWork(data).then(function (res) {
				if (!res) {
					return false;
				}
				_this2.$toast("批改成功", "right");
			}, function (err) {
				console.log(err);
			});
		},
		getListenExamination: function getListenExamination(versionId) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getExamination({ versionId: versionId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this3.exampaperData = res.data;
			}, function (err) {
				console.log(err);
			});
		},
		getListenAnswer: function getListenAnswer(doWorkId) {
			var _this4 = this;

			// 获取用户答案与老师布置题目
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getTeacherQuerstion({ doWorkId: doWorkId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this4.userAnswers = res.data.workAnswers;
				_this4.showdata = res.data.checkedResource.join(); //选择布置作业数组               
			}, function (err) {
				console.log(err);
			});
		}
	})
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_selecter_selecter_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_selecter_selecter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_selecter_selecter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editInput_editInput__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editInput_editInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_editInput_editInput__);



var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      showStu: false,
      showClass: false,
      isNotice: false,
      params: {},
      arr: [],
      teacherId: "",
      isShow: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isNotice", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "classStudent", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "classList", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "currentClass", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "num", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "mobile", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "userIds", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "currentSchool", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "url", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "clickFlag", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "partclassList", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectedclassList", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "is_select", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "is_addClass", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "is_alertName", false), _ref;
  },

  components: {
    notice: __WEBPACK_IMPORTED_MODULE_2__components_notice_notice_vue___default.a,
    selecter: __WEBPACK_IMPORTED_MODULE_3__components_selecter_selecter_vue___default.a,
    EditInput: __WEBPACK_IMPORTED_MODULE_7__components_editInput_editInput___default.a
  },
  created: function created() {
    var _this = this;

    // alert('我进class了')
    this.$nextTick(function () {
      _this.getClassData(0);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["getUser"]), (_extends2 = {
    //获取班级信息
    getClassData: function getClassData(index) {
      var _this2 = this;

      var user = this.getUser();
      this.mobile = user.mobile;
      //获取班级，并过滤不是老师身份的
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getDetailedInf({ uin: user.userId }).then(function (res) {
        if (!res) {
          return false;
        }
        var classRes = "";
        _this2.teacherId = res.data.userId;
        for (var i = res.data.classes.length - 1, len = 0; i >= len; i--) {
          if (res.data.classes[i].userRole != 2) {
            res.data.classes.splice(i, 1);
          }
        }
        if (!res.data.classes.length) {
          return false;
        }
        var classId = res.data.classes[index].classId;
        return { classRes: res, classId: classId };
      }).then(function (res1) {
        if (!res1) {
          return false;
        }
        var classData = res1;
        __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getHomeworkStatistics({ classIds: classData.classId }).then(function (res) {
          if (!res) {
            return false;
          }
          if (res.data.length > 0) {
            classData.classRes.data.classes[index].workCount = res.data[0].workCount;
          }
          _this2.classList = classData.classRes.data.classes;

          if (!_this2.is_select) {

            _this2.partclassList = [];
            _this2.selectedclassList = [];
            _this2.classList.forEach(function (item, index) {
              item.name = item.className;
              item.index = index;
              if (index < 4) {
                _this2.partclassList.push(item);
              } else {
                _this2.selectedclassList.push(item);
              }
            });
          }

          if (_this2.is_addClass) {
            _this2.classList.forEach(function (item, index) {
              item.name = item.className;
              item.index = index;
            });

            if (_this2.classList.length < 5) {
              _this2.partclassList = _this2.classList;
            } else {
              var arr1 = _this2.classList.slice(-1);
              var arr2 = _this2.partclassList.pop();
              _this2.selectedclassList.push(arr2);
              _this2.partclassList = arr1.concat(_this2.partclassList);
            }
            _this2.is_addClass = false;
          }

          _this2.showClass = true;
          _this2.currentClass = classData.classRes.data.classes[index];

          if (_this2.is_alertName) {
            var alertIndex = -1;
            alertIndex = _this2.partclassList.findIndex(function (item) {
              return item.classId == _this2.currentClass.classId;
            });
            _this2.partclassList[alertIndex].className = _this2.currentClass.className;
            _this2.is_alertName = false;
          }
          _this2.currentSchool = _this2.currentClass.schoolName;
        });
        //获取班级成员信息
        __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getClassStudent({ classId: classData.classId, pageSize: 100 }).then(function (res) {
          if (!res) {
            return false;
          }

          if (res) {
            var userArr = [];
            for (var i = 0; i < res.data.pageList.length; i++) {
              var item = res.data.pageList[i];
              if (item.userRole === 2) {
                res.data.pageList.splice(i, 1);
                i = -1;
                continue;
              }
              userArr[i] = res.data.pageList[i].userId;
              _this2.userIds = userArr.join(",");
            }
            var studentArr = res.data.pageList;
            if (res.data.pageList.length == 0) {
              _this2.arr = [];
              _this2.classStudent = studentArr;
              _this2.showStu = true;
              _this2.clickFlag = false;
              return false;
            }
            return studentArr;
          }
        }).then(function (res2) {
          //获取班级所有服务
          if (!res2) {
            return false;
          }
          if (res2) {
            __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getAllservice({ uIds: _this2.userIds }).then(function (res) {
              if (!res || !res.data.length) {
                return false;
              }
              _this2.arr = [];
              for (var i = 0, len = res.data.length; i < len; i++) {
                var item = res.data[i];
                for (var j = 0, len2 = item.service.length; j < len2; j++) {
                  if (item.service[j].ExpiredStatus != "已过期") {
                    _this2.arr.push(item.service[j]);
                  }
                }
              }
              //遍历所有服务查看该学生是否有服务
              for (var i = 0, len = res2.length; i < len; i++) {
                var item1 = res2[i];
                item1.IsBuyArr = [];
                item1.IsTryArr = [];
                for (var j = 0, len2 = _this2.arr.length; j < len2; j++) {
                  var item2 = _this2.arr[j];
                  if (item1.userName == item2.UseName) {
                    if (item2.IsBuy) {
                      item1.IsBuyArr.push(item2);
                    } else {
                      item1.IsTryArr.push(item2);
                    }
                  }
                }
              }
              _this2.clickFlag = false;
              _this2.classStudent = res2;
            });
          }
        });
      });
    },
    deleteStudent: function deleteStudent(item) {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 3,
        noticeTitle: "删除确认",
        identify: "delete",
        userId: item.userId,
        userName: item.userName
      };
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "deleteStudent", function deleteStudent(item) {
    this.isNotice = !this.isNotice;
    this.params = {
      type: 3,
      noticeTitle: "删除学生",
      identify: "delete",
      userId: item.userId,
      userName: item.userName
    };
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "isConfirm", function isConfirm(val, identify, userId, classObj, schoolId) {
    var _this3 = this;

    if (val) {
      switch (identify) {
        case "checkClass":
        case "checkService":
          break;
        case "delete":
          __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].deleteStudent({
            classId: this.currentClass.classId,
            userId: userId
          }).then(function (res) {
            if (!res) {
              return false;
            }
            if (res) {
              _this3.getClassData(_this3.num);
              _this3.$toast("删除成功", "right");
            }
          });
          break;
        case "redact":
          __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].modifyClassInformation(classObj).then(function (res) {
            if (!res) {
              return false;
            }
            if (res) {
              _this3.is_alertName = true;
              _this3.getClassData(_this3.num);
              _this3.$toast("修改成功", "right");
            }
          });
          break;
        case "addClass":
          this.num = this.classList.length;
          this.is_select = true;
          this.is_addClass = true;
          this.getClassData(this.num);
          break;
        case "addStudent":
          this.getClassData(this.num);
          break;
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "checkService", function checkService() {
    this.isNotice = !this.isNotice;
    document.body.style.overflow = "hidden";
    this.params = {
      type: 5,
      noticeTitle: "查看服务详情",
      serviceArr: this.classStudent,
      identify: "checkService",
      classId: this.currentClass.classId
    };
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "redact", function redact(currentClass) {
    this.isNotice = !this.isNotice;
    this.params = {
      type: 6,
      noticeTitle: "编辑班级信息",
      identify: "redact",
      currentClass: currentClass
    };
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "showOneClass", function showOneClass(index) {
    if (this.clickFlag) {
      return false;
    }
    this.num = index;
    this.clickFlag = true;
    this.getClassData(index);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "createClass", function createClass() {
    this.isNotice = !this.isNotice;
    this.params = {
      type: 7,
      noticeTitle: "添加班级",
      identify: "addClass",
      mobile: this.mobile,
      currentClass: this.currentClass
    };
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "addStudent", function addStudent(currentClass) {
    this.isNotice = !this.isNotice;
    this.params = {
      type: 8,
      noticeTitle: "添加学生",
      identify: "addStudent",
      currentClass: currentClass,
      classStudent: this.classStudent,
      teacherId: this.teacherId
    };
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "studentExcel", function studentExcel() {
    if (this.classStudent.length === 0) {
      this.$toast("班级内还没有学生哦~请先添加学生", "error");
      return false;
    }
    var classId = this.currentClass.classId;
    //                let http = 'http://testpc.teacher.jiaofucloud.cn/'
    var url = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* http */] + "/gateway/v1/student/exportStudentByExcel?classId=" + classId + "&brandId=" + __WEBPACK_IMPORTED_MODULE_6__config__["c" /* brandId */] + "&clientId=" + __WEBPACK_IMPORTED_MODULE_6__config__["b" /* clientId */];
    this.url = url;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "filterPhone", function filterPhone(num) {
    var phone = num;
    if (phone) {
      // return (phone = phone.substr(0, 3) + "****" + phone.substr(7));
      return "已激活";
    } else {
      return "未激活";
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "selecter", function selecter(obj) {
    this.is_select = true;
    // debugger
    var selIndex = obj.dataIndex;

    var replaceArr1 = this.selectedclassList.splice(selIndex, 1);
    var replaceArr2 = this.partclassList.splice(-1, 1);

    this.selectedclassList = this.selectedclassList.concat(replaceArr2);
    this.partclassList = replaceArr1.concat(this.partclassList);

    this.classList = [];
    this.classList = this.partclassList.concat(this.selectedclassList);

    this.num = this.partclassList[0].index;
    this.clickFlag = true;

    this.getClassData(this.partclassList[0].index);
  }), _extends2))
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reportTable_echartLine_vue__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reportTable_echartLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_reportTable_echartLine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reportTable_reportTable_vue__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reportTable_reportTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reportTable_reportTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reportTable_scoreTable_vue__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reportTable_scoreTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_reportTable_scoreTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      classList: [],
      classId: '',
      className: '',
      startDate: '',
      endDate: '',
      exportClassWorkUrl: '',
      exportUrl: '',
      workList: [],
      userList: [],
      classBaseInfo: {},
      echartData: [],
      scoreData: [],
      page: 1
    };
  },

  components: {
    reportTable: __WEBPACK_IMPORTED_MODULE_4__components_reportTable_reportTable_vue___default.a,
    rankHeader: __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue___default.a,
    echartLine: __WEBPACK_IMPORTED_MODULE_3__components_reportTable_echartLine_vue___default.a,
    scoreTable: __WEBPACK_IMPORTED_MODULE_5__components_reportTable_scoreTable_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      var classList = window.sessionStorage.getItem('studentsListData');
      _this.classList = classList ? JSON.parse(classList) : [];
      if (!_this.classList.length) {
        return false;
      }
      _this.classId = _this.classList[0].classId;
      _this.className = _this.classList[0].className;
      _this.setInitTime();
      _this.getWorkStatistics();
    });
  },

  methods: {
    setInitTime: function setInitTime() {
      var nowdate = new Date();
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth();
      var d = nowdate.getDate();
      var formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      var maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59';
      this.endDate = Date.parse(maxTime);
      this.startDate = Date.parse(formatwdate);
    },
    changedPicker: function changedPicker(data) {
      this.startDate = data.startDate;
      this.endDate = data.endDate;
    },
    getWorkStatistics: function getWorkStatistics() {
      var _this2 = this;

      if (this.endDate - this.startDate > 2678400000) {
        this.$toast('统计报告时间段最长选择1个月（31天）', 'error');
        return false;
      }
      var data = {
        classId: this.classId,
        className: this.className,
        startDate: Math.floor(this.startDate / 1000),
        endDate: Math.floor(this.endDate / 1000)
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getClassWorkStatistics(data).then(function (res) {
        if (!res.data) {
          return false;
        }
        _this2.workList = res.data.workList;
        _this2.userList = res.data.userList;
        _this2.exportWorkStatistics(data);
      });
      this.getclassBaseInfo();
      this.setsoreType(0);
      this.setClassWorkReport();
    },
    setClassWorkReport: function setClassWorkReport() {
      var _this3 = this;

      var params = {
        classId: this.classId,
        className: this.className,
        startDate: Math.floor(this.startDate / 1000),
        endDate: Math.floor(this.endDate / 1000),
        page: this.page,
        pageSize: 5
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getClassWorkReport(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.scoreData = res.data;
      });
      this.exportClassWorkUrl = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/gateway/v1/epaperstatistics/exportClassWorkReport?clientId=' + __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */] + '&classId=' + this.classId + '&className=' + this.className + '&startDate=' + Math.floor(this.startDate / 1000) + '&endDate=' + Math.floor(this.endDate / 1000) + '&page=' + this.page + '&pageSize=' + 5;
    },
    exportWorkStatistics: function exportWorkStatistics() {
      this.exportUrl = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/gateway/v1/epaperstatistics/exportClassWorkStatistics?clientId=' + __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */] + '&classId=' + this.classId + '&className=' + this.className + '&startDate=' + Math.floor(this.startDate / 1000) + '&endDate=' + Math.floor(this.endDate / 1000);
    },
    changClassId: function changClassId(data) {
      this.classId = data.classId;
      this.className = data.className;
    },
    setPage: function setPage(val) {
      this.page = val;
      this.setClassWorkReport();
    },
    getclassBaseInfo: function getclassBaseInfo() {
      var _this4 = this;

      var params = {
        classId: this.classId,
        begin: Math.floor(this.startDate / 1000),
        end: Math.floor(this.endDate / 1000)
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getClassBaseInfo(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this4.classBaseInfo = res.data;
      });
    },
    setsoreType: function setsoreType(data) {
      var _this5 = this;

      var params = {
        classId: this.classId,
        soreType: data,
        begin: Math.floor(this.startDate / 1000),
        end: Math.floor(this.endDate / 1000)
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getclasssoreline(params).then(function (res) {
        if (!res || !res.data) {
          return false;
        }
        _this5.echartData = res.data;
      });
    }
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_history_history_vue__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_history_history_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_history_history_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progressBar_progressBar_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progressBar_progressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_progressBar_progressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__unit_progressBar_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      historyHomework: [],
      isShow: false,
      PageIndex: 1,
      PageCount: 0,
      LastBookArr: [],
      totalCount: 0,
      BookText: "",
      pull_data: true,
      loadMore: true,
      index: 1
    };
  },
  created: function created() {
    var _this = this;

    // alert("home")
    this.loading = false;
    this.$nextTick(function () {
      _this.cleanCatalog();
      _this.removeWorks();
      if (window.localStorage.user && window.localStorage.user != "underfined") {
        var user = JSON.parse(window.localStorage.getItem("user"));
        _this.setUser(user);
      }
      _this.removeCrumb();
      _this.setCrumb("首页");
      _this.getHomework();
    });
  },

  watch: {
    $attrs: function $attrs(val) {
      if (val.loadMore && val.currentName) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["getUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setUser", "removeCrumb", "setCrumb", "cleanCatalog", "removeWorks"]), {

    //收回作业事件
    collectHomework: function collectHomework() {
      this.homework();
      this.$toast("收取作业成功", "right");
    },
    arrowShow: function arrowShow() {
      if (this.LastBookArr.length <= 2) {
        return;
      }
      this.isShow = true;
      if (this.$refs.swider.style.left == 0) {
        this.$refs.arrowRight.style.display = "block";
        this.$refs.arrowLeft.style.display = "none";
      }
    },


    // 滚动加载更多
    handleScroll: function handleScroll() {
      var scrollTop = this.$refs.viewWrapper.scrollTop; //scrollTop为滚动条在Y轴上的滚动距离
      var clientHeight = this.$refs.viewWrapper.clientHeight; //clientHeight为内容可视区域的高度。
      var scrollHeight = this.$refs.viewWrapper.scrollHeight; //scrollHeight为内容可视区域的高度加上溢出（滚动）的距离
      if (scrollTop + clientHeight === scrollHeight) {
        this.loadMore = true;
        this.PageIndex++;
        this.getHomework();
      } else {
        this.loadMore = false;
      }
    },

    //设置请求参数
    setParams: function setParams() {
      this.params = {
        page: this.PageIndex,
        pageSize: 5
      };
    },

    //先获取到需要参数，再发请求
    getHomework: function getHomework() {
      this.setParams();
      this.homework();
    },

    //发送请求拿布置作业数据
    homework: function homework() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].homework(this.params).then(function (res) {
        if (!res) {
          return false;
        }
        _this2.showPage = true;
        var homeworkData = [];
        // let currentTime = res.data.currentTime
        var currentTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["timeStamp"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["nowDate"])());
        var homeworks = [];

        // this.historyHomework = res.data.pageList;
        res.data.pageList.map(function (item) {
          item.state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["closeDateState"])(currentTime, item.sendDate, item.effectiveDate);
          item.stateText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["closeDate"])(currentTime, item.sendDate, item.effectiveDate);
          item.isShow_recall = false;
          item.currentTime = currentTime;

          item.workList.forEach(function (item2) {
            item2.rush_state = 1;
            item2.rush_result = false;
            item2.currentTime = currentTime;
            item2.effectiveDate = item.effectiveDate;
            item2.sendDate = item.sendDate;
            var submitTotal = 0;
            item2.workContents.forEach(function (item3) {
              submitTotal += item3.submitCount;
            });

            if (submitTotal === 0) {
              item2.complete_rate = 0;
              item2.decimals_rate = 0;
            } else {
              item2.decimals_rate = (submitTotal / (item2.totalNum * item2.workContents.length)).toFixed(2);
              item2.complete_rate = (item2.decimals_rate * 100).toFixed(0).toString() + "%";
            }
          });
          homeworks.push(item);
        });
        _this2.totalCount = res.data.totalCount;
        _this2.PageCount = Math.ceil(res.data.totalCount / _this2.params.pageSize);

        // if(this.PageIndex > 1 && !this.pull_data) {
        //   this.historyHomework = this.historyHomework.concat(homeworks);
        // }else{
        //   this.historyHomework = homeworks;
        // }
        _this2.historyHomework = _this2.historyHomework.concat(homeworks);
        _this2.loading = false;
      });
    },
    renderCanvas: function renderCanvas() {
      var _this3 = this;

      var cavnasDoms = document.querySelectorAll("canvas");

      var objName = "canvasThree" + this.index_id;

      cavnasDoms.forEach(function (dom) {
        // console.log('dom',dom.id)
        var canvasObj = new __WEBPACK_IMPORTED_MODULE_6__unit_progressBar_js__["a" /* default */](dom.id, _this3.decimalsRate);
        canvasObj.runCircle();
      });
    },
    removeWork: function removeWork(index, delIndex) {
      this.historyHomework[delIndex].workList.splice(index, 1);
      if (this.historyHomework[delIndex].workList.length <= 0) {
        this.historyHomework.splice(delIndex, 1);
        if (this.historyHomework.length <= 0) {
          this.getHomework();
        }
      }
    }
  }),
  components: {
    history: __WEBPACK_IMPORTED_MODULE_2__components_history_history_vue___default.a,
    paging: __WEBPACK_IMPORTED_MODULE_3__components_paging_paging_vue___default.a,
    progressBar: __WEBPACK_IMPORTED_MODULE_4__components_progressBar_progressBar_vue___default.a
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isChecked: false,
      userName: "", //70018520,492976026,70020437
      paddWord: "",
      isFocus: false,
      browser: true,
      isDownload: false,
      loadUrl: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      window.sessionStorage.setItem('studentsListData', []);
      window.sessionStorage.setItem('studentsTemp', []);
      var strName = localStorage.getItem("keyName");
      var strPass = localStorage.getItem("keyPass");
      if (strName && strPass) {
        _this.userName = strName;
        _this.paddWord = strPass;
        _this.isChecked = true;
      }
      _this.setState([0, 0]);
      _this.isChecked = true;
      _this.downFun();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["getUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(["setUser", "setToast", "removeUser", "setState"]), {
    login: function login() {
      var _this2 = this;

      if (this.userName.length == 0) {
        this.$toast("账号不能为空", "error");
        return;
      }
      if (this.userName.length != 0 && this.paddWord.length == 0) {
        this.$toast("密码不能为空", "error");
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].login({ username: this.userName, password: this.paddWord.toString() }).then(function (res) {
        if (!res.data) {
          _this2.$toast("账号或密码错误", "error");
          return false;
        }
        //  let obj ={"userId":this.userName,"clientId":100143,"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjcwMDE4NTIwLCJjbGllbnRJZCI6IjEwMDE0MyIsIm1vYmlsZSI6IjEzMDExMTExMTExIiwicmVhbE5hbWUiOiLmoJflrZDogIHluIjkuIAiLCJuaWNrTmFtZSI6Iuagl-WtkOiAgeW4iOS4gCIsImF2YXRhciI6IiIsImlhdCI6MTUwNjU5NDgzNH0.sudUdXHibosWTBWECRNtLQWRBbBUpdDHQHSTxIl05mw","mobile":"13011111111","realName":"栗子老师一","nickName":"栗子老师一","avatar":"","brandId":524726977,"schoolId":0,"brandName":"测试用","logo":"http://rimg3.ciwong.net/6v68/tools/images/155014/4a399d2a0ea8c1d3baff62fb21fb96898d7e4359.png","host":"http://eapi.my.jiaofucloud.cn","qudao":"http://qudao.jiaofuyun.site","username":"70018520","password":"123456","isUnread":false}
        if (res.data.accessToken) {
          _this2.setUser(res.data);
          //  window.localStorage.setItem("user",JSON.stringify({"Name}));
          // 登录成功后跳转到布置作业
          _this2.$router.push({ path: "web/selectGrade" });
          localStorage.setItem("keyName", _this2.userName);
          if (_this2.isChecked) {
            localStorage.setItem("keyPass", _this2.paddWord);
          } else {
            localStorage.removeItem("keyPass");
          }

          // 登录成功存储班级列表
          __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].grads({ userRole: 2 }).then(function (res) {
            if (!res) {
              return false;
            }
            var arr = [];
            var grads = res.data;
            for (var i = 0; i < grads.length; i++) {
              var item = grads[i];
              arr.push({
                title: item.className,
                path: "classManage"
              });
            }
            window.sessionStorage.setItem("classListData", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
          });
        }
      }, function (err) {
        console.log(err);
      });
    },

    // 记住密码
    rememberPassword: function rememberPassword() {
      this.isChecked = !this.isChecked;
    },
    autoLogin: function autoLogin() {
      if (window.localStorage.userName && window.localStorage.userName != "underfined") {
        this.userName = JSON.parse(window.localStorage.getItem("userName")).Name;
      }
      if (window.localStorage.passWord && window.localStorage.passWord != "underfined") {
        this.paddWord = JSON.parse(window.localStorage.getItem("passWord")).paddWord;
      }
      this.login();
    },

    //键盘事件
    keyLogin: function keyLogin() {
      this.login();
    },
    downFun: function downFun() {
      var version = navigator.userAgent.match(/Chrome\/(.*?) Safari/)[1];
      var v = version.split('.')[0];
      if (v > 49) {
        this.isDownload = true;
        this.loadUrl = apps.xi.web || 'http://xi.my.ciwong.com';
        // fetch.downLoad().then(res => {
        //   console.log(res)
        // })
      }
    }
    // register() {
    //   this.$router.push({ path: "register" });
    // }

  })
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paging_paging_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paging_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paging_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      papers: [],
      createUrl: '',
      params: {},
      pageIndex: 1,
      pageCount: 2,
      keyword: '',
      isNotice: false,
      noticParams: {},
      indexId: Number,
      isSearch: false,
      loading: false
    };
  },

  components: {
    paging: __WEBPACK_IMPORTED_MODULE_2__components_paging_paging_vue___default.a,
    notice: __WEBPACK_IMPORTED_MODULE_3__components_notice_notice_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.delIndex = -1;
    this.$nextTick(function () {
      _this.getPapers();
    });
  },

  watch: {
    '$route': 'getPapers',
    '$attrs': function $attrs(val) {
      if (val.loadMore && val.currentName) {
        console.log('home is ok loadData');
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['getUser']), {
    search: function search(e) {
      this.isSearch = true;
      if (!this.keyword.trim()) {
        this.getPapers();
      }
      this.pageIndex = 1;
      this.getPapers();
    },
    setParams: function setParams() {
      var userInfo = this.getUser();
      this.params = {
        userID: userInfo.userId,
        periodId: 0,
        SubjectID: 0,
        keyWord: this.keyword.trim(),
        pageIndex: this.pageIndex,
        pageSize: 12
      };
    },
    getPapers: function getPapers() {
      var _this2 = this;

      this.setParams();
      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].getPaper(this.params).then(function (res) {
        if (!res) {
          _this2.papers = [];
          return false;
        }
        // this.papers = res.data.result;
        _this2.papers = _this2.papers.concat(res.data.result);
        _this2.pageCount = Math.ceil(res.data.total_count / _this2.params.pageSize);
        _this2.loading = false;
      });
    },
    clearInput: function clearInput(e) {
      this.keyword = '';
    },
    pageNum: function pageNum(pageIndex) {
      this.pageIndex = pageIndex;
      this.getPapers();
    },
    link: function link(type, item) {
      var userInfo = this.getUser();
      var auth = encodeURIComponent(btoa(userInfo.userId) + ':' + btoa(userInfo.password));
      var returnUrl = encodeURIComponent(window.location.href);

      this.createUrl = 'http://tools.booksauthor.ciwong.com/taskresult/EditExamForTeach?router=managePaper&auth=';
      // this.createUrl = 'http://test.booksauthor.ciwong.com/taskresult/EditExamForTeach?auth='
      this.createUrl += auth + '&clientId=' + __WEBPACK_IMPORTED_MODULE_4__config__["b" /* clientId */] + '&brandId=' + __WEBPACK_IMPORTED_MODULE_4__config__["c" /* brandId */] + '&returnUrl=' + returnUrl;
      if (type == 0) {
        this.createUrl += '&id=';
        window.location.href = this.createUrl;
      } else if (type == 1) {
        var query = {
          versionId: item.examinationID,
          brandId: __WEBPACK_IMPORTED_MODULE_4__config__["c" /* brandId */],
          clientId: __WEBPACK_IMPORTED_MODULE_4__config__["b" /* clientId */],
          userId: userInfo.userId
        };
        this.$router.push({ path: 'selectOnlinePaper', query: query });
      } else if (type == 2) {
        var id = item.examinationID;
        this.createUrl += '&id=' + id;
        window.location.href = this.createUrl;
      }
    },
    deletePaper: function deletePaper(item, index) {
      this.delIndex = index;
      this.indexId = item.examinationID;
      this.isNotice = !this.isNotice;
      this.noticParams = { type: 1, noticeText: "确定删除此份试卷!", noticeTitle: "确认删除", button1: "返回", button2: "删除" };
    },
    isConfirm: function isConfirm() {
      var _this3 = this;

      var ExaminationID = { 'ExaminationID': this.indexId };
      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].delPaper(ExaminationID).then(function (res) {
        if (!res) {
          return false;
        }
        // this.getPapers()
        _this3.papers.splice(_this3.delIndex, 1);
      });
    },
    pull_work: function pull_work() {
      this.pageIndex++;
      this.getPapers();
    }
  })
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_oneReport_echartLine_vue__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_oneReport_echartLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_oneReport_echartLine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_oneReport_echartPie_vue__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_oneReport_echartPie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_oneReport_echartPie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_oneReport_scoreTable_vue__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_oneReport_scoreTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_oneReport_scoreTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      leftBar: true,
      routerParams: {},
      studentAllList: [],
      echartLineData: [],
      echartPieData: [],
      basicData: {},
      reportDetail: [],
      workReport: {},
      ranking: 0,
      userName: '',
      page: 1,
      timeData: {}
    };
  },

  components: {
    echartLine: __WEBPACK_IMPORTED_MODULE_1__components_oneReport_echartLine_vue___default.a,
    echartPie: __WEBPACK_IMPORTED_MODULE_2__components_oneReport_echartPie_vue___default.a,
    workInfo: __WEBPACK_IMPORTED_MODULE_3__components_oneReport_scoreTable_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.urlData = _this.$route.query;
      _this.timeData = {
        startDate: _this.urlData.startDate,
        endDate: _this.urlData.endDate
      };
      _this.ranking = _this.urlData.index;
      _this.getStudentList();
      _this.getEchartData();
      _this.getEchartPieData();
      _this.getReportDetail();
    });
  },

  methods: {
    getStudentList: function getStudentList() {
      var _this2 = this;

      var listData = this.urlData;
      var params = {
        classId: listData.classId,
        startDate: listData.startDate,
        endDate: listData.endDate
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getStudentWorkReport(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this2.studentAllList = res.data;
        _this2.userName = _this2.studentAllList[_this2.ranking - 1].userName;
      });
    },
    getEchartData: function getEchartData(resourceT) {
      var _this3 = this;

      var params = this.urlData;
      var paramsData = {
        classId: params.classId,
        userId: params.userId,
        resourceType: resourceT || '',
        startDate: params.startDate,
        endDate: params.endDate
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getScoreRecord(paramsData).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.echartLineData = res.data;
      });
    },
    getEchartPieData: function getEchartPieData() {
      var _this4 = this;

      var params = {
        classId: this.urlData.classId,
        userId: this.urlData.userId,
        startDate: this.urlData.startDate,
        endDate: this.urlData.endDate
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getStudentWorkReportInfo(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this4.basicData = res.data;
        _this4.workReport = _this4.basicData.workReport;
        _this4.echartPieData = _this4.basicData.statistics;
      });
    },
    getReportDetail: function getReportDetail() {
      var _this5 = this;

      var paramsData = this.urlData;
      paramsData.page = this.page;
      paramsData.pageSize = 5;
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getStudentReportDetail(paramsData).then(function (res) {
        if (!res) {
          return false;
        }
        _this5.reportDetail = res.data;
      });
    },
    setresourceType: function setresourceType(i) {
      var resourceArr = ['', 'a7527f97-14e6-44ef-bf73-3039033f128e', '992a5055-e9d0-453f-ab40-666b4d7030bb', 'fcfd6131-cdb6-4eb8-9cb9-031f710a8f15', 'c458a8d4-e3ca-403c-b6b2-ae166e955590', '3ac07125-31ac-11e5-a511-782bcb066f05'];
      console.log(i, resourceArr[i]);
      this.getEchartData(resourceArr[i]);
    },
    setPage: function setPage(val) {
      this.page = val;
      this.getReportDetail();
    },
    lastStudent: function lastStudent() {
      var index = this.ranking * 1;
      if (index <= 0) {
        return false;
      }
      var userId = this.studentAllList[index - 2].userId;
      this.urlData.userId = userId;
      this.userName = this.studentAllList[index - 2].userName;
      this.getEchartData();
      this.getEchartPieData();
      this.getReportDetail();
      this.ranking -= 1;
    },
    nextStudent: function nextStudent() {
      var index = this.ranking * 1;
      var listLen = this.studentAllList.length;
      if (index >= listLen) {
        return false;
      }
      var userId = this.studentAllList[index].userId;
      this.urlData.userId = userId;
      this.userName = this.studentAllList[index].userName;
      this.getEchartData();
      this.getEchartPieData();
      this.getReportDetail();
      this.ranking += 1;
    },
    toggleStudent: function toggleStudent(data) {
      var index = data.ranking;
      this.ranking = index;
      var userId = this.studentAllList[index - 1].userId;
      this.urlData.userId = userId;
      this.userName = this.studentAllList[index - 1].userName;
      this.getEchartData();
      this.getEchartPieData();
      this.getReportDetail();
      // this.ranking += 1
    },
    hideLeftBar: function hideLeftBar() {
      this.leftBar = !this.leftBar;
    },
    goBack: function goBack() {
      var params = {
        classId: this.urlData.classId,
        startDate: this.urlData.startDate,
        endDate: this.urlData.endDate
      };
      this.$router.push({ name: "studentReport", query: params });
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowMenu: false,
            isShowTop: false,
            pageHeight: { 'heigth': '600px' }
        };
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            window.addEventListener('load', _this.windowOnLoad);
        });
    },

    watch: {
        '$route': function $route(newValue, oldValue) {
            // this.isShowMenu = newValue.path !='/' && newValue.path != '/home' && newValue.path != '/class' && newValue.name != 'personMsg'?true:false;
            // this.isShowTop = newValue.path =='/ranks'?false:true;
        }
    },
    methods: {
        // //监听页面刷新事件
        // windowOnLoad(){
        //     this.isShowMenu = this.$route.path !='/' && this.$route.path !='/home' && this.$route.path !='/class' && this.$route.name !='personMsg'?true:false;
        //     this.isShowTop = this.$route.path =='/ranks'?false:true;
        // },
        // setPageHeight(){
        //     this.isShowMenu = this.$route.path !='/' && this.$route.path !='/home' && this.$route.path !='/class' && this.$route.path !='/ForgotPwd'?true:false;
        // },
        // setHeight(){
        //     let pageHeight = 0;
        //     let screenHeight= document.body.offsetHeight
        //     if(this.isShowMenu) {
        //         pageHeight = screenHeight - 120;
        //     } else {
        //         pageHeight = screenHeight - 60;
        //     }
        //     this.pageHeight = {heigth: pageHeight+'px'};
        // }
    }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_banner_topBanner_vue__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_banner_topBanner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_banner_topBanner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShowMenu: false,
      isShowTop: true,
      rwidth: true,
      Lwidth: false,
      pageHeight: 816,
      loadMore: false
    };
  },

  components: {
    topBanner: __WEBPACK_IMPORTED_MODULE_0__components_banner_topBanner_vue___default.a,
    navigation: __WEBPACK_IMPORTED_MODULE_1__components_navigation_navigation___default.a
  },
  created: function created() {
    var that = this;
    this.$nextTick(function () {
      that.setHeight();
    });
  },
  mounted: function mounted() {
    var that = this;
    window.onresize = function () {
      that.setHeight();
    };
  },

  methods: {
    setHeight: function setHeight() {
      var pageHeight = 0;
      var screenHeight = window.innerHeight;
      if (this.isShowMenu) {
        pageHeight = screenHeight - 110;
      } else {
        pageHeight = screenHeight - 80;
      }
      this.pageHeight = pageHeight;
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_personMsg_basicMsg_vue__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_personMsg_basicMsg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_personMsg_basicMsg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_personMsg_teachMsg_vue__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_personMsg_teachMsg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_personMsg_teachMsg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_alertMsg_alertMobile_vue__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_alertMsg_alertMobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_alertMsg_alertMobile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userId: "",
      userInformation: {},
      avatar: "",
      mobile: "",
      imgUrl: "",
      layerMB: false,
      buttontext: "更换手机号"
    };
  },

  components: {
    basicMsg: __WEBPACK_IMPORTED_MODULE_4__components_personMsg_basicMsg_vue___default.a,
    teachMsg: __WEBPACK_IMPORTED_MODULE_5__components_personMsg_teachMsg_vue___default.a,
    alertMobile: __WEBPACK_IMPORTED_MODULE_6__components_alertMsg_alertMobile_vue___default.a
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.setCrumb("个人资料修改");
      _this2.mobile = _this2.getUser().mobile;
      _this2.userId = _this2.$route.params.userId;
      _this2.userInfo();

      // 判断用户是否绑定手机号
      if (_this2.mobile) {
        _this2.mobile = _this2.getUser().mobile;
      } else {
        _this2.mobile = "未绑定";
        _this2.buttontext = "绑定";
      }
      console.log(_this2.mobile);
    });
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(["removeCrumb", "setCrumb", "setUser"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["getUser"]), {
    userInfo: function userInfo() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].getDetailedInf({ uin: this.userId }).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.userInformation = res.data;

        console.log(_this3.userInformation, "66");
        _this3.userInformation.mobile = _this3.getUser().mobile;
        _this3.userInformation.avatar = _this3.userInformation.avatar || "static/img/photo.png";
        _this3.userInformation.password = _this3.getUser().password;
        _this3.avatar = _this3.userInformation.avatar;
        //   console.log("this.avatar", this.avatar)
      });
    },
    sureMobile: function sureMobile(res) {
      this.mobile = this.getUser().mobile;
    },
    altMobile: function altMobile() {
      this.layerMB = !this.layerMB;
    },
    preview: function preview(e) {
      //   debugger
      var url = e.currentTarget.value;
      var prevDiv = document.getElementById("preview");
      var file = e.target.files || e.dataTransfer.files;
      if (file[0].size >= 5242880) {
        return false;
      }
      if (file[0]) {
        var _this = this;
        var reader = new FileReader();
        reader.onload = function (evt) {
          var src = evt.target.result;

          var image = new Image();
          image.onload = function () {
            //             var canvas = document.createElement('canvas');
            //             var imageWidth = 100;
            //             var imageHeight = 100;
            //             var offsetX = 100;
            //             var offsetY = 100;
            //
            //             canvas.width = imageWidth;
            //             canvas.height = imageHeight;
            //
            //             var context = canvas.getContext('2d');
            //
            //             context.drawImage(image, offsetX, offsetY, imageWidth, imageHeight);
            // var data=;
            _this.save(src);
          };
          image.setAttribute("src", src);
          prevDiv.appendChild(image);
        };
        reader.readAsDataURL(file[0]);
      }
    },
    save: function save(imgsrc) {
      var _this4 = this;

      //   console.log("imgsrc",imgsrc)
      var headers = {
        crossDomain: true,
        xhrFields: { withCredentials: true }
      };
      __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].upload({ file: imgsrc }).then(function (res) {
        if (!res) {
          console.log("!res", res);
          _this4.avatar = "static/img/photo.png";
          return false;
        }
        var imgUrl = res.data;
        console.log(res);

        __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].getAvatar({ avatar: imgUrl }).then(function (res) {
          if (!res) {
            _this4.avatar = "static/img/photo.png";
            return false;
          }
          _this4.avatar = imgUrl;
          _this4.$toast("修改成功！", "right");

          var userInfo = _this4.getUser();
          userInfo.avatar = _this4.avatar;
          _this4.setUser(userInfo);
        });
      });
    }
  })
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__unit_Temporalitaet__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_rankPCWorkTable_rankPCWorkTable__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_rankPCWorkTable_rankPCWorkTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_rankPCWorkTable_rankPCWorkTable__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        rankPCWorkTable: __WEBPACK_IMPORTED_MODULE_8__components_rankPCWorkTable_rankPCWorkTable___default.a
    },
    data: function data() {
        var _ref;

        return _ref = {
            rankcontentList: [], //tab栏内容
            rankStatistics: [], //分数
            unRecords: [], //学生记录（有成绩或者班级信息）
            rankRecords: [],
            allWorkId: '', //记录总成绩ID
            currentTitle: '', //当前tab栏对应的title
            endTime: '', //作业结束时间
            arrShow: false, //箭头显示与隐藏
            stateText: '进行中', //作业状态
            stateTime: '',
            stateBtn: true,
            minWidth: 960
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'arrShow', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'pcmoreInfo', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sendDate', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'effectiveDate', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'WorkMessage', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ReviceObject', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'pcLoading', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'allData', new Array()), _ref;
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            _this.rankData();
        });
    },

    watch: {
        '$route': 'rankData'
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getWorks']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb']), {
        //点击图标切换布置信息
        moreToggleInfoShow: function moreToggleInfoShow(e) {
            e.stopPropagation();
            this.pcmoreInfo = !this.pcmoreInfo;
        },

        //点击弹框不消失
        moreInfoShow: function moreInfoShow(e) {
            e.stopPropagation();
            this.pcmoreInfo = true;
        },

        //点击页面消失
        moreInfoHide: function moreInfoHide() {
            this.pcmoreInfo = false;
        },
        rankData: function rankData() {
            var url = window.location.href;

            var params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filter__["parseParam"])(url);
            this.ReviceObject = decodeURI(params.ReviceObject);
            this.WorkMessage = decodeURI(params.WorkMessage);
            this.allWorkId = params.workId;
            this.sendDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDate"])(params.sendDate, 'yyyy-MM-dd W hh:mm');
            this.effectiveDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDate"])(params.effectiveDate, 'yyyy-MM-dd W hh:mm');
            this.rankStatistics = [];
            var differenceTimePub = params.sendDate - parseInt(new Date().getTime() / 1000);
            // alert(differenceTimePub)
            if (differenceTimePub > 0) {
                this.stateText = "待发布";
                this.stateTime = "stateOrange";
                this.endTime = __WEBPACK_IMPORTED_MODULE_6__unit_Temporalitaet__["a" /* default */].timeStamp(differenceTimePub);
            } else {
                var differenceTimeEff = params.effectiveDate - parseInt(new Date().getTime() / 1000);
                if (differenceTimeEff < 0) {
                    this.stateText = "已结束";
                    this.stateTime = "stateGray";
                    this.stateBtn = false;
                } else {
                    this.endTime = __WEBPACK_IMPORTED_MODULE_6__unit_Temporalitaet__["a" /* default */].timeStamp(differenceTimeEff);
                    this.stateGreen = "stateGreen";
                }
            }
            this.rankcontentList = [];
            this.unRecords = [];
            this.rankRecords = [];
            this.toFetchWorkId(params);
        },
        toFetchWorkId: function toFetchWorkId(params) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */].rankWork(params).then(function (res) {
                if (!res) {
                    return false;
                }
                _this2.pcLoading = false;
                var rankHeader = res.data.header;
                _this2.rankcontentList = res.data.header[2];
                console.log("111", _this2.rankcontentList);
                _this2.currentTitle = res.data.work.workName;
                _this2.minWidth = (_this2.rankcontentList.length + 3) * 160;
                _this2.minWidth = _this2.minWidth > 960 ? _this2.minWidth : 960;
                if (res.data.records < 1) {
                    var allStudents = res.data.classInfo.members;
                    _this2.rankStatistics = [];
                    for (var i = 0, len = allStudents.length; i < len; i++) {
                        var item = allStudents[i];
                        item.isShow = 0;
                        item.tabDatas = new Array(rankHeader[2].length);
                        _this2.unRecords.push(item);
                        _this2.rankRecords = [];
                    }
                } else {
                    _this2.rankStatistics = res.data.statistics;
                    //学生信息合并
                    var _allStudents = res.data.receivers;
                    var rankRecords = res.data.records;
                    var unreceivers = res.data.unreceivers;

                    for (var _i = 0, _len = _allStudents.length; _i < _len; _i++) {
                        var _item = _allStudents[_i];
                        _item.isShow = 0;
                        _item.tabDatas = new Array(rankHeader[2].length);

                        for (var j = 0, rLen = rankRecords.length; j < rLen; j++) {
                            if (rankRecords[j].userId == _item.userId) {
                                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_item, rankRecords[j]);
                                _item.isShow = 1;
                                _this2.rankRecords.push(_item);
                            }
                        }
                        if (_item.isShow == 0) {
                            _this2.unRecords.push(_item);
                        }
                    }
                    for (var k = 0, kLen = unreceivers.length; k < kLen; k++) {
                        var _item2 = unreceivers[k];
                        _item2.isShow = -1;
                        _item2.tabDatas = new Array(rankHeader[2].length);
                        _this2.unRecords.push(_item2);
                    }
                }
            });
        }
    })
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rankWork_rankWorkWeb_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rankWork_rankWorkWeb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_rankWork_rankWorkWeb_vue__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            pageHeight: "600px",
            rankWeb: false
        };
    },

    components: {
        rankWorkWeb: __WEBPACK_IMPORTED_MODULE_0__components_rankWork_rankWorkWeb_vue___default.a
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            _this.OnLoad();
        });
    },

    methods: {
        OnLoad: function OnLoad() {
            if (!this.$route.path.indexOf("/api")) {
                this.rankWeb = false;
            } else {
                this.rankWeb = true;
            }
        }
    }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_readWords_readWords_vue__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_readWords_readWords_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_readWords_readWords_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(18);


//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _ref;

        return _ref = {
            selecteSentencedArr: [], //
            worksData: [],
            index: 0,
            parentVersionId: "",
            versionId: '',
            resourceName: "",
            serviceId: "",
            packageId: ""
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'versionId', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'cId', ""), _ref;
    },

    components: {
        readWords: __WEBPACK_IMPORTED_MODULE_2__components_readWords_readWords_vue___default.a
    },
    created: function created() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.getHomeWork();
        });
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getWorks', 'getSubject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb', 'setSuject']), {
        getHomeWork: function getHomeWork() {
            var params = this.$route.query;
            this.serviceId = params.serviceId;
            this.packageId = params.packageId;
            this.versionId = params.versionId;
            this.parentVersionId = params.parentVersionId;
            this.cId = params.cId;
            this.resourceName = params.resourceName;
            this.timesId = params.timesId;
            //                 this.worksData = this.getWorks().contents;
            //                 //遍历
            //                 //get (item, index)
            //                 this.worksData.forEach((item,index)=> {
            //                     if(item.parentVersionId==this.parentVersionId && item.versionId==this.versionId){
            //                         this.index = index;
            // //                        this.selecteSentencedArr = item.checkedResource.split(',');
            //                     }
            //                 })
        },
        submitSentence: function submitSentence(arr, count, num) {
            var _this3 = this;

            var _this = this;
            var contents = this.getWorks().contents;

            if (contents && count) {
                contents.map(function (item, index) {
                    if (item.versionId == _this.versionId && item.parentVersionId == _this.parentVersionId) {
                        item.count = count;
                        item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDataToMinutes"])(count * 10 * _this3.timesId);
                        item.checkedResource = arr.join(',');
                        item.workScore = 100;
                    }
                });
            }
            if (count === 0) {
                contents.map(function (item, index) {
                    if (item.versionId == _this.versionId && item.parentVersionId == _this.parentVersionId) {
                        item.count = num;
                        item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filter__["formatDataToMinutes"])(num * 10 * _this3.timesId);
                        item.checkedResource = arr.join(',');
                        item.workScore = 100;
                    }
                });
            }
            //传回选择段落数目
            // let contents = this.getSubject();
            // contents.map((item) =>{
            //     if(item.moduleInfo.moduleId != 30){
            //         item.resourceList.map((content) =>{
            //             if(content.versionId == _this.versionId && content.parentVersionId == _this.parentVersionId) {
            //                 content.count = count;
            //                 content.readTimes = count * 5;
            //             }
            //         })
            //     }
            // })
            // this.setSuject(contents);
            // this.worksData[this.index].checkedResource = arr.join(',');
            // this.worksData[this.index].workScore = 100;
            this.setWorks({ contents: [] });
            this.setWorks({ contents: contents });
            this.$router.push({ path: "publishHomeWork", query: { serviceId: this.serviceId, packageId: this.packageId, cId: contents[0].cId, isFirst: 0 } });
        }
    })
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      step: 1,
      check_tel: true,
      regTel: '',
      wait: 60,
      timer: '',
      waitCode: false,
      isRegTel: true,
      isVerify: true,
      verifyNum: '',
      username: '',
      password: '',
      confirmPassword: '',
      flag_num: false,
      flag_name: false,
      flag_password: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setUser']), {
    verifyTel: function verifyTel() {
      if (this.regTel.length < 11) return false;

      var reg = /^1[3|4|5|7|8][0-9]{9}$/; //验证规则
      var flag = reg.test(this.regTel); //true
      if (flag) {
        this.sendCode();
      } else {
        this.isRegTel = false;
        this.$toast("请输入正确的手机号", 'error');
      }
    },
    resend: function resend() {
      if (this.wait != 0) {
        return false;
      }
      this.wait = 60;
      this.sendCode();
    },
    sendCode: function sendCode() {
      var _this = this;

      this.countTime();
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getsendVerifyCode({ mobile: this.regTel, template_id: 2, business_id: __WEBPACK_IMPORTED_MODULE_5__config__["c" /* brandId */] }).then(function (res) {
        if (!res) {
          _this.isVerify = false;
          _this.$toast(res.msg, "error");
          return false;
        }
        // this.check_tel = false;
        _this.waitCode = true;
        _this.$toast('发送成功', "right");
      });
    },
    countTime: function countTime() {
      var _this2 = this;

      this.check_tel = false;
      var timer = setInterval(function () {
        if (_this2.wait == 0) {
          _this2.waitCode = false;

          clearInterval(timer);
        } else {
          _this2.wait--;
        }
      }, 1000);
    },
    checkNum: function checkNum() {
      var _this3 = this;

      if (this.verifyNum.length < 6) return false;
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getcheckVerifyCode({ verify_code: this.verifyNum, business_id: __WEBPACK_IMPORTED_MODULE_5__config__["c" /* brandId */], mobile: this.regTel }).then(function (res) {
        if (!res) {
          _this3.$toast(res.msg, 'error');
          return false;
        }
        _this3.step = 2;
      });
    },
    register: function register() {
      var _this4 = this;

      if (this.username.length < 2 || this.password.length < 6 || this.confirmPassword.length < 6) {
        return false;
      }
      if (this.password != this.confirmPassword) {
        this.$toast("密码前后输入不一致", "error");
        return false;
      }
      if (this.flag_num || this.flag_name || this.flag_password) {
        return false;
      }
      var params = {
        business_id: __WEBPACK_IMPORTED_MODULE_5__config__["c" /* brandId */],
        mobile: this.regTel,
        verify_code: this.verifyNum,
        username: this.username,
        sex: 0,
        password: this.password,
        confirmPassword: this.confirmPassword
      };
      var initdata = window.localStorage.user ? JSON.parse(window.localStorage.user) : {};
      // window.location.href  = window.location.origin + '?stade=2';
      var that = this;
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].signup(params).then(function (res) {
        if (!res) {
          _this4.$toast(res.msg, 'error');
          return false;
        }
        var mobile = res.data.mobile;
        _this4.$toast("注册成功！", 'right');
        console.log(mobile);
        __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].login({ username: mobile, password: _this4.password }).then(function (res) {
          if (res) {
            var userData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(res.data, initdata);
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
            _this4.setUser(userData);
            that.$router.push({ path: "/web/class" });
          }
        });
      });
    },
    checkInput: function checkInput(type) {
      if (type == 1) {
        //手机号
        var reg = /[^\d]/g;
        var flag_num = reg.test(this.regTel);
        if (flag_num) {
          this.flag_num = true;
        } else {
          this.flag_num = false;
        }
      } else if (type == 2) {
        //姓名
        var _reg = /[^\u4E00-\u9FA5]/g;
        var flag_name = _reg.test(this.username);
        console.log('flag_name', flag_name);
        if (flag_name || this.username.length < 2 && this.username.length > 0) {
          this.flag_name = true;
        } else {
          this.flag_name = false;
        }
      } else {
        //密码
        var _reg2 = /[\W]/g;
        var flag_password = _reg2.test(this.password);
        console.log('flag_password', flag_password);
        if (flag_password) {
          this.flag_password = true;
        } else {
          this.flag_password = false;
        }
      }
    }
  })
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(14);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      noGrade: true,
      grads: [],
      groups: [],
      isActive: 0,
      selectNum: 0
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.setWorks({});
      var studentsListData = window.sessionStorage.getItem('studentsTemp');
      if (studentsListData) {
        _this.grads = JSON.parse(studentsListData);
        _this.groups = _this.grads[0].students;
        _this.getSelectedNum();
      } else {
        var params = {
          userRole: 2,
          exists: 1
        };
        _this.getClass(params);
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])(["setWorks"]), {
    getClass: function getClass(params) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].grads(params).then(function (res) {
        if (!res) {
          _this2.noGrade = false;
          return false;
        }
        return res;
      }).then(function (grads) {
        if (!grads || grads.data && !grads.data.length) {
          _this2.noGrade = false;
          return false;
        }
        var classIds = [];
        for (var i = 0; i < grads.data.length; i++) {
          classIds.push(grads.data[i].classId);
        }
        var param = {
          classIds: classIds.join(","),
          userRole: 1
        };
        _this2.getStuList(param);
      });
    },


    // 获取班级数据
    getStuList: function getStuList(param) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].getMemberlist(param).then(function (res) {
        if (!res) {
          return false;
        }
        _this3.grads = res.data;
        _this3.getGrads(false);
        _this3.groups = _this3.grads[0].students;
      });
    },

    // 遍历班级数据，添加选中标识，得到班级下面的分组数组
    getGrads: function getGrads(checked) {
      var _this4 = this;

      var grads = [];
      this.grads.map(function (item, index) {
        item.checked = checked; // 选中标识
        item.selNum = 0;
        var students = item.data;

        var _getGroups = _this4.getGroups(students, checked),
            newStu = _getGroups.newStu,
            student_count = _getGroups.student_count;

        item.students = newStu;
        item.count = student_count;
        grads.push(item);
      });
      this.grads = grads;
      window.sessionStorage.setItem("studentsListData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.grads));
      window.sessionStorage.setItem("studentsTemp", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.grads));
    },

    // 获取班级的分组，对分组进行处理
    getGroups: function getGroups(students, checked) {
      var group = {};
      var newStu = [];
      var groupTitles = [];
      var student_count = 0;
      students.sort(function (a, b) {
        return a.userName.localeCompare(b.userName);
      });
      for (var index = 0, len = students.length; index < len; index++) {
        var item = students[index];
        if (item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        item.checked = checked;
        // 分组判断处理
        // 1.如果班级下面学生有分组就显示对应的分组，如果没有就列为未分组
        // 2.未分组列成员名单默认不展开
        item.teamName = item.teamName || "未分组";
        var same_index = groupTitles.indexOf(item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: item.teamName,
            data: [item],
            count: 1,
            checked: checked,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          var _group = newStu[same_index];
          _group.data.push(item);
          _group.count += 1;

          newStu[same_index] = _group;
        }
        student_count++;
      }
      return { newStu: newStu, student_count: student_count };
    },
    setGroups: function setGroups(groups, checked) {
      var _this5 = this;

      groups.map(function (item) {
        item.checked = checked;
        item.selNum = checked ? item.count : 0;
        item.data = _this5.setStudents(item.data, checked);
      });
      this.groups = groups;
      return groups;
    },

    // 班级的点击事件处理
    selectedGradFun: function selectedGradFun(index, showTag) {
      var grad = this.grads[index];
      var checked = !grad.checked;
      this.isActive = index;

      if (!checked && showTag) {
        this.groups = grad.students;
        return;
      }
      var groups = this.setGroups(grad.students, checked);
      var selNum = checked ? grad.count : 0;
      this.grads[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(grad, {
        checked: checked,
        students: groups,
        selNum: selNum
      });
      this.getSelectedNum();
    },
    setStudents: function setStudents(students, checked) {
      students.map(function (item) {
        item.checked = checked;
      });
      return students;
    },

    // 分组的点击事件处理
    selectGroup: function selectGroup(index) {
      var group = this.groups[index];
      var checked = !group.checked;
      var selNum = checked ? group.count : 0;
      var data = this.setStudents(group.data, checked);
      this.grads[this.isActive].selNum += checked && group.selNum < group.count ? group.count - group.selNum : -1 * group.selNum;
      this.grads[this.isActive].checked = true;
      this.groups[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(group, { checked: checked, data: data, selNum: selNum });
      this.getSelectedNum();
    },

    // 分组下面学生成员的点击事件处理
    selectedStudentFun: function selectedStudentFun(index, sIndex) {
      var group = this.groups[index];
      var student = group.data[sIndex];
      var checked = !student.checked;
      var selNum = group.selNum + (checked ? 1 : -1);
      group.data[sIndex].checked = checked;
      this.groups[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(group, {
        selNum: selNum,
        checked: selNum == group.count
      });
      this.grads[this.isActive].selNum += checked ? 1 : -1;
      this.grads[this.isActive].checked = true;
      this.getSelectedNum();
    },

    // 学生成员的显示与隐藏
    showStu: function showStu(index) {
      var group = this.groups[index];
      this.groups[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(group, { teamShow: !group.teamShow });
    },
    getSelectedNum: function getSelectedNum() {
      var count = 0;
      this.grads.map(function (item) {
        if (item.selNum > 0) {
          count++;
        }
      });
      this.selectNum = count;
    },

    // 下一步操作
    nextOne: function nextOne() {
      var _this6 = this;

      if (!this.selectNum) {
        this.$toast("请选择布置对象");
        return false;
      }
      var classList = []; // 布置作业班级集合  以班级为单位,
      var userList = []; // 布置作业班级集合  以学生个人为单位,
      var classIdArr = [];
      var target = "";
      // debugger
      this.grads.forEach(function (item) {
        var grad = {};
        if (item.checked && item.selNum) {
          grad = {
            schoolId: item.schoolId,
            classId: item.classId,
            className: item.className,
            selectStudentLength: item.selNum,
            studentCount: item.count
          };
          var groupList = item.students;
          groupList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(groupList).sort(function (a, b) {
            var group_first = groupList[a];
            var group_second = groupList[b];
            return group_second.selNum / group_second.count - group_first.selNum / group_first.count;
          }).map(function (index) {
            return groupList[index];
          });
          classIdArr.push(grad.classId);
          if (item.selNum < item.count) {
            var _userList = [];
            target += ";" + item.className + "-";
            groupList.map(function (gItem) {
              var user = {};
              var isGroupChecked = false;
              if (gItem.selNum === gItem.count) {
                isGroupChecked = true;
                target += gItem.title + ",";
              } else if (gItem.selNum > 0) {
                // target += item.className + "-";
              }
              gItem.data.map(function (sItem) {
                if (sItem.checked) {
                  user = {
                    userId: sItem.userId,
                    userName: sItem.userName
                  };
                  if (!isGroupChecked) {
                    target += sItem.userName + ",";
                  } else {
                    user.groupName = gItem.title;
                  }
                  _userList.push(user);
                }
              });
              // target = target.substring(0, target.length - 1) + ";";
            });
            grad.userList = _userList;
          } else {
            target += ";" + item.className;
          }
          classList.push(grad);
        }
      });
      console.log('this', this.grads);
      window.sessionStorage.setItem("studentsTemp", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.grads));
      var classIdstr = classIdArr.join(","); // 班级ID拼接
      target = target.substring(1, target.length).replace(",;", ";");
      __WEBPACK_IMPORTED_MODULE_5__fetch__["a" /* default */].getClassService({ classids: classIdstr, sId: 0, uId: __WEBPACK_IMPORTED_MODULE_7__config__["c" /* brandId */] }).then(function (res) {
        console.log(res);
        if (!res) {
          return false;
        }
        if (res.data.length > 0 || classList.length < 2) {
          _this6.setWorks({ classList: classList, target: target });
          window.sessionStorage.setItem("service", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.data));
          _this6.$router.push({
            path: "setHomework",
            query: { bookType: 1, classIdstr: classIdstr }
          });
        } else {
          _this6.$toast("所选班级使用的书籍不相同，您可以单个班级布置");
          return false;
        }
      });
    }
  })
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_question_exampaper_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filter__ = __webpack_require__(18);


//
//
//
//
//
//

 // 接口
 // 所有题型组件



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    exampaper: __WEBPACK_IMPORTED_MODULE_3__components_question_exampaper_vue___default.a
  },
  data: function data() {
    return {
      page: 'selectListenSpeak', // 当前页面
      versionId: '', // 试卷ID 5413356909901475565
      exampaperData: {}, // 试卷信息
      worksData: {}, // 外部作业数据
      selectedWork: {},
      index: -1,
      serviceId: "",
      packageId: "",
      parentVersionId: "",
      cId: "",
      moduleId: 15,
      checkedResource: '',
      selectFlag: 0,
      thirdParty: true
    };
  },
  created: function created() {
    var _this2 = this;

    var params = this.$route.query;
    this.versionId = params.versionId;
    this.serviceId = params.serviceId;
    this.packageId = params.packageId;
    this.cId = params.cId;
    this.checkedResource = params.checkedResource;
    this.parentVersionId = params.parentVersionId;
    var selectFlag = params.selectFlag;
    if (selectFlag) {
      this.selectFlag = 1;
    }
    this.$nextTick(function () {
      _this2.setCrumb('选择听说模考大题');
      _this2.getHomeWork();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getWorks', 'getSubject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb', 'setSuject']), {
    getHomeWork: function getHomeWork() {
      this.worksData = this.getWorks().contents;
      //				let _this = this;
      //				this.worksData && this.worksData.forEach((item,index)=>{
      //					if(item.versionId==_this.versionId){
      //						_this.index = index;
      //					}
      //				})
    },
    submitExampaper: function submitExampaper(arr, count, score, num) {
      var _this = this;
      //传回选择大题数目
      var contents = this.getWorks().contents;
      if (contents && count) {
        contents.map(function (item, index) {
          if (item.versionId == _this.versionId && item.parentVersionId == _this.parentVersionId) {
            item.count = count;
            item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__filter__["formatDataToMinutes"])(count * 180);
            item.checkedResource = arr.join(',');
            item.workScore = score;
          }
        });
      }
      this.setWorks({ contents: [] });
      this.setWorks({ contents: contents });
      this.$router.push({ path: "publishHomeWork", query: { serviceId: this.serviceId, packageId: this.packageId, cId: contents[0].cId, isFirst: 0 } });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    var listenData = {
      parentVersionId: this.parentVersionId,
      versionId: this.versionId,
      moduleId: this.moduleId,
      checkedResource: this.checkedResource
    };
    __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].filterListen(listenData).then(function (res) {
      if (!res) {
        return false;
      }
      var json = typeof res == 'string' ? JSON.parse(res) : res;
      if (json.errcode == undefined || json.errcode != 0 || !json.data) {
        console.log('服务器报错:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      } else {
        _this3.exampaperData = json.data;
        _this3.selectFlag == 0 ? _this3.exampaperData.checkedResourceEmpty = 1 : _this3.exampaperData.checkedResourceEmpty = 0;
      }
    }, function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_checkAll_checkAll_vue__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_checkAll_checkAll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_checkAll_checkAll_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      allClass: [], // 拼接好之后的班级和班级学生数组
      classArr: [],
      getIndex: 0,
      classList: [], // 布置作业班级集合  以班级为单位,
      userList: [], // 布置作业的接受者集合 以个人为单位,
      isReady: false,
      isChecked: false
    };
  },

  components: {
    checkAll: __WEBPACK_IMPORTED_MODULE_3__components_checkAll_checkAll_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.setWorks({ contents: [] });
    this.setCatalog([]);
    this.removeCrumb();
    var params = {
      userRole: 2,
      exists: 1
    };
    __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].grads(params).then(function (res) {
      _this.classArr = res.data;
      _this.getClassStudent(_this.classArr);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["getWorks"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(["setWorks", "removeCrumb", "setCatalog"]), {
    classClick: function classClick(index) {
      this.allClass.forEach(function (item, index) {
        item.selected = false;
      });
      this.allClass[index].selected = true;
    },
    singerChange: function singerChange(index, index2) {
      var _this2 = this;

      this.isChecked = false;
      var oneClass = this.allClass[index];
      var student = oneClass.studentArr[index2];
      student.isChecked = !student.isChecked;
      var checkedLen = oneClass.checkedStudents.length;
      var noCheckLen = oneClass.studentArr.length;
      if (checkedLen === noCheckLen) {
        //全选
        oneClass.checkAll = true;
        oneClass.isIndeterminate = false;
      } else if (checkedLen > 0) {
        oneClass.checkAll = false;
        oneClass.isIndeterminate = true;
      } else {
        oneClass.checkAll = false;
        oneClass.isIndeterminate = false;
      }
      this.allClass.forEach(function (item) {
        if (item.checkedStudents.length > 0) {
          _this2.isChecked = true;
        }
      });
    },

    getClassStudent: function getClassStudent(classArr) {
      var _this3 = this;

      if (this.getIndex > classArr.length - 1) {
        this.isReady = true;
        return false;
      }
      // 递归,多个请求一起,不能保证请求返回的顺序,依次递归请求,保证顺序
      var currentClassId = classArr[this.getIndex].classId;
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getClassStudent({
        classId: currentClassId,
        userRole: 1,
        pageSize: 100
      }).then(function (res) {
        var obj = {
          className: classArr[_this3.getIndex].className, // 班级名称
          classId: classArr[_this3.getIndex].classId, // 班级ID
          studentArr: res.data.pageList, // 学生数组
          checkedStudents: [], // 已选择的学生标记
          selected: _this3.getIndex ? false : true, //选中标识
          checkAll: false, // 全选标识
          isIndeterminate: false //  部分选中标识
        };
        obj.studentArr.forEach(function (item, index) {
          item.isChecked = false;
        });
        _this3.allClass.push(obj);
        _this3.getIndex++;
        _this3.getClassStudent(classArr);
      });
    },
    // 选择回传的事件
    nextOne: function nextOne() {
      var _this4 = this;

      if (!this.isChecked) {
        return false;
      }
      this.userList = [];
      this.classList = [];
      var allCheckClassArr = [];
      var classIdArr = [];
      var classIdstr = "";
      // 最后点的时候去确认allClass里的选择列表 拼成对应的参数
      // 不管是布置个人还是班级 都需要向班级集合里添加
      this.allClass.forEach(function (item) {
        var studentCount = item.studentArr.length;
        var selectStudentLength = item.checkedStudents.length;

        var classId = item.classId;
        var className = item.className;
        if (item.checkedStudents.length > 0) {
          var obj = {
            classId: classId,
            className: className,
            studentCount: studentCount,
            selectStudentLength: selectStudentLength
          };
          classIdArr.push(classId);
          _this4.classList.push(obj); // 向班级集合里添加布置对象
          if (item.checkedStudents.length !== item.studentArr.length) {
            // 选择班级里的部分学生布置
            item.checkedStudents.forEach(function (studentId) {
              item.studentArr.forEach(function (student) {
                if (studentId.userId === student.userId) {
                  var obj = {
                    userId: studentId.userId,
                    userName: student.userName,
                    classId: classId
                  };
                  _this4.userList.push(obj);
                }
              });
            });
          } else {
            allCheckClassArr.push(obj);
          }
        }
      });
      if (!this.classList.length) {
        this.$toast("您还没有选择布置对象哦~", "error");
        return false;
      }
      classIdstr = classIdArr.join(",");
      __WEBPACK_IMPORTED_MODULE_4__fetch__["a" /* default */].getClassService({ classids: classIdstr, sId: 0, uId: __WEBPACK_IMPORTED_MODULE_6__config__["c" /* brandId */] }).then(function (res) {
        if (!res) {
          return false;
        }
        if (classIdArr.length > 1) {
          // 多个班级的话没有服务就停留在本界面
          if (res.data.length) {
            window.sessionStorage.setItem("service", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
            _this4.$router.push({
              path: "setHomework",
              query: { bookType: 1, classIdstr: classIdstr }
            });
          } else {
            _this4.$toast("所选班级使用的书籍不相同，您可以单个班级布置。", "error");
            return false;
          }
        } else {
          //一个班级的话没有服务进入下一个页面提示
          window.sessionStorage.setItem("service", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
          _this4.$router.push({
            path: "setHomework",
            query: { bookType: 1, classIdstr: classIdstr }
          });
        }
      });
      this.setWorks({
        userList: this.userList,
        classList: this.classList,
        allCheckClassArr: allCheckClassArr
      });
    },
    handleCheckAllChange: function handleCheckAllChange(index) {
      var _this5 = this;

      this.isChecked = false;
      var oneClass = this.allClass[index];
      oneClass.studentArr.forEach(function (item, index) {
        item.isChecked = oneClass.checkAll;
      });
      oneClass.checkedStudents = oneClass.checkAll ? oneClass.studentArr : [];
      oneClass.isIndeterminate = false;
      this.allClass.forEach(function (item) {
        if (item.checkedStudents.length > 0) {
          _this5.isChecked = true;
        }
      });
    }
  })
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//

 // 接口
 // 所有题型组件
// import loadingImg from '../components/loadingImg/loadingImg.vue' //loading


/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		exampaper: __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default.a
	},
	data: function data() {
		return {
			page: 'selectOnlinePaper', // 当前页面
			versionId: '', // 试卷ID 	4613335007164703262
			accessToken: '',
			clientId: '',
			brandId: '',
			webloading: true,
			exampaperData: {}, // 试卷信息
			moduleId: 124,
			thirdParty: true,
			doworkTime: ''
		};
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			_this.getData();
			_this.setCrumb('在线作答预览');
		});
	},

	watch: {
		'$route': 'getData'
	},
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setCrumb', 'setUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUser']), {
		getData: function getData() {
			var _this2 = this;

			var $this = this;
			this.webloading = true;
			var params = this.$route.query;
			if (params.env) {
				var user = {
					clientId: params.clientId,
					brandId: params.brandId
				};
				if (params.env == 'production') {
					user.host = 'http://eapi.my.ciwong.com';
				} else if (params.env == 'test') {
					user.host = 'http://eapi.my.jiaofucloud.cn';
				}
				console.log(user, 'LLLLLLLLLLLL');
				this.setUser(user);
			}
			this.doworkTime = params.readTime;
			if (params.userId) {
				this.thirdParty = false;
			}
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getOnlineExamination({ versionId: params.versionId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this2.exampaperData = res.data;
				// setTimeout(()=>{
				// 	$this.webloading=false;
				// }, 1000)
			}, function (err) {
				console.log(err);
			});
		}
	})
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_selectText_selectText_vue__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_selectText_selectText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_selectText_selectText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(18);

//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selecteSentencedArr: [], //
            worksData: [],
            index: 0,
            versionId: "",
            resourceName: "",
            serviceId: "",
            packageId: "",
            parentVersionId: "",
            cId: ""
        };
    },

    components: {
        selectText: __WEBPACK_IMPORTED_MODULE_1__components_selectText_selectText_vue___default.a
    },
    created: function created() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.setCrumb('筛选段落');
            _this2.getHomeWork();
        });
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getWorks', 'getSubject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb', 'setSuject']), {
        getHomeWork: function getHomeWork() {
            var params = this.$route.query;
            this.serviceId = params.serviceId;
            this.packageId = params.packageId;
            this.versionId = params.versionId;
            // this.cId = this.getWorks().contents[0].cId;
            this.parentVersionId = params.parentVersionId;
            this.resourceName = params.resourceName;
            this.timesId = params.timesId;
            //                this.worksData = this.getWorks().contents;
            //                //遍历
            //                //get (item, index)
            //                this.worksData.forEach((item,index)=> {
            //                    if(item.versionId==this.versionId){
            //                        this.index = index;
            //                    }
            //                })
        },
        submitSentence: function submitSentence(arr, count, allCount, num, indexArr) {
            var _this3 = this;

            //
            var _this = this;

            var contents = this.getWorks().contents;
            if (contents && count && allCount) {
                contents.map(function (item, index) {
                    if (item.moduleId == _this3.$route.query.moduleId && item.versionId == _this.versionId && item.parentVersionId == _this.parentVersionId) {
                        item.count = count;
                        item.sentenceCount = allCount;
                        item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__filter__["formatDataToMinutes"])(allCount * 15 * _this3.timesId);
                        item.checkedResource = arr.join(',');
                        item.workScore = 100;
                        item.indexArr = indexArr;
                    }
                });
            }
            if (count === 0) {
                contents.map(function (item, index) {
                    if (item.moduleId == _this3.$route.query.moduleId && item.versionId == _this.versionId && item.parentVersionId == _this.parentVersionId) {
                        item.count = num;
                        item.sentenceCount = allCount;
                        item.refLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__filter__["formatDataToMinutes"])(num * 15 * _this3.timesId);
                        item.checkedResource = arr.join(',');
                        item.workScore = 100;
                        item.indexArr = indexArr;
                    }
                });
            }
            //   debugger
            this.setWorks({ contents: [] });
            this.setWorks({ contents: contents });
            this.$router.push({ path: "publishHomeWork", query: { serviceId: this.serviceId, packageId: this.packageId, cId: contents[0].cId, isFirst: 0 } });
        }
    })
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_setWork_setBooks_vue__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_setWork_setBooks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_setWork_setBooks_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import setPaper from "./../components/setWork/setPaper.vue"

/* harmony default export */ __webpack_exports__["default"] = ({
  inheritAttrs: false,
  data: function data() {
    return {
      index: 1,
      loadData: this.$attrs
    };
  },

  components: {
    setBooks: __WEBPACK_IMPORTED_MODULE_2__components_setWork_setBooks_vue___default.a
    // setPaper
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.setCrumb("选择作业用书");
      var params = _this.$route.query;
      _this.index = params.bookType;
    });
  },

  watch: {
    $attrs: function $attrs(val) {
      this.loadData = val;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["setCrumb"]), {
    toggle: function toggle(param) {
      if (param == 1) {
        this.$router.push({ path: "setHomework", query: { bookType: 1 } });
        this.setCrumb("试卷");
        this.setCrumb("选择作业用书");
      } else {
        this.$router.push({ path: "setHomework", query: { bookType: 2 } });
        this.setCrumb("选择作业用书");
        this.setCrumb("试卷");
      }
      var params = this.$route.query;
      this.index = params.bookType;
    },
    goBack: function goBack() {
      window.history.back();
    }
    // toPaper() {
    //   this.$router.push({path:'setPaper', query:{bookType: 1}})
    // }

  })
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_noData_nodata_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_noData_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_noData_nodata_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      classList: [],
      classId: '',
      className: '',
      startDate: '',
      endDate: '',
      studentScore: [],
      wechatUrl: ''
    };
  },

  components: {
    rankHeader: __WEBPACK_IMPORTED_MODULE_2__components_reportTable_header_vue___default.a,
    noFound: __WEBPACK_IMPORTED_MODULE_3__components_noData_nodata_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      var classList = window.sessionStorage.getItem('studentsListData');
      _this.classList = classList ? JSON.parse(classList) : [];
      if (!_this.classList.length) {
        return false;
      }
      var routerData = _this.$route.query;
      if (routerData.classId) {
        _this.classList.map(function (item) {
          if (item.classId == routerData.classId) {
            _this.classId = item.classId * 1;
            _this.className = item.className;
          }
        });
        _this.startDate = routerData.startDate * 1000;
        _this.endDate = routerData.endDate * 1000;
        _this.getWorkStatistics();
      } else {
        _this.classId = _this.classList[0].classId;
        _this.className = _this.classList[0].className;
        _this.setInitTime();
        _this.getWorkStatistics();
      }
    });
  },

  methods: {
    setInitTime: function setInitTime() {
      var nowdate = new Date();
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth();
      var d = nowdate.getDate();
      var formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      var maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59';
      this.endDate = Date.parse(maxTime);
      this.startDate = Date.parse(formatwdate);
      this.timeFlag = true;
    },
    changedPicker: function changedPicker(data) {
      this.startDate = data.startDate;
      this.endDate = data.endDate;
    },
    getWorkStatistics: function getWorkStatistics() {
      if (this.endDate - this.startDate > 2678400000) {
        this.$toast('统计报告时间段最长选择1个月（31天）', 'error');
        return false;
      }
      this.wechatUrl = '';
      var startDate = this.startDate / 1000;
      var endDate = this.endDate / 1000;
      var redirectUrl = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config__["d" /* httpApp */] + "/genearch/#/studyWeekly?startDate=" + startDate + "&endDate=" + endDate);
      var wechatUrl = __WEBPACK_IMPORTED_MODULE_1__config__["d" /* httpApp */] + "/wechat/v4/redirect?state=8&actionId=6&redirectUrl=" + redirectUrl;
      this.wechatUrl = wechatUrl;
      this.getstudentS();
    },
    changClassId: function changClassId(data) {
      console.log(data.classId, 'changClassId');
      this.classId = data.classId;
      this.className = data.className;
    },
    getstudentS: function getstudentS() {
      var _this2 = this;

      console.log(this.classId, 'getstu');
      var params = {
        classId: this.classId,
        startDate: this.startDate / 1000,
        endDate: this.endDate / 1000
      };
      __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */].getStudentWorkReport(params).then(function (res) {
        if (!res) {
          return false;
        }
        _this2.studentScore = res.data;
      });
    },
    lookOneStudent: function lookOneStudent(data) {
      var routerUrl = {
        userId: data.userId,
        classId: this.classId,
        startDate: this.startDate / 1000,
        endDate: this.endDate / 1000,
        index: data.ranking
      };
      this.$router.push({ name: "oneStudentReport", query: routerUrl });
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_singleChoice_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_question_multipleChoice_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_question_multipleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_question_multipleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_question_filling_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_question_filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_question_filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_question_allFilling_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_question_allFilling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_question_allFilling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_question_reading_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_question_reading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_question_reading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_question_shortanswer_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_question_shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_question_shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_question_imitation_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_question_imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_question_imitation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_question_judge_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_question_judge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_question_judge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 接口
// 试卷
 // 1单选题
 // 2多选题
 // 3填空题
 // 4完形填空
 // 5阅读理解
 // 6简答题
 // 7模仿朗读or简答题
 // 8判断题


/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		singleChoice: __WEBPACK_IMPORTED_MODULE_2__components_question_singleChoice_vue___default.a,
		multipleChoice: __WEBPACK_IMPORTED_MODULE_3__components_question_multipleChoice_vue___default.a,
		filling: __WEBPACK_IMPORTED_MODULE_4__components_question_filling_vue___default.a,
		judge: __WEBPACK_IMPORTED_MODULE_9__components_question_judge_vue___default.a,
		allFilling: __WEBPACK_IMPORTED_MODULE_5__components_question_allFilling_vue___default.a,
		reading: __WEBPACK_IMPORTED_MODULE_6__components_question_reading_vue___default.a,
		shortanswer: __WEBPACK_IMPORTED_MODULE_7__components_question_shortanswer_vue___default.a,
		imitation: __WEBPACK_IMPORTED_MODULE_8__components_question_imitation_vue___default.a
	},
	data: function data() {
		return {
			moduleId: '',
			question: {},
			playerObj: 0
		};
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			_this.getData();
			_this.setCrumb('查看详情');
		});
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapActions */])(['setCrumb']), {
		getData: function getData() {
			var _this2 = this;

			var params = this.$route.query;
			this.moduleId = params.moduleId;
			// 获取题目信息
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getSingleWork(params).then(function (res) {
				if (!res) {
					return false;
				}
				var question = res.data[0];
				var flag = question.stem.match(/^\d{1,9}/);
				if (!flag) {
					for (var i = 0, lenq = question.children.length; i < lenq; i++) {
						question.children[i].stem = i + 1 + "." + question.children[i].stem;
					}
				}
				_this2.question = _this2.setRefAnswer(question);
			}, function (err) {
				console.log(err);
			});
		},

		setRefAnswer: function setRefAnswer(question) {
			//选择题选项匹配
			var answerIdArr = "";
			var options = "";
			var result = [],
			    arr = [];
			if (question.ref_info.answers != "") {
				answerIdArr = question.ref_info.answers;
				options = question.options;
				// 选择题答案解析
				if (question.qtype == 1) {
					for (var i = 0; i < answerIdArr.length; i++) {
						for (var j = 0; j < options.length; j++) {
							options[j].is_answer = false;
							if (options[j].id == answerIdArr[i]) {
								options[j].index = j;
								options[j].is_answer = true;
								arr.push(options[j]);
								break;
							}
						};
					}
				}
				if (arr != '') {
					question.options = options;
					question.ref_info.answers = arr;
				}
				return question;
			} else {
				//chil
				for (var k = 0, cLen = question.children.length; k < cLen; k++) {
					var cquestion = question.children[k];
					answerIdArr = cquestion.ref_info.answers;
					options = cquestion.options;
					arr = [];
					// 选择题答案解析
					if (cquestion.qtype == 1) {
						for (var _i = 0; _i < answerIdArr.length; _i++) {
							for (var _j = 0; _j < options.length; _j++) {
								options[_j].is_answer = false;
								if (options[_j].id == answerIdArr[_i]) {
									options[_j].index = _j;
									options[_j].is_answer = true;
									arr.push(options[_j]);
									break;
								}
							}
						}
						if (arr != '') {
							cquestion.ref_info.answers = arr;
						}
					}
				}
				return question;
			}
		},
		playedObj: function playedObj(playerObj) {
			this.playerObj = playerObj;
		}
	})
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_player_audio_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_player_audio_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            useInfo: [],
            useScore: [],
            exampaperData: "",
            readTimes: "",
            readText: "",
            playerObj: 0,
            index: 0,
            userScore: 0,
            userRank: 0,
            allUrl: []
        };
    },

    components: {
        watchStuHead: __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_5__components_player_audio_vue___default.a
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            _this.setCrumb('单词跟读');
            _this.getInfo();
            _this.toFetchDoWork();
        });
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getWorks']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb']), {
        subPlayStatus: function subPlayStatus(val) {
            this.myIsPlay = val;
            console.log(val);
        },
        playedObj: function playedObj(playerObj) {
            this.allPause();
            this.playerObj = playerObj;
        },
        allPause: function allPause() {
            var audios = document.querySelectorAll('audio');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audios), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item.pause();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        toFetchDoWork: function toFetchDoWork() {
            var _this2 = this;

            this.userScore = this.$route.query.actualScore;
            this.userRank = this.$route.query.index;
            __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getTeacherQuerstion({ doWorkId: this.$route.query.doWorkId }).then(function (res) {
                if (!res) {
                    return false;
                }
                console.log("danci", res.data);
                _this2.exampaperData = res.data;
                var requirementContent = _this2.exampaperData.requirementContent;
                _this2.readTimes = requirementContent.readtimes;
                if (requirementContent.speekingtype == 1) {
                    _this2.readText = "跟读";
                } else if (requirementContent.speekingtype == 2) {
                    _this2.readText = "朗读";
                } else {
                    _this2.readText = "背诵";
                }
                _this2.getAllUrl();
            }, function (err) {
                console.log(err);
            });
        },
        getInfo: function getInfo() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getInfo({ userId: this.$route.query.userId }).then(function (res) {
                if (!res) {
                    return false;
                }
                _this3.useInfo = res.data;
            });
        },
        playOrPause: function playOrPause() {
            this.myIsPlay = !this.myIsPlay;
            this.allPlay();
        },
        getAllUrl: function getAllUrl() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.exampaperData.workAnswers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    this.allUrl.push(item.versionId);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        allPlay: function allPlay() {
            var audios = document.getElementById("playAll");
            var that = this;
            audios.src = this.allUrl[that.index];
            audios.load();
            audios.addEventListener('loadedmetadata', function () {
                audios.play();
                audios.addEventListener('ended', function () {
                    this.index++;
                    if (this.index >= len) {
                        return false;
                    }
                    this.allPlay();
                });
                that.index++;
                console.log('current source num', that.index);
                that.allPlay();
            });
        }
    })
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_player_audio_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_player_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_watchStuHead_watchStuHead__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_watchStuHead_watchStuHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_watchStuHead_watchStuHead__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            useInfo: [],
            useScore: [],
            exampaperData: "",
            readTimes: "",
            readText: "",
            playerObj: 0,
            userScore: 0,
            userRank: 0,
            allUrl: []
        };
    },

    components: {
        watchStuHead: __WEBPACK_IMPORTED_MODULE_5__components_watchStuHead_watchStuHead___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_4__components_player_audio_vue___default.a
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            _this.setCrumb('句子跟读');
            _this.getInfo();
            _this.toFetchDoWork();
        });
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getWorks']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setWorks', 'setCrumb']), {
        IsShow: function IsShow() {
            this.isShow = !this.isShow;
        },
        playedObj: function playedObj(playerObj) {
            this.playerObj = playerObj;
        },
        toFetchDoWork: function toFetchDoWork() {
            var _this2 = this;

            this.userScore = this.$route.query.actualScore;
            this.userRank = this.$route.query.index;
            __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getTeacherQuerstion({ doWorkId: this.$route.query.doWorkId }).then(function (res) {
                if (!res) {
                    return false;
                }
                _this2.exampaperData = res.data;
                var userId = res.data.userId;
                var requirementContent = _this2.exampaperData.requirementContent;
                _this2.readTimes = requirementContent.readtimes;
                if (requirementContent.speekingtype == 1) {
                    _this2.readText = "跟读";
                } else if (requirementContent.speekingtype == 2) {
                    _this2.readText = "朗读";
                } else {
                    _this2.readText = "背诵";
                }
                _this2.getAllUrl();
            }, function (err) {
                console.log(err);
            });
        },
        getInfo: function getInfo() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_2__fetch__["a" /* default */].getInfo({ userId: this.$route.query.userId }).then(function (res) {
                if (!res) {
                    return false;
                }
                _this3.useInfo = res.data;
            });
        },
        getAllUrl: function getAllUrl() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.exampaperData.workAnswers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    this.allUrl.push(item.versionId);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        matchCont: function matchCont(val) {
            return val.replace(/\{/g, '').replace(/\}/g, '');
        }
    })

});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unit_toast_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unit_toast_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__unit_toast_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__seo__ = __webpack_require__(425);






// import ElementUI from 'element-ui';








// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/title'

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__unit_toast_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Checkbox"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["CheckboxGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["MenuItemGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Table"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["TableColumn"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Steps"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"]);

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$echarts = __WEBPACK_IMPORTED_MODULE_11_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__filter__).forEach(function (k) {
  __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter(k, __WEBPACK_IMPORTED_MODULE_7__filter__[k]);
});

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});
router.beforeEach(function (to, from, next) {
  document.title = __WEBPACK_IMPORTED_MODULE_12__seo__["a" /* default */][to.name];
  // if (to.fullPath.indexOf('/web') > -1) {
  //   if (to.name === 'home') {
  //     if (window.localStorage.user) {
  //       next()
  //     } else {
  //       next({path: '/web/login'})
  //     }
  //   }
  // }
  next();
});
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue___default.a);
  }
}).$mount('#app');

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = ({
  setCrumb: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["t" /* WRITE_CRUMB */]),
  removeCrumb: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["v" /* CLEAN_CRUMB */]),
  setWorks: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["q" /* WRITE_WORKS */]),
  removeWorks: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["r" /* CLEAN_WORKS */]),
  setUser: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["n" /* WRITE_USER */]),
  removeUser: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["o" /* CLEAN_USER */]),
  setSuject: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["k" /* WRITE_SUBJECT */]),
  removeSubject: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["l" /* CLEAN_SUBJECT */]),
  setToast: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["h" /* WRITE_TOAST */]),
  cleanToast: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["i" /* CLEAN_TOAST */]),
  setCatalog: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["e" /* WRITE_CATALOG */]),
  cleanCatalog: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["f" /* CLEAN_CATALOG */]),
  setState: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["b" /* WRITE_STATE */]),
  removeState: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["c" /* CLEAN_STATE */])
});

function Write(type) {
  return function (_ref) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var commit = _ref.commit;
    return commit.apply(undefined, [type].concat(args));
  };
}

function Ready(type) {
  return function (_ref2) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var dispatch = _ref2.dispatch;

    var res = dispatch.apply(undefined, [type].concat(args));
    return res;
  };
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	getWorks: function getWorks(state) {
		return state.works.works;
	},
	getCrumb: function getCrumb(state) {
		return state.crumb.crumb;
	},
	getUser: function getUser(state) {
		return state.user.user;
	},
	getSubject: function getSubject(state) {
		return state.subject.subject;
	},
	getCatalog: function getCatalog(state) {
		return state.catalog.catalog;
	},
	showToast: function showToast(state) {
		return state.toast.toast;
	},
	getNavSate: function getNavSate(state) {
		return state.navstate.navstate;
	}
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;



var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* CATALOG */], JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* CATALOG */]) || '[]'));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["e" /* WRITE_CATALOG */], function (state, obj) {
	state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* CATALOG */]] = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["f" /* CLEAN_CATALOG */], function (state) {
	state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* CATALOG */]] = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;



var state = {
	crumb: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["s" /* CRUMB */]) || '[]')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["t" /* WRITE_CRUMB */], function (state, title) {
	var url = window.location.href;
	var arr = [title, url];
	var flag = true;
	state.crumb.find(function (item, index) {
		if (item && item[0] == title) {
			state.crumb.splice(index + 1);
			flag = false;
		}
	});

	if (flag) {
		state.crumb.push(arr);
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["u" /* READ_CRUMB */], function (state) {
	return state.crumb;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["v" /* CLEAN_CRUMB */], function (state) {
	return state.crumb = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;

/*
 * @Author: 大明冯
 * @Date: 2018-08-07 10:37:35
 * @Last Modified by: 大明冯
 * @Last Modified time: 2018-08-07 11:50:16
 */



var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* STATE */], JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* STATE */]) || '[]'));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["b" /* WRITE_STATE */], function (state, index) {
  state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* STATE */]] = index;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["c" /* CLEAN_STATE */], function (state) {
  state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* STATE */]] = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;



var state = {
	subject: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["j" /* SUBJECT */]) || '[]')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["k" /* WRITE_SUBJECT */], function (state, obj) {
	state.subject = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["l" /* CLEAN_SUBJECT */], function (state) {
	state.subject = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;



var state = {
	toast: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["g" /* TOAST */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["h" /* WRITE_TOAST */], function (state, obj) {
	state.toast = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["i" /* CLEAN_TOAST */], function (state) {
	state.toast = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(52);


var _mutations;



var state = {
	user: JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["m" /* USER */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["n" /* WRITE_USER */], function (state, obj) {
	state.user = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["o" /* CLEAN_USER */], function (state) {
	state.user = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types__ = __webpack_require__(52);



var _mutations;



var state = {
	works: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__mutations_types__["p" /* WORKS */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["q" /* WRITE_WORKS */], function (state, obj) {
	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.works, obj);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["r" /* CLEAN_WORKS */], function (state) {
	state.works = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger__);



var localStoragePlugin = function localStoragePlugin(store) {
    store.subscribe(function (mutation, state) {
        var STORAGE_KEY = mutation.type.split('_')[1];
        if (STORAGE_KEY === 'user') {
            window.localStorage.setItem(STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state[STORAGE_KEY][STORAGE_KEY]));
        } else {
            window.sessionStorage.setItem(STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state[STORAGE_KEY][STORAGE_KEY]));
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = ( false ? [createLogger(), localStoragePlugin] : [localStoragePlugin]);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    TimeStatus: function TimeStatus(effectiveDate, sendDate) {
        var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
        if (curTimestamp > effectiveDate) {
            return 2; //已经结束状态
        } else if (curTimestamp < sendDate) {
            return 0; //未开始状态
        } else {
            return 1; //进行中状态
        }
    },
    timeStamp: function timeStamp(second_time) {
        var time = parseInt(second_time) + "秒";
        if (parseInt(second_time) > 60) {
            var min = parseInt(second_time / 60);
            time = min + "分";
            if (min > 60) {
                min = parseInt(second_time / 60) % 60;
                var hour = parseInt(parseInt(second_time / 60) / 60);
                time = hour + "小时" + min + "分";
                if (hour > 24) {
                    hour = parseInt(parseInt(second_time / 60) / 60) % 24;
                    var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
                    time = day + "天" + hour + "小时" + min + "分";
                }
            }
        }
        return time;
    }
});

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.1f21434.png";

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAiCAMAAABsgdmyAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAz1BMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkAAAABkRzgAAAAQ3RSTlMAKoaYkpeMPTL9XM1oU1Zg/vj3+dHn09Tp+gUEA9bI5Mvw7+j85hq4wzPSoOBnlvQ4Rc7dNxseGRYcLPJPe06bqaZhcb66cgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAChSURBVCjP7ZLHEoJAEETbHFEwIsYFM+acRef//8kCFd3aPXvyXabrHaa6agYIBENhjkg0BsQTJJJEitJKhkPJqhpyeQgUCEWJLsl1+a9/rXVN1O7RKkbV4KnVCQ3JP1ATLZUx00O3ntNk7Q4s+eV93e31B684/CpoE40kvcdEk4+e+rtn83daEJa0Wm9ctsDOC/vDkXCS9T4Dl6tz43DsOx5hSTBNioKrVQAAAABJRU5ErkJggg=="

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAUZJREFUOI2lkTFLQlEYhp/vpBRtbUGBBg0NBdHSEDgYFDQ0tLW2Sqb9hH6AilZLY2tDU6CRl3QLIlpbmyQiIyPieu/XoFwz79ULvdM58D3PeT8O/DPincqlOUw7NjDhmg82D+69+3VuCeQSo7usH95FOnBhFXGqgkwOCIyi1eIyyfQj5dIC6twCDQxPAJHu0BnIs6qkENfpE6i2SGY6sDg1oMGESZBIN3sCZBH0iI3Mje+iVm4e26kBr134xSuIqggIKm4g3DZ1P7gjGBYrH6dt6ihND7ZOpqkUtkcLrHwcW/phANveQ7gYLrCKs9hSB1oDtUWiAtFgwVVxHNv1h30StMJDGBi8b/yVrfQ3sDMK7DUQUUW/EKbCIRpTaP5tcI6yT6WwAqqBrMgYsAZ63GsAEHlPIZoF/Rz+uDqonvI2kw3XNkR+AGOpfrJrqs88AAAAAElFTkSuQmCC"

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultPaper.c87a3d6.png";

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAVlJREFUOI3Fkj8vQ3EUhp9z700Q0T+hqVoMvoLBYJFgEfEdyihSm42wGEj5BGI0UCuViFgMZlsnIiEtOjRSvddraHGbK2nE4Gy/J2+e35uTA38c+5EW8zmwFYM0gFAZ2SbTue3OgvOtAXzvEdMq4rIVGwfWMS/F5GIlHPciAt/JGJhcd4+JpTsATrZL5rgbCoIM0CZoNiju7CMNt0ivYaOCK6R6k1mXwZjQNaLWypWYWp5vNpD0pRQ1oYu2VlJd0M4wa9/B+ZpHkOhnMvcAwNlOmqehMqkbi3D3pcLEmg/gfAkayQXEcajJMcn7LI3EPFIh1KZAEM9Gl2jqQ+oLdYwhYhgOIhYSx+D77fDH+X9B9JC+pw7mYxLC/70g0Aye94ZbrhL0n3YWmN0CIxR35+C9CoAa4MfB8aGYHwQnDhrBuI0KEt2HPL/OIh2YWddPv6l52gWSPUef7ANuNIFPOwntHQAAAABJRU5ErkJggg=="

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAdRJREFUOI2V0z9oU0EcB/Dv914S3RyETiJIFwcHOzgJVlyqVgexgjpIA8n7g7uLiAFxcBK6XO4GI1JEgkM3cREH6WChU8eKg0pwEVNqS6C5r4NPiZLXF7/Te8fvPnw57ggAzrmjki6RnML++dHr9R63Wq09a+1ZY8wrADeSJFmh9/6CpBUAtRJkB8BckiTvrLWnSR4j+QzADsmrFUkPANQkvTTGPBkOh7vjlGq1+rnRaGx676+EELokX0taJPlU0nJF0gzJzTRNr5U0gvf+uqRlkhGA+bzAoqR1Q9IA+DQh8hxANLJ8huRGlmUbpgwAgHa7fStH+HtN0q6k80mSrHc6nYOVMsRa2yTp/kG2jTFzcRyvttvthcFgMLVvI+fccWOMH4Oci+N41Xt/iuQLkpVCqNvtRgDuSboNQDmylSNr+dgR5GdWCPX7/VkAN0lelNQE8M0YMzuC/JXCMwohXM4/50l+qNVq0/V6/XvRfCEkaQtAI4qiN81m82PRXCmUpun9ss2jmegeTQxJKnuwYxNC+LPPSPpCcsZae+J/kKWlpQMAFvIiX+mcuwPg0a9/rZEc+/rH5CSAQ5K2JU1TEp1zDwHEJA9P2kjSHsn3IYS7WZa9/QlKMttNlHwldAAAAABJRU5ErkJggg=="

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAABHNCSVQICAgIfAhkiAAAATZJREFUKJF10T1Lw1AUBuD3PU3FxaERHIQOdXBxqLOri0PBghDo4BQoKQ46iX+hkxXSchsICB2EglsGFzdRwcnVH3EXN5vmuFxL7ccZDw8v54NYU0mS7BdFEZNsllaBfr9fFZEXkoeqWuciiON4u1wufwCoqWohIqcyD9I03fI87xlADQBUNWy329kMjcfjjTzPn0jWHbjpdDr3ACAOlKy1jwCOHLiLoqj7FyAAYK0dkWw48BBF0dX8GGKM6ZFsOZD5vn++uIyQ3Fx3qxmqVCoXqpoBAMmGtXa0hIIgmPq+fwbg1cGWMab3DwFAEAQ/nuedqOqng5fD4fD6HwKAMAy/8zw/BvDlWl1jTAsAlt6SpunuZDJ5J1kFMCXZXEIAMBgM9kTkjeSOqmYrEQAkSXJQFMUtyeYvuVh0gjafTDsAAAAASUVORK5CYII="

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login_logo.575a828.png";

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAHMSURBVDiNrZO/axNxGMafnCE2KimmUoVgWrIY5EBH55Kh4GScXTQgpCD4J7h0dHCRaJbuOkgQHUrI0sHS4UjPRCpci5LFu9Zcvk1zP753j4OJbZKLIPgZ3+d9H7683+eNkSTO0OofodrR8cE6wP7ABgDkkvNYvbKMUkbFzYtpjMEhbiC51q5zsVHhurHNpjDpBJJOINkUJteNbS42Knzc2uRJ4I/GiNFwYecti1qNXd/hLLq+w/tajSs7b+gG8tSg3K7znlZjOHP0lJBkUatxrV3/baALi1cbFdq+O9X8VHvIO5s59uXxWN32XV5rvKIuLCrVjo7y9VtIxROIgiAm9oxUPIEn2duodnQgv7VBrfcj8rm21+VX0Y7UmsJkfmuDijGwkZ/8miHP957hwae7kdqNC5dhDGwokeoQN3QgKSM1jyESMQVKLjmPL/2jv/lEYgxsLCVTUFYXlvDONP7Z4L25j0I6C+VRRsXL7030pDfVdF6ZQzwWn6r3pIcX3zSUMir+BKkYESTb+8k90YoMUnkUJPI/RHlkcvaYdoVFLwzoBpK7wpp5TDFOxOzz8SFed3R8PDyAcWIjoZzDcjKFQjqLUkaFemlhbB+/AE2zJeWKDiKhAAAAAElFTkSuQmCC"

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAMAAAD6xte7AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABFFBMVEUAAAAAuo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8Auo8AAABYzex4AAAAWnRSTlMAsPPf8v383fDlNek2MUI+II5y5pSuSaHUgxEq7RiGnc+VSCUvqIH2lxDgSgG4ZI9H3FTsE0XnxPgdQb2AWgamTC7OmkMVCeIs7zKiUtrVtyunWDAos+roryZBIa2EAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAMZJREFUGNNFj2s3QmEQhXflFKdQbuWI3C8pRYio3Am5lC6e//9DvO85rewPs2ae2bPWHoXCkQlnrGhscsoVxBPTMyPNJlMwp/kFZ1FjLZHOLAtvhezqCK2R0/qG2NQWbPtoh11pb98yHeQ5lApFjswiXxJl6zjmxKtYl3SqgJ0RgfPqhWfhpX9b40rXVaneMKiJuNEtd/9p7nkQj0882+Gl9WrqGwkp/t7+CByffOkb13RAp2v/+lGaYhC05/QH/vtDGfhr0R9XeCAYLLxW7QAAAABJRU5ErkJggg=="

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/noStudent.a839abc.png";

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAAg0lEQVQYlVXOoQoCURAF0LMPBUWwGPYvDAqyTSyKwWgy2N6PafAHxLRYrH6IxSAGwbCWt/C8MGUOw50ixihLgQ3K4D9rTPDNYYEZHji1UGGOJw74BIyxwgtHvCFgmUov6UILVzSpeJjDHXVa7jFoAW5pRtih18nerdHHFNscGpzRRfkDGScWTYQaeScAAAAASUVORK5CYII="

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAAg0lEQVQYlU3OsQpBYQAF4O/eSRFl8xJK2diuUnabsv3lsZTNYlLK3diU8hKyKKJMWO5f/1m/OudkIYQFbtjgq0qOF7qYIEthjSv6KFL4YIU7hhhEgDeWeGKEXgR4YFftFCm0MMYPZYQ65mhij3OOGmZo44BjHJ+igxPK9G4DF2yrfvAH/8oaSMk6J3kAAAAASUVORK5CYII="

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAABHNCSVQICAgIfAhkiAAAAYdJREFUKJGFkL2KEwEUhb97ExD8AUEiprUSbVa2dtek8wV0MpmACFYWsk+ghZaKzVoJmoSZQFaJMduIT6AgiykWDAoWIoogkgRSJJljNZLdBD3V4XA+LvcYC2q328en0+ljYNPMCpL2zexeGIYvF3uemW63e2I2m70H1oEHwDUz2wM6cRxvLUKWmSRJtoHNYrG4ViqVZlnearVuSXrk7heCIBgcuASUgSeLAEClUtmW9H0+n1/KsnxmJBWAn6zWDzM7vfQT0Dez8uF2p9M5aWbnJX1Ygtz9PnAjjuO7WVav109NJpOnwGA8Hr9ZGqLRaBzL5/N94CzwS9IXYE3SHLgeRVFyAOr1ekdHo9Fr4JyZ3ZZ0BCikabrv7pclbQFBtVrd+TvEcDh8DpyRdDGKoq+H3tpNkuSbpEaz2ezXarWPniRJ2cyuuPvVFQAAYRg+BF64+zOAvKSbwG4YhnurgEy5XO5Omqaf4jhedzPbcPdX/wIAgiD4DAyADZf028ze/Q8CkPQWGP4BgK2f9w8EKygAAAAASUVORK5CYII="

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAsCAYAAADretGxAAAABHNCSVQICAgIfAhkiAAAAi1JREFUWIXtmD1v00AYgJ/XdtLEMSI0RO0ACv2Q0gGxMbTKgoRA/JXCAqJCDEwsVCDEQPtXOiAxBYURMVFESfkYgDZVKgW7JLGPIVwpyK4aEyMk/Ez2ne/e53yvz7oTfrC62biifHUXmEU4TlIodoE3YsqdxTPzawAC8Lj57JYouZdY4GiWrk4vPJCVzecXCIKntplhfrzC6XwR28wkFtX1e3zw2jR23uH6PSVKLhkq8G8D1EpTVJ1yogIAtpmh6pSplaYAREmwZADnASr2iUSD/86pvE47OWcJUgTIiLH/gALaXQ/P76FGFNQ2MxSz+UESAjnD0lWTRliDna6LO0IBGORCu+uF1oVK7Pn9EYb/ief3ji6RFFFv9q9KRJFKaFIJTSqhSSU0qYQmldCkEppUQpNKaP4/CYkoD5XImVZY8R+Tj9hihkqMZ21yphVpHge9AwsjdMgClLL2CBUO559IzNiT31cBG19bbHdd+ipgcsxhplDCkuHHFVviVWeLVtfdv//0rYMC5pzy0H3Fno6DAoeVJSoRhop5mBBbIuzrOZktxJRQ6gtAV/lDNZxzypSyNqYMVpOJMYfZQunI7feCwRmIgs8WIi+Bi+/d9lCdWGJw9tjEUOIH+ejt6ssXhihZBlS91eR1ZzvyNGVUuH6P9c4W9VYTQIlhLAvAykbjOhLcBzETNfgF5SslN6/NLDza/z2svq1XA4wbwGWBSmKhoQk8MQgeLk7X1gG+A/7oo2pT5pKlAAAAAElFTkSuQmCC"

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAMCAYAAAA9HRKyAAAABHNCSVQICAgIfAhkiAAAAvJJREFUaIHtmU9oHFUcxz/fN8PGJUsi5BBSWDA5SCa5aKFiXCkNbaItggWLYClBaaknRSpIjzn1pkhbKLTFigTFVRB6KLRbWrz4D/SkL4sHL4vSQPYQ2EST7O6vh2RrD5u6S9xdOrufy7x5fOfxed9hDjMjatw430dYOQWcERoDMOwP4CPKwVWOvLtOj/+VfD5/wsyOmtmLksrAj5K+GR8fX+i0WxxppG8BcOvCHqjkBBP1FjLwEMww+85f7VGPN/l8fo+ZLQDTO0TuVqvV45OTk/fa6RVXmuk7xOYduXJWqO7DACCYMMpZbH4/mq+2Rrt7MLMskAmCgJGREZLJJJJYX19neXmZ1dXVaUkLwKFOu8aBRvp2zn0GzDpyg3NCmf9aVChDbnCu9frxxnt/ku2bMzo6SiqVIggCnHMkk0nS6TSpVApJBxcXF9/stO/jTqN9AzPe+zkHevtRC5rZJ+bsha2zR2d7NMRrAMPDw4RhWDcwNDRUGx5rk1OcabhvScdCjAkEhn0BOix4shY0s0skEh+wuXlneybSrY+t1TuIM5JWAPr7+3fMJBKJ2nBvoVDo9b0LSqVSU307hANAfI1zGYMigME5KsFZNjfvCPaxNela6N4VmNnf28dOq3QFTfbtQuBX4HmMLzF7HTRlcISyrhFWvxU88yAu/Waz7021xLxb8P4GcHhtbY2BgYG6kY2Njdrwl3Q6/Uq71OKIb67vnx3GVQChELOvUOXZug8DUMv22BVXAJaWliiXy3UDxWIRAElX2qcVWxruG7gostmAwT+/k/QcgBkVoCDx1MMXmdlPzK5M9T677h7v/W1JB+t9BiwWi5RKJYCbURS93GnXONBg39ejKHp168fczQ/TyN0Werregob9jlUP8dL7hTbuI7Z470ckfQ4c2CFyt6+v742xsbGldnrFlWb61r9T155gY+U0MIPYek8wvgdyJAYvM/3WP60W7za893PAUUkZoGJmP0i6HkXRp512iyON9H0fHvlOphMWz0YAAAAASUVORK5CYII="

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAVBJREFUKJGNks9KAmEUR8/MRs2JyVo4U22SjIqCaOFjuBCH/pAPkbZs46JWQa+RSAQ9RkG4ELWEJJmcsYUkGY2r28KwUZE6cFf3dy7c77sKY0iaE/SohddbByCo1ei0i8oNF/6cMhRSLDOj3XFwNoe5FmJlZ9BolMB5+uLqtEP3I6Hc0sIvSXbbFacuU3mtiRxvtSSF+Sseaa0JKc2g/NhVkYxuA6iS5oTD8wjG6vi6kyytw15+XlLkVPSohREP/m39YMZDRAxLpf+5MXyI/xDbhX5vU/2/MYpKIFylUZrsFGVQ4zw/QECrqHTaRZy6NxGwlEGN4zx6vLsFACQza8tr7e/vaJZFMvrLcIgkWZTsliN2dfoBNMsi2W1XkkRh9ORMwvo9+/kFjHiQ2O7vTs6jRyH/RrebUG5pj4i+ATkihkW/twlAQKvw7haUay79uW/fj+2RMTROUQAAAABJRU5ErkJggg=="

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAlJJREFUOI2Vk8FrXFUUxn/f7TMjGRdlNibgH6Cli9BaTKGLWgutK5WWgdZSukneBGEWQ6turIOrgl1l9d4bNVmEFoIt3Za2WiyBNKJ01a7cVkFIFmrCvObdz80bCQMintU9l/P77vm454ixGAwGszHGS7bfkHQQiLafSXoaQliem5tb31uv0WFxcbHRaDS+sH1ZUhgXrqMCvgSupmn6AiAA9Pv9pNForAEf1/CKpLO7u7vTMcbXbJ8BVoB9wKe2f+j3+wlAAjA9Pd0HDgO/Ah+mafr92Mu3gdt5nn9j+4ak2ampqc+AzzUYDA5XVbUhKcQYjy0sLKz9S/sAZFn2jqT7tiNwKMQYO5KC7a//CwbodDoPbC/XVj8KwAGAEMItgDzPzxdFMTMOFkUxk2XZOQBJ39bXryvP8z+BJrBf0oztB7b/CiGcnJ+f/7GGj8QY70tqAseBX4DnwO+J7T8kNScmJrS1tbUxOTn5SNLxGON3RVGcAF6KMd6V9Irth9vb2z81m839ALarADwBGA6Hs71eb6csy9O2H9bAhu21EVyW5eler7cDHKot/BwkPamTeYButzsciYz8j+Butzus87l/BGKMOVBK+qAoinfHRWzf2wsXRXFK0nu2d5Ik+Ur1334i6Zrt3ySdHw3S0tLSy2VZVqOxzfP8beAm8KrtK51O57oAVldX921ubq5LerNubUXSnaqqHiVJMmH7LdvvAxdqC+utVutYu92u/vcy2b7earWuttvtEvZs4yiyLDsKXAQO1Otc2X4GPJW0nKbp4731fwNC0zrY1M89cwAAAABJRU5ErkJggg=="

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAAkFJREFUOI2dz09IVFEUBvDvu29eoqkEEllhmJE10d+VgRBEIc6Ai0YwcFGrKIggDCKo1i5aBy2KoNoEKQ7oc+YR2RAupGgRtRiGgoIgEMnMoUnfvV+LRpmZxKhvdS/n3N89h6jI+Pj4ft/3+621O0l2kGwE8Mlaez+fz4dDQ0M/sEa4cshkMhdIDgPYBACSfjeQ5atGFxYWBgcGBpZqEVMGBknektQo6a6kY8Visd05dwLATUlfSfY3NzePpdPpplokFgTBPpLDknwAl3p7e+9U1D8CeBYEwQtjzCOSCd/3rwG4XjUJyfMAdki6VwOsJplM5qIougAAxphTIyMjW2vXOVLef2ItYCW+77+UlCcZb2ho2FU7SSsAOOferYdYa7+R/CAJJDtqkVJ5zLb1EAB1zrlmkpD0vQqR9J4kjDGp9QRJHSQPAlj2PO9tFbK8vPyk3HQ2k8mcXAuYmpqKxWKxGySbJD3v6ekpVNZjhUJhNB6PTxtjuiU9CMPwyuLiYhhF0c/6+npXV1fXWSqVLhtj+iXJWnu19hMCQBAEm40x0yR3A4Bz7rMxZpak55zbQ3LDygNr7eOWlpaLXV1dc6vrAEAymZwFcFTSbUlfjDHbJR2WdABATNJTAH0AXnmed3p+fv7hzMxMS9UklQnDcFsURcdJbgSwBOB1IpF4AwC5XK6tVCqFAPYCCIrF4plUKjX3B/K3TE5OtpPMkuy01o5Za8/9MwIAExMTrSQnPc875Jzr/h8DAJBOp7dks9k+APgFKFcDZIGXyHMAAAAASUVORK5CYII="

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAABHNCSVQICAgIfAhkiAAAAPBJREFUOI2tkSFOxGAQhd9rKjAI7IZLgOIMCCSerNugIPM3gYSE4Dq9AA7JEao2SILhAAiCwWHWQco8zDZZ0aUty1PzkvkyXzI0s0MANyT3MSCS7tz9BABykrcAniLivA/MsuwCwE7bcwC7ku6rqnrog81sCmC77UwpaYhuh36dL4czSc9DQZIzAJN8Wd7cvVe7jZkdAZhkY3VXk6+WoiiOI2K2ZvcTwKm7v3TCEbEg2akv6atpmo+1l929BlD/p/Y3ycuyLB9/hbu0JQXJ997LY7U3elUmaSFp7y8wzeya5NVYUNKcAJBSOoiIrZHw6w9q3mxckBXMpQAAAABJRU5ErkJggg=="

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1218),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1154),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1167),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1205),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a3211fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1214),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1178),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1206),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1192),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43026d1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1173),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1de73322",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41f3d0f3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1198),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ab59c45",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1199),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ac3b3c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17e00baa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1153),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-030d90a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1211),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1241),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1190),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1179),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1250),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1166),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1182),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1176),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1202),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1197),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1217),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1212),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1175),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1196),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-382de0a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1243),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1247),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1200),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-768e2223",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1208),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6fd67be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1242),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1244),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1238),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1194),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c445eb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1230),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7fc997c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1223),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1169),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1209),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1215),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1235),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('selectText', {
    attrs: {
      "checked": _vm.selecteSentencedArr,
      "resourceName": _vm.resourceName
    },
    on: {
      "submitSentence": _vm.submitSentence
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('p', [_vm._v("阅读理解小题说明")]), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 5
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.question.children), function(question, index) {
    return _c('div', {
      staticClass: "m-t20"
    }, [(question.qtype == 1) ? _c('singleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 2) ? _c('multipleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 3) ? _c('filling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 4) ? _c('allFilling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 6) ? _c('shortanswer', {
      attrs: {
        "question": question,
        "id": question.id + index,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 7) ? _c('imitation', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 8) ? _c('judge', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oneStudentReport"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "icon_back"
  }), _vm._v(" 返回")]), _vm._v("\n    学生作业报告详情\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "oneBox"
  }, [(_vm.leftBar) ? _c('div', {
    staticClass: "oneBoxL"
  }, [_c('ul', _vm._l((_vm.studentAllList), function(item, index) {
    return _c('li', {
      class: {
        active: index == (_vm.ranking - 1)
      },
      on: {
        "click": function($event) {
          _vm.toggleStudent(item)
        }
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "fr smallF"
    }, [_vm._v(_vm._s(item.totalScore))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "oneBoxR",
    class: {
      oneRwidth: !_vm.leftBar
    }
  }, [_c('span', {
    staticClass: "leftBtn",
    on: {
      "click": _vm.hideLeftBar
    }
  }, [_c('i', {
    staticClass: "iconBtn iconBtnLeft",
    class: {
      iconBtnRight: !_vm.leftBar
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "oneNav"
  }, [_c('span', {
    staticClass: "oneName"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticClass: "wtUp",
    on: {
      "click": _vm.lastStudent
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("上一个")])]), _vm._v(" "), _c('span', {
    staticClass: "wtNext",
    on: {
      "click": _vm.nextStudent
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("下一个")])])]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "basicInfo"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("基本情况")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("成绩排名")]), _vm._v(" "), _c('th', [_vm._v("\n              得分\n              "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，学生平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("班级平均分\n              "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，学生平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("提交率")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.workReport.ranking))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.workReport.avgScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.workReport.classAvgRelativeScore))]), _vm._v(" "), _c('td', {
    staticClass: "equalAvg",
    class: {
      'overAvg': _vm.workReport.submitRate > _vm.workReport.classSubmitRate, 'lowAvg': _vm.workReport.submitRate < _vm.workReport.classSubmitRate
    }
  }, [_vm._v(_vm._s(_vm.workReport.submitRate) + "%")])])])]), _vm._v(" "), _c('echartLine', {
    attrs: {
      "echartData": _vm.echartLineData,
      "userName": _vm.userName
    },
    on: {
      "setresourceType": _vm.setresourceType
    }
  }), _vm._v(" "), _c('echartPie', {
    attrs: {
      "echartData": _vm.echartPieData
    }
  }), _vm._v(" "), _c('workInfo', {
    attrs: {
      "reportDetail": _vm.reportDetail,
      "workReport": _vm.workReport,
      "timeData": _vm.timeData
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigBox"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxTitle"
  }, [_vm._v("\n            班级服务使用情况\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "border": "1",
      "id": "tb"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.serviceArr), function(item) {
    return (_vm.params.serviceArr.length > 0) ? _c('tbody', {
      staticClass: "tddd"
    }, _vm._l((item.serviceArr), function(service, index) {
      return _c('tr', [(index == 0) ? _c('td', {
        attrs: {
          "rowSpan": index == 0 ? item.serviceArr.length : 1
        }
      }, [_vm._v(_vm._s(item.userName))]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(service.ServiceTypeName))]), _vm._v(" "), _c('div', {
        staticClass: "buy",
        class: {
          noBuy: !service.IsBuy
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.StartTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.ExpireTime))])])
    })) : _vm._e()
  }), _vm._v(" "), (_vm.params.serviceArr.length == 0) ? _c('tr', {
    staticClass: "tddd"
  }, [_c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom serviceBottom",
    on: {
      "click": _vm.serviceExcel
    }
  }, [_c('button', {
    staticClass: "serviceExcel"
  }, [_c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("导出服务详情")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "thead"
  }, [_c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "240px"
    }
  }, [_vm._v("服务名称")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "190px"
    }
  }, [_vm._v("开通时间")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "190px"
    }
  }, [_vm._v("到期时间")])])
}]}

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "unfold",
    staticClass: "layerPW"
  }, [_c('div', [_c('header', {
    staticClass: "top"
  }, [_c('p', [_vm._v("修改密码")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("旧密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPW),
      expression: "oldPW"
    }],
    staticClass: "field",
    attrs: {
      "type": "passWord",
      "placeholder": "请输入旧密码",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.oldPW)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPW = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("新密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPW),
      expression: "newPW"
    }],
    staticClass: "field",
    attrs: {
      "type": "passWord",
      "placeholder": "请输入新密码",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newPW)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPW = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("确认密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surePW),
      expression: "surePW"
    }],
    staticClass: "field",
    attrs: {
      "type": "passWord",
      "placeholder": "确认新密码",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.surePW)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surePW = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button write",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "button green",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeMask"
  })])
},staticRenderFns: []}

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noFound"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂时找不到您要的数据~")])])
}]}

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachments.lenght) ? _c('div', {
    staticClass: "m-t10"
  }, _vm._l((_vm.attachments), function(data) {
    return _c('div', [(data.file_url) ? _c('div', {}, [(data.file_type == 1) ? _c('div', {
      staticClass: "img-box m-t20"
    }, [_c('img', {
      attrs: {
        "src": data.file_url,
        "alt": ""
      }
    })]) : (data.file_type == 2) ? _c('div', {
      staticClass: "m-t20"
    }, [_c('theAudio', {
      attrs: {
        "src": data.file_url,
        "id": _vm.id,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1) : (data.file_type == 3) ? _c('div', {
      staticClass: "video m-t20 center"
    }, [(data.file_url.indexOf('letv://')) ? _c('video', {
      attrs: {
        "src": data.file_url,
        "controls": "controls",
        "preload": "auto"
      }
    }) : _c('embed', {
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(data.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()]) : _vm._e()])
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workStatistics"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("班级作业报告")]), _vm._v(" "), _c('div', {
    staticClass: "contentReport"
  }, [_c('rankHeader', {
    attrs: {
      "classList": _vm.classList,
      "className": _vm.className,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "changClassId": _vm.changClassId,
      "changedPicker": _vm.changedPicker,
      "getWorkStatistics": _vm.getWorkStatistics
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "basicInfo"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("基本情况")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("布置作业次数")]), _vm._v(" "), _c('th', [_vm._v("平均提交率")]), _vm._v(" "), _c('th', [_vm._v("平均作业时长")]), _vm._v(" "), _c('th', [_vm._v("\n            平均成绩\n            "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，班级平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.classBaseInfo.assignNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("toPercent")(_vm.classBaseInfo.avgFinishRate, 2, '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("secTotime1")(_vm.classBaseInfo.avgWorkTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.classBaseInfo.score))])])])]), _vm._v(" "), _c('echartLine', {
    attrs: {
      "echartData": _vm.echartData
    },
    on: {
      "setsoreType": _vm.setsoreType
    }
  }), _vm._v(" "), _c('reportTable', {
    attrs: {
      "userList": _vm.userList,
      "worklist": _vm.workList,
      "url": _vm.exportUrl
    }
  }), _vm._v(" "), _c('scoreTable', {
    attrs: {
      "scoreData": _vm.scoreData,
      "url": _vm.exportClassWorkUrl
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "book"
  }, [(_vm.type == 1) ? _c('div', {
    staticClass: "images"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'publishHomeWork',
        query: {
          bookId: _vm.booksData.productId,
          bookName: _vm.booksData.productName,
          serviceId: _vm.booksData.serviceId,
          packageId: _vm.booksData.packageId,
          subject: _vm.booksData.subject,
          isFirst: 1
        }
      }
    }
  }, [(_vm.booksData.cover) ? _c('img', {
    attrs: {
      "src": _vm.booksData.cover,
      "alt": ""
    }
  }) : (!_vm.booksData.cover) ? _c('img', {
    attrs: {
      "src": __webpack_require__(1052),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    class: {
      isTop: _vm.booksData.istop == 1
    },
    on: {
      "click": _vm.setTop
    }
  })], 1) : _c('div', {
    staticClass: "images"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'publishBooks',
        query: {
          paper: _vm.booksData,
          type: 2
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1053),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paper_title",
    attrs: {
      "title": _vm.booksData.examinationTitle
    }
  }, [_vm._v(_vm._s(_vm.booksData.examinationTitle))])]), _vm._v(" "), _c('span', {
    staticClass: "view_btn",
    on: {
      "click": _vm.view
    }
  }, [_vm._v("预览")])], 1), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "bookMsg"
  }, [_c('h4', {
    attrs: {
      "title": _vm.booksData.bookName
    }
  }, [_vm._v(_vm._s(_vm.booksData.productName))]), _vm._v(" "), _c('p', {
    attrs: {
      "title": _vm.booksData.serviceName
    }
  }, [_vm._v(_vm._s(_vm.booksData.serviceName))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeUl($event)
      }
    }
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "particulars"
  }, [_c('div', {
    staticClass: "schoolName"
  }, [_c('span', [_vm._v("所在学校:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolName),
      expression: "schoolName"
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.schoolName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grads"
  }, [_c('span', [_vm._v("年级:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentText),
      expression: "currentText"
    }],
    class: {
      arrowDown: !_vm.isShowUl, arrowUp: _vm.isShowUl
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentText)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showUl($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    staticClass: "className",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.className)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.className = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isShowUl) ? _c('ul', {
    staticClass: "gradsUl"
  }, _vm._l((_vm.gradsArr), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.checkGrad(item)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.params.button1 || "取消"))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.params.button2 || "确定"))]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progressBar clear"
  }, [_c('div', {
    staticClass: "surePass"
  }, [_c('div', {
    staticClass: "anyield"
  }, [_c('p', [_vm._v("完成率")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.completeRate))])]), _vm._v(" "), _c('canvas', {
    ref: "canvasDom",
    staticClass: "circleRun",
    attrs: {
      "data-run": "0",
      "id": 'canvasThree' + _vm.index_id,
      "decimalsRate": _vm.decimalsRate,
      "amout": "1000",
      "nowData": "1000"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStuHead"
  }, [_c('div', {
    staticClass: "watContent"
  }, [_c('div', {
    staticClass: "watConTitle"
  }, [(_vm.useInfo.avatar && _vm.useInfo.avatar.length > 0) ? _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.useInfo.avatar
    }
  }) : _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": __webpack_require__(390)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "realName"
  }, [_c('p', {
    staticClass: "studenName"
  }, [_c('span', [_vm._v(_vm._s(_vm.useInfo.realName))])]), _vm._v(" "), _c('p', {
    staticClass: "studenNum"
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("学生号 : ")]), _c('span', [_vm._v(_vm._s(_vm.useInfo.userId))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "stuConCount"
  }, [_c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.userScore, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("分数")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm.userRank))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("名次")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ensure($event)
      }
    }
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), (_vm.noticeType == 1) ? _c('div', {
    staticClass: "deleteNotice1"
  }, [_c('div', {
    staticClass: "deleteText"
  }, [_vm._v("确定从当前班级删除 "), _c('span', [_vm._v(_vm._s(_vm.params.userName))]), _vm._v(" 么？")])]) : (_vm.noticeType == 2) ? _c('div', {
    staticClass: "deleteNotice2"
  }, [_c('div', {
    staticClass: "verification"
  }, [_c('div', {
    staticClass: "verificationTitle"
  }, [_vm._v("请输入以下验证码")]), _vm._v(" "), _c('div', {
    staticClass: "verificationCode"
  }, [_c('span', [_vm._v(_vm._s(_vm.randomArr[0]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.randomArr[1]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.randomArr[2]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.randomArr[3]))])]), _vm._v(" "), _c('div', {
    staticClass: "inputCode"
  }, [_c('form', _vm._l((_vm.isInputArr), function(item, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.textArr[index]),
        expression: "textArr[index]",
        modifiers: {
          "number": true
        }
      }],
      class: {
        import: _vm.isInputArr[index]
      },
      attrs: {
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.textArr[index])
      },
      on: {
        "keyup": function($event) {
          _vm.moveNext(index);
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.textArr, index, _vm._n($event.target.value))
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.params.button1 || "取消"))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.params.button2 || "确定"))])])])
},staticRenderFns: []}

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basicInfo tableBox"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("作业详情")]), _vm._v(" "), (_vm.workList) ? _c('noFound') : _c('table', [_c('tr', [_c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("排名")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("完成情况")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("总分 ")])]), _vm._v(" "), _vm._l((_vm.userList.slice(0, 10)), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.finishCount) + " / " + _vm._s(item.totalWork))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalScore))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    staticClass: "loadMore",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("点击查看更多作业详情>>")])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  }), _vm._v(" "), _c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "userAnswers": _vm.userAnswers,
      "showdata": _vm.showdata,
      "isShowAnswer": _vm.isShowAnswer,
      "moduleId": _vm.moduleId
    },
    on: {
      "correctScore": _vm.correctScore
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBigImg"
  }, [_c('div', {
    staticClass: "imgMask",
    on: {
      "click": _vm.imgFun
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_Pos",
    attrs: {
      "src": _vm.imgSrc
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(1058),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo_title"
  }, [_vm._v("习习教师")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "personal"
  }, [(_vm.userInformation.avatar) ? _c('img', {
    staticClass: "profile",
    attrs: {
      "src": _vm.userInformation.avatar,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('em'), _vm._v(" "), _c('div', {
    staticClass: "exit"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.goPersonal
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1064),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("个人中心")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1068),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("退出登录")])])])])])]), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meun"
  }, [_c('ul')])
}]}

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "notfond",
    attrs: {
      "src": __webpack_require__(1049)
    }
  })])
}]}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    ref: "setHomework",
    staticClass: "setHomework"
  }, 'div', _vm.$attrs, false), [_vm._m(0), _vm._v(" "), _c('setBooks', {
    attrs: {
      "loadData": _vm.loadData
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n    布置作业\n    "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(392),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', [_vm._v("作业留言")])])])])
}]}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', [_vm._v("小题说明")]), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(_vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('b', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-box clearfix"
  }, _vm._l((_vm.question.options), function(option, opIndex) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(opIndex)) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.stem)
      }
    }), _vm._v(" "), _c('attachments', {
      attrs: {
        "playerObj": _vm.playerObj,
        "id": _vm.question.id,
        "attachments": option.attachments
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1)
  })), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setUserAnswer(_vm.question.options, _vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers,
      "listenTextModule": _vm.question.textModule,
      "qtype": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "qtype": 1,
      "tags": _vm.question.tags
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankHead"
  }, [_c('div', {
    staticClass: "classSelect"
  }, [_c('span', {
    staticClass: "_label"
  }, [_vm._v("班级：")]), _c('span', {
    staticClass: "selectActive",
    on: {
      "click": _vm.selectShow
    }
  }, [_vm._v(_vm._s(_vm.className))]), _vm._v(" "), _c('span', {
    staticClass: "button workbtn1",
    class: {
      active: !_vm.timeFlag
    },
    on: {
      "click": _vm.setOneweek
    }
  }, [_vm._v("近1周")]), _vm._v(" "), _c('span', {
    staticClass: "button workbtn2",
    class: {
      active: _vm.timeFlag
    },
    on: {
      "click": _vm.setOnemonth
    }
  }, [_vm._v("近1个月")]), _vm._v(" "), (_vm.selectFlag) ? _c('ul', {
    staticClass: "selectBox"
  }, _vm._l((_vm.classList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.changClassId(item)
        }
      }
    }, [_vm._v("\n         " + _vm._s(item.className) + "\n       ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "timeBox"
  }, [_c('span', {
    staticClass: "_label"
  }, [_vm._v("时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "timestamp",
      "picker-options": _vm.pickerOptions1
    },
    on: {
      "change": function($event) {
        _vm.changedPicker()
      }
    },
    model: {
      value: (_vm.startD),
      callback: function($$v) {
        _vm.startD = $$v
      },
      expression: "startD"
    }
  }), _vm._v("\n     至\n     "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "timestamp",
      "picker-options": _vm.pickerOptions2
    },
    on: {
      "change": function($event) {
        _vm.changedPicker()
      }
    },
    model: {
      value: (_vm.endD),
      callback: function($$v) {
        _vm.endD = $$v
      },
      expression: "endD"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "button",
    on: {
      "click": _vm.getWorkStatistics
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.shareFlag) ? _c('div', {
    staticClass: "wechatShare"
  }, [_c('span', [_vm._v("微信分享: ")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom-end",
      "width": "210",
      "trigger": "hover"
    }
  }, [_c('div', {
    ref: "qrcode",
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wechatTip"
  }, [_vm._v("打开微信扫一扫分享学生成绩"), _c('br'), _vm._v(" 每个家长只能看到自己孩子的成绩")]), _vm._v(" "), _c('i', {
    staticClass: "iconWechat",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice delTeam",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ensure($event)
      }
    }
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n    " + _vm._s(_vm.params.noticeTitle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "deleteNotice"
  }, [_c('div', {
    staticClass: "deleteText"
  }, [_c('p', [_vm._v("确定删除“ "), _c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" ”吗？")]), _vm._v(" "), _c('p', [_vm._v("删除小组后，该小组下的学生会回归到未分组")])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "sure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inline-block"
  }, [_c('div', {
    staticClass: "button",
    class: _vm.myIsPlay ? 'play' : 'pause',
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": _vm.player
    }
  }, [_c('audio', {
    attrs: {
      "src": _vm.src,
      "preload": "auto"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words clear"
  }, [_c('div', [_c('h4', {
    staticClass: "selectWords-title"
  }, [_vm._v(_vm._s(_vm.resourceName))]), _vm._v(" "), (_vm.selectFlag) ? _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "checkKuang fl",
    class: {
      checked: _vm.isAllChecked, chooseSome: _vm.selectTextArr.length != 0 && _vm.selectTextArr.length < _vm.followreadText.length
    },
    on: {
      "click": _vm.allCheck
    }
  }), _vm._v(" "), _c('span', [_vm._v("全选")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main clear"
  }, _vm._l((_vm.followreadText), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wordsContent",
      class: {
        'active': item.isChecked
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.checkFun(item, index)
        }
      }
    }, [(index % 4 == 0 && _vm.selectFlag) ? _c('div', {
      staticClass: "singleChoice",
      class: {
        checked: _vm.singleChoiceArr[Math.ceil(index / 4)] === 2, chooseSome: _vm.singleChoiceArr[Math.ceil(index / 4)] === 1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.singleChoice(index, '1')
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "title",
      attrs: {
        "title": item.content
      }
    }, [_vm._v(_vm._s(item.content))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "bottomMenu clearfix"
  }, [_c('div', {
    staticClass: "bottomMenuBox clearfix"
  }, [(_vm.selectTextArr.length != 0) ? _c('div', {
    staticClass: "fl",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("共选\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.selectTextArr.length || 0))]), _vm._v("\n                个单词, 预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDataToMinute")(_vm.doworkTime)))]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('span', {
    staticClass: "cancel fl",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button confirm",
    on: {
      "click": _vm.backSentenceArr
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankError"
  }, [(_vm.webloading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": _vm.loadingImg
    }
  }) : _vm._l((_vm.paperData), function(items, indexF) {
    return _c('ul', {
      staticClass: "rankErrorBox"
    }, [_c('p', {
      staticClass: "rankErrorTit",
      attrs: {
        "title": items.module_type_name
      }
    }, [_vm._v(_vm._s(items.module_type_name))]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "margin-bottom": "30px"
      }
    }, _vm._l((items.children), function(item, indexChild) {
      return _c('li', {
        staticClass: "rankErrorTwo clearfix",
        on: {
          "click": function($event) {
            _vm.watchTotal(item)
          }
        }
      }, [(!item.stem) ? _c('p', {
        staticClass: "fl"
      }, [_vm._v(_vm._s(indexChild + 1) + ".")]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "rankErrorTitP",
        class: {
          fl: item.children.length == 0
        },
        attrs: {
          "title": _vm.delHtmlTag(item.stem)
        },
        domProps: {
          "innerHTML": _vm._s(_vm.delHtmlTag(item.stem))
        }
      }), _vm._v(" "), (item.children.length == 0) ? _c('div', [(item.is_objective == 0) ? _c('div', {
        staticClass: "fr"
      }, [_c('div', {
        staticClass: "progress"
      }, [_c('span', {
        staticClass: "progressChild bgOrange",
        style: ({
          width: (item.errorCount / _vm.answerData.submitCount) * 100 + '%'
        })
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "errorNum"
      }, [_c('i', {
        class: {
          orange: item.errorCount >= 0
        }
      }, [_vm._v(_vm._s(item.errorCount >= 0 ? item.errorCount : "--"))]), _vm._v(" 人错误")])])]) : _c('div', {
        staticClass: "fr"
      }, [_c('div', {
        staticClass: "progress"
      }, [_c('span', {
        staticClass: "progressChild bgGreen",
        style: ({
          width: (item.avgScore / item.question_ref_sorce) * 100 + '%'
        })
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "errorNum"
      }, [_vm._v("平均分: "), _c('i', {
        class: {
          green: item.avgScore >= 0
        }
      }, [_vm._v(_vm._s(item.avgScore >= 0 ? _vm.toMathThree(item.avgScore) : "--"))]), _vm._v(" 分")])])])]) : _c('ul', _vm._l((item.children), function(itemC, indexChildC) {
        return _c('li', {
          staticClass: "rankErrorTwo clearfix"
        }, [(!itemC.stem) ? _c('p', {
          staticClass: "fl"
        }, [_vm._v(_vm._s(indexChildC + 1) + ".")]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "rankErrorTitP fl",
          attrs: {
            "title": _vm.delHtmlTag(itemC.stem)
          },
          domProps: {
            "innerHTML": _vm._s(_vm.delHtmlTag(itemC.stem))
          }
        }), _vm._v(" "), (itemC.is_objective == 0) ? _c('div', {
          staticClass: "fr"
        }, [_c('div', {
          staticClass: "progress"
        }, [_c('span', {
          staticClass: "progressChild bgOrange",
          style: ({
            width: (itemC.errorCount / _vm.answerData.submitCount) * 100 + '%'
          })
        })]), _vm._v(" "), _c('div', [_c('span', {
          staticClass: "errorNum"
        }, [_c('i', {
          class: {
            orange: itemC.errorCount >= 0
          }
        }, [_vm._v(_vm._s(itemC.errorCount >= 0 ? itemC.errorCount : "--"))]), _vm._v(" 人错误")])])]) : _c('div', {
          staticClass: "fr"
        }, [_c('div', {
          staticClass: "progress"
        }, [_c('span', {
          staticClass: "progressChild bgGreen",
          style: ({
            width: (itemC.avgScore / itemC.question_ref_sorce) * 100 + '%'
          })
        })]), _vm._v(" "), _c('div', [_c('span', {
          staticClass: "errorNum"
        }, [_vm._v("平均分: "), _c('i', {
          class: {
            green: itemC.avgScore >= 0
          }
        }, [_vm._v(_vm._s(itemC.avgScore >= 0 ? _vm.toMathThree(itemC.avgScore) : "--"))]), _vm._v(" 分")])])])])
      }))])
    }))])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.emptyFlag) ? _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt_e",
    class: {
      tabBt: false
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoAnswer),
      expression: "infoAnswer"
    }],
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.topicAct(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.explains[0]),
      expression: "explains[0]"
    }],
    class: {
      topic_Active: _vm.topicActive == 3
    },
    on: {
      "click": function($event) {
        _vm.topicAct(3)
      }
    }
  }, [_vm._v("试题解析")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledgePoints.length > 0),
      expression: "knowledgePoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.topicAct(2)
      }
    }
  }, [_vm._v("考点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.skillPoints.length > 0),
      expression: "skillPoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 5
    },
    on: {
      "click": function($event) {
        _vm.topicAct(5)
      }
    }
  }, [_vm._v("能力点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tags),
      expression: "tags"
    }],
    class: {
      topic_Active: _vm.topicActive == 4
    },
    on: {
      "click": function($event) {
        _vm.topicAct(4)
      }
    }
  }, [_vm._v("试题标签")])]), _vm._v(" "), (_vm.topicActive == 1 && _vm.infoAnswer) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.infoAnswer.options, _vm.infoAnswer.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 8) ? _c('p', [_vm._v(_vm._s(_vm.setAnswers(_vm.infoAnswer)))]) : _vm._e(), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setShortAnswer(_vm.infoAnswer))
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.knowledgePoints), function(item, index) {
    return _c('span', {
      staticClass: "topc_knowledgeP"
    }, [_vm._v(_vm._s(item.point_displayname))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 3 && _vm.explains) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_c('div', {
    staticClass: "clearfix m-b20",
    domProps: {
      "innerHTML": _vm._s(_vm.explains[0].context)
    }
  }), _vm._v(" "), _vm._l((_vm.explains[0].attachments), function(item, index) {
    return (_vm.explains[0].attachments.length > 0) ? _c('div', {
      staticClass: "m-b20"
    }, [(item.file_type == 2) ? _c('div', {
      staticClass: "button",
      class: _vm.myIsPlay ? 'play' : 'pause',
      on: {
        "click": _vm.player
      }
    }, [_c('audio', {
      attrs: {
        "src": item.file_url,
        "preload": "auto"
      }
    })]) : _vm._e(), _vm._v(" "), (item.file_type == 3 && _vm.videoP) ? _c('div', {
      staticClass: "coverUrl",
      on: {
        "click": _vm.videoPlayer
      }
    }, [_c('img', {
      staticClass: "coverVodio",
      attrs: {
        "src": item.cover_Url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "coverUrlPlay",
      attrs: {
        "src": __webpack_require__(391)
      }
    })]) : _vm._e(), _vm._v(" "), _c('embed', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.file_type == 3 && !_vm.videoP),
        expression: "item.file_type==3 && !videoP"
      }],
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "pic": "item.cover_Url",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(item.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.explains[0].lecturer) ? _c('div', [_c('b', [_vm._v("主讲教师:  ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.explains[0].lecturer))]), _vm._v(" "), (_vm.explains[0].tags) ? _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l((_vm.explains[0].tags.split(',')), function(tag, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(tag))])
  })) : _vm._e()]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 4) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 5) ? _c('div', _vm._l((_vm.skillPoints), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.groupsLength != 0) ? _c('div', {
    staticClass: "groupsManage clearfix"
  }, [_c('div', {
    staticClass: "createGroup clearfix"
  }, [_c('span', [_vm._v("共\n        "), _c('em', [_vm._v(_vm._s(_vm.groupsLength))]), _vm._v(" 个小组")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("新建小组")])]), _vm._v(" "), _vm._l((_vm.groups), function(item, index) {
    return (item.title != '未分组') ? _c('div', {
      key: index,
      staticClass: "groupsList"
    }, [_c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "fr"
    }, [_c('li', [_c('img', {
      attrs: {
        "src": __webpack_require__(1051),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "edit fr",
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_vm._v("编辑")])]), _vm._v(" "), _c('li', [_c('img', {
      attrs: {
        "src": __webpack_require__(1054),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "delete fr",
      on: {
        "click": function($event) {
          _vm.delTeam(index)
        }
      }
    }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
      staticClass: "stuList"
    }, [_c('ul', _vm._l((item.data), function(sitem, sindex) {
      return _c('li', {
        key: sindex
      }, [_vm._v(_vm._s(sitem.userName))])
    }))])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "noClassList"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("该班级下还没有小组，赶紧添加一个吧")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("新建小组")])]), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "publish clear"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "work_title"
  }, [_c('edit-input', {
    attrs: {
      "defalutTitle": _vm.workName
    },
    on: {
      "changeTitle": _vm.changeTitle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "publishTarget"
  }, [_c('article', {
    staticClass: "secondBox",
    staticStyle: {
      "padding": "26px 50px 10px 50px"
    }
  }, [_c('div', {
    staticClass: "grids clear"
  }, [_c('span', {
    staticClass: "choose"
  }, [_vm._v("布置班级")]), _vm._v(" "), _c('div', {
    staticClass: "student_details"
  }, [_c('span', [_vm._v(_vm._s(_vm.target))])])])]), _vm._v(" "), _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params_type != 2),
      expression: "params_type != 2"
    }],
    staticClass: "secondBox contents",
    staticStyle: {
      "padding": "0px 50px 20px 50px"
    }
  }, [_c('div', {
    staticClass: "grids clear"
  }, [_c('span', {
    staticClass: "choose"
  }, [_vm._v("作业内容")]), _vm._v(" "), _c('div', {
    staticClass: "work_details"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#999"
    }
  }, [_vm._v("共选\n                "), _c('span', {
    staticStyle: {
      "color": "#00ba8f",
      "padding": "0 3px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.articles.length))]), _vm._v("\n                条内容，预计\n                "), _c('span', {
    staticStyle: {
      "color": "#00ba8f",
      "padding": "0 3px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.allTimes))]), _vm._v("\n                分钟完成作业")]), _vm._v(" "), _c('ul', _vm._l((_vm.articles), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.resourceName))]), _vm._v(" "), (item.moduleId == 10 || item.moduleId == 127) ? _c('span') : _vm._e()])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "publishTime"
  }, [_c('article', {
    staticClass: "secondBox",
    staticStyle: {
      "padding": "30px 50px 0px 50px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "grids time clear"
  }, [_c('span', {
    staticClass: "choose"
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('div', {
    staticClass: "selectTime"
  }, [_c('p', {
    staticClass: "radio",
    class: {
      'active': !_vm.dateShow
    },
    on: {
      "click": function($event) {
        _vm.modify(1)
      }
    }
  }, [_vm._v("\n                立即发布\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "radio",
    class: {
      'active': _vm.dateShow
    },
    on: {
      "click": function($event) {
        _vm.modify(2)
      }
    }
  }, [_vm._v("\n                定时发布\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateShow),
      expression: "dateShow"
    }],
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendDate),
      expression: "sendDate"
    }],
    staticClass: "timing",
    attrs: {
      "id": "myIDSecond"
    },
    domProps: {
      "value": (_vm.sendDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "times sel_hours"
  }, [_c('origin-select', {
    attrs: {
      "data": 23,
      "selectObj": "time_hours",
      "defValue": _vm.default_V.Hour
    },
    on: {
      "selecter": _vm.selecter
    }
  }), _vm._v(" "), _c('p', [_vm._v("时")])], 1), _vm._v(" "), _c('div', {
    staticClass: "times sel_minutes"
  }, [_c('origin-select', {
    attrs: {
      "data": 59,
      "selectObj": "time_minutes",
      "defValue": _vm.default_V.defMinute
    },
    on: {
      "selecter": _vm.selecter
    }
  }), _vm._v(" "), _c('p', [_vm._v("分")])], 1)])])])]), _vm._v(" "), _c('article', {
    staticClass: "secondBox"
  }, [_c('div', {
    staticClass: "grids time secondBox",
    staticStyle: {
      "padding": "20px 50px 0px 54px"
    }
  }, [_c('span', {
    staticClass: "font_14",
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("截止时间")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "timing",
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "id": "myID"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "times sel_hours"
  }, [_c('origin-select', {
    attrs: {
      "data": 23,
      "selectObj": "hours",
      "defValue": _vm.default_V.defHour
    },
    on: {
      "selecter": _vm.selecter
    }
  }), _vm._v(" "), _c('p', [_vm._v("时")])], 1), _vm._v(" "), _c('div', {
    staticClass: "times sel_minutes"
  }, [_c('origin-select', {
    attrs: {
      "data": 59,
      "selectObj": "minutes",
      "defValue": _vm.default_V.defMinute
    },
    on: {
      "selecter": _vm.selecter
    }
  }), _vm._v(" "), _c('p', [_vm._v("分")])], 1)])]), _vm._v(" "), _c('article', {
    staticClass: "firstBox"
  }, [_c('div', {
    staticClass: "grids clear",
    staticStyle: {
      "padding": "20px 0 30px 54px"
    }
  }, [_c('span', {
    staticClass: "font_14"
  }, [_vm._v("作业留言")]), _vm._v(" "), _c('div', {
    staticClass: "workMessage"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workMessage),
      expression: "workMessage"
    }],
    staticClass: "textarea",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "maxlength": "100",
      "placeholder": "同学们，请按时完成作业哦！"
    },
    domProps: {
      "value": (_vm.workMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.noticParams,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "footerBox"
  }, [_c('div', [_c('input', {
    staticClass: "button prev",
    attrs: {
      "type": "button",
      "value": "上一步"
    },
    on: {
      "click": _vm.goPrev
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button green",
    attrs: {
      "type": "button",
      "value": "确认发布",
      "id": "btn"
    },
    on: {
      "click": _vm.publish
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n    布置作业\n    "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(393),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("作业留言")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "smallpro"
  }, [_vm._v("您最多可以输入\n                "), _c('i', {
    staticStyle: {
      "color": "#00ba8f"
    }
  }, [_vm._v("100")]), _vm._v("个字")])
}]}

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('div', [_c('P', [_vm._v("小题说明多选")]), _vm._v(" "), (_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    staticClass: "correctHand",
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-box clearfix"
  }, _vm._l((_vm.question.options), function(option, opIndex) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(opIndex)) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.stem)
      }
    }), _vm._v(" "), _c('attachments', {
      attrs: {
        "attachments": option.attachments,
        "playerObj": _vm.playerObj,
        "id": _vm.question.id
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1)
  })), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setUserAnswer(_vm.question.options, _vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 2
    }
  }) : (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "qtype": 2,
      "tags": _vm.question.tags
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acceptMsg"
  }, [(_vm.arr.length > 0) ? _c('div', {
    staticClass: "systemMessagesBGC"
  }, [_c('div', {
    staticClass: "MsgContent"
  }, [_vm._l((_vm.arr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "msg"
    }, [_c('div', {
      staticClass: "message"
    }, [_c('p', [(item.content.imgUrl) ? _c('i', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_vm._v("【有图】")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('pre', {
      ref: "msgshow",
      refInFor: true,
      staticClass: "main_contents",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v(_vm._s(item.content.content))]), _vm._v(" "), (item.show_details == 'false') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(index, item)
        }
      }
    }, [_vm._v("展开")]) : _vm._e(), _vm._v(" "), (item.show_details == 'true') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(index, item)
        }
      }
    }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show_details == 'true'),
        expression: "item.show_details == 'true'"
      }],
      attrs: {
        "src": item.content.imgUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "senderInfo"
    }, [_c('p', {
      staticClass: "sender"
    }, [_vm._v("发送人：" + _vm._s(item.senderName))]), _vm._v(" "), _c('p', {
      staticClass: "TimeBox"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("formatDate")(item.publishDate, 'yyyy-MM-dd hh:mm')) + "\n                  ")])])])
  }), _vm._v(" "), (_vm.loading && _vm.PageIndex !== _vm.PageCount) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()], 2), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDone) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(389),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#A6A6A6",
      "margin-top": "10px"
    }
  }, [_vm._v("放心吧，有消息我们会马上通知您的~")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.readShow == 'ReadShow') ? _c('rankErrorRead', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readShow == 'TextShow') ? _c('rankErrorText', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readShow == 'OnlineShow') ? _c('rankErrorOnline', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer,
      "moduleId": _vm.moduleId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "homeWorkContent"
  }, [(_vm.resourceList != '') ? _c('h4', {
    attrs: {
      "title": _vm.moduleInfo.moduleName
    }
  }, [_vm._v(_vm._s(_vm.moduleInfo.moduleName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdlContent"
  }, _vm._l((_vm.selectedTextNumArr), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "main",
      on: {
        "click": function($event) {
          _vm.increment($event, item, item.resourceType)
        }
      }
    }, [_c('span', {
      staticClass: "noChoose",
      class: {
        'choose': item.isChecked
      }
    }), _vm._v(" "), (item.isPublished) ? _c('span', {
      staticClass: "publishedIcon"
    }, [_vm._v("布置过")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "stitle",
      attrs: {
        "title": item.resourceName
      }
    }, [_vm._v(_vm._s(item.resourceName))]), _vm._v(" "), (item.isChecked) ? _c('span', {
      staticClass: "write",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goDetail(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.chooseText))]) : _vm._e()]), _vm._v(" "), ((_vm.moduleInfo.moduleId == 10 || _vm.moduleInfo.moduleId == 15 || _vm.moduleInfo.moduleId == 30 || _vm.moduleInfo.moduleId == 124 || _vm.moduleInfo.moduleId == 127 || _vm.moduleInfo.moduleId == 66) && item.isChecked) ? _c('chooseText', {
      key: index,
      attrs: {
        "moduleId": _vm.moduleInfo.moduleId,
        "item": item,
        "readTime": item.refLong,
        "serviceId": _vm.serviceId,
        "packageId": _vm.packageId,
        "readtimes": item.readtimes,
        "speekingtype": item.speekingtype,
        "cId": _vm.cId,
        "index": index
      },
      on: {
        "changeParams": _vm.changeParams
      }
    }) : _vm._e()], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    ref: "notice",
    staticClass: "notices"
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "transition": "fade",
      "transition-mode": "out-in",
      "params": _vm.params
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeMask"
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectObject"
  }, [(_vm.noGrade) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "selectContent clearfix"
  }, [_c('div', {
    staticClass: "leftBox fl"
  }, _vm._l((_vm.grads), function(item, index) {
    return (item.count != 0) ? _c('div', {
      key: index,
      staticClass: "classbox",
      class: {
        active: index == _vm.isActive
      }
    }, [_c('em', {
      class: {
        '': item.selNum == 0, 'is-indeterminate': item.selNum < item.count && item.selNum > 0, 'allSelected': item.selNum == item.count && item.selNum != 0
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectedGradFun(index)
        }
      }
    }), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectedGradFun(index, true)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.className))]), _vm._v(" "), _c('span', {
      staticClass: "checkCount fr"
    }, [_vm._v(_vm._s(item.selNum) + " / " + _vm._s(item.count))])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "rightBox fr"
  }, [_vm._l((_vm.groups), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "checkBox clearfix"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "groups fl",
      on: {
        "click": function($event) {
          _vm.selectGroup(index)
        }
      }
    }, [_c('em', {
      class: {
        '': item.selNum == 0, 'is-indeterminate': item.selNum < item.count && item.selNum > 0, 'allSelected': item.selNum == item.count && item.selNum != 0
      }
    }), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "margin-right": "6px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.selNum) + " / " + _vm._s(item.count))])])]), _vm._v(" "), _c('span', {
      staticClass: "teamShow fr",
      class: {
        'arrow-up': item.teamShow, 'arrow-down': !item.teamShow
      },
      on: {
        "click": function($event) {
          _vm.showStu(index)
        }
      }
    }, [_vm._v(_vm._s(!item.teamShow ?
      '展开' : '收起'))])]), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.teamShow),
        expression: "item.teamShow"
      }],
      staticClass: "students clearfix"
    }, _vm._l((item.data), function(sItem, sIndex) {
      return _c('li', {
        key: sIndex
      }, [_c('span', {
        class: {
          'active': sItem.checked
        },
        on: {
          "click": function($event) {
            _vm.selectedStudentFun(index, sIndex)
          }
        }
      }, [_vm._v(_vm._s(sItem.userName))])])
    }))])
  }), _vm._v(" "), _c('div')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "nextOne"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'gray': _vm.selectNum == 0, 'green': _vm.selectNum > 0
    },
    on: {
      "click": _vm.nextOne
    }
  }, [_vm._v("下一步")])])]) : _c('div', {
    staticClass: "noData"
  }, [_c('img', {
    staticClass: "noGrade",
    attrs: {
      "src": __webpack_require__(27)
    }
  }), _vm._v(" "), _c('span', [_vm._v("没有可以布置作业的班级")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n      布置作业\n      "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1067),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', [_vm._v("选择内容")]), _vm._v(" "), _c('span', [_vm._v("作业留言")])])])])
}]}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scoreTable"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("作业详情")]), _vm._v(" "), _c('div', {
    staticClass: "referBox"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("timestampToTime")(_vm.timeData.startDate)) + " 至 " + _vm._s(_vm._f("timestampToTime")(_vm.timeData.endDate)) + "期间")]), _vm._v(" "), _c('div', {
    staticClass: "boxSubmit"
  }, [_c('span', [_vm._v("收到作业" + _vm._s(_vm.workReport.workCount) + "次")]), _vm._v(" "), _c('ul', {
    staticClass: "progressBar"
  }, [_c('li', [_c('span', [_vm._v("排名前五： " + _vm._s(_vm.workReport.topFifthCount) + "次")]), _vm._v(" "), _c('div', {
    staticClass: "barBox"
  }, [_c('span', {
    staticClass: "barLi bar1",
    style: ({
      width: (_vm.workReport.topFifthCount / _vm.workReport.workCount) * 100 + '%'
    })
  })])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("未提交：" + _vm._s(_vm.workReport.unSubmitCount) + "次")]), _vm._v(" "), _c('div', {
    staticClass: "barBox"
  }, [_c('span', {
    staticClass: "barLi bar2",
    style: ({
      width: (_vm.workReport.unSubmitCount / _vm.workReport.workCount) * 100 + '%'
    })
  })])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("低于平均分：" + _vm._s(_vm.workReport.underAvgScoreCount) + "次")]), _vm._v(" "), _c('div', {
    staticClass: "barBox"
  }, [_c('span', {
    staticClass: "barLi bar3",
    style: ({
      width: (_vm.workReport.underAvgScoreCount / _vm.workReport.workCount) * 100 + '%'
    })
  })])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("高于平均分：" + _vm._s(_vm.workReport.overAvgScoreCount) + "次")]), _vm._v(" "), _c('div', {
    staticClass: "barBox"
  }, [_c('span', {
    staticClass: "barLi bar4",
    style: ({
      width: (_vm.workReport.overAvgScoreCount / _vm.workReport.workCount) * 100 + '%'
    })
  })])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.reportDetail.pageList), function(item) {
    return _c('table', {
      staticClass: "chunkT",
      attrs: {
        "cellspacing": "0"
      }
    }, _vm._l((item.contentList), function(ritem, rindex) {
      return _c('tr', [(rindex == 0) ? _c('td', {
        staticClass: "dateT",
        attrs: {
          "rowspan": item.contentList.length
        }
      }, [_vm._v(_vm._s(item.sendDate))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "wName"
      }, [_vm._v("\n            " + _vm._s(ritem.resourceName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(ritem.ranking) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(ritem.actualScore) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(ritem.avgScore) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(ritem.workScore) + "\n          ")])])
    }))
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 5,
      "layout": "total, prev, pager, next",
      "total": _vm.reportDetail.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('th', [_vm._v("作业")]), _vm._v(" "), _c('th', [_vm._v("排名")]), _vm._v(" "), _c('th', [_vm._v("\n          得分\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          班级平均分\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          总分\n        ")])])])
}]}

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [(_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    staticClass: "correctHand",
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', [_c('theAudio', {
    attrs: {
      "src": _vm.question.userAnswer && _vm.question.userAnswer.answers[0].content,
      "id": _vm.id + 1111111,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setNewAns(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v("/" + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")]), _vm._v(" "), (_vm.handle) ? _c('div', {
    staticClass: "handleScore clearfix"
  }, [_c('span', {
    staticClass: "correcting",
    class: {
      half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleHr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_right: _vm.Cright, C_right_hover: !_vm.Cright
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_error: _vm.C_error, C_error_hover: !_vm.C_error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCe(_vm.question)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scoreVal),
      expression: "scoreVal"
    }],
    staticClass: "scoreNow",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.scoreVal)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        _vm.checkPrice(_vm.question, _vm.scoreVal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scoreVal = $event.target.value
      }
    }
  }), _vm._v("\n                        分\n                        "), _c('input', {
    staticClass: "scoreSure",
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sentNewSocre(_vm.question, _vm.question.question_ref_sorce / _vm.question.options.length, _vm.scoreVal)
      }
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers[0],
      "listenTextModule": false,
      "qtype": 7
    }
  }) : _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.options,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 3
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt"
  }, [_c('li', {
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.tabListen(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), (_vm.listenTextModule && _vm.listenTextModule.length > 0 && _vm.listenTextModule[0].questionStem) ? _c('li', {
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.tabListen(2)
      }
    }
  }, [_vm._v("听力原文")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Topic_bg"
  }, [(_vm.topicActive == 1) ? _c('div', [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.question.options, _vm.question.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer.solving_idea)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qtype == 7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer)
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2 && _vm.listenTextModule) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.listenTextModule[0].questionStem)
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paging"
  }, [_c('span', [_vm._v(_vm._s(_vm.PagenumId) + "/" + _vm._s(_vm.PageCount))]), _vm._v(" "), _c('div', {
    staticClass: "lastone",
    on: {
      "click": _vm.lastone
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1062),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nextone",
    on: {
      "click": _vm.nextone
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1063),
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Sec"
  }, [_c('div', {
    staticClass: "altSch"
  }, [_c('span', [_vm._v("所在学校 :")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.school
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))])])])])
},staticRenderFns: []}

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice messageNotice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "messagePadding",
    staticStyle: {
      "height": "350px",
      "overflow-y": "auto"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.params.noticeText))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.params.noticeSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footerNotice"
  }, [(_vm.params.sendType != 1) ? _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "60px",
      "vertical-align": "top"
    }
  }, [_vm._v("发送人:\n        ")]) : _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "80px",
      "vertical-align": "top"
    }
  }, [_vm._v("发送班级：\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.params.sender))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.params.time))])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeUl($event)
      }
    }
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "addClassStep1"
  }, [_c('div', {
    staticClass: "addClass"
  }, [_c('div', {
    staticClass: "schoolName"
  }, [_c('span', [_vm._v("所在学校:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolName),
      expression: "schoolName"
    }],
    staticClass: "checkSchool",
    attrs: {
      "type": "text",
      "placeholder": "选择学校"
    },
    domProps: {
      "value": (_vm.schoolName)
    },
    on: {
      "click": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.addClassList), function(item, index) {
    return _c('div', {
      staticClass: "grads"
    }, [(index == 0) ? _c('span', [_vm._v("创建班级:")]) : _vm._e(), (index != 0) ? _c('span', {
      staticClass: "zhanwei"
    }) : _vm._e(), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.currentText),
        expression: "item.currentText"
      }],
      class: {
        arrowDown: !item.isShowUl, arrowUp: item.isShowUl
      },
      attrs: {
        "type": "text",
        "placeholder": "选择年级"
      },
      domProps: {
        "value": (item.currentText)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showUl(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "currentText", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.className),
        expression: "item.className"
      }],
      staticClass: "className",
      attrs: {
        "type": "text",
        "placeholder": "输入班级名称",
        "maxlength": "10"
      },
      domProps: {
        "value": (item.className)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "className", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.addClassList.length > 1 && index != 0) ? _c('div', {
      staticClass: "deleteAdd",
      on: {
        "click": function($event) {
          _vm.deleteAdd(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.isShowUl) ? _c('ul', {
      staticClass: "gradsUl"
    }, _vm._l((_vm.gradsArr), function(item) {
      return _c('li', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.checkGrad(item, index)
          }
        }
      }, [_vm._v(_vm._s(item.text))])
    })) : _vm._e()])
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "oneMoreClass"
  }, [_c('button', {
    staticClass: "button green",
    on: {
      "click": _vm.oneMoreClass
    }
  }, [_vm._v("再建一个")])]) : _vm._e()], 2)]) : (_vm.step == 2) ? _c('div', {
    staticClass: "addClassStep2"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "selectArea"
  }, [_c('checkArea', {
    on: {
      "selectAreas": _vm.selectAreas
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWords),
      expression: "keyWords"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索学校名称"
    },
    domProps: {
      "value": (_vm.keyWords)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.search
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.schoolList.length != 0),
      expression: "schoolList.length != 0"
    }],
    staticClass: "prompt"
  }, [_c('p', [_vm._v("您可能想添加:")]), _vm._v(" "), _c('ul', {
    staticClass: "clear clearfix"
  }, _vm._l((_vm.schoolList), function(item) {
    return _c('li', {
      attrs: {
        "title": item.schoolName
      },
      on: {
        "click": function($event) {
          _vm.checkSchool(item)
        }
      }
    }, [_vm._v(_vm._s(item.schoolName))])
  }))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.schoolList.length == 0),
      expression: "schoolList.length == 0"
    }]
  }, [_vm._v("未找到相关学校，若需创建学校，请联系客服(400-800-5500)")])])]), _vm._v(" "), _c('paging', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.schoolList.length != 0),
      expression: "schoolList.length != 0"
    }],
    attrs: {
      "PagenumId": _vm.PageIndex,
      "PageCount": _vm.PageCount
    },
    on: {
      "mypagenum": _vm.pageNum
    }
  })], 1) : (_vm.step == 3) ? _c('div', {
    staticClass: "addFinish"
  }, [_c('div', {
    staticClass: "addFinishContent"
  }, [_c('div', {
    staticClass: "finishIcon"
  }), _vm._v(" "), _c('p', {
    staticClass: "finishTitle"
  }, [_vm._v("创建班级成功!")]), _vm._v(" "), _vm._l((_vm.addClassList), function(item) {
    return _c('p', {
      staticClass: "finishClassName"
    }, [_c('span', {
      staticClass: "class"
    }, [_vm._v("班级名称:")]), _vm._v(" "), _c('span', {
      staticClass: "classNmae"
    }, [_vm._v(_vm._s(item.className))])])
  }), _vm._v(" "), _c('p', {
    staticClass: "teacherPhone"
  }, [_vm._v("请告诉学生输入您的手机号 "), _c('span', [_vm._v(_vm._s(_vm.params.mobile))]), _vm._v(" 加入班级")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), (_vm.step != 2) ? _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.abolishText))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.ensureText))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-question"
  }, [(_vm.webloading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": __webpack_require__(388)
    }
  }) : _c('div', {
    staticClass: "exampaperInfo"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e6e6e6",
      "padding-bottom": "20px",
      "margin-bottom": "30px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.exampaper.title))]), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('span', {
    class: {
      paperBtn: _vm.paperBtnInfo, paperBtnActive: !_vm.paperBtnInfo
    },
    on: {
      "click": _vm.paperInfo
    }
  }, [_vm._v("试卷信息")]) : _vm._e(), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paperBtnInfo),
      expression: "!paperBtnInfo"
    }],
    staticClass: "examPaper"
  }, [_c('div', {
    staticClass: "exam_top"
  }, [(_vm.exampaper.ref_score) ? _c('span', [_c('b', [_vm._v("总分:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_score) + "分")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('b', [_vm._v("总难度:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.difficultyDegree))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v("总答题时间:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_answer_time) + "分")])])]), _vm._v(" "), _c('div', {
    staticClass: "exam_tag"
  }, [(_vm.exampaper.videoReview) ? _c('div', [(_vm.videoPlay && _vm.exampaper.videoReview.coverUrl != null) ? _c('div', {
    staticClass: "coverUrl",
    on: {
      "click": _vm.videoPlayer
    }
  }, [_c('img', {
    staticClass: "coverUrl",
    attrs: {
      "src": _vm.exampaper.videoReview.coverUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "coverUrlPlay",
    attrs: {
      "src": __webpack_require__(391)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.exampaper.videoReview.videoUnique != null && !_vm.videoPlay) ? _c('embed', {
    attrs: {
      "src": "http://yuntv.letv.com/bcloud.swf",
      "allowFullScreen": "true",
      "quality": "high",
      "width": "300",
      "height": "150",
      "align": "middle",
      "allowScriptAccess": "always",
      "flashvars": _vm.videoSrc(_vm.exampaper.videoReview.videoUnique),
      "type": "application/x-shockwave-flash"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exampaper.testItems.length > 0) ? _c('ul', {
    staticClass: "exam_testItems"
  }, [_c('b', [_vm._v("考点信息:")]), _vm._v(" "), _vm._l((_vm.exampaper.testItems), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      staticClass: "paperInfoT"
    }, [_vm._v("• " + _vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "paperInfoC"
    }, [_vm._v(_vm._s(item.content))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.exampaper.tags) ? _c('ul', {
    staticClass: "exam_tags"
  }, [_c('b', {
    staticClass: "paperInfoT"
  }, [_vm._v("来源")]), _vm._v(" "), _vm._l((_vm.exampaper.tags), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "paperInfoTag"
    }, [_vm._v("\n                                " + _vm._s(item) + "\n                            ")])
  })], 2) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.exampaper.parts), function(part, index) {
    return _c('div', {
      key: index,
      staticClass: "p-20 bg-fff border"
    }, [(_vm.page == 'selectListenSpeak' && _vm.selectFlag) ? _c('div', {
      staticClass: "fr"
    }, [_c('div', {
      staticClass: "button choice",
      class: {
        'checkedSel': part.isChecked, 'noCheck': !part.isChecked
      },
      on: {
        "click": function($event) {
          _vm.choiceBigQ(part, index)
        }
      }
    }, [_vm._v(_vm._s(part.buttonText))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "m-t10"
    }, [_c('p', [_vm._v("大题描述")]), _vm._v(" "), (_vm.moduleId != 15) ? _c('span', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(_vm.questionNum[index]) + "、(共" + _vm._s(part.question_ref_sorce) + "分, " + _vm._s(part.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding-left": "30px"
      }
    }, [_vm._v(_vm._s(part.module_type_name))])]), _vm._v(" "), _vm._l((part.children), function(question, index) {
      return _c('div', {
        key: index,
        staticClass: "m-t30"
      }, [(question.qtype == 1) ? _c('singleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "question": question,
          "moduleId": _vm.moduleId,
          "id": question.id + index,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 2) ? _c('multipleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 3) ? _c('filling', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 4 || question.qtype == 9 || question.qtype == 10) ? _c('allFilling', {
        attrs: {
          "qtype": 9,
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 5) ? _c('reading', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 6) ? _c('shortanswer', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer,
          "padShow": _vm.padShow
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 7) ? _c('imitation', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 8) ? _c('judge', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : _vm._e()], 1)
    })], 2)
  })], 2), _vm._v(" "), ((_vm.page == 'selectListenSpeak' || _vm.page == 'selectOnlinePaper') && this.thirdParty) ? _c('div', {
    staticClass: "m-select-question",
    class: {
      relativeBox: _vm.barHide
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.selectedExampaperArr.length) ? _c('div', {
    staticClass: "fl"
  }, [_vm._v("共选 " + _vm._s(_vm.selectedExampaperArr.length || 0) + " 条内容，预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0px 5px"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("formatDataToMinutes")(_vm.doworkTime)) + " ")]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button inline-block m-l20 surebtn",
    on: {
      "click": _vm.backQuestionArr
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('form', {
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [(_vm.step == 1) ? _c('div', {}, [_vm._m(0), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "tel"
    }
  }, [_vm._v("手机号码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regTel),
      expression: "regTel"
    }],
    class: {
      error_bor: !_vm.isRegTel
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.regTel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.regTel = $event.target.value
      }, function($event) {
        _vm.checkInput(1)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_num),
      expression: "flag_num"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持数字的输入")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "verify"
    }
  }, [_vm._v("手机验证码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyNum),
      expression: "verifyNum"
    }],
    class: {
      error_bor: !_vm.isVerify
    },
    attrs: {
      "type": "text",
      "id": "verify",
      "maxlength": "6",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button gray verify",
    class: {
      btn_resend: _vm.regTel.length == 11 && !_vm.waitCode, seconds: _vm.waitCode
    },
    attrs: {
      "type": "button"
    }
  }, [(_vm.check_tel && !_vm.waitCode) ? _c('span', {
    class: {
      col_fff: _vm.regTel.length == 11
    },
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    on: {
      "click": _vm.verifyTel
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.waitCode) ? _c('span', [_vm._v(_vm._s(_vm.wait) + "s后重试")]) : _vm._e(), _vm._v(" "), (!_vm.check_tel && !_vm.waitCode) ? _c('span', {
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "-40px"
    }
  }, [_c('button', {
    staticClass: "button gray btn_register",
    class: {
      btn_resend: _vm.verifyNum.length >= 6
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkNum
    }
  }, [_vm._v("下一步")])])]) : (_vm.step == 2) ? _c('div', {}, [_vm._m(1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("真实姓名 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: {
      error_bor: _vm.flag_name
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }, function($event) {
        _vm.checkInput(2)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_name),
      expression: "flag_name"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持2-10个汉字输入")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "passWord"
    }
  }, [_vm._v("密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "passWord",
      "placeholder": "请输入密码",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.checkInput(3)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_password),
      expression: "flag_password"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持字母和数字的组合")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "passWord"
    }
  }, [_vm._v("确认密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "-40px"
    }
  }, [_c('button', {
    staticClass: "button gray btn_register",
    class: {
      btn_resend: _vm.confirmPassword.length >= 6 && _vm.password.length >= 6
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headMsg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1050),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "vertical-align": "sub"
    }
  }, [_vm._v("验证手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headMsg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1066),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("完善资料")])])
}]}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginBox"
  }, [(_vm.browser) ? _c('div', {
    staticClass: "login",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "loginBG"
  }, [_c('div', {
    staticClass: "loginContent"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "loginBox"
  }, [_c('img', {
    staticClass: "icon-login",
    attrs: {
      "src": __webpack_require__(1057),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("习习教师")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.userName),
      expression: "userName",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "text",
      "placeholder": "您的账号或手机号"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paddWord),
      expression: "paddWord",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "pwdInput",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.paddWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paddWord = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginTools"
  }, [_c('div', {
    class: {
      checkbox: true, checked: _vm.isChecked
    },
    on: {
      "click": _vm.rememberPassword
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })]), _vm._v("\n              记住密码\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "button loginBtn",
    attrs: {
      "type": "button",
      "value": "登录"
    },
    on: {
      "click": _vm.login,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyLogin($event)
      }
    }
  })])])]), _vm._v(" "), (_vm.isDownload) ? _c('a', {
    staticClass: "download",
    attrs: {
      "href": _vm.loadUrl
    }
  }, [_vm._v("下载客户端")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scoreTable"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("成绩详情")]), _vm._v(" "), (!(_vm.scoreData.pageList && !_vm.scoreData.pageList.length)) ? _c('a', {
    staticClass: "btnExport",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("导出")]) : _vm._e(), _vm._v(" "), (_vm.scoreData.pageList && !_vm.scoreData.pageList.length) ? _c('noFound') : _c('div', [_c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('th', [_vm._v("作业")]), _vm._v(" "), _c('th', [_vm._v("布置对象")]), _vm._v(" "), _c('th', [_vm._v("\n            提交率"), _c('br')]), _vm._v(" "), _c('th', [_vm._v("\n            优秀率"), _c('br'), _vm._v("\n            （≥90）\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            及格率"), _c('br'), _vm._v("\n            （≥60）\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            不及格率"), _c('br'), _vm._v("\n            （＜60）\n          ")])])]), _vm._v(" "), _vm._l((_vm.scoreData.pageList), function(item) {
    return _c('table', {
      staticClass: "chunkT",
      attrs: {
        "cellspacing": "0"
      }
    }, _vm._l((item.contentList), function(ritem, rindex) {
      return _c('tr', [(rindex == 0) ? _c('td', {
        staticClass: "dateT",
        attrs: {
          "rowspan": item.contentList.length
        }
      }, [_vm._v(_vm._s(item.sendDate))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "wName"
      }, [_vm._v("\n              " + _vm._s(ritem.resourceName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(ritem.receiver) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(ritem.submitRate) + "%\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(ritem.excellentRate) + "%\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(ritem.passRate) + "%\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(ritem.failRate) + "%\n            ")])])
    }))
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 5,
      "layout": "total, prev, pager, next",
      "total": _vm.scoreData.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankError"
  }, _vm._l((_vm.paperData), function(items, indexs) {
    return _c('ul', {
      staticClass: "rankErrorBox"
    }, _vm._l((items.sentences), function(item, index) {
      return _c('li', {
        staticClass: "rankErrorTwo clearfix"
      }, [_c('p', {
        staticClass: "rankErrorTit fl",
        attrs: {
          "title": item.content
        }
      }, [_vm._v(_vm._s(_vm.matchCont(item.content)))]), _vm._v(" "), _c('div', {
        staticClass: "fr"
      }, [_c('div', {
        staticClass: "progress"
      }, [_c('span', {
        staticClass: "progressChild bgGreen",
        style: ({
          width: (item.avgScore / 100) * 100 + '%'
        })
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "errorNum"
      }, [_vm._v("平均分: "), _c('i', {
        class: {
          green: item.avgScore >= 0
        }
      }, [_vm._v(_vm._s(item.avgScore >= 0 ? _vm.toMathThree(item.avgScore) : "--"))]), _vm._v(" 分")])])])])
    }))
  }))
},staticRenderFns: []}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.params.noticeText))]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom notice1"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.params.button1 || "取消"))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.params.button2 || "确定"))]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        提示\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.params.noticeText))]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "ensure2 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setBooks_box"
  }, [_c('div', {
    staticClass: "setBooks",
    staticStyle: {
      "padding": "40px"
    }
  }, [_c('div', {
    staticClass: "header clear"
  }, [_c('form', {
    staticClass: "search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索试卷名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': _vm.keyword.trim().length > 0
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('article', {
    staticClass: "book_list clear"
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.papers), function(item) {
    return _c('li', [_c('book', {
      attrs: {
        "booksData": item,
        "type": 2
      }
    })], 1)
  }))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && !_vm.isSearch) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时还没有试卷哦")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && _vm.pageIndex == 1 && _vm.isSearch) ? _c('div', {
    staticClass: "noResult clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("搜索无结果")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eChart"
  }, [_c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "fl tip"
  }, [_vm._v("成绩曲线")]), _vm._v(" "), _c('div', {
    staticClass: "classSelect fr"
  }, [_c('span', {
    staticClass: "selectActive",
    on: {
      "click": _vm.selectShow
    }
  }, [_vm._v(_vm._s(_vm.subjectName))]), _vm._v(" "), (_vm.subjectF) ? _c('ul', {
    staticClass: "selectBox"
  }, _vm._l((_vm.subjectList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.changetype(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px",
      "height": "330px"
    },
    attrs: {
      "id": "myChart"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankError"
  }, _vm._l((_vm.paperData), function(items, index) {
    return _c('ul', {
      staticClass: "rankErrorBox"
    }, [_c('li', {
      staticClass: "rankErrorTwo clearfix"
    }, [_c('p', {
      staticClass: "rankErrorTit fl",
      attrs: {
        "title": items.content
      }
    }, [_vm._v(_vm._s(index + 1) + "." + _vm._s(items.content))]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_c('div', {
      staticClass: "progress"
    }, [_c('span', {
      staticClass: "progressChild bgGreen",
      style: ({
        width: (items.avgScore / 100) * 100 + '%'
      })
    })]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "errorNum"
    }, [_vm._v("平均分: "), _c('i', {
      class: {
        green: items.avgScore >= 0
      }
    }, [_vm._v(_vm._s(items.avgScore >= 0 ? _vm.toMathThree(items.avgScore) : "--"))]), _vm._v(" 分")])])])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [(_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    staticClass: "correctHand",
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124 && !_vm.underlineF) ? _c('div', [_c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999 inline-b"
  }, [_vm._v("学生答案：")]), _vm._v(" "), (_vm.moduleId == 15 && _vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content) ? _c('span', [_c('theAudio', {
    attrs: {
      "src": _vm.question.userAnswer.answers[0].content,
      "id": _vm.id + 10001,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1) : (_vm.moduleId == 124) ? _c('div', {
    staticClass: "inline-b"
  }, [(_vm.padShow) ? _c('span', {
    staticClass: "editImg",
    attrs: {
      "onClick": "brigeCanvas(this)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.matchUrl(_vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content))
    }
  }) : _c('div', {
    staticClass: "fl",
    domProps: {
      "innerHTML": _vm._s(_vm.matchUrl(_vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content))
    },
    on: {
      "click": function($event) {
        _vm.imgFun(_vm.question)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bigImgShow && _vm.imgFlag) ? _c('bigImgShow', {
    attrs: {
      "imgSrc": _vm.imgUrl
    },
    on: {
      "imgBigShow": _vm.imgBigShow
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox f-error_txt",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setNewAns(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")]), _vm._v(" "), (_vm.handle) ? _c('div', {
    staticClass: "handleScore clearfix"
  }, [_c('span', {
    staticClass: "correcting",
    class: {
      half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleHr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_right: _vm.Cright, C_right_hover: !_vm.Cright
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_error: _vm.C_error, C_error_hover: !_vm.C_error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCe(_vm.question)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scoreVal),
      expression: "scoreVal"
    }],
    staticClass: "scoreNow",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.scoreVal)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        _vm.checkPrice(_vm.question, _vm.scoreVal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scoreVal = $event.target.value
      }
    }
  }), _vm._v("\n                        分\n                        "), _c('input', {
    staticClass: "scoreSure",
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sentNewSocre(_vm.question, _vm.question.question_ref_sorce / _vm.question.options.length, _vm.scoreVal)
      }
    }
  })]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info,
      "listenTextModule": _vm.question.textModule,
      "qtype": 6
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 6
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigBox2"
  }, [_c('section', {
    ref: "allHeight",
    staticClass: "publishHomeWork clear"
  }, [_vm._m(0), _vm._v(" "), (_vm.catalog.length) ? _c('article', {
    ref: "leftHeight",
    staticClass: "box menu"
  }, [_c('h4', {
    staticClass: "tip"
  }, [_vm._v("单元目录")]), _vm._v(" "), _c('ul', {
    staticClass: "first"
  }, _vm._l((_vm.catalog), function(unit, index) {
    return _c('li', {
      key: index,
      staticClass: "first_li",
      class: {
        'selectedUnit': unit.id == _vm.unitId && unit.children.length != 0, 'onlyUnit': unit.id == _vm.unitId && unit.children.length == 0
      }
    }, [_c('div', {
      staticClass: "gridUnit",
      on: {
        "click": function($event) {
          _vm.toggle(0, unit, [unit.id])
        }
      }
    }, [_c('p', {
      class: {
        'chooseUnit': unit.id == _vm.unitId, 'noChooseUnit': unit.id != _vm.unitId
      },
      attrs: {
        "title": unit.name
      }
    }, [_vm._v(_vm._s(unit.name))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.children.length != 0),
        expression: "unit.children.length!=0"
      }],
      staticClass: "icon arrow-icon",
      class: {
        'arrow-up': unit.id == _vm.unitId
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.count > 0 && (!unit.checked || unit.children.length == 0)),
        expression: "unit.count>0 && (!unit.checked || unit.children.length == 0)"
      }],
      staticClass: "count_style"
    }, [_vm._v(_vm._s(unit.count))])]), _vm._v(" "), (unit.children.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.checked),
        expression: "unit.checked"
      }],
      staticClass: "second"
    }, _vm._l((unit.children), function(page, cIndex) {
      return _c('li', {
        key: cIndex
      }, [_c('div', {
        staticClass: "gridPage",
        on: {
          "click": function($event) {
            _vm.toggle(1, page, [unit.id, page.id])
          }
        }
      }, [_c('p', {
        class: {
          'choosePage': page.id == _vm.pageId && page.children.length == 0, 'noChoosePage': page.id != _vm.pageId
        },
        attrs: {
          "title": page.name
        }
      }, [_vm._v(_vm._s(page.name))]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.children != 0),
          expression: "page.children!=0"
        }],
        staticClass: "icon arrow-icon",
        class: {
          'arrow-down': page.id == _vm.pageId
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.count > 0 && (!page.checked || page.children.length == 0)),
          expression: "page.count>0 && (!page.checked || page.children.length == 0)"
        }],
        staticClass: "count_style"
      }, [_vm._v(_vm._s(page.count))])]), _vm._v(" "), (page.children.length) ? _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.checked),
          expression: "page.checked"
        }],
        staticClass: "third"
      }, _vm._l((page.children), function(item, ccIndex) {
        return _c('li', {
          key: ccIndex
        }, [_c('div', {
          staticClass: "gridItem",
          class: {
            'chooseItem': item.id == _vm.itemId, 'noChooseItem': item.id != _vm.itemId
          },
          attrs: {
            "title": item.name
          },
          on: {
            "click": function($event) {
              _vm.toggle(2, item, [unit.id, page.id, item.id])
            }
          }
        }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.count > 0),
            expression: "item.count > 0"
          }],
          staticClass: "count_style",
          staticStyle: {
            "right": "17px"
          }
        }, [_vm._v(_vm._s(item.count))])])])
      })) : _vm._e()])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "boxContent",
    staticClass: "box content"
  }, [_c('ul', _vm._l((_vm.module), function(item, sIndex) {
    return _c('li', {
      key: sIndex
    }, [_c('homeworkcontent', {
      attrs: {
        "moduleInfo": item.moduleInfo,
        "resourceList": item.resourceList,
        "checkedResource": item.checkedResource,
        "serviceId": _vm.serviceId,
        "packageId": _vm.packageId,
        "sIndex": sIndex,
        "cId": _vm.cId,
        "publishedBooks": _vm.publishedBooks
      },
      on: {
        "increment": _vm.increment
      }
    })], 1)
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module.length == 0),
      expression: "module.length == 0"
    }],
    staticClass: "noModule"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有可以布置的内容！")])])]), _vm._v(" "), _c('div', {
    staticClass: "box footers"
  }, [_c('span', [_c('span', {
    staticClass: "prev",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('span', {
    staticClass: "button",
    class: {
      'green': _vm.contents.length != 0, 'gray': _vm.contents.length == 0
    },
    on: {
      "click": _vm.subQuestion
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("布置作业")]), _vm._v(" "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(392),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', [_vm._v("作业留言")])])])])
}]}

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkAll"
  }, [_c('el-submenu', {
    attrs: {
      "index": _vm.index + ''
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "className"
  }, [_vm._v(_vm._s(_vm.className))]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.checkedStudents.length) + "/" + _vm._s(_vm.students.length))])], 1), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "box",
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.checkedStudents),
      callback: function($$v) {
        _vm.checkedStudents = $$v
      },
      expression: "checkedStudents"
    }
  }, _vm._l((_vm.students), function(student, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": student.userId,
        "title": student.userName
      }
    }, [_vm._v(_vm._s(student.userName))])
  }))], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "historyWork clear"
  }, [_c('div', {
    staticClass: "historyHead"
  }, [_c('div', {
    staticClass: "headContent clear"
  }, [_c('span', [_vm._v(_vm._s(_vm.content.workName))])]), _vm._v(" "), _c('div', {
    staticClass: "workName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1072),
      "alt": ""
    },
    on: {
      "mouseenter": _vm.enter,
      "mouseleave": _vm.leave
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showName),
      expression: "showName"
    }],
    staticClass: "down"
  }, [_vm._v(_vm._s(_vm.content.bookName))])]), _vm._v(" "), _c('div', {
    staticClass: "titleAndState"
  }, [_c('div', {
    staticClass: "state",
    class: {
      underway: _vm.content.state == 0, unpublished: _vm.content.state == 1, end: _vm.content.state == -1
    }
  }, [_c('i', {
    staticClass: "point",
    class: {
      underway: _vm.content.state == 0, unpublished: _vm.content.state == 1, end: _vm.content.state == -1
    }
  }), _vm._v("\n        " + _vm._s(_vm.Timetext[_vm.content.state + 1]) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "publishTime"
  }, [(_vm.content.state == 0) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.content.publishDate, 'yyyy-MM-dd W hh:mm')) + " 发布")]) : _vm._e(), _vm._v(" "), (_vm.content.state == -1) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.content.effectiveDate, 'yyyy-MM-dd W hh:mm')) + " 截止")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.content.stateText) + "\n      ")])])]), _vm._v(" "), _c('div', _vm._l((_vm.content.workList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "historyContent"
    }, [_c('div', {
      staticClass: "receiveObj"
    }, [_c('div', [_c('p', {
      attrs: {
        "title": item.reviceObject
      }
    }, [_vm._v(_vm._s(item.reviceObject))])]), _vm._v(" "), (_vm.content.state == 0 || _vm.content.state == -1) ? _c('div', {
      staticClass: "summary",
      on: {
        "click": function($event) {
          _vm.toRank(item, -1, index)
        }
      }
    }, [_vm._v("\n          成绩汇总\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "recall_btn",
      on: {
        "click": function($event) {
          _vm.recall(item, index)
        }
      }
    }, [_c('span', [_vm._v("撤回")])]), _vm._v(" "), (_vm.content.state == 0 || _vm.content.state == -1) ? _c('div', {
      staticClass: "rush_btn",
      on: {
        "click": function($event) {
          _vm.rush(item, index)
        }
      }
    }, [_c('span', [_vm._v("催交")])]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((item.workContents), function(item2, index2) {
      return _c('div', {
        key: index2,
        staticClass: "workContent clear",
        on: {
          "click": function($event) {
            _vm.toRank(item, index2, index)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(item2.resourceName))]), _vm._v(" "), _c('span', [_c('i', {
        staticStyle: {
          "color": "#FF5400"
        }
      }, [_vm._v(_vm._s(item2.submitCount))]), _vm._v("/  " + _vm._s(item.totalNum) + "人 \n            "), _c('i', [_vm._v("完成")])])])
    }))])
  })), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params1,
      "isNotice": _vm.isNotice1
    },
    on: {
      "isConfirm": _vm.isConfirm1
    }
  }), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params2,
      "isNotice": _vm.isNotice2
    },
    on: {
      "isConfirm": _vm.isConfirm2
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('readWords', {
    attrs: {
      "checked": _vm.selecteSentencedArr
    },
    on: {
      "submitSentence": _vm.submitSentence
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  }), _vm._v(" "), _c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "userAnswers": _vm.userAnswers,
      "moduleId": _vm.moduleId,
      "isShowAnswer": _vm.isShowAnswer,
      "padShow": _vm.app_interaction
    },
    on: {
      "correctScore": _vm.correctScore
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "studentStatistics"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("作业报告")]), _vm._v(" "), _c('div', {
    staticClass: "contentReport"
  }, [_c('rankHeader', {
    attrs: {
      "classList": _vm.classList,
      "className": _vm.className,
      "wechatUrl": _vm.wechatUrl,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "shareFlag": true
    },
    on: {
      "changClassId": _vm.changClassId,
      "changedPicker": _vm.changedPicker,
      "getWorkStatistics": _vm.getWorkStatistics
    }
  }), _vm._v(" "), (!_vm.studentScore.length) ? _c('div', {
    staticClass: "scoreTable"
  }, [_c('noFound')], 1) : _c('div', {
    staticClass: "scoreTable"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("成绩排名")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("提交率")]), _vm._v(" "), _c('th', [_vm._v("\n            得分\n            "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "时间段内，学生作业得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("作业时长")]), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.studentScore), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ranking))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.submitRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.avgScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("secTotime1")(item.totalTime)))]), _vm._v(" "), _c('td', {
      staticClass: "watchInfo",
      on: {
        "click": function($event) {
          _vm.lookOneStudent(item)
        }
      }
    }, [_vm._v("\n            查看详情\n          ")])])
  }))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editInput"
  }, [_c('div', {
    staticClass: "_input"
  }, [_c('div', {
    staticClass: "default_title",
    class: {
      'hidden': _vm.change
    }
  }, [_vm._v(_vm._s(_vm.defalutTitle))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    class: {
      'hidden': !_vm.change
    },
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "blur": _vm.handler,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "edit_btn",
    on: {
      "click": _vm.modify
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1055),
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eChart"
  }, [_c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "fl tip"
  }, [_vm._v("成绩分档统计")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px",
      "height": "330px"
    },
    attrs: {
      "id": "myChartpie"
    }
  })])
}]}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankWorkTable"
  }, [_c('div', {
    staticClass: "export fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(387),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": _vm.exportUrl
    }
  }, [_vm._v("导出成绩")])])]), _vm._v(" "), _c('div', {
    staticClass: "workTable"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("排名")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _vm._l((_vm.collectHeader), function(item, index) {
    return _c('th', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s(item.score) + "分")])])
  }), _vm._v(" "), _c('th', [_c('p', [_vm._v("总分")]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.workScore.score) + "分")])])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.collectData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _vm._l((item.tabDatas), function(items, index) {
      return _c('td', {
        key: index
      }, [(items.moduleId != 66) ? _c('span', [_vm._v(_vm._s(items.score))]) : _vm._e(), _vm._v(" "), (items.moduleId == 66 && items.submitStatus.hasQuestion && items.submitStatus.isSubmit) ? _c('span', [_vm._v(_vm._s(items.score))]) : (items.moduleId == 66 && !items.submitStatus.hasQuestion && items.submitStatus.isSubmit) ? _c('span', [_vm._v(_vm._s('已提交' || '未提交'))]) : _vm._e()])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalScore || 0))])], 2)
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank mt120",
    style: ({
      minWidth: _vm.minWidth + 'px'
    }),
    on: {
      "click": _vm.moreInfoHide
    }
  }, [(_vm.pcLoading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": __webpack_require__(388)
    }
  }) : _c('div', [_c('div', {
    staticClass: "tabContent viewport"
  }, [_c('div', {
    staticClass: "tabtitleBox"
  }, [_c('img', {
    staticClass: "morePc",
    attrs: {
      "src": __webpack_require__(1059)
    },
    on: {
      "click": _vm.moreToggleInfoShow
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "tabConTitle",
    attrs: {
      "title": _vm.currentTitle
    }
  }, [_vm._v(_vm._s(_vm.currentTitle))]), _vm._v(" "), (_vm.pcmoreInfo) ? _c('div', {
    staticClass: "moreInfo",
    on: {
      "click": _vm.moreInfoShow
    }
  }, [_c('div', {
    staticClass: "pcWorkName"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("作业名称:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.currentTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "pcSendDate"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("布置时间:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.sendDate))])]), _vm._v(" "), _c('div', {
    staticClass: "pcEffectiveDate"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("截止时间:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.effectiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "pcLeaveMessge"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("作业留言:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.WorkMessage))])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v(_vm._s(_vm.ReviceObject))]), _vm._v(" "), _c('button', {
    staticClass: "button btn-size",
    class: {
      green: _vm.stateTime == "stateGreen", gray: _vm.stateTime == "stateGray", orange: _vm.stateTime == "stateOrange"
    }
  }, [_vm._v(_vm._s(_vm.stateText))]), _vm._v(" "), (_vm.stateTime == "stateOrange") ? _c('div', {
    staticClass: "unPublish"
  }, [_c('p', {
    staticClass: "unPublishTime"
  }), _vm._v(" "), _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v("距离发布时间还有：" + _vm._s(_vm.endTime))])]) : _c('div', [(_vm.stateBtn) ? _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v("距离截止时间还剩：" + _vm._s(_vm.endTime))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tabConCount clearfix"
  }, [_c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.max, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("最高分")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.min, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("最低分")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.average, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("平均分")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "socreRank viewport"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rankWorkTable"
  }, [_c('rankPCWorkTable', {
    attrs: {
      "list": _vm.rankRecords,
      "unlist": _vm.unRecords,
      "hList": _vm.rankcontentList
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "socreRankTitle"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n                  成绩排名\n              ")])])
}]}

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "area clear"
  }, [_c('div', {
    attrs: {
      "id": "province"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.provinces,
      "autoIsShow": false,
      "selectObj": "province",
      "selecterText": _vm.province_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "city"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.cities,
      "autoIsShow": false,
      "selectObj": "city",
      "selecterText": _vm.city_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "district"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.districts,
      "autoIsShow": false,
      "selectObj": "district",
      "selecterText": _vm.district_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-question"
  }, [_c('div', {
    staticClass: "p-30 bg-fff m-t30"
  }, [(_vm.question.qtype == 1) ? _c('singleChoice', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 2) ? _c('multipleChoice', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 3) ? _c('filling', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 4) ? _c('allFilling', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 5) ? _c('reading', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 6) ? _c('shortanswer', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 7) ? _c('imitation', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 8) ? _c('judge', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "managePaper"
  }, [_c('div', {
    staticClass: "header clear"
  }, [_c('form', {
    staticClass: "search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索试卷名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': _vm.keyword.trim().length > 0
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('button', {
    staticClass: "create",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.link(0)
      }
    }
  }, [_vm._v("创建试卷")])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.papers), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.examinationTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(item.createDate, 'y年M月dd日')))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "handle",
      on: {
        "click": function($event) {
          _vm.link(1, item)
        }
      }
    }, [_vm._v("预览")]), _vm._v(" "), _c('span', {
      staticClass: "handle",
      on: {
        "click": function($event) {
          _vm.link(2, item)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), _c('span', {
      staticClass: "handle",
      on: {
        "click": function($event) {
          _vm.deletePaper(item, index)
        }
      }
    }, [_vm._v("删除")])])])
  }))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && !_vm.isSearch) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时还没有试卷哦")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && _vm.pageIndex == 1 && _vm.isSearch) ? _c('div', {
    staticClass: "noResult clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("搜索无结果")])]) : _vm._e(), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.noticParams,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("试卷名称")]), _vm._v(" "), _c('th', [_vm._v("创建时间")]), _vm._v(" "), _c('th', [_vm._v("常用操作")])])])
}]}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankTable fl"
  }, [_c('div', {
    staticClass: "details clearfix"
  }, [_c('h2', [_vm._v(_vm._s(_vm.singleData.resourceName))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.singleData.moduleId == 10) ? _c('span', [_vm._v("模式：" + _vm._s(_vm._f("speekingType")(_vm.singleData.speekingtype, _vm.singleData.resourceType)))]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 10) ? _c('span', [_vm._v("次数：" + _vm._s(_vm.singleData.readtimes) + "次")]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId != 66) ? _c('span', [_vm._v("总分：\n        "), _c('em', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.singleData.workScore) + "分")])]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66 && _vm.hasQuestion) ? _c('span', [_vm._v("总分：\n        "), _c('em', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.singleData.workScore) + "分")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "finish fl"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.singleData.count) + "/" + _vm._s(_vm.rankTableData.length))]), _vm._v(" "), _c('span', [_vm._v("完成情况")])]), _vm._v(" "), (_vm.singleData.moduleId != 66) ? _c('div', {
    staticClass: "average finish fl"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm._f("numFilter")(_vm.singleData.averageGrad)))]), _vm._v(" "), _c('span', [_vm._v("平均分")])]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66 && _vm.hasQuestion) ? _c('div', {
    staticClass: "average finish fl"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm._f("numFilter")(_vm.singleData.averageGrad)))]), _vm._v(" "), _c('span', [_vm._v("平均分")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(387),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("导出成绩")])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("排名")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), (_vm.singleData.moduleId != 66) ? _c('th', [_vm._v("得分\n          ")]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66 && _vm.hasQuestion) ? _c('th', [_vm._v("得分\n          ")]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66) ? _c('th', [_vm._v("用时")]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 10 || _vm.singleData.moduleId == 127) ? _c('th', [_vm._v("完成次数")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "submitTime"
  }, [_vm._v("提交时间\n          ")]), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rankTableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), (_vm.singleData.moduleId != 66) ? _c('td', [(item.submitCount == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.actualScore)), (item.workStatus == 17 || item.workStatus == 15) ? _c('i', {
      staticClass: "icon-correct"
    }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66 && _vm.hasQuestion) ? _c('td', [(item.submitCount == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.actualScore) + " "), (item.workStatus == 17 || item.workStatus == 15) ? _c('i', {
      staticClass: "icon-correct"
    }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 66) ? _c('td', [_vm._v(_vm._s(_vm._f("secTotime")(item.workLong)))]) : _vm._e(), _vm._v(" "), (_vm.singleData.moduleId == 10 || _vm.singleData.moduleId == 127) ? _c('td', [_vm._v(_vm._s(item.submitCount || '-'))]) : _vm._e(), _vm._v(" "), (item.submitDate == 0) ? _c('td', [_vm._v("-")]) : _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(item.submitDate, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#01BA90",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.checkMore(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.submitCount ? '查看' : '-'))])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "unfold",
    staticClass: "layerMB"
  }, [_c('div', [_c('header', {
    staticClass: "top"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoShow),
      expression: "infoShow"
    }]
  }, [_vm._v("更换新手机号后,原手机号" + _vm._s(_vm.oldMobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')) + "将不能再作为登录使用！")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("新手机号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNum),
      expression: "newNum"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.newNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("短信验证码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.securityNum),
      expression: "securityNum"
    }],
    staticClass: "field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.securityNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.securityNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button green",
    on: {
      "click": _vm.send
    }
  }, [(!_vm.waitCode) ? _c('span', [_vm._v("获取短信验证码")]) : _c('span', [_vm._v(_vm._s(_vm.wait) + "s")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fail),
      expression: "fail"
    }]
  }, [_vm._v("验证码输入不正确，绑定号码失败！")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button",
    class: {
      'green': (_vm.newNum && _vm.securityNum), 'gray': (!_vm.newNum || !_vm.securityNum)
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "button write",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeMask"
  })])
},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": _vm.videoId
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('p', [_vm._v("填空题小题说明")]), _vm._v(" "), (_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    staticClass: "correctHand",
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "inline-block"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('b', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline-b m-l10",
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.question.options), function(option, $index) {
    return (_vm.isShowAnswer) ? _c('div', [_c('div', {
      staticClass: "u-question-item"
    }, [_c('span', {
      staticClass: "color-999999"
    }, [_vm._v("学生答案：")]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setFillingAnswer(_vm.question.userAnswer, $index))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fr u-question-r"
    }, [_c('div', {
      staticClass: "assessIconBox f-error_txt",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question, $index))
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setNewAns(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
      staticClass: "col-red",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessFilling(_vm.question, $index))
      }
    }), _vm._v(" / " + _vm._s(parseFloat((_vm.question.question_ref_sorce / _vm.question.options.length).toFixed(1)) || 0) + "分）")]), _vm._v(" "), (_vm.handle == $index) ? _c('div', {
      staticClass: "handleScore clearfix"
    }, [_c('span', {
      staticClass: "correcting",
      class: {
        half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleHr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_right: _vm.Cright, C_right_hover: !_vm.Cright
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_error: _vm.C_error, C_error_hover: !_vm.C_error
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCe(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scoreVal),
        expression: "scoreVal"
      }],
      staticClass: "scoreNow",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.scoreVal)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          _vm.checkPrice(_vm.question, $index, _vm.scoreVal)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.scoreVal = $event.target.value
        }
      }
    }), _vm._v("\n                            分\n                            "), _c('input', {
      staticClass: "scoreSure",
      attrs: {
        "type": "button",
        "value": "确定"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sentNewSocre(_vm.question, $index, _vm.scoreVal)
        }
      }
    })]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.options,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 3
    }
  }) : _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.options,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 3
    }
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fotgotPwd"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lines avlines"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "sort",
    class: {
      avbg: _vm.step == 2 || _vm.step == 3
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {}, [_vm._v("安全验证")])]), _vm._v(" "), _c('div', {
    staticClass: "lines",
    class: {
      avlines: _vm.step == 3
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "sort",
    class: {
      avbg: _vm.step == 3
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {}, [_vm._v("重置密码")])])]), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "step"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }, function($event) {
        _vm.avbtn(1)
      }]
    }
  }), _vm._v(" "), (_vm.mobile.length > 0) ? _c('span', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    class: {
      avbg: _vm.av_step == 1
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])]) : (_vm.step == 2) ? _c('div', {
    staticClass: "step"
  }, [_c('p', [_vm._v("我们已向您的手机" + _vm._s(_vm.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')) + "发送了一条6位数的验证码，请打开手机查收")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("验证 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "verify",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, function($event) {
        _vm.avbtn(2)
      }]
    }
  }), _vm._v(" "), (_vm.code.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "430px"
    },
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button submit",
    class: {
      avbg: _vm.wait == 0
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送"), (_vm.wait != 0) ? _c('span', [_vm._v(_vm._s(_vm.wait) + "s")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    class: {
      avbg: _vm.av_step == 2
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])]) : (_vm.step == 3) ? _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "password",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.confirm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.password.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "100px"
    },
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("确认密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "input_filed",
    attrs: {
      "type": "password",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "blur": _vm.confirmPwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.confirmPassword.length > 0) ? _c('span', {
    staticClass: "delete",
    staticStyle: {
      "right": "100px"
    },
    on: {
      "click": function($event) {
        _vm.del(2)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "button next",
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendPwd
    }
  }, [_vm._v("完成")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sort avbg"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "active"
  }, [_vm._v("确认账号")])])
}]}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankWorkP"
  }, [_c('rankWorkWeb')], 1)
},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "moduleId": _vm.moduleId,
      "thirdParty": _vm.thirdParty,
      "doworkTimes": _vm.doworkTime
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notices"
  }, [_c('div', {
    staticClass: "notice addGroups"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "addBox"
  }, [_c('p', [_c('span', [_vm._v("小组名称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamName),
      expression: "teamName"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请输入小组名称"
    },
    domProps: {
      "value": (_vm.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teamName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stuContent"
  }, [_c('div', {
    staticClass: "leftContent"
  }, [_c('form', {
    staticClass: "searchStudents",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keywords),
      expression: "keywords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "请输入学生名字"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': !_vm.btnShow
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'searchBtn': _vm.btnShow
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "groups"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noStudent),
      expression: "noStudent"
    }],
    staticClass: "noStu"
  }, [_vm._v("您搜索的学生不存在~")]), _vm._v(" "), _vm._l((_vm.selectStudents), function(item, index) {
    return _c('ul', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.title) + "\n                "), _c('em', [_vm._v("(" + _vm._s(item.data.length) + ")")])]), _vm._v(" "), _vm._l((item.data), function(sitem, sIndex) {
      return _c('li', {
        key: sIndex
      }, [_c('span', {
        class: {
          'active': sitem.checked
        },
        on: {
          "click": function($event) {
            _vm.stuToggle(sitem)
          }
        }
      }, [_vm._v(_vm._s(sitem.userName))])])
    })], 2)
  })], 2)]), _vm._v(" "), (_vm.identify == 'addGroup') ? _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "groups"
  }, [_c('ul', [_c('span', [_vm._v("已选学生\n                "), _c('em', [_vm._v("(" + _vm._s(_vm.selCount) + ")")])]), _vm._v(" "), _c('ul', _vm._l((_vm.selectStu), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('em', {
      on: {
        "click": function($event) {
          _vm.deleteAddStu(item, index)
        }
      }
    })])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.identify == 'edit') ? _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "groups"
  }, [_c('ul', [_c('span', [_vm._v("已选学生\n                "), _c('em', [_vm._v("(" + _vm._s(_vm.editStu.length) + ")")])]), _vm._v(" "), _c('ul', _vm._l((_vm.editStu), function(sitem, sIndex) {
    return _c('li', {
      key: sIndex
    }, [_c('span', [_vm._v(_vm._s(sitem.userName))]), _vm._v(" "), _c('em', {
      on: {
        "click": function($event) {
          _vm.deleteStu(sitem, sIndex)
        }
      }
    })])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "sure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v("取消")])])])])
},staticRenderFns: []}

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sendMsg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.greenBtn),
      expression: "greenBtn"
    }]
  }, [_c('button', {
    staticClass: "button green sendBtn",
    on: {
      "click": _vm.sendBtn
    }
  }, [_vm._v("发送通知")]), _vm._v(" "), _c('div', {
    staticClass: "MsgContent"
  }, [_vm._l((_vm.pageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "msg"
    }, [_c('div', {
      staticClass: "message"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(1060),
        "alt": "消息"
      }
    }), _vm._v(" "), _c('pre', {
      ref: "msgshow",
      refInFor: true,
      staticClass: "main_contents"
    }, [_vm._v(_vm._s(item.content.content))]), _vm._v(" "), (item.show_details == 'false') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(item, index)
        }
      }
    }, [_vm._v("展开")]) : _vm._e(), _vm._v(" "), (item.show_details == 'true') ? _c('i', {
      on: {
        "click": function($event) {
          _vm.showMsg(item, index)
        }
      }
    }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "receiveMsg clearfix"
    }, [_c('span', {
      staticClass: "receiveClass fl",
      attrs: {
        "title": item.classNames
      }
    }, [_vm._v("发送班级 : " + _vm._s(item.classNames))]), _vm._v(" "), _c('span', {
      staticClass: "receiveTime fr"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.publishDate, 'yyyy-MM-dd hh:mm')))])])])
  }), _vm._v(" "), (_vm.loading && _vm.pageIndex !== _vm.pageCount) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()], 2), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.noticParams,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1), _vm._v(" "), _c('send', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.greenBtn),
      expression: "!greenBtn"
    }],
    on: {
      "backMsg": _vm.backMsg
    }
  }), _vm._v(" "), (_vm.pageList.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(389),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#A6A6A6",
      "margin-top": "10px"
    }
  }, [_vm._v("您暂时还没发送校讯通知哦~")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "send"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('span', {
    staticClass: "step"
  }, [_vm._v("发送对象:")]), _vm._v(" "), _c('div', {
    staticClass: "sel_class"
  }, _vm._l((_vm.checkedClass), function(item, index) {
    return _c('span', [_vm._v(" " + _vm._s(item.className) + "; ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "origin_select",
    class: {
      arrowUp: _vm.showSelect
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectClass($event)
      }
    }
  }, [_vm._v("\n      班级\n        "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }],
    staticClass: "selectBox"
  }, _vm._l((_vm.grads), function(item, index) {
    return _c('li', {
      staticClass: "input"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": index
      }
    }, [_c('span', {
      staticClass: "inputBox fl",
      class: {
        isChecked: item.isChecked
      }
    }, [_c('span', {
      staticClass: "checkBox"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedClass),
        expression: "checkedClass"
      }],
      attrs: {
        "type": "checkbox",
        "id": index
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.checkedClass) ? _vm._i(_vm.checkedClass, item) > -1 : (_vm.checkedClass)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedClass,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedClass = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedClass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedClass = $$c
          }
        }, function($event) {
          _vm.checkedClassFun(index)
        }]
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "studentName fl"
    }, [_vm._v("\n                " + _vm._s(item.className) + "\n              ")])])])
  }))])]), _vm._v(" "), _c('div', {}, [_c('span', {
    staticClass: "step"
  }, [_vm._v("通知内容：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticStyle: {
      "border": "1px solid #dadada",
      "padding": "10px"
    },
    attrs: {
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "30px 0 20px"
    }
  }, [_c('button', {
    staticClass: "button write btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "button green btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textNum)
    }
  }), _vm._v(" "), (_vm.item.resourceType === _vm.ResType_Zaixianzuoda) ? _c('span', {
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_vm._v("\n      已选  \n      "), _c('i', {
    staticStyle: {
      "color": "#01B98F",
      "padding-right": "3px"
    }
  }, [_vm._v(_vm._s(_vm.item.bigItemCount))]), _vm._v("个大题\n    ")]) : _vm._e(), _vm._v(" "), (_vm.item.resourceType === _vm.ResType_DanCiGenDu || _vm.item.resourceType === _vm.ResType_Xuanzeduanluo || _vm.moduleId == 15 || _vm.moduleId == 30 || _vm.moduleId == 66 || _vm.item.resourceType === _vm.ResType_Zaixianzuoda) ? _c('span', [_vm._v("\n         预计\n      "), _c('i', {
    staticStyle: {
      "color": "#00ba8f",
      "padding": "0px 3px"
    }
  }, [_vm._v(_vm._s(_vm.readTime))]), _vm._v("分钟\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "choice clear"
  }, [(_vm.moduleId == 10 || _vm.moduleId == 127) ? _c('div', {
    staticClass: "selectSpeek"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.speektypes,
      "selectObj": "types",
      "defValue": _vm.typesId
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleId == 10 || _vm.moduleId == 127) ? _c('div', {
    staticClass: "selectRead"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.readTimes,
      "selectObj": "times",
      "defValue": _vm.timesId
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftNav"
  }, _vm._l((_vm.navData), function(sitem, sindex) {
    return _c('div', {
      key: sindex
    }, [(sindex == 0) ? _c('h3', [_vm._v(_vm._s(sitem.title))]) : (sindex == 1) ? _c('h3', {
      staticClass: "classList"
    }, [_vm._v(_vm._s(sitem.title))]) : (sindex == 2) ? _c('h3', {
      staticClass: "classList"
    }, [_vm._v(_vm._s(sitem.title))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((sitem.child), function(item, index) {
      return _c('li', {
        key: index,
        class: {
          active: sindex == _vm.current[0] && index == _vm.current[1]
        },
        on: {
          "click": function($event) {
            _vm.toggle(sindex, index, item)
          }
        }
      }, [(sindex == 0) ? _c('em', {
        staticClass: "work"
      }) : _vm._e(), _vm._v(" "), (sindex == 1) ? _c('em', {
        staticClass: "classNav"
      }) : _vm._e(), _vm._v("\n        " + _vm._s(item.title) + "\n      ")])
    }))])
  }))
},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStukw"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.exampaperData.resourceName))]), _vm._v(" "), _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "watchStuCon"
  }, [_c('div', {
    staticClass: "watchStuConT"
  }, [_c('p', {
    staticClass: "stuConT-l fl"
  }, [_vm._v("要求" + _vm._s(_vm.readText) + _vm._s(_vm.readTimes) + "次；该题分值：" + _vm._s(_vm.exampaperData.workScore) + "分。(实际" + _vm._s(_vm.readText) + _vm._s(_vm.exampaperData.submitCount) + "次)")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("播放全部音频")]), _c('div', {
    staticClass: "fl"
  }, [_c('theAudio', {
    attrs: {
      "src": null,
      "allUrl": _vm.allUrl,
      "id": 0,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "stuSubject"
  }, _vm._l((_vm.exampaperData.workAnswers), function(sub, $index) {
    return _c('li', {
      staticClass: "stuSubCon"
    }, [_c('p', {
      staticClass: "stuSubM"
    }, [_vm._v(_vm._s(_vm.matchCont(sub.answers[0].word)))]), _vm._v(" "), _c('div', {
      staticClass: "stuSubConFoot clearfix"
    }, [_c('div', {
      staticClass: "subConFoot-l fl"
    }, [_c('theAudio', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "src": sub.answers[0].audioUrl,
        "id": sub.versionId,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "subConFoot-r fr"
    }, [_c('span', {
      staticClass: "subConSocre"
    }, [_vm._v(_vm._s(sub.score))]), _vm._v(" "), _c('span', [_vm._v("分")])])])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t120"
  }, [_c('exampaper', {
    attrs: {
      "page": _vm.page,
      "selectFlag": _vm.selectFlag,
      "thirdParty": _vm.thirdParty,
      "exampaperData": _vm.exampaperData,
      "serviceId": _vm.serviceId,
      "packageId": _vm.packageId,
      "cId": _vm.cId,
      "moduleId": _vm.moduleId,
      "versionId": _vm.versionId
    },
    on: {
      "submitExampaper": _vm.submitExampaper
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eChart"
  }, [_c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "fl tip"
  }, [_vm._v("成绩曲线")]), _vm._v(" "), (_vm.echartData.length) ? _c('div', {
    staticClass: "classSelect fr"
  }, [_c('span', {
    staticClass: "selectActive",
    on: {
      "click": _vm.selectShow
    }
  }, [_vm._v(_vm._s(_vm.subjectName))]), _vm._v(" "), (_vm.subjectF) ? _c('ul', {
    staticClass: "selectBox"
  }, _vm._l((_vm.subjectList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.changetype(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  })) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.echartData.length) ? _c('noFound') : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      noHeight: !_vm.echartData.length
    },
    staticStyle: {
      "width": "100%",
      "height": "330px"
    },
    attrs: {
      "id": "myChart"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('p', [_vm._v("完型填空 说明")]), _vm._v(" "), (_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    staticClass: "correctHand",
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(_vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 4
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.question.children), function(question, index) {
    return _c('div', {
      staticClass: "m-t20"
    }, [(question.qtype == 1) ? _c('singleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 3) ? _c('filling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 6) ? _c('shortanswer', {
      attrs: {
        "question": question,
        "underlineF": true,
        "id": question.id + index,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 7) ? _c('imitation', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setBooks_box"
  }, [(_vm.showPage) ? _c('div', {
    staticClass: "setBooks"
  }, [_c('div', {
    staticClass: "header clear"
  }, [(_vm.service.length != 0) ? _c('form', {
    staticClass: "search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索书籍"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': _vm.keywords.trim().length > 0
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1070),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.service.length != 0) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "selectService"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.service,
      "selectObj": "service",
      "selectId": _vm.serviceId,
      "defValue": _vm.service.length === 1 ? '' : '全部服务'
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGrads"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.grads,
      "selectObj": "grads",
      "selectId": _vm.gradId,
      "defValue": _vm.grads.length === 1 ? '' : '全部年级'
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('article', {
    ref: "viewBooks",
    staticClass: "book_list clear",
    on: {
      "scroll": function($event) {
        _vm.handleScroll()
      }
    }
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.catalog), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('book', {
      attrs: {
        "booksData": item,
        "type": 1
      },
      on: {
        "setTop": _vm.setTop
      }
    })], 1)
  })), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()]), _vm._v(" "), (_vm.catalog.length == 0 && !_vm.isSearch && _vm.service.length != 0) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有找到符合条件的书籍")])]) : _vm._e(), _vm._v(" "), (_vm.service.length == 0) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有可以布置作业的书籍")]), _vm._v(" "), _c('p', [_vm._v("您可以联系\"教育顾问\"获取帮助")])]) : _vm._e(), _vm._v(" "), (_vm.catalog.length == 0 && _vm.pageIndex == 1 && _vm.isSearch) ? _c('div', {
    staticClass: "noResult clear"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有找到符合条件的书籍")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prev"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("上一步")])])])
},staticRenderFns: []}

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "socreTable",
    attrs: {
      "border": "0",
      "align": "center"
    }
  }, [_c('thead', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('tr', [_c('td', {
    on: {
      "click": function($event) {
        _vm.sort = {
          key: 'index',
          val: -_vm.sort.val
        }
      }
    }
  }, [_vm._v("排名  \n        "), _vm._m(0)]), _vm._v(" "), _c('td', {
    on: {
      "click": function($event) {
        _vm.sort = {
          key: 'userName',
          val: -_vm.sort.val
        }
      }
    }
  }, [_vm._v("姓名  \n        "), _vm._m(1)]), _vm._v(" "), _vm._l((_vm.hList), function(item) {
    return _c('td', {
      attrs: {
        "title": item.resourceName || item.name
      }
    }, [_vm._v("\n        " + _vm._s(item.name || item.resourceName) + "\n      ")])
  }), _vm._v(" "), _c('td', {
    on: {
      "click": function($event) {
        _vm.sort = {
          key: 'actualScore',
          val: -_vm.sort.val
        }
      }
    }
  }, [_vm._v("总分  \n        "), _vm._m(2)])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.players), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "_rank",
      class: {
        grayzi: data.isShow == -1
      }
    }, [_vm._v(_vm._s(data.index ? data.index : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "name",
      class: {
        grayzi: data.isShow == -1
      }
    }, [_vm._v(_vm._s(data.userName))]), _vm._v(" "), _vm._l((data.tabDatas), function(item) {
      return _c('td', {
        class: {
          unSublime: item.score < 0
        }
      }, [_vm._v("\n        " + _vm._s(item.score >= 0 ? _vm.toMathTwo(item.score) : '未提交'))])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalScore >= 0 ? _vm.toMathTwo(data.totalScore) : '-'))])], 2)
  }), _vm._v(" "), _vm._l((_vm.unlist), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "_rank",
      class: {
        grayzi: data.isShow == -1
      }
    }, [_vm._v(_vm._s(data.index ? data.index : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "name",
      class: {
        grayzi: data.isShow == -1
      }
    }, [_vm._v(_vm._s(data.userName))]), _vm._v(" "), _vm._l((data.tabDatas), function(item) {
      return (data.isShow == 0) ? _c('td', {
        staticClass: "unSublime"
      }, [_vm._v("未提交")]) : _c('td', {
        class: {
          grayzi: data.isShow == -1
        }
      }, [_vm._v("-")])
    }), _vm._v(" "), (data.isShow == 0) ? _c('td', {
      staticClass: "unSublime"
    }, [_vm._v("未提交")]) : _c('td', {
      class: {
        grayzi: data.isShow == -1
      }
    }, [_vm._v("-")])], 2)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "arrIcon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "arrIcon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "arrIcon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240)
    }
  })])
}]}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStudc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.exampaperData.resourceName))]), _vm._v(" "), _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "watchStuCon"
  }, [_c('div', {
    staticClass: "watchStuConT"
  }, [_c('p', {
    staticClass: "stuConT-l fl"
  }, [_vm._v("要求" + _vm._s(_vm.readText) + _vm._s(_vm.readTimes) + "次；该题分值：" + _vm._s(_vm.exampaperData.workScore) + "分。(实际" + _vm._s(_vm.readText) + _vm._s(_vm.exampaperData.submitCount) + "次)")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("播放全部音频")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('theAudio', {
    attrs: {
      "src": null,
      "allUrl": _vm.allUrl,
      "id": 0,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "stuSubject clearfix"
  }, _vm._l((_vm.exampaperData.workAnswers), function(sub, $index) {
    return _c('li', {
      staticClass: "stuSubCon"
    }, [_c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(sub.answers[0].word))]), _vm._v(" "), _c('div', {
      staticClass: "stuSubConFoot clearfix"
    }, [_c('theAudio', {
      staticClass: "fl",
      attrs: {
        "src": sub.answers[0].audioUrl,
        "id": sub.versionId,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "fr"
    }, [_c('span', {
      staticClass: "stuSubConScore"
    }, [_vm._v(_vm._s(sub.score))]), _vm._v(" "), _c('span', [_vm._v("分")])])], 1)])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class"
  }, [(_vm.classList.length > 0) ? _c('div', {
    staticClass: "existClass"
  }, [_c('div', {
    staticClass: "classList clearfix"
  }, [_vm._l((_vm.partclassList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "oneClass",
      class: {
        currentClass: _vm.num == item.index
      },
      attrs: {
        "title": item.className
      },
      on: {
        "click": function($event) {
          _vm.showOneClass(item.index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.className) + "\n            ")])
  }), _vm._v(" "), (_vm.classList.length > 4) ? _c('div', {
    staticClass: "select_class"
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.selectedclassList,
      "autoIsShow": false,
      "selectObj": "selectClass",
      "selecterText": "更多班级..."
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "addClass",
    on: {
      "click": _vm.createClass
    }
  }, [_vm._v("\n                添加班级\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "classHead"
  }, [_c('div', {
    staticClass: "classHeadLeft"
  }, [_c('div', {
    staticClass: "className"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClass.className))]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.redact(_vm.currentClass)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkService",
    on: {
      "click": _vm.checkService
    }
  }, [_vm._v("\n                    班级服务使用情况\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "classHearRight"
  }, [_c('div', {
    staticClass: "classCount"
  }, [_c('span', [_vm._v(_vm._s(_vm.classStudent.length))]), _vm._v("\n                    班级人数\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "workCount"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClass.workCount || 0))]), _vm._v("\n                    已布置作业数\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "addStudent",
    on: {
      "click": function($event) {
        _vm.addStudent(_vm.currentClass)
      }
    }
  }, [_c('i', {
    staticClass: "studentHead"
  }), _vm._v(" "), _c('span', [_vm._v("添加学生")])]), _vm._v(" "), _c('a', {
    staticClass: "exportStuInf",
    attrs: {
      "href": _vm.url
    },
    on: {
      "click": _vm.studentExcel
    }
  }, [_c('i', {
    staticClass: "derivation"
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "classStudent"
  }, [_c('div', {
    staticClass: "classTools"
  }, [_c('div', {
    staticClass: "studentCount"
  }, [_vm._v("共" + _vm._s(_vm.classStudent.length) + "个学生")])]), _vm._v(" "), (_vm.classStudent.length > 0) ? _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.classStudent), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filterPhone(item.mobile)))]), _vm._v(" "), _c('td', {
      staticClass: "bigshowService"
    }, [(item.IsBuyArr.length == 0 && item.IsTryArr.length == 0) ? _c('span', [_vm._v("暂无")]) : _vm._e(), _vm._v(" "), (item.IsBuyArr.length > 0 || item.IsTryArr.length > 0) ? _c('div', {
      staticClass: "isBox"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "200",
        "trigger": "hover"
      }
    }, [_c('div', {
      staticClass: "showService"
    }, _vm._l((item.IsBuyArr), function(item1, index1) {
      return _c('p', {
        key: index1
      }, [_vm._v(_vm._s(item1.ServiceTypeName))])
    })), _vm._v(" "), (item.IsBuyArr.length > 0) ? _c('div', {
      staticClass: "buy",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }) : _vm._e()]), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "200",
        "trigger": "hover"
      }
    }, [_c('div', {
      staticClass: "showService"
    }, _vm._l((item.IsTryArr), function(item2, index2) {
      return _c('p', {
        key: index2
      }, [_vm._v(_vm._s(item2.ServiceTypeName))])
    })), _vm._v(" "), (item.IsTryArr.length > 0) ? _c('div', {
      staticClass: "noBuy",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('td', [(false) ? _c('div', {
      staticClass: "checkStudent"
    }, [_c('button', {
      staticClass: "button green"
    }, [_vm._v("\n                                查看详情\n                            ")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          _vm.deleteStudent(item)
        }
      }
    })])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.classStudent.length == 0 && _vm.showStu) ? _c('div', {
    staticClass: "noStudent"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "noStudentImg"
  }, [_c('img', {
    staticClass: "noGrade",
    attrs: {
      "src": __webpack_require__(1061)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t30"
  }, [_c('p', [_vm._v("一、让学生通过老师号" + _vm._s(_vm.mobile) + "加入班级")]), _vm._v(" "), _c('p', [_vm._v("二、点击\""), _c('i', {
    staticClass: "noStudentAdd",
    on: {
      "click": function($event) {
        _vm.addStudent(_vm.currentClass)
      }
    }
  }, [_vm._v("添加学生")]), _vm._v("\"手动添加学生进入班级")])])])]) : _vm._e()])]) : (_vm.classList.length == 0) ? _c('div', {
    staticClass: "noClass"
  }, [_c('div', {
    staticClass: "noClassBox"
  }, [_c('img', {
    staticClass: "noGrade",
    attrs: {
      "src": __webpack_require__(27)
    }
  }), _vm._v(" "), _c('span', [_vm._v("您还没有班级哦~赶紧创建一个吧")]), _vm._v(" "), _c('div', {
    staticClass: "create"
  }, [_c('button', {
    staticClass: "button green",
    on: {
      "click": _vm.createClass
    }
  }, [_vm._v("去创建")])])])]) : _vm._e(), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticClass: "exportExcel"
  }, [_vm._v("导出学生信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("账号")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("服务情况")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("账号")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("服务情况")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])])
}]}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('p', [_vm._v("判断题小题说明")]), _vm._v(" "), (_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ".")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), (_vm.question.userAnswer) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setAnswers(_vm.question.userAnswer.answers[0].content))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers,
      "skillPoints": _vm.question.skill_points,
      "knowledgePoints": _vm.question.knowledge_points,
      "explains": _vm.question.explains,
      "qtype": 8,
      "tags": _vm.question.tags
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-box clearfix"
  }, [_c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("正确")])]), _vm._v(" "), _c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("错误")])])])
}]}

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "personMsg"
  }, [_c('div', {
    staticClass: "photo fl"
  }, [_c('img', {
    staticClass: "head_icon",
    attrs: {
      "src": _vm.avatar,
      "alt": "用户头像"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "alter",
    attrs: {
      "for": "xFile"
    }
  }, [_vm._v("修改头像")]), _vm._v(" "), _c('form', [_c('input', {
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0 0 0 0)"
    },
    attrs: {
      "type": "file",
      "id": "xFile",
      "accept": "image/png, image/jpeg, image/gif, image/jpg"
    },
    on: {
      "change": function($event) {
        _vm.preview($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear",
    attrs: {
      "id": "preview"
    }
  }), _vm._v(" "), _c('div', [_c('basicMsg', {
    attrs: {
      "userInformation": _vm.userInformation,
      "birthday": _vm.userInformation.birthday,
      "userId": _vm.userId
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "revisePhone"
  }, [_c('p', [_c('img', {
    staticClass: "phone",
    attrs: {
      "src": __webpack_require__(1065),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("绑定手机号：")]), _vm._v(" "), _c('span', {
    staticClass: "rightSpan",
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.mobile))]), _vm._v(" "), _c('span', {
    staticClass: "bule_alert",
    on: {
      "click": _vm.altMobile
    }
  }, [_vm._v(_vm._s(_vm.buttontext))])])]), _vm._v(" "), _c('div', [_c('alertMobile', {
    attrs: {
      "layerMB": _vm.layerMB,
      "oldMobile": _vm.mobile
    },
    on: {
      "sureMobile": _vm.sureMobile
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_c('span', [_vm._v("个人中心")])])
}]}

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "checkboxLabel"
  }, [_c('i', {
    staticClass: "noChooseRom",
    class: {
      'chooseRom': _vm.setQuestionId
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "selecter",
    on: {
      "mouseleave": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.selecterText
    },
    on: {
      "click": _vm.showPanel
    }
  }, [_vm._v(_vm._s(_vm.selecterText))]), _vm._v(" "), _c('ul', {
    staticClass: "panel",
    class: {
      'showPanel': _vm.showSelecter
    }
  }, [_c('li', {
    class: {
      'isShow': !_vm.autoIsShow
    },
    on: {
      "click": function($event) {
        _vm.selected(-1)
      }
    }
  }, [_vm._v("---全部---")]), _vm._v(" "), _vm._l((_vm.selectData), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selected(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toogle_content"
  }, [_c('form', {
    staticClass: "basic-grey"
  }, [_c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userInformation.realName))]), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("账号 :")]), _vm._v(" "), _c('span', {
    staticClass: "rightSpan",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v(_vm._s(_vm.userInformation.userId))])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "school"
  }, [_c('span', [_vm._v("学校：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.school))])]), _vm._v(" "), _c('li', {
    staticClass: "grads"
  }, [_c('span', [_vm._v("班级：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.grads))])])])]), _vm._v(" "), _c('div', [_c('alertPW', {
    attrs: {
      "layerPW": _vm.layerPW,
      "password": _vm.userInformation.password
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scorll"
  }, [_c('div', {
    staticClass: "Home"
  }, [(_vm.totalCount > 0) ? _c('div', {
    staticClass: "oldHome"
  }, [_vm._m(0), _vm._v(" "), (_vm.historyHomework.length) ? _c('div', {
    ref: "viewWrapper",
    staticClass: "historyHomework",
    on: {
      "scroll": function($event) {
        _vm.handleScroll()
      }
    }
  }, [_vm._l((_vm.historyHomework), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_c('history', {
      key: index,
      attrs: {
        "content": item,
        "delIndex": index,
        "PageIndex": _vm.PageIndex
      },
      on: {
        "removeWork": _vm.removeWork
      }
    })], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.totalCount == 0) ? _c('div', {
    staticClass: "newHome"
  }, [_vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("检查作业")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noWorkBox"
  }, [_c('img', {
    staticClass: "noGrade",
    attrs: {
      "src": __webpack_require__(27)
    }
  }), _vm._v(" "), _c('span', [_vm._v("您还没有布置过作业呢，赶紧去布置吧")])])
}]}

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schoolMsg"
  }, [_c('div', {
    staticClass: "menu clear"
  }, [_c('ul', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('li', {
    class: {
      activeLi: _vm.index == 1
    },
    on: {
      "click": function($event) {
        _vm.toggle(1)
      }
    }
  }, [_vm._v("我发送的")]), _vm._v(" "), _c('li', {
    class: {
      activeLi: _vm.index != 1
    },
    on: {
      "click": function($event) {
        _vm.toggle(2)
      }
    }
  }, [_vm._v("\n          我接收的\n          "), _c('i', {
    class: {
      msgPro: _vm.userInformation.isUnread
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "border_line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sendBox"
  }, [(_vm.index == 1) ? _c('sendMsg', {
    attrs: {
      "loadData": _vm.loadData
    }
  }) : _c('acceptMsg', {
    attrs: {
      "loadData": _vm.loadData
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "viewWrapper",
    staticClass: "view clearfix"
  }, [_c('topBanner'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    class: {
      w1080: _vm.rwidth, w100: _vm.Lwidth
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectObject"
  }, [_c('div', {
    staticClass: "selectHead"
  }, [_vm._v("布置作业")]), _vm._v(" "), _c('div', {
    staticClass: "selectContent clearfix"
  }, [_c('div', {
    staticClass: "leftBox fl"
  }, _vm._l((_vm.allClass), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "classbox",
      class: {
        selected: item.selected, frist: index === 0
      },
      attrs: {
        "index": index
      },
      on: {
        "click": function($event) {
          _vm.classClick(index)
        }
      }
    }, [_c('el-checkbox', {
      attrs: {
        "indeterminate": item.isIndeterminate
      },
      on: {
        "change": function($event) {
          _vm.handleCheckAllChange(index)
        }
      },
      model: {
        value: (item.checkAll),
        callback: function($$v) {
          _vm.$set(item, "checkAll", $$v)
        },
        expression: "item.checkAll"
      }
    }, [_vm._v(_vm._s(item.className))]), _vm._v(" "), _c('span', {
      staticClass: "checkCount fr"
    }, [_vm._v(_vm._s(item.checkedStudents.length) + "/" + _vm._s(item.studentArr.length))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "rightBox fr"
  }, _vm._l((_vm.allClass), function(item, index1) {
    return (item.selected) ? _c('div', {
      key: index1,
      staticClass: "checkBox"
    }, _vm._l((item.studentArr), function(student, index2) {
      return _c('div', {
        key: index2,
        staticClass: "input fl"
      }, [_c('label', {
        staticClass: "label",
        attrs: {
          "for": index2
        }
      }, [_c('span', {
        staticClass: "inputBox fl",
        class: {
          isChecked: student.isChecked
        }
      }, [_c('span', {
        staticClass: "checkBox"
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.checkedStudents),
          expression: "item.checkedStudents"
        }],
        attrs: {
          "type": "checkbox",
          "id": index2
        },
        domProps: {
          "value": student,
          "checked": Array.isArray(item.checkedStudents) ? _vm._i(item.checkedStudents, student) > -1 : (item.checkedStudents)
        },
        on: {
          "change": [function($event) {
            var $$a = item.checkedStudents,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = student,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(item, "checkedStudents", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(item, "checkedStudents", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(item, "checkedStudents", $$c)
            }
          }, function($event) {
            _vm.singerChange(index1, index2)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "studentName fl"
      }, [_vm._v("\n              " + _vm._s(student.userName) + "\n            ")])])])
    })) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "nextOne"
  }, [_c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.isChecked
    },
    on: {
      "click": _vm.nextOne
    }
  }, [_vm._v("下一步")])])])
},staticRenderFns: []}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankWork"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.goback
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1056),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("返回")])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.workName))]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1069),
      "alt": ""
    },
    on: {
      "click": _vm.showInfo
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "info down"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("布置对象")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.reviceObject))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("所属书籍")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workList.bookName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("布置时间")]), _vm._v(" "), (_vm.workList.state == 0 || _vm.workList.state == -1) ? _c('p', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.workList.publishDate, 'yyyy-MM-dd W hh:mm')))]) : (_vm.workList.state == 1 || _vm.workList.state == -1) ? _c('p', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.workList.sendDate, 'yyyy-MM-dd W hh:mm')))]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("截止时间")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.workList.effectiveDate, 'yyyy-MM-dd W hh:mm')))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("作业留言")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workList.workMessage))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "workContent clearfix"
  }, [_c('div', {
    staticClass: "leftBox fl"
  }, [_c('div', {
    staticClass: "summaryContent"
  }, [_c('ul', [_c('h3', {
    staticClass: "summaryStudentTitle"
  }, [_vm._v("按学生查看")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.tabFun(-1)
      }
    }
  }, [_c('span', {
    staticClass: "summaryStudentClick",
    class: {
      currentWork: _vm.activeIndex == -1
    }
  }, [_vm._v("成绩汇总")])]), _vm._v(" "), _c('h3', {
    staticClass: "summaryContentTitle"
  }, [_vm._v("按内容查看")]), _vm._v(" "), _vm._l((_vm.contentList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        currentWork: index == _vm.activeIndex
      },
      on: {
        "click": function($event) {
          _vm.tabFun(index, item.contentId)
        }
      }
    }, [(item.correctMark) ? _c('i', {
      staticClass: "icon-correct"
    }) : _vm._e(), _vm._v(_vm._s(item.resourceName) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.activeIndex == -1) ? _c('rankWorkTable', {
    attrs: {
      "collectHeader": _vm.collectHeader,
      "workScore": _vm.workScore,
      "collectData": _vm.collectData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex != -1) ? _c('rankTable', {
    attrs: {
      "rankTableData": _vm.rankTableData,
      "singleData": _vm.singleData,
      "workId": _vm.workId,
      "contentId": _vm.contentId,
      "url": _vm.url,
      "activeIndex": _vm.activeIndex,
      "hasQuestion": _vm.hasQuestion
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooseText"
  }, [_c('div', {
    staticClass: "Text"
  }, [_c('div', {
    staticClass: "selectText"
  }, [_c('div', {
    staticClass: "selectText-title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.resourceName))])]), _vm._v(" "), _c('div', {
    staticClass: "allChoose"
  }, [_c('input', {
    class: {
      'checked': _vm.choose, 'noChecked': !_vm.choose
    },
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": ""
    },
    on: {
      "click": _vm.allChoose
    }
  }), _vm._v(" "), _c('span', [_vm._v("全选")])]), _vm._v(" "), _vm._l((_vm.followreadText), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "textContent clearfix"
    }, [(_vm.selectFlag) ? _c('div', {
      staticClass: "choose"
    }, [_c('button', {
      staticClass: "button choice",
      class: {
        checked: item.isChecked
      },
      on: {
        "click": function($event) {
          _vm.checkFun(item, index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.text))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottomMenu clearfix"
  }, [_c('div', {
    staticClass: "bottomMenuBox"
  }, [(_vm.selectTextArr.length != 0) ? _c('div', {
    staticClass: "fl",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("共选\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.selectTextArr.length || 0))]), _vm._v("\n                个段落, 预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDataToMinute")(_vm.doworkTime)))]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('span', {
    staticClass: "cancel fl",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button confirm",
    on: {
      "click": _vm.backSentenceArr
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classManage"
  }, [_c('div', {
    staticClass: "selectHead"
  }, [_c('span', [_vm._v(_vm._s(_vm.studentsList.className))])]), _vm._v(" "), _c('div', {
    staticClass: "classContent"
  }, [_c('div', {
    staticClass: "studentsList"
  }, [_c('div', {
    staticClass: "listTitle"
  }, _vm._l((_vm.selectTitle), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'select': _vm.changeStyle == index
      },
      on: {
        "click": function($event) {
          _vm.toggle(index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })), _vm._v(" "), (_vm.changeStyle == 0) ? _c('div', {
    staticClass: "table clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tableBody"
  }, _vm._l((_vm.newStuList), function(item, index) {
    return (item.userRole == 1) ? _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.userId))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.phone ? '已激活' : '未激活'))]), _vm._v(" "), _c('li', [_vm._v(_vm._s((item.teamName == "未分组") ? '-' : item.teamName))])]) : _vm._e()
  }))]) : _vm._e()]), _vm._v(" "), (_vm.changeStyle == 1) ? _c('groups', {
    attrs: {
      "index": _vm.classIndex
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableHead"
  }, [_c('ul', [_c('li', [_vm._v("姓名")]), _vm._v(" "), _c('li', [_vm._v("账号")]), _vm._v(" "), _c('li', [_vm._v("状态")]), _vm._v(" "), _c('li', [_vm._v("所在小组")])])])
}]}

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "originSelect"
  }, [(_vm.dataType === 'number') ? _c('select', {
    attrs: {
      "name": ""
    },
    on: {
      "change": _vm.changeEvent
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "selected": (index + 1) == _vm.defValue
      }
    }, [_vm._v(_vm._s(item))])
  })) : (_vm.selectObj == 'service' || _vm.selectObj == 'grads') ? _c('select', {
    attrs: {
      "name": ""
    },
    on: {
      "change": _vm.changeEvent
    }
  }, [(_vm.defValue) ? _c('option', [_vm._v(_vm._s(_vm.defValue))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "selected": index == _vm.valIndex
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2) : _c('select', {
    attrs: {
      "name": ""
    },
    on: {
      "change": _vm.changeEvent
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "selected": (index + 1) == _vm.defValue
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticStyle: {
      "background": "#93DACA"
    },
    on: {
      "click": function($event) {
        _vm.goFun(0)
      }
    }
  }, [_vm._v("继续布置")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goFun(1)
      }
    }
  }, [_vm._v("查看作业")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n    布置作业\n    "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(393),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("作业留言")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1071),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("您的作业已经发布成功！")])])
}]}

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "440px",
      "margin": "30px auto 40px",
      "border": "1px solid #e6e6e6"
    }
  }, [_c('div', {
    staticClass: "noticeMenu"
  }, [_c('div', {
    staticClass: "oldAccount fl",
    class: {
      active: !_vm.isNewStudent
    },
    on: {
      "click": _vm.oldStuClick
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v("\n            已有账号\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "newAccount fl",
    class: {
      active: _vm.isNewStudent
    },
    on: {
      "click": _vm.newStuClick
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v("\n            新建账号\n          ")])]), _vm._v(" "), (!_vm.isNewStudent) ? _c('div', {
    staticClass: "searchStuBox"
  }, [_c('div', {
    staticClass: "noticeSearchStu"
  }, [_c('div', {
    staticClass: "searchBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "请输入学生的账号/手机号"
    },
    domProps: {
      "value": (_vm.userId)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userId = $event.target.value
      }, _vm.search]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "searchStudent"
  })])]), _vm._v(" "), (_vm.newStudentInf) ? _c('div', {
    staticClass: "searchResult"
  }, [_c('p', [_vm._v("可能添加的学生:")]), _vm._v(" "), _c('div', {
    staticClass: "studentInf"
  }, [(_vm.newStudentInf.avatar) ? _c('img', {
    staticClass: "studentImg",
    attrs: {
      "src": _vm.newStudentInf.avatar,
      "alt": _vm.newStudentInf.realName
    }
  }) : (!_vm.newStudentInf.avatar) ? _c('img', {
    staticClass: "studentImg",
    attrs: {
      "src": __webpack_require__(390),
      "alt": _vm.newStudentInf.realName
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "studentName"
  }, [_vm._v(_vm._s(_vm.newStudentInf.userName))]), _vm._v(" "), (false) ? _c('img', {
    staticClass: "sex",
    attrs: {
      "src": _vm.newStudentInf.src,
      "alt": "性别"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "studentAccount"
  }, [_vm._v(_vm._s(_vm.newStudentInf.userId))]), _vm._v(" "), _c('div', {
    staticClass: "clickAddStu",
    on: {
      "click": function($event) {
        _vm.addStudent(_vm.newStudentInf.userId, _vm.newStudentInf.realName)
      }
    }
  }, [_vm._v("添加")])])]) : _vm._e(), _vm._v(" "), (!_vm.newStudentInf && _vm.isSearch) ? _c('div', {
    staticClass: "noUsers"
  }, [_c('p', [_vm._v("未找到符合条件的学生!")])]) : _vm._e()]) : (_vm.isNewStudent) ? _c('div', {
    staticClass: "createdStudentBox"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.studentNames),
      expression: "studentNames",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "student",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入学生姓名，每行一个(可以直接复制粘贴Excle中的数据)"
    },
    domProps: {
      "value": (_vm.studentNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentNames = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.isNewStudent) ? _c('div', {
    staticClass: "passwordBox"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("为新建账号设置初始密码:")]), _vm._v(" "), _c('div', {
    staticClass: "randomPwd fl",
    on: {
      "click": _vm.setRandomPwd
    }
  }, [_c('i', {
    staticClass: "checkKuang"
  }, [(_vm.isChecked) ? _c('u') : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("随机密码")])]), _vm._v(" "), _c('div', {
    staticClass: "initialPwd fl",
    on: {
      "click": _vm.setinitialPwd
    }
  }, [_c('i', {
    staticClass: "checkKuang"
  }, [(!_vm.isChecked) ? _c('u') : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("统一密码")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), (_vm.isNewStudent) ? _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.params.button1 || "取消"))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.params.button2 || "确定"))])]) : _vm._e()])
},staticRenderFns: []}

/***/ })
],[574]);


// WEBPACK FOOTER //
// static/js/app.707e5fd072b5369c70b3.js